webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//目前使用行動裝置判斷
var agent = navigator.userAgent;
var checkDevice = {
  ios: agent.match(/iP(hone|od|ad)/i),
  android: agent.match(/Android/i)
};

//iOS(iPad, iPhone) Meta Viewport 鎖定縮放拖曳

var IosFixed = function () {
  function IosFixed() {
    _classCallCheck(this, IosFixed);
  }

  _createClass(IosFixed, [{
    key: 'metaViewport',
    value: function metaViewport() {
      if (checkDevice.ios || checkDevice.android) {
        document.documentElement.addEventListener('touchstart', function (event) {
          if (event.touches.length > 1) {
            event.preventDefault();
          }
        }, false);

        var lastTouchEnd = 0;
        document.documentElement.addEventListener('touchend', function (event) {
          var now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        }, false);
      }
    }
  }]);

  return IosFixed;
}();

//CSS Transition & Animation 結束判斷


var transitionEnd = 'webkitTransitionEnd oTransitionEnd msTransitionEnd transitionend';
var animationEnd = 'webkitAnimationEnd oAnimationEnd msAnimationEnd animationend';

//輸出
exports.checkDevice = checkDevice;
exports.IosFixed = IosFixed;
exports.transitionEnd = transitionEnd;
exports.animationEnd = animationEnd;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//控制瀏覽器捲軸、按鈕
var BodyCtrl = function () {
  function BodyCtrl() {
    _classCallCheck(this, BodyCtrl);

    this.body = $('body');
  }

  _createClass(BodyCtrl, [{
    key: 'ctrl',
    value: function ctrl(settings) {
      switch (settings) {
        case 'scrollHide':
          this.body.addClass('scrollHide');
          break;
        case 'scrollShow':
          this.body.removeClass('scrollHide');
          break;
        case 'scrollHideF':
          this.body.addClass('scrollHideF');
          break;
        case 'scrollShowF':
          this.body.removeClass('scrollHideF');
          break;
        case 'btnLock':
          this.body.css('pointer-events', 'none');
          break;
        case 'btnUnlock':
          this.body.css('pointer-events', 'auto');
          break;
      }
    }
  }]);

  return BodyCtrl;
}();

//輸出


exports.BodyCtrl = BodyCtrl;

//jQuery 模組化
/*
(function($){
  $.fn.test = function(settings){
    //指定物件
    var $this = this;

    //設定初始預設並帶入此專案
    var status = $.extend({
      s: 'test'
    }, settings);

    var ss = status.s;

    //邏輯函式區
    var t = function($this){
      $this.on('click', function(){
        alert(ss);
      });
    }

    //輸出
    t();
  }
})(jQuery);

$('element').test();

$('element').test({
  s: 'test_'
});
*/

//直接鎖定瀏覽器捲軸目前位置(無顯示影藏)
/*
var scrollLock     = false;
var scrollPosition = {left: 0, top: 0};
$(window).on('scroll', function(){
  if (scrollLock) {
    window.scrollTo(scrollPosition.left, scrollPosition.top);
  } else {
    scrollPosition = {
      lelf: self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
      top : self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    };
  }
});
*/
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LazyLoad = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


__webpack_require__(26);

__webpack_require__(27);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//圖片延遲載入
var LazyLoad = function () {
  function LazyLoad() {
    _classCallCheck(this, LazyLoad);

    this.img = $('img.lazy');
    this.imgNoCrop = $('img.noCropLazy');
    this.imgScroll = $('img.lazyS');
    this.scrollLazy = $('.scrollLazy');
  }

  _createClass(LazyLoad, [{
    key: 'imgLoad',
    value: function imgLoad() {
      this.img.lazy({
        delay: 1000,
        afterLoad: function afterLoad(e) {
          //物件列表圖片裁切
          e.parent().css('background-image', 'url(' + e.attr('src') + ')');
          e.parent().empty();
        }
      });
    }
  }, {
    key: 'scrollImgLoad',
    value: function scrollImgLoad() {
      this.imgScroll.lazy({
        appendScroll: this.scrollLazy,
        afterLoad: function afterLoad(e) {
          //物件列表圖片裁切
          e.parent().css('background-image', 'url(' + e.attr('src') + ')');
          e.parent().empty();
        }
      });
    }
  }, {
    key: 'noImgCropLoad',
    value: function noImgCropLoad() {
      this.imgNoCrop.lazy({
        afterLoad: function afterLoad(e) {
          // e.parent().css('background-image', 'none'); //原設定
          e.parent().css('background-image', 'url("images/recruitment/logo1.png")'); //20230210 kai write
        }
      });
    }
  }]);

  return LazyLoad;
}();

//輸出


exports.LazyLoad = LazyLoad;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
*/

// t: current time, b: begInnIng value, c: change In value, d: duration
jQuery.easing['jswing'] = jQuery.easing['swing'];

jQuery.extend(jQuery.easing, {
	def: 'easeOutQuad',
	swing: function swing(x, t, b, c, d) {
		//alert(jQuery.easing.default);
		return jQuery.easing[jQuery.easing.def](x, t, b, c, d);
	},
	easeInQuad: function easeInQuad(x, t, b, c, d) {
		return c * (t /= d) * t + b;
	},
	easeOutQuad: function easeOutQuad(x, t, b, c, d) {
		return -c * (t /= d) * (t - 2) + b;
	},
	easeInOutQuad: function easeInOutQuad(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t + b;
		return -c / 2 * (--t * (t - 2) - 1) + b;
	},
	easeInCubic: function easeInCubic(x, t, b, c, d) {
		return c * (t /= d) * t * t + b;
	},
	easeOutCubic: function easeOutCubic(x, t, b, c, d) {
		return c * ((t = t / d - 1) * t * t + 1) + b;
	},
	easeInOutCubic: function easeInOutCubic(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
		return c / 2 * ((t -= 2) * t * t + 2) + b;
	},
	easeInQuart: function easeInQuart(x, t, b, c, d) {
		return c * (t /= d) * t * t * t + b;
	},
	easeOutQuart: function easeOutQuart(x, t, b, c, d) {
		return -c * ((t = t / d - 1) * t * t * t - 1) + b;
	},
	easeInOutQuart: function easeInOutQuart(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
		return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
	},
	easeInQuint: function easeInQuint(x, t, b, c, d) {
		return c * (t /= d) * t * t * t * t + b;
	},
	easeOutQuint: function easeOutQuint(x, t, b, c, d) {
		return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	},
	easeInOutQuint: function easeInOutQuint(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
		return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
	},
	easeInSine: function easeInSine(x, t, b, c, d) {
		return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
	},
	easeOutSine: function easeOutSine(x, t, b, c, d) {
		return c * Math.sin(t / d * (Math.PI / 2)) + b;
	},
	easeInOutSine: function easeInOutSine(x, t, b, c, d) {
		return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
	},
	easeInExpo: function easeInExpo(x, t, b, c, d) {
		return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
	},
	easeOutExpo: function easeOutExpo(x, t, b, c, d) {
		return t == d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
	},
	easeInOutExpo: function easeInOutExpo(x, t, b, c, d) {
		if (t == 0) return b;
		if (t == d) return b + c;
		if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
		return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
	},
	easeInCirc: function easeInCirc(x, t, b, c, d) {
		return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
	},
	easeOutCirc: function easeOutCirc(x, t, b, c, d) {
		return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
	},
	easeInOutCirc: function easeInOutCirc(x, t, b, c, d) {
		if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
		return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
	},
	easeInElastic: function easeInElastic(x, t, b, c, d) {
		var s = 1.70158;var p = 0;var a = c;
		if (t == 0) return b;if ((t /= d) == 1) return b + c;if (!p) p = d * .3;
		if (a < Math.abs(c)) {
			a = c;var s = p / 4;
		} else var s = p / (2 * Math.PI) * Math.asin(c / a);
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
	},
	easeOutElastic: function easeOutElastic(x, t, b, c, d) {
		var s = 1.70158;var p = 0;var a = c;
		if (t == 0) return b;if ((t /= d) == 1) return b + c;if (!p) p = d * .3;
		if (a < Math.abs(c)) {
			a = c;var s = p / 4;
		} else var s = p / (2 * Math.PI) * Math.asin(c / a);
		return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	},
	easeInOutElastic: function easeInOutElastic(x, t, b, c, d) {
		var s = 1.70158;var p = 0;var a = c;
		if (t == 0) return b;if ((t /= d / 2) == 2) return b + c;if (!p) p = d * (.3 * 1.5);
		if (a < Math.abs(c)) {
			a = c;var s = p / 4;
		} else var s = p / (2 * Math.PI) * Math.asin(c / a);
		if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
	},
	easeInBack: function easeInBack(x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c * (t /= d) * t * ((s + 1) * t - s) + b;
	},
	easeOutBack: function easeOutBack(x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
	},
	easeInOutBack: function easeInOutBack(x, t, b, c, d, s) {
		if (s == undefined) s = 1.70158;
		if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
		return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
	},
	easeInBounce: function easeInBounce(x, t, b, c, d) {
		return c - jQuery.easing.easeOutBounce(x, d - t, 0, c, d) + b;
	},
	easeOutBounce: function easeOutBounce(x, t, b, c, d) {
		if ((t /= d) < 1 / 2.75) {
			return c * (7.5625 * t * t) + b;
		} else if (t < 2 / 2.75) {
			return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
		} else if (t < 2.5 / 2.75) {
			return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
		} else {
			return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
		}
	},
	easeInOutBounce: function easeInOutBounce(x, t, b, c, d) {
		if (t < d / 2) return jQuery.easing.easeInBounce(x, t * 2, 0, c, d) * .5 + b;
		return jQuery.easing.easeOutBounce(x, t * 2 - d, 0, c, d) * .5 + c * .5 + b;
	}
});

/*
 *
 * TERMS OF USE - EASING EQUATIONS
 * 
 * Open source under the BSD License. 
 * 
 * Copyright © 2001 Robert Penner
 * All rights reserved.
 * 
 * Redistribution and use in source and binary forms, with or without modification, 
 * are permitted provided that the following conditions are met:
 * 
 * Redistributions of source code must retain the above copyright notice, this list of 
 * conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright notice, this list 
 * of conditions and the following disclaimer in the documentation and/or other materials 
 * provided with the distribution.
 * 
 * Neither the name of the author nor the names of contributors may be used to endorse 
 * or promote products derived from this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY 
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
 *  COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 *  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
 *  GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED 
 * AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 *  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED 
 * OF THE POSSIBILITY OF SUCH DAMAGE. 
 *
 */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkEffect = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


var _common = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//頁面淡入淡出
var LinkEffect = function () {
  function LinkEffect() {
    _classCallCheck(this, LinkEffect);

    this.le = $('.linkEffect');
    this.body = $('html, body');
  }

  _createClass(LinkEffect, [{
    key: 'effect',
    value: function effect() {
      var _this = this;

      this.le.each(function (i, e) {
        if ($(e).prop('href').length > 0) {
          $(e).on('click', function (j) {
            j.preventDefault();
            var $this = $(j.currentTarget);
            var url = $this.attr('href');
            _this.body.addClass('active').one(_common.transitionEnd, function () {
              window.location = url;
            });
          });
        }
      });
    }
  }]);

  return LinkEffect;
}();

//輸出


exports.LinkEffect = LinkEffect;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lightbox = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


__webpack_require__(10);

__webpack_require__(11);

var _link_effect = __webpack_require__(8);

var _map = __webpack_require__(12);

var _form = __webpack_require__(13);

var _other = __webpack_require__(14);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//Lightbox
var Lightbox = function () {
  function Lightbox() {
    _classCallCheck(this, Lightbox);

    this.img = $('a[data-type="image"]');
    this.objForm = $('a.formLightbox');
    this.mortgageForm = $('a.mortgageLightbox');
    this.objMap = $('a.mapLightbox');
    this.webQRcode = $('button.qrcodeWeb');
    this.objQRcode = $('button.qrcodeRealty');
    this.openVideo = $('a#openVideo');
    this.personalInfo = $('button.personalInfo, a.personalInfo');
    this.personalForm = $('a.personalLightbox');
    this.personalQRcode = $('button.qrcodePersonal');
  }

  _createClass(Lightbox, [{
    key: 'image',
    value: function image() {
      this.img.fancybox({
        loop: true,
        protect: true,
        buttons: ['zoom', 'slideShow', 'fullScreen', 'close']
      });
    }
  }, {
    key: 'map',
    value: function map() {
      this.objMap.fancybox({
        toolbar: false,
        smallBtn: false,
        touch: false,
        afterLoad: function afterLoad() {
          //For AJAX
          var map = new _map.LightboxMap();
          map.mapAPI(); //Google Maps
        }
      });
    }
  }, {
    key: 'form',
    value: function form() {
      this.objForm.fancybox({
        toolbar: false,
        smallBtn: false,
        touch: false,
        afterLoad: function afterLoad() {
          //For AJAX
          var linkEffect = new _link_effect.LinkEffect();
          var realtyForm = new _form.RealtyForm();
          var sendForm = new _other.SendForm();
          linkEffect.effect(); //頁面淡入淡出
          realtyForm.checkForm(); //Lightbox - 預約看屋 & 降價通知 & 買屋留言
          sendForm.realtyForm(); //Lightbox表單送出 - 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)
        }
      });
      this.mortgageForm.fancybox({
        toolbar: false,
        smallBtn: false,
        touch: false,
        afterLoad: function afterLoad() {
          //For AJAX
          var mortgage = new _form.Mortgage();
          mortgage.resultMortgage(); //Lightbox - 房貸試算
        }
      });
      this.personalForm.fancybox({
        toolbar: false,
        smallBtn: false,
        touch: false,
        afterLoad: function afterLoad() {
          //For AJAX
          var linkEffect = new _link_effect.LinkEffect();
          var personalForm = new _form.PersonalForm();
          var sendForm = new _other.SendForm();
          linkEffect.effect(); //頁面淡入淡出
          personalForm.checkForm(); //Lightbox - 業務個人
          sendForm.personalForm(); //Lightbox表單送出 - 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)
        }
      });
    }
  }, {
    key: 'qrcode',
    value: function qrcode() {
      this.webQRcode.fancybox({
        toolbar: false,
        smallBtn: false,
        touch: false
      });
      this.objQRcode.fancybox({
        toolbar: false,
        smallBtn: false,
        touch: false
      });
      this.personalQRcode.fancybox({
        toolbar: false,
        smallBtn: false,
        touch: false
      });
    }
  }, {
    key: 'video',
    value: function video() {
      this.openVideo.fancybox({
        buttons: ['close'],
        smallBtn: false,
        touch: false
      });
    }
  }, {
    key: 'personal',
    value: function personal() {
      this.personalInfo.fancybox({
        toolbar: false,
        smallBtn: false,
        touch: false
      });
    }
  }]);

  return Lightbox;
}();

//輸出


exports.Lightbox = Lightbox;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MapRealtySearch = exports.MapRealtyDetail = exports.LightboxMap = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


var _common = __webpack_require__(1);

var _lazyload = __webpack_require__(3);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//Lightbox
var LightboxMap = function () {
    function LightboxMap() {
        _classCallCheck(this, LightboxMap);

        this.map = '#mapCanvas';

        //台灣圖霸api key
        this.gompAccessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM';
        //
    }

    //API


    _createClass(LightboxMap, [{
        key: 'initialize',
        value: function initialize(mapInfo) {

            //Lat & Lng
            var lat = mapInfo.lat;
            var lng = mapInfo.lng;
            // const myLatLng = new google.maps.LatLng(lat, lng);
            var myLatLng = [lng, lat];
            var center = {
                lat: lat,
                lng: lng
            };

            gomp.accessToken = this.gompAccessToken;
            /*
            
            gomp.accessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM';
            */
            //ab -n 100 -c 100 -k http://www.futurelove.com.tw/
            //地圖基本設定
            var mapOptions = {
                container: 'mapCanvas', // 地圖容器 ID
                // style: 'https://api.map8.zone/styles/go-life-maps-tw-style-std/style.json', // 地圖樣式檔案位置
                style: 'https://api.map8.zone/styles/go-life-maps-tw-style-singfujia-0e0150b5/style.json',
                maxBounds: [[105, 15], [138.45858, 33.4]], // 台灣地圖區域
                // maxBounds: [[center.lng - boundsRange.lng, center.lat - boundsRange.lat], [center.lng + boundsRange.lng, center.lat + boundsRange.lat]],
                center: [lng, lat], // 初始中心座標，格式為 [lng, lat]
                // center: [120.221420, 23.008305], // 初始中心座標，格式為 [lng, lat]
                zoom: 15, // 初始 ZOOM LEVEL; [0-20, 0 為最小 (遠), 20 ;最大 (近)]
                minZoom: 6, // 限制地圖可縮放之最小等級, 可省略, [0-19.99]
                maxZoom: 19.99, // 限制地圖可縮放之最大等級, 可省略 [0-19.99]
                pitch: 0, // 攝影機仰角, 可省略, [0-60]
                bearing: 0, // 地圖角度, 可省略, [-180 ~ 180; 0 為正北朝上, 180 為正南朝上]
                attributionControl: false,
                speedLoad: false
            };

            //繪製地圖
            var map = new gomp.Map(mapOptions).addControl(new gomp.AttributionControl({
                compact: false
            }));

            //主標記 & 資訊窗
            this.mapMarker(myLatLng, map, mapInfo);
        } //initialize(mapInfo) {

        //主標記 & 資訊窗

    }, {
        key: 'mapMarker',
        value: function mapMarker(myLatLng, map, mapInfo) {

            //設定地圖標記點
            var markerEl = document.createElement('img');
            markerEl.src = './images/marker.png'; // 請代換為您的圖檔之 URL (例如 "https://example.com/image.png")
            markerEl.style = 'width:80px;';

            //建立地圖標記點
            map.on('load', function () {
                var nowMapCenterPoint = map.getCenter();
                /*
                var markerPoint = new gomp.Marker(markerEl, {offset: [0, -21]})
                    .setLngLat(nowMapCenterPoint)
                    .addTo(map);
                  */
                map.addImage('marker', markerEl); //加入圖
                map.addLayer(pointsSource); //加入訊息框的layer

                //移除map8 logo
                $('.gomp-ctrl-bottom-right').remove();
            });

            //---建立物件資料訊息框 start

            var pointsSource = {
                "id": "pois",
                "type": "symbol",
                "source": {
                    "type": "geojson",
                    "data": {
                        "type": "FeatureCollection",
                        "features": [{
                            "type": "Feature",
                            "properties": {
                                "description": '<h3>' + mapInfo.title + '</h3><p class="add">' + mapInfo.add + '</p><p class="option">' + mapInfo.option + '</p>'
                            },
                            "geometry": {
                                "type": "Point",
                                "coordinates": [mapInfo.lng, mapInfo.lat]
                            }
                        }]
                    }
                },
                "layout": {
                    "icon-image": "marker",
                    "icon-offset": [0, -12],
                    "icon-allow-overlap": true,
                    "icon-size": 0.3
                } //var pointsSource = {

            };var popup = new gomp.Popup({
                anchor: 'bottom',
                closeButton: true,
                closeOnClick: false,
                offset: [0, -42]
            });

            map.on('click', 'pois', function (e) {
                // 設定滑鼠游標樣式
                map.getCanvas().style.cursor = 'pointer';

                var coordinates = e.features[0].geometry.coordinates.slice();
                var description = e.features[0].properties.description;

                // 確保訊息視窗不會被遮擋
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                // 設定訊息視窗內容並在地圖上顯示
                popup.setLngLat(coordinates).setHTML(description).addTo(map);
            });
            //---建立物件資料訊息框 end
        } //mapMarker(myLatLng, map, mapInfo) {

        //輸出

    }, {
        key: 'mapAPI',
        value: function mapAPI() {
            var map = $(this.map);
            var mapInfo = {
                el: this.map,
                lat: map.data('lat'),
                lng: map.data('lng'),
                title: map.data('title'),
                add: map.data('add'),
                option: map.data('option')
            };

            this.initialize(mapInfo);

            //移除map8 logo
            $('.gomp-ctrl-bottom-right').remove();
            $('.gomp-ctrl-bottom-left').remove();
        }
    }]);

    return LightboxMap;
}();

//物件內頁-週邊地圖


var MapRealtyDetail = function () {
    function MapRealtyDetail() {
        _classCallCheck(this, MapRealtyDetail);

        this.map = '#mapCanvasInside';
        // this.rd  = $('.googleMap');
        this.rd = $('.map8');
        // this.rd  = $('#map8_content');
        this.nav = this.rd.data('nav'); //頁面key判斷(nav = buy_d)
        this.mt = this.rd.data('mt'); //項目名稱 realty_d
        this.id = this.rd.data('id'); //物件id  
        //偏移距離
        this.boundsRange = {
            // lat: 0.013, 
            // lng: 0.022
            lat: 0.001,
            lng: 0.001
        };
    }

    //API 定義基本參數，及宣告其它function


    _createClass(MapRealtyDetail, [{
        key: 'initialize',
        value: function initialize(mapInfo) {

            //Lat & Lng
            var lat = mapInfo.lat;
            var lng = mapInfo.lng;
            var myLatLng = [lng, lat];
            var center = {
                lat: lat,
                lng: lng
            };

            //台灣圖霸api key

            gomp.accessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM';

            //地圖基本設定
            var mapOptions = {
                container: 'mapCanvasInside', // 地圖容器 ID
                // style: 'https://api.map8.zone/styles/go-life-maps-tw-style-std/style.json', // 地圖樣式檔案位置
                style: 'https://api.map8.zone/styles/go-life-maps-tw-style-singfujia-0e0150b5/style.json',
                maxBounds: [[105, 15], [138.45858, 33.4]], // 台灣地圖區域
                // maxBounds: [[center.lng - boundsRange.lng, center.lat - boundsRange.lat], [center.lng + boundsRange.lng, center.lat + boundsRange.lat]],
                center: [lng - this.boundsRange.lng, lat - this.boundsRange.lat], // 初始中心座標，格式為 [lng, lat]
                // center: [120.221420, 23.008305], // 初始中心座標，格式為 [lng, lat]
                zoom: 15, // 初始 ZOOM LEVEL; [0-20, 0 為最小 (遠), 20 ;最大 (近)]
                minZoom: 6, // 限制地圖可縮放之最小等級, 可省略, [0-19.99]
                maxZoom: 19.99, // 限制地圖可縮放之最大等級, 可省略 [0-19.99]
                pitch: 0, // 攝影機仰角, 可省略, [0-60]
                bearing: 0, // 地圖角度, 可省略, [-180 ~ 180; 0 為正北朝上, 180 為正南朝上]
                attributionControl: false,
                speedLoad: false
            };

            //繪製地圖
            var map = new gomp.Map(mapOptions).addControl(new gomp.AttributionControl({
                compact: false
            }));

            //將基本設定戴入到地圖
            map.addControl(new gomp.FullscreenControl({ container: document.querySelector('.map8') })); //放大全螢幕功能
            map.addControl(new gomp.NavigationControl(), 'top-left'); //週邊地圖拉遠拉進設定加入

            //移除map8 logo
            $('.gomp-ctrl-bottom-right').remove();

            //全螢幕放大
            /*
            $('.gomp-ctrl-fullscreen').on('click', function() {
              $('.gomp-canvas').width('100%');
            });
            */

            //---建立物件資料訊息框 start

            var pointsSource = {
                "id": "pois",
                "type": "symbol",
                "source": {
                    "type": "geojson",
                    "data": {
                        "type": "FeatureCollection",
                        "features": [{
                            "type": "Feature",
                            "properties": {
                                "description": "<span style='font-weight:bold;font-size:16px;'>" + mapInfo.title + "</span><br /><span>" + mapInfo.add + "</span>"
                            },
                            "geometry": {
                                "type": "Point",
                                "coordinates": [lng - this.boundsRange.lng, lat - this.boundsRange.lng]
                            }
                        }]
                    }
                },
                "layout": {
                    "icon-image": "marker",
                    "icon-offset": [0, -12],
                    "icon-allow-overlap": true,
                    "icon-size": 0.3
                } //var pointsSource = {
            };var popup = new gomp.Popup({
                anchor: 'bottom',
                closeButton: true,
                closeOnClick: false,
                offset: [0, -42]
            });

            map.on('click', 'pois', function (e) {
                // 設定滑鼠游標樣式
                map.getCanvas().style.cursor = 'pointer';

                var coordinates = e.features[0].geometry.coordinates.slice();
                var description = e.features[0].properties.description;

                // 確保訊息視窗不會被遮擋
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                // 設定訊息視窗內容並在地圖上顯示
                popup.setLngLat(coordinates).setHTML(description).addTo(map);
            });

            //---建立物件資料訊息框 end 


            //設定地圖標記點
            var markerEl = document.createElement('img');
            markerEl.src = './images/marker.png'; // 請代換為您的圖檔之 URL (例如 "https://example.com/image.png")
            markerEl.style = 'width:80px;';

            //建立地圖標記點
            map.on('load', function () {
                var nowMapCenterPoint = map.getCenter();
                /*
                var markerPoint = new gomp.Marker(markerEl, {offset: [0, -21]})
                    .setLngLat(nowMapCenterPoint)
                    .addTo(map);
                */
                map.addImage('marker', markerEl); //加入圖
                map.addLayer(pointsSource); //加入訊息框的layer
            });

            //主標記 & 資訊窗
            // this.mapMarker(myLatLng, map, mapInfo);

            //---周邊設施參數宣告(map8)
            //將基本設定戴入到地圖
            // var gompWebServiceJsClient = new GompWebServiceJsClient({key: gomp.accessToken});


            // var radius = 500;    // 500 公尺
            // var colorIndex = {blue: "#2970C0", green: "#4E9A54", gold: "#D28706", red: "#D63030"};
            var iconArray = ["airport", "bank", "bus", "edu", "gas", "hospital", "office", "park", "parking", "store", "subway", "temple", "train", "conv", "funeral", "trash", "people", "factory"];
            var iconElArray = {};

            //地標圖設定
            iconArray.forEach(function (iconName) {
                var el = document.createElement("img");
                el.src = "images/icons/" + iconName + ".png";
                iconElArray[iconName] = el;
            });

            // console.log('開始mapAround');
            this.mapAround(mapInfo, map); //週邊環境(中心點、地圖參數)
            this.tab_click(mapInfo, map); //點擊周邊環境時觸發，代入物件資料(主要用坐標)，回傳週邊地圖陣列

            //主標記 & 資訊窗
            // this.mapMarker(myLatLng, map, infoWindow, mapInfo);

            // map.addLayer(reData); //代入回傳週邊地圖資料陣列
        } //initialize(mapInfo) {


        /******************週邊環境選擇 tab 按下時 start********************/
        //依中心點，並依點擊的設施，列出相關地標資料並回傳為陣列

    }, {
        key: 'tab_click',
        value: function tab_click(mapInfo, map) {
            var _this = this;

            //---回原點(判斷是否有定位)
            $('#backBtn').on('click', function () {
                map.flyTo({
                    center: [mapInfo.lng - _this.boundsRange.lng, mapInfo.lat - _this.boundsRange.lat], // 中心點
                    zoom: 15 // 縮放比例
                    // pitch: 45 // 頃斜度
                });
            });

            //---選取週邊設施項目(列表項目)
            $("#nearby_amenity li").click(function () {
                // var catValue      = $(this).attr('data-cat');
                // var iconValue     = $(this).find('button').attr('data-type');
                var catValue = $("#nearby_amenity li").find('button[class="actives"]').parents().attr('data-cat');
                var iconValue = $("#nearby_amenity li").find('button[class="actives"]').attr('data-type');
                var distanceValue = $('.distanceTabs li').find('button[class="actives"]').attr('data-distance');

                //判斷學區圖
                // if( iconValue == 'school_district_es') {
                //   //國小
                //   toggleSchoolDistLayers('school_district_es');
                // } else if( iconValue == 'school_district_jhs' ) {
                //   //國中
                //   toggleSchoolDistLayers('school_district_jhs');
                // } else if( iconValue == 'hideAll' ) {
                //   //不顯示學區
                //   toggleSchoolDistLayers('hideAll');  
                // } else {
                //判斷是否有值，有值再標示週邊
                if (catValue == undefined || iconValue == undefined || distanceValue == undefined) {
                    //沒值則切換為清空
                    removeMapAround(map, iconValue);
                } else {
                    if (catValue.length != 0 && iconValue.length != 0 && distanceValue.length != 0) {
                        //皆有值則切換
                        MapAroundDisplay(catValue, iconValue, distanceValue);
                    }
                }
                /*
                if( catValue.length != 0 && iconValue.length != 0 && distanceValue.length != 0) {
                  //皆有值則切換
                  console.log('切換');
                  MapAroundDisplay(catValue, iconValue, distanceValue);
                } 
                */
                // } //if( iconValue == 'school_district_es') {


                // MapAround(catValue, iconValue, distanceValue);
            });

            //---選取距離(列表公里)
            $('.distanceTabs li').click(function () {
                var catValue = $("#nearby_amenity li").find('button[class="actives"]').parents().attr('data-cat');
                var iconValue = $("#nearby_amenity li").find('button[class="actives"]').attr('data-type');
                var distanceValue = $('.distanceTabs li').find('button[class="actives"]').attr('data-distance');

                //判斷是否有值，有值再標示週邊
                if (catValue == undefined || iconValue == undefined || distanceValue == undefined) {
                    removeMapAround(map, iconValue);
                } else {
                    if (catValue.length != 0 && iconValue.length != 0 && distanceValue.length != 0) {
                        //皆有值則切換
                        MapAroundDisplay(catValue, iconValue, distanceValue);
                    }
                }
                /*
                if( catValue.length != 0 && iconValue.length != 0 && distanceValue.length != 0) {
                  //皆有值則切換
                  MapAroundDisplay(catValue, iconValue, distanceValue);
                } 
                */
            }); //$('.distanceTabs li').click(function(){

            //---預設選取第一筆資料
            map.on('load', function () {
                var catValue = $("#nearby_amenity li").find('button[class="actives"]').parents().attr('data-cat');
                var iconValue = $("#nearby_amenity li").find('button[class="actives"]').attr('data-type');
                var distanceValue = $('.distanceTabs li').find('button[class="actives"]').attr('data-distance');
                if (catValue.length != 0 && iconValue.length != 0 && distanceValue.length != 0) {
                    MapAroundDisplay(catValue, iconValue, distanceValue);
                }
            });

            /********************點地圖坐標顯示訊息框*********************/
            var setPopup = function setPopup(feature, distance) {

                //訊息匡參數
                var popup = new gomp.Popup({
                    anchor: 'bottom',
                    closeButton: true,
                    closeOnClick: false,
                    autoPan: true,
                    offset: [0, -12],
                    className: 'my-class'
                });

                // var distance = gompWebServiceJsClient.getDistanceFromLatLngInKm(center.lat, center.lng, feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
                popup.setLngLat(feature.geometry.coordinates).setHTML('<h5 style="font-size: 1.25em;font-weight: bold;">' + feature['properties']['name'] + '</h5>' + (

                // [Jethro 2019-09-91] Port to Map8's Premium / Housing API
                feature["properties"]["formatted_address"].length !== 0 ? '<span class="badge">景點地址</span>' + feature["properties"]["formatted_address"] + '<br />' : '') + '<span class="badge">直線距離</span>' + distance + ' 公尺<br />').addTo(map);
                popup.id = feature.properties.id;

                // 移至 Popup 可見範圍
                var dPWidth = popup._container.offsetWidth;
                var dPHeight = popup._container.offsetHeight;
                var dPX = popup._pos.x;
                var dPY = popup._pos.y;
                var mapW = map.transform.width;
                var mapH = map.transform.height;
                var padding = 20;
                var panPoint = {
                    x: 0,
                    y: 0
                };
                if (dPX < dPWidth / 2 + padding) {
                    panPoint.x = dPX - (dPWidth / 2 + padding);
                }
                if (dPX > mapW - padding - dPWidth / 2) {
                    panPoint.x = dPX - (mapW - dPWidth / 2 - padding);
                }
                if (dPY < dPHeight + padding + 53) {
                    panPoint.y = dPY - (dPHeight + padding + 53);
                }
                if (dPY > mapH - padding) {
                    panPoint.y = dPY - (mapH - padding);
                }
                map.panBy([panPoint.x, panPoint.y]);
            };

            /******************刪除週邊相關資料********************/
            var removeMapAround = function removeMapAround(map, iconValue) {
                //週邊環境移除
                if (map.getLayer("nearby_amenity-style")) {
                    map.removeLayer("nearby_amenity-style"); //清除圖標
                    map.removeSource("nearby_amenity"); //清除資料陣列
                } //if( map.getLayer("nearby_amenity-style") ) {

                //檢查是否已經有此圖像
                if (iconValue != undefined) {
                    if (map.hasImage(iconValue)) {
                        map.removeImage(iconValue);
                    }
                } //if(iconValue != undefined) {

                //全刪掉訊息框資料
                // console.log('圖層數量:'+ $('.gomp-popup .gomp-popup-anchor-bottom').length );
                $('.gomp-popup').remove();

                //移除畫圓資料
                // if( map.getLayer("circle-outline") && map.getLayer("circle-text") && map.getLayer("circle-fill") ) {
                if (map.getLayer("circle-outline")) {

                    map.removeLayer("circle-outline"); //外圍線
                    map.removeSource("circle-outline"); //清除資料陣列

                    map.removeLayer("circle-text"); //字
                    map.removeSource("circle-text"); //清除資料陣列

                    map.removeLayer("circle-fill"); //底色
                    map.removeSource("circle-fill"); //清除資料陣列
                } //if( map.getLayer("circle-outline") ) {  

                //移除範圍資料(列表式)
                $('.place').html(' ');
            }; // removeMapAround(map, iconValue) {

            /******************週邊環境選擇 tab 按下時 end********************/

            // $("#nearby_amenity li").click(function(){
            var MapAroundDisplay = function MapAroundDisplay(catValue, iconValue, distanceValue) {

                _this.removeMapAround(map, iconValue);

                //週邊環境移除
                /*
                if( map.getLayer("nearby_amenity-style") ) {
                  map.removeLayer("nearby_amenity-style"); //清除圖標
                  map.removeSource("nearby_amenity"); //清除資料陣列
                } //if( map.getLayer("nearby_amenity-style") ) {
                  //檢查是否已經有此圖像
                if( map.hasImage( iconValue ) ) {
                  map.removeImage( iconValue );
                }
                  //全刪掉訊息框資料
                // console.log('圖層數量:'+ $('.gomp-popup .gomp-popup-anchor-bottom').length );
                // $('.gomp-popup').remove();
                    //移除畫圓資料
                // if( map.getLayer("circle-outline") && map.getLayer("circle-text") && map.getLayer("circle-fill") ) {
                if( map.getLayer("circle-outline") ) {  
                    map.removeLayer("circle-outline");  //外圍線
                  map.removeSource("circle-outline"); //清除資料陣列
                    map.removeLayer("circle-text"); //字
                  map.removeSource("circle-text"); //清除資料陣列
                    map.removeLayer("circle-fill"); //底色
                  map.removeSource("circle-fill"); //清除資料陣列
                  } //if( map.getLayer("circle-outline") ) {  
                  //移除範圍資料(列表式)
                $('.place').html(' ');
                */

                //抓取範圍
                // var distanceValue = $('.distanceTabs li').find('button[class="active"]').attr('data-distance');

                //抓取所點擊設施的參數
                // var catValue = $(this).attr('data-cat'); //中文(用到搜尋資料用)
                // var iconValue = $(this).find('button').attr('data-type'); //英文代號(用到icon上)
                var radiusValue = distanceValue / 1000; //抓資料範圍
                var colorIndex = { blue: "#2970C0", green: "#4E9A54", gold: "#D28706", red: "#D63030" };

                //map8的key值

                gomp.accessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM';

                //將參數傳進map8抓取坐標資料
                //傳送進 https://api.map8.zone/v2/premium/housing/nearbyNimby 抓取回傳周邊坐標
                var key_url = 'https://api.map8.zone/v2/premium/housing/nearbyAmenity?key=' + gomp.accessToken + '&location=' + mapInfo.lat + '%2C' + mapInfo.lng + '&radius=' + radiusValue + '&cat=' + catValue;

                // console.log(key_url);
                //&limit=10
                var gompWebServiceJsClient = new GompWebServiceJsClient({ key: gomp.accessToken });
                var reData; //週邊地圖結果回傳

                $.ajax({
                    url: key_url,
                    dataType: 'json',
                    async: false //非同步處理
                }).done(function (data) {
                    // console.log(data);
                    //篩選陣列內容
                    reData = data.results.filter(function (item, index, array) {
                        // console.log(item.cat+"---"+catValue);s
                        return item.cat == catValue;
                        // return item.cat.localeCompare(catValue); 
                    }); //done(function( data ) {
                }); //$.ajax({

                // console.log(reData);

                //重新安排陣列
                var Arr = []; //預計紀錄的陣列
                reData.map(function (n) {
                    var geoJ = {
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates": [n.geometry.location.lng, n.geometry.location.lat]
                        },
                        "properties": n
                    };
                    Arr.push(geoJ);
                });

                //周邊設施重排陣列
                var mapString = {
                    "type": "FeatureCollection",
                    "features": Arr
                };

                var popup = new gomp.Popup({
                    anchor: 'bottom',
                    closeButton: true,
                    closeOnClick: false,
                    autoPan: true,
                    offset: [0, -42],
                    className: 'my-class'
                });

                //---把值放入到map8地圖

                //設定對應圖
                var ele = document.createElement("img");
                ele.src = "images/icons/" + iconValue + ".png";

                var icon_array = {};
                icon_array[0] = ele;
                // console.log(icon_array[0]);

                map.addImage(iconValue, icon_array[0]);
                //map.addImage('markerK', map_ele_obj_icon['K']);
                // console.log('圖片載入完畢');
                // console.log(mapString);
                //重新寫入的程式

                map.addSource("nearby_amenity", {
                    "type": "geojson",
                    "data": mapString
                });

                /*
                map.setLayoutProperty(
                  'amenityLayer',
                    // 'twhg-stores',
                      {
                          "stops": [
                            //  zoom level 14 以上才會顯示，故設定 12
                              [12, ""], // zoom level 12 - 18 皆顯示空字串
                              [14, "{NAME}"], // zoom level 18 起才顯示名稱
                          ]
                      }
                )
                */

                //重新加入的圖層
                map.addLayer({
                    id: "nearby_amenity-style",
                    type: "symbol",
                    source: "nearby_amenity",
                    layout: {
                        "icon-image": iconValue,
                        "icon-allow-overlap": true
                    },
                    paint: {
                        "icon-opacity": 1
                    }
                });

                // 訊息圖層
                map.on("mouseenter", 'nearby_amenity-style', function () {
                    map.getCanvas().style.cursor = "pointer";
                });
                map.on("mouseleave", 'nearby_amenity-style', function () {
                    map.getCanvas().style.cursor = "";
                });

                var countvv = 0;
                map.off("click").on("click", 'nearby_amenity-style', function (e) {
                    // map.bind("click", 'nearby_amenity-style', function(e) {
                    // console.log(e);
                    // countvv++;

                    // console.log('點擊nearby_amenity-style次數:'+countvv);

                    var feature = e.features[0]; //參數
                    var distance = gompWebServiceJsClient.getDistanceFromLatLngInKm(mapInfo.lat, mapInfo.lng, feature.geometry.coordinates[1], feature.geometry.coordinates[0]); //距離

                    setPopup(feature, distance);
                    //---將setPopup內容直接移過來
                    /*
                    var distance = gompWebServiceJsClient.getDistanceFromLatLngInKm(mapInfo.lat, mapInfo.lng, feature.geometry.coordinates[1], feature.geometry.coordinates[0]);
                    // console.log(feature.geometry.coordinates);
                    popup
                        .setLngLat(feature.geometry.coordinates)
                        .setHTML(
                            '<h5 style="font-size: 1.25em;font-weight: bold;">' + feature['properties']['name'] + '</h5>' +
                              // [Jethro 2019-09-91] Port to Map8's Premium / Housing API
                            ((feature["properties"]["formatted_address"].length !== 0) ? '<span class="badge">景點地址</span>' + feature["properties"]["formatted_address"] + '<br />' : '') +
                              '<span class="badge">直線距離</span>' + distance + ' 公尺<br />'
                        )
                        .addTo(map);
                        // console.log(distance);
                    popup.id = feature.properties.id;
                      // 移至 Popup 可見範圍
                    var dPWidth = popup._container.offsetWidth;
                    var dPHeight = popup._container.offsetHeight;
                    var dPX = popup._pos.x;
                    var dPY = popup._pos.y;
                    var mapW = map.transform.width;
                    var mapH = map.transform.height;
                    var padding = 20;
                    var panPoint = {
                        x: 0,
                        y: 0
                    };
                    if (dPX < dPWidth / 2 + padding) {
                        panPoint.x = dPX - (dPWidth / 2 + padding);
                    }
                    if (dPX > mapW - padding - dPWidth / 2) {
                        panPoint.x = dPX - (mapW - dPWidth / 2 - padding);
                    }
                    if (dPY < dPHeight + padding + 53) {
                        panPoint.y = dPY - (dPHeight + padding + 53);
                    }
                    if (dPY > mapH - padding) {
                        panPoint.y = dPY - (mapH - padding);
                    }
                    map.panBy([panPoint.x, panPoint.y]);
                    */
                    //---將setPopup內容直接移過來
                });

                // 繪製中心點半徑方圓範圍
                // var circle = turf.circle(turf.point([mapInfo.lng, mapInfo.lat]), radius / 1000, {});

                var circle = turf.circle(turf.point([mapInfo.lng - _this.boundsRange.lng, mapInfo.lat - _this.boundsRange.lat]), radiusValue, {});

                map.addLayer({
                    "id": "circle-fill",
                    "type": "fill",
                    "source": {
                        "type": "geojson",
                        "data": circle
                    },
                    "paint": {
                        "fill-color": colorIndex["blue"],
                        "fill-opacity": 0.2
                    }
                });

                map.addLayer({
                    id: "circle-text",
                    type: "symbol",
                    source: {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [{
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: [mapInfo.lng - _this.boundsRange.lng, mapInfo.lat - _this.boundsRange.lat]
                                }
                            }]
                        }
                    },
                    layout: {
                        'text-allow-overlap': true,
                        'text-field': '半徑 ' + distanceValue + ' 公尺範圍',
                        'text-font': ["Open Sans Regular"],
                        'text-offset': [0, 1],
                        'text-size': 15
                    },
                    paint: {
                        'text-color': colorIndex["blue"],
                        'text-halo-color': '#fff',
                        'text-halo-width': 2
                    }
                });
                map.addLayer({
                    "id": "circle-outline",
                    "type": "line",
                    "source": {
                        "type": "geojson",
                        "data": circle
                    },
                    "paint": {
                        "line-color": "blue",
                        "line-opacity": 0.3,
                        "line-width": 2,
                        "line-offset": 1
                    },
                    "layout": {}
                });

                //週邊地圖資料，放置列表
                reData.forEach(function (item, index, array) {
                    $('.place').append('<li class="mapAroundList"><p class="name" lng="' + item.geometry.location.lng + '" lat="' + item.geometry.location.lat + '" add="' + item.formatted_address + '" distance="' + item.distance * 1000 + '">' + item.name + '</p><p class="distance">約<span>' + item.distance * 1000 + '</span>公尺</p></li>');
                });

                //資料列表點擊觸發
                $('.mapAroundList').on("click", function (e) {
                    //  console.log($(this).find('p').attr('data'));
                    //  console.log(popup);
                    var add = $(this).find('p').attr('add');
                    var lng = $(this).find('p').attr('lng');
                    var lat = $(this).find('p').attr('lat');
                    var object_name = $(this).find('p').html();
                    var distance = $(this).find('p').attr('distance');

                    popup.setLngLat([lng, lat]).setHTML('<h5 style="font-size: 1.25em;font-weight: bold;">' + object_name + '</h5>' + (

                    // [Jethro 2019-09-91] Port to Map8's Premium / Housing API
                    add.length !== 0 ? '<span class="badge">景點地址</span>' + add + '<br />' : '') + '<span class="badge">直線距離</span>' + distance + ' 公尺<br />').addTo(map);

                    // 移至 Popup 可見範圍
                    var dPWidth = popup._container.offsetWidth;
                    var dPHeight = popup._container.offsetHeight;
                    var dPX = popup._pos.x;
                    var dPY = popup._pos.y;
                    var mapW = map.transform.width;
                    var mapH = map.transform.height;
                    var padding = 20;
                    var panPoint = {
                        x: 0,
                        y: 0
                    };
                    if (dPX < dPWidth / 2 + padding) {
                        panPoint.x = dPX - (dPWidth / 2 + padding);
                    }
                    if (dPX > mapW - padding - dPWidth / 2) {
                        panPoint.x = dPX - (mapW - dPWidth / 2 - padding);
                    }
                    if (dPY < dPHeight + padding + 53) {
                        panPoint.y = dPY - (dPHeight + padding + 53);
                    }
                    if (dPY > mapH - padding) {
                        panPoint.y = dPY - (mapH - padding);
                    }
                    map.panBy([panPoint.x, panPoint.y]);
                });

                // }); // $("#nearby_amenity li").click(function(){
            }; //let MapAroundDisplay = (catValue, iconValue, distanceValue) => { 


            /******************學區圖用 start********************/
            var schoolDistType = ["school_district_es", "school_district_jhs"];
            map.once("idle", function () {
                map.addSource("school_dist", {
                    type: "vector",
                    url: "https://api.map8.zone/data/school-district.json"
                });
                schoolDistType.forEach(function (name, i) {
                    map.addLayer({
                        'id': name,
                        'type': "fill",
                        'source': "school_dist",
                        'source-layer': name,
                        'paint': {

                            'fill-color': '#000000',
                            'fill-opacity': 0.7
                        },
                        'layout': {
                            'visibility': 'none'
                        }
                    });
                    map.addLayer({
                        'id': name + '_line_black',
                        'type': "line",
                        'source': "school_dist",
                        'source-layer': name,
                        'paint': {
                            'line-color': name == 'school_district_es' ? '#666' : '#333',
                            'line-opacity': 1,
                            'line-width': 0.5
                        },
                        'layout': {
                            'line-join': 'miter',
                            'visibility': 'none'
                        }
                    });
                    map.addLayer({
                        'id': name + '_line',
                        'type': "line",
                        'source': "school_dist",
                        'source-layer': name,
                        'paint': {
                            'line-color': name == 'school_district_es' ? '#ffff00' : '#ff6f00',
                            'line-opacity': 1,
                            'line-width': 3
                        },
                        'layout': {
                            'line-join': 'miter',
                            'visibility': 'none'
                        }
                    }, name + '_line_black');
                    map.addLayer({
                        'id': name + '_text',
                        'type': "symbol",
                        'source': "school_dist",
                        'source-layer': name,
                        'layout': {
                            'text-field': ['format', ['get', 'schoolname'], {}, '\n ', {}, '學區', { 'font-scale': .8 }],
                            'text-font': ["Open Sans Bold"],
                            'text-size': 15,
                            'visibility': 'none'
                        },
                        'paint': {
                            'text-color': name == 'school_district_es' ? '#ffff00' : '#fc7c21',
                            'text-halo-color': '#000',
                            'text-halo-width': 1
                        }
                    });
                });
            }); //map.once("idle", function() {

            //畫圖線(學區圖)
            var setSchoolDistLayerVisibility = function setSchoolDistLayerVisibility(schoolDistType, visibility) {
                var layerNameSuffixes = ['', '_line', '_line_black', '_text'];
                layerNameSuffixes.forEach(function (v) {
                    map.setLayoutProperty(schoolDistType + v, "visibility", visibility);
                });
            }; //let setSchoolDistLayerVisibility = (schoolDistType, visibility) => {

            //判斷學區圖
            var toggleSchoolDistLayers = function toggleSchoolDistLayers(target) {
                if (target == schoolDistType[0]) {
                    setSchoolDistLayerVisibility(schoolDistType[0], 'visible');
                    setSchoolDistLayerVisibility(schoolDistType[1], 'none');
                } else if (target == schoolDistType[1]) {
                    setSchoolDistLayerVisibility(schoolDistType[0], 'none');
                    setSchoolDistLayerVisibility(schoolDistType[1], 'visible');
                } else {
                    //不顯示
                    setSchoolDistLayerVisibility(schoolDistType[0], 'none');
                    setSchoolDistLayerVisibility(schoolDistType[1], 'none');
                }
            }; //let toggleSchoolDistLayers= (target) => { 

            $(".school_distance").click(function () {
                var iconValue = $(this).attr('data-info'); //抓取學區圖的顯示狀態

                //判斷學區圖
                if (iconValue == 'school_district_es') {
                    //國小
                    toggleSchoolDistLayers('school_district_es');
                } else if (iconValue == 'school_district_jhs') {
                    //國中
                    toggleSchoolDistLayers('school_district_jhs');
                    // } else if( iconValue == 'hideAll' ) {
                    //   //不顯示學區
                    //   toggleSchoolDistLayers('hideAll');
                } else {
                    toggleSchoolDistLayers('hideAll');
                } //if( iconValue == 'school_district_es') {

                // MapAround(catValue, iconValue, distanceValue);
            });
        } //tab_click(mapInfo) {

        /******************學區圖用 end ********************/

        /******************刪除週邊相關資料********************/

    }, {
        key: 'removeMapAround',
        value: function removeMapAround(map, iconValue) {
            //週邊環境移除
            if (map.getLayer("nearby_amenity-style")) {
                map.removeLayer("nearby_amenity-style"); //清除圖標
                map.removeSource("nearby_amenity"); //清除資料陣列
            } //if( map.getLayer("nearby_amenity-style") ) {

            //檢查是否已經有此圖像
            if (map.hasImage(iconValue)) {
                map.removeImage(iconValue);
            }

            //全刪掉訊息框資料
            // console.log('圖層數量:'+ $('.gomp-popup .gomp-popup-anchor-bottom').length );
            $('.gomp-popup').remove();

            //移除畫圓資料
            // if( map.getLayer("circle-outline") && map.getLayer("circle-text") && map.getLayer("circle-fill") ) {
            if (map.getLayer("circle-outline")) {

                map.removeLayer("circle-outline"); //外圍線
                map.removeSource("circle-outline"); //清除資料陣列

                map.removeLayer("circle-text"); //字
                map.removeSource("circle-text"); //清除資料陣列

                map.removeLayer("circle-fill"); //底色
                map.removeSource("circle-fill"); //清除資料陣列
            } //if( map.getLayer("circle-outline") ) {  

            //移除範圍資料(列表式)
            $('.place').html(' ');
        } // removeMapAround(map, iconValue) {

        /******************週邊環境選擇 tab 按下時 end********************/

        //主標記 & 資訊窗
        // mapMarker(myLatLng, map, infoWindow, mapInfo) {

    }, {
        key: 'mapMarker',
        value: function mapMarker(myLatLng, map, mapInfo) {

            //設定訊息框內容
            var pointsSource = {
                "id": "pois",
                "type": "symbol",
                "source": {
                    "type": "geojson",
                    "data": {
                        "type": "FeatureCollection",
                        "features": [{
                            "type": "Feature",
                            "properties": {
                                "description": "<span style='font-weight:bold;font-size:16px;'>" + mapInfo.title + "</span><br /><span>" + mapInfo.add + "</span>"
                            },
                            "geometry": {
                                "type": "Point",
                                "coordinates": [mapInfo.lng, mapInfo.lat]
                            }
                        }]
                    }
                },
                "layout": {
                    "icon-image": "marker",
                    "icon-offset": [0, -12],
                    "icon-allow-overlap": true
                } //var pointsSource = {

            };var popup = new gomp.Popup({
                anchor: 'bottom',
                closeButton: true,
                closeOnClick: false,
                offset: [0, -42]
            });

            map.on('click', 'pois', function (e) {
                // 設定滑鼠游標樣式
                map.getCanvas().style.cursor = 'pointer';

                var coordinates = e.features[0].geometry.coordinates.slice();
                var description = e.features[0].properties.description;

                // 確保訊息視窗不會被遮擋
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }

                // 設定訊息視窗內容並在地圖上顯示
                popup.setLngLat(coordinates).setHTML(description).addTo(map);
            });

            //設定地圖標記點
            var markerEl = document.createElement('img');
            markerEl.src = '../images/marker.png'; // 請代換為您的圖檔之 URL (例如 "https://example.com/image.png")
            markerEl.style = 'width:80px;';

            //建立地圖標記點
            map.on('load', function () {
                var nowMapCenterPoint = map.getCenter();
                map.addImage('marker', markerEl); //加入圖
                map.addLayer(pointsSource); //加入訊息框的layer
            });
        } //mapMarker(myLatLng, map, infoWindow, mapInfo) { 

        //週邊環境
        // mapAround(myLatLng, map, infoWindow, service) {

    }, {
        key: 'mapAround',
        value: function mapAround(center, map) {

            var box = $('#locationSearch');
            var locationBtn = box.find('#locationBtn');
            var classTabs = box.find('.classTabs button');
            var distanceTabs = box.find('.distanceTabs button');
            var la = box.find('.place');
            var distance = 0;
            var place = '';
            var markers = [];
            var markerPopup = [];

            box.find('.classTabs li').on('click', function (h) {
                // console.log(h.currentTarget.innerHTML);

            });

            //標記

            var createMarkers = function createMarkers(pm) {}

            // let placeLoc = pm.geometry.location;
            /*
            let marker = new google.maps.Marker({
              map     : map,
              position: placeLoc
            });
            */
            /*
            原本註解
            marker.setIcon({
              url:'bank.png',
              size: new google.maps.Size(70, 71),
              anchor: new google.maps.Point(17, 14),
              scaledSize: new google.maps.Size(35, 35)
            });
            */
            /*
             marker.setMap(map);
               //計算兩點之間距離
             let meters = google.maps.geometry.spherical.computeDistanceBetween(myLatLng, placeLoc);
               //輸出地點(列表式)
             la.append('<li><p class="name">' + pm.name + '</p><p class="distance">約<span>' + Math.round(meters) + '</span>公尺</p></li>');
               //資訊窗
             let infoDOM = '<p class="name">' + pm.name + '</p>';
             google.maps.event.addListener(marker, 'click', function() {
               map.panTo(placeLoc);
               //infoWindow.setContent(pm.name);
               infoWindow.setContent(infoDOM);
               infoWindow.open(map, this);
             });
               markers.push(marker);
             */


            //搜索標記 & 選擇地點
            // let publicMarkers = (myLatLng) => {
            ;var publicMarkers = function publicMarkers(center) {}

            //週邊環境移除
            // console.log('開始移除');
            // if(map.getLayer("nearby_amenity-style")) {
            // map.removeLayer("nearby_amenity-style");
            // map.removeSource("nearby_amenity"); //清除資料陣列
            // }


            /*
            let request = {
              location: myLatLng,
              radius  : distance,
              type    : place
            };
            let placeLatLng = [];
            let placeName   = [];
            
            service.nearbySearch(request, function(results, status) {
              if (status == google.maps.places.PlacesServiceStatus.OK) {
                clearMarkers();
                for (let i = 0; i < results.length; i++) {
                  createMarkers(results[i]);
                  placeLatLng.push(results[i].geometry.location);
                  placeName.push(results[i].name);
                }
                //選擇地點
                la.find('li').each((i, e) => {
                  $(e).on('click', () => {
                    la.find('li').removeClass('active');
                    $(e).addClass('active');
                    map.panTo(placeLatLng[i]);
                    infoWindow.setContent(placeName[i]);
                    infoWindow.open(map, markers[i]);
                  });
                });
              }else{
                clearMarkers();
                if (results.length == 0) {
                  la.append('<li class="disabled">尚無相關資訊</li>');
                }
              }
            });
            */

            //列表開啟 & 關閉
            ;locationBtn.on('click', function () {
                // console.log('開啟周邊設施選單');
                box.toggleClass('active');
                // console.log('結束周邊設施選單');
            });

            //類型切換
            classTabs.each(function (i, e) {
                // console.log(e);
                if (i == 0) {
                    //預設順序第一個選取
                    $(e).addClass('actives');
                    place = $(e).data('type');
                }

                $(e).on('click', function () {
                    // console.log(e);
                    // classTabs.removeClass('actives');
                    // $(e).addClass('actives');
                    // place = $(e).data('type');
                    if ($(e).attr('class') == 'actives') {
                        //同筆開關
                        classTabs.removeClass('actives');
                    } else {
                        //切換他筆
                        classTabs.removeClass('actives');
                        $(e).addClass('actives');
                        place = $(e).data('type');
                    }
                });
            });

            //方圓距離切換
            distanceTabs.each(function (i, e) {
                if (i == 0) {
                    $(e).addClass('actives');
                    distance = $(e).data('distance');
                }
                $(e).on('click', function () {

                    if ($(e).attr('class') == 'actives') {
                        //同筆開關
                        distanceTabs.removeClass('actives');
                    } else {
                        //切換他筆
                        distanceTabs.removeClass('actives');
                        $(e).addClass('actives');
                    }
                    /*
                    distanceTabs.removeClass('actives');
                    $(e).addClass('actives');
                    /*/
                    // distance = $(e).data('distance');
                    // publicMarkers(myLatLng);
                });
            });

            //預設輸出
            // publicMarkers(myLatLng);

        } //mapAround(center, map) {


        //輸出

    }, {
        key: 'mapAPI',
        value: function mapAPI() {
            var _this2 = this;

            //這段只有一開始會進來
            //AJAX 匯入
            if (this.rd.length > 0) {
                $.ajax({
                    type: "POST",
                    url: 'map.php',
                    data: {
                        nav: this.nav, //昀寬多加
                        mt: this.mt,
                        id: this.id
                    },
                    success: function success(mapData) {
                        //加入DOM
                        _this2.rd.append(mapData);
                        // $('.map8').html(mapData);
                        // $('.map8').html('333');

                        var map = $(_this2.map);
                        var mapInfo = {
                            el: _this2.map,
                            lat: map.data('lat'),
                            lng: map.data('lng'),
                            title: map.data('title'),
                            add: map.data('add'),
                            option: map.data('option')
                        };
                        // $('.map8').html('222');
                        //將物件放在中心點
                        _this2.initialize(mapInfo);
                    }
                });
            }
        }
    }]);

    return MapRealtyDetail;
}();

//地圖找屋


var MapRealtySearch = function () {
    function MapRealtySearch() {
        _classCallCheck(this, MapRealtySearch);

        // this.markerclusterer = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js';

        //台灣圖霸api key
        this.gompAccessToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM';

        this.mapBox = $('#mapSearch');
        this.map = '#mapCanvasSearch';
        this.loading = $('#loadingMapData');

        this.headerEl = $('header');
        this.containerEl = $('#container');
        this.locationEl = this.containerEl.find('#location');
        this.pageTitleEl = this.containerEl.find('.pageTitle');

        this.mapTools = $('#mapTools');
        this.lineDrawBtn = this.mapTools.find('#lineDrawBtn'); //訂閱畫線按鈕
        this.objsListBtn = this.mapTools.find('#objsListBtn');
        this.searchMapBtn = this.mapTools.find('#searchMapBtn');
        this.backBtn = this.mapTools.find('#backBtn');

        this.locationSearch = $('#locationSearch');
        this.toggleBox = this.locationSearch.find('.toggleBox');
        this.loadingObjs = $('#loadingObjsData');
        this.lineDrawData = this.toggleBox.find('#lineDrawData'); //畫線說明內容
        this.ajaxObjsList = this.toggleBox.find('.ajaxObjsList'); //物件列表
        this.mapSearchForm = $('#mapSearchForm'); //搜尋物件條件
        this.submitMapBtn = this.mapSearchForm.find('#submitMapBtn'); //搜尋按鈕
        this.subscriptionBtn = this.mapSearchForm.find('#subscriptionBtn'); //訂閱按鈕

        this.lineDrawDataBtn = this.lineDrawData.find('.btn'); //地圖圈選按鈕
        this.mapLineDrawDistance = this.mapSearchForm.find('.mapLineDrawDistance'); //選圈選距離
        // console.log(this.submitMapBtn);

        //偏移距離
        this.boundsRange = {
            // lat: 0.013, 
            // lng: 0.022
            lat: 0.0003,
            lng: 0.0001
        };
    }

    //自適應高度


    _createClass(MapRealtySearch, [{
        key: 'rwdHeight',
        value: function rwdHeight() {
            var resultH = 0;
            var windowH = $(window).height();
            if (window.matchMedia('(min-width: 1280px)').matches) {
                this.locationEl.show();
                this.pageTitleEl.show();
                resultH = windowH - this.headerEl.outerHeight() - (this.locationEl.outerHeight() + this.pageTitleEl.outerHeight());
            } else {
                this.locationEl.hide();
                this.pageTitleEl.hide();
                resultH = windowH - this.headerEl.outerHeight();
            }
            this.mapBox.css('height', resultH);
        }

        //全螢幕

    }, {
        key: 'fullscreenMap',
        value: function fullscreenMap() {
            var _this3 = this;

            this.locationEl.css({
                maxWidth: '100%',
                margin: 0
            });
            this.pageTitleEl.find('.box').css({
                maxWidth: '100%',
                margin: 0
            });
            this.containerEl.find('.area').css({
                maxWidth: '100%',
                margin: 0
            });
            this.rwdHeight(); //自適應高度
            $(window).on('resize', function () {
                _this3.rwdHeight();
            });
        }

        //列表 & 搜尋切換

    }, {
        key: 'locationSearchToggle',
        value: function locationSearchToggle() {
            var _this4 = this;

            //列表 & 搜尋 (含 RWD)
            var resizeToggle = function resizeToggle() {
                //清空前一次事件
                _this4.lineDrawBtn.off('click'); //關閉地圖圈訂閱
                _this4.objsListBtn.off('click');
                _this4.searchMapBtn.off('click');

                if (window.matchMedia('(max-width: 1279px)').matches) {

                    if (_this4.locationSearch.is('.active')) {

                        /*
                        if(this.toggleBox.is('.active')){
                          //開搜尋條件
                          this.searchMapBtn.addClass('active'); //open
                          this.objsListBtn.removeClass('active'); //close
                          this.lineDrawBtn.removeClass('active'); //close
                        }else{
                          
                          //開列表
                          this.objsListBtn.addClass('active'); //open
                          this.searchMapBtn.removeClass('active'); //close
                          this.lineDrawBtn.removeClass('active'); //close
                        }
                        */
                    } else {
                        //全關
                        _this4.objsListBtn.removeClass('active'); //close
                        _this4.searchMapBtn.removeClass('active'); //close
                        _this4.lineDrawBtn.removeClass('active'); //close
                        _this4.toggleBox.removeClass('active2');
                    } // if(this.locationSearch.is('.active')){


                    //列表
                    _this4.objsListBtn.on('click', function (e) {
                        var $this = $(e.currentTarget);
                        $this.toggleClass('active');
                        _this4.searchMapBtn.removeClass('active');
                        _this4.lineDrawData.removeClass('active');
                        // this.toggleBox.removeClass('active');
                        _this4.toggleBox.removeClass('active2');
                        _this4.toggleBox.addClass('active');

                        if ($this.is('.active')) {
                            _this4.locationSearch.addClass('active');
                        } else {
                            _this4.locationSearch.removeClass('active');
                        }
                    });
                    //搜尋
                    _this4.searchMapBtn.on('click', function (e) {
                        var $this = $(e.currentTarget);
                        $this.toggleClass('active');
                        _this4.objsListBtn.removeClass('active');
                        _this4.lineDrawData.removeClass('active');
                        _this4.toggleBox.addClass('active2');

                        if ($this.is('.active')) {
                            _this4.locationSearch.addClass('active');
                        } else {
                            _this4.locationSearch.removeClass('active');
                        }
                    });
                    //畫圖訂閱
                    _this4.lineDrawBtn.on('click', function (e) {

                        var $this = $(e.currentTarget);
                        $this.toggleClass('active');

                        //將其它已打開的選項關閉
                        _this4.objsListBtn.removeClass('active');
                        _this4.searchMapBtn.removeClass('active');
                        _this4.toggleBox.removeClass('active');
                        _this4.toggleBox.removeClass('active2');

                        if ($this.is('.active')) {
                            _this4.locationSearch.addClass('active');
                        } else {
                            _this4.locationSearch.removeClass('active');
                        }
                        // console.log(this.lineDrawData);

                        // if($this.is('.active')){
                        //   this.lineDrawData.addClass('active');
                        // }else{
                        //   this.lineDrawData.removeClass('active');
                        // }
                    });
                } else {
                    _this4.objsListBtn.addClass('active');
                    _this4.searchMapBtn.removeClass('active');
                    _this4.locationSearch.removeClass('active');
                    _this4.toggleBox.removeClass('active');

                    //列表
                    _this4.objsListBtn.on('click', function (e) {
                        var $this = $(e.currentTarget);
                        $this.addClass('active');
                        _this4.searchMapBtn.removeClass('active');
                        _this4.locationSearch.addClass('active');
                        _this4.toggleBox.removeClass('active');
                    });
                    //搜尋
                    _this4.searchMapBtn.on('click', function (e) {
                        var $this = $(e.currentTarget);
                        $this.addClass('active');
                        _this4.objsListBtn.removeClass('active');
                        _this4.locationSearch.addClass('active');
                        _this4.toggleBox.addClass('active');
                    });
                    //畫圖訂閱
                    _this4.lineDrawBtn.on('click', function (e) {
                        /*
                        const $this = $(e.currentTarget);
                        $this.addClass('active');
                        this.objsListBtn.removeClass('active');
                        this.locationSearch.addClass('active');
                        this.toggleBox.addClass('active');
                        */
                        var $this = $(e.currentTarget);
                        $this.toggleClass('active');

                        //將其它已打開的選項關閉
                        _this4.objsListBtn.removeClass('active');
                        _this4.searchMapBtn.removeClass('active');
                        _this4.toggleBox.removeClass('active');

                        // console.log(this.lineDrawData);

                        // if($this.is('.active')){
                        //   this.lineDrawData.addClass('active');
                        // }else{
                        //   this.lineDrawData.removeClass('active');
                        // }
                    });
                }

                //畫面關閉按鈕
                // this.objsListBtn_close = $('#objsListBtn_close');
                _this4.objsListBtn_close = $('.objsListBtn_close');

                //列表關閉
                _this4.objsListBtn_close.on('click', function (e) {
                    $('#locationSearch').removeClass('active'); //畫布上層
                    $('.toggleBox').removeClass('active'); //搜尋畫布
                    $('.toggleBox').removeClass('active2');
                    $('#searchMapBtn').removeClass('active'); //搜尋條件
                    $('#objsListBtn').removeClass('active'); //物件列表
                    $('#lineDrawBtn').removeClass('active'); //訂閱
                });

                //按下訂閱按鈕全關(到地圖圈選)
                /*
                this.lineDrawDataBtn.on('click', (e) => {
                  $('#locationSearch').removeClass('active'); //畫布上層
                  $('.toggleBox').removeClass('active'); //搜尋畫布
                  $('.toggleBox').removeClass('active2');
                  $('#searchMapBtn').removeClass('active'); //搜尋條件
                  $('#objsListBtn').removeClass('active'); //物件列表
                  $('#lineDrawBtn').removeClass('active'); //訂閱
                    //改變滑鼠手勢
                  console.log(this.map);
                  // this.map.getCanvas().style.cursor = 'crosshair';
                  // this.map.style.cursor = 'crosshair';
                  // this.mapBox.css("cursor","crosshair");
                    //先將地圖上的物件移除
                  var draw = new gompDraw({
                      displayControlsDefault: false,
                      controls: {
                          polygon: true,
                          trash: true
                      }
                  });
                  
                  map.addControl(draw);
                    // clickDistance();
                  }); //this.lineDrawDataBtn.on('click', (e) => {
                */

                /* ****** 建立中央點並畫圈 start ****** */

                // let clickDistance = () => {
                // map.getCanvas().style.cursor = 'crosshair';
                // map.on('click', function(e) {
                // console.log('測試');
                // });
                // } //clickDistance() {


                /* ****** 建立中央點並畫圈 end ****** */

                //按下距離全關
                _this4.mapLineDrawDistance.on('click', function (e) {

                    $('#locationSearch').removeClass('active'); //畫布上層
                    $('.toggleBox').removeClass('active'); //搜尋畫布
                    $('.toggleBox').removeClass('active2');
                    $('#searchMapBtn').removeClass('active'); //搜尋條件
                    $('#objsListBtn').removeClass('active'); //物件列表
                    $('#lineDrawBtn').removeClass('active'); //訂閱
                }); //this.mapLineDrawDistance.on('click', (e) => {
            }; // let resizeToggle = () => {

            resizeToggle();
            $(window).on('resize', resizeToggle);

            //送出搜尋返回列表
            this.submitMapBtn.on('click', function () {
                _this4.toggleBox.removeClass('active');

                if (window.matchMedia('(max-width: 1279px)').matches) {
                    _this4.locationSearch.removeClass('active');
                    _this4.lineDrawBtn.removeClass('active'); //關閉畫圖訂閱
                } else {
                    _this4.objsListBtn.addClass('active');
                    _this4.searchMapBtn.removeClass('active');
                    _this4.lineDrawBtn.removeClass('active'); //關閉畫圖訂閱
                }
            });
        }
        //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)

    }, {
        key: 'locationSearchBack',
        value: function locationSearchBack() {
            if (window.matchMedia('(max-width: 1279px)').matches) {
                this.locationSearch.removeClass('active');
                this.toggleBox.removeClass('active');
                this.searchMapBtn.removeClass('active');
                this.objsListBtn.removeClass('active');
                this.lineDrawBtn.removeClass('active'); //關閉畫圖訂閱
            }
        } //locationSearchBack() {

        //重整資訊，弄成適合map8的陣列資料

    }, {
        key: 'markerInfoWindow',
        value: function markerInfoWindow(jsonArray) {
            var content = ""; //訊息內容參數
            var typePrice = 0;

            //資料庫引入物件資料
            var objLat = jsonArray.lat;
            var objLng = jsonArray.lng;
            var objId = jsonArray.object_info_id;
            var objTitle = jsonArray.case_name;
            var objType = jsonArray.commission_model;
            var objClass = jsonArray.land_name;
            var add = jsonArray.outer_address;
            var floor = jsonArray.t_floor;
            var floorB = jsonArray.r_floor;
            var room = jsonArray.room_nums;
            var livingR = jsonArray.living_room_nums;
            var wc = jsonArray.bathroom_nums;
            var age = jsonArray.c_date;
            var imgFolder = jsonArray.object_img_folder;
            var imgName = jsonArray.img_name;
            var price = parseInt(jsonArray.co_price).toFixed(0);
            var rent = parseInt(jsonArray.c_rent).toFixed(0);
            var rentM = jsonArray.c_rent_month;

            //---製作視窗內容 start

            // content += "<div style='cursor: pointer;' onclick=window.open('?nav=buy_d&id="+objId+"')>";
            content += "<div style='cursor: pointer;' onclick=window.open('?nav=all_object_d&id=" + objId + "')>";
            //案名
            content += "<h3 style='color:#008ed8;font-size: 1rem;font-weight: 700;margin:0 0 5px 0;'>" + objTitle + "</h3>";
            //外部地址
            content += "<p style='color: #555;margin:0  0 3px 0;line-height: 1.25rem;'>" + add + "</p>";

            //建物類型、地坪
            content += "<p style='color: #555;margin:0 0 3px 0;line-height: 1.25rem;'>";
            content += "<font style='color:#008ed8;font-weight:bold;'>" + objClass + "</font> ";
            content += "| 地坪 : <font style='color:#008ed8;font-weight:bold;'>" + floorB + "</font> 坪</p>";

            //格局(房廳衛、屋齡)
            if (objClass == '建地' || objClass == '農地' || objClass == '工業地' || objClass == '土地(其他)') {
                content += "";
            } else {
                content += "<p style='color: #555;margin:0 0 3px 0;line-height: 1.25rem;'>";
                content += "格局 : <font style='color:#008ed8;font-weight:bold'>" + room + "</font> 房 ";
                content += "<font style='color:#008ed8;font-weight:bold'>" + livingR + "</font> 廳 ";
                content += "<font style='color:#008ed8;font-weight:bold'>" + wc + "</font> 衛 ";
                content += "| 屋齡 : <font style='color:#008ed8;font-weight:bold'>" + age + "</font> 年";
                content += "</p>";
            }
            //價格(區分租金、買價)
            if (objType == '售案' || objType == '租售案') {
                content += "<p style='color: #555;margin:0 0 3px 0;line-height: 1.25rem;'>總價 : <font style='color:red;font-weight:bold;'>" + price + " 萬</p>";
                typePrice = price;
            }
            if (objType == '租案' || objType == '租售案') {
                content += "<p style='color: #555;margin:0 0 3px 0;line-height: 1.25rem;'>租金 : <font style='color:red;font-weight:bold;'>" + rent + "元 / " + rentM + " 個月</p>";
                typePrice = rent;
            }

            content += "<br><img src='https://singfujia.s3.hicloud.net.tw/item/object/more_large/" + imgFolder + "/" + imgName + "' style='width:150px;'>";
            content += "</div>";

            //傳送數據
            var feature = {
                'type': 'Feature',
                'geometry': {
                    'type': 'point',
                    'coordinates': [objLng, objLat]
                },
                'properties': {
                    "name": objTitle,
                    "cost": typePrice,
                    "description": content,
                    "image-url": "https://singfujia.s3.hicloud.net.tw/item/object/more_large/" + imgFolder + "/" + imgName
                }

            };

            return feature;
        } //markerInfoWindow() {

        //自動定位到目前的位置，並檢查瀏覽器是否支援定位服務
        //因 HTML5 navigator.geolocation 與 Google Map 不支援ES6， 所以採用 ES5 寫法

    }, {
        key: 'positioning',
        value: function positioning(map, myLatLng) {
            var option = {
                enableHighAccuracy: true,
                timeout: 60000,
                maximumAge: 0
            };
            var userLocation = void 0;
            var $gpsBtn = $('#gpsBtn');

            //隱藏 GPS 按鈕
            $gpsBtn.parent().hide();

            //判斷是否支援定位服務
            if (navigator.geolocation) {
                // alert('啟動定位');
                //取得使用者現在座標位置並顯示
                // console.log('進入1');
                navigator.geolocation.getCurrentPosition(displayAndWatch, errorCallback, option);
            } else {
                // alert('預設定位');
                // console.log('進入2');
                //回到預設座標
                map.panTo(myLatLng);
                // alert('您目前的設備不支援定位服務');
                Swal.fire('您目前的設備不支援定位服務');
            }

            //GPS錯誤訊息
            function errorCallback(error) {
                var errorTypes = {
                    0: '不明原因錯誤',
                    //1: '使用者拒絕提供位置資訊',
                    1: 'GPS定位服務尚未開啟\n開啟後請再重整瀏覽器',
                    2: '無法取得位置資訊',
                    3: '位置查詢逾時'
                };
                //let errorMessage = 'error code=' + error.code + '\n' + error.message + '\n' + errorTypes[error.code];
                var errorMessage = errorTypes[error.code];
                // alert(errorMessage);
                Swal.fire(errorMessage);
            }

            //回原點 & RWD
            function backPoint(pos) {
                //取得座標
                // let getLocation = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);

                //回原點
                $('#backBtn').on('click', function () {
                    //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)
                    if (window.matchMedia('(max-width: 1279px)').matches) {
                        $('#locationSearch').removeClass('active');
                        $('.toggleBox').removeClass('active');
                        $('#searchMapBtn').removeClass('active');
                        $('#objsListBtn').removeClass('active');
                    }
                    map.panTo(getLocation);
                });
                //RWD
                /*
                google.maps.event.clearInstanceListeners(window);
                google.maps.event.addDomListener(window, 'resize', () => {
                  google.maps.event.trigger(map, 'resize');
                  map.panTo(getLocation);
                });
                */
            }

            function displayAndWatch(position) {
                //定位目前使用者座標位置
                setUserLocation(position);
                //判斷行動裝置，是否開啟 & 關閉監聽使用者座標位置是否移動 (GPS模式)
                if (_common.checkDevice.ios || _common.checkDevice.android) {
                    watchCurrentPosition();
                }
                //回原點 & RWD
                backPoint(position);
            }

            //定位目前使用者座標位置
            function setUserLocation(pos) {

                //地圖縮放
                map.setZoom(17);
                //取得座標
                // let getLocation = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
                //顯示標記
                var markerSize = 80;
                /*
                userLocation = new google.maps.Marker({
                  position: getLocation,
                  map     : map,
                  icon    : {
                    url       : 'images/marker0.png',
                    scaledSize: new google.maps.Size(markerSize, markerSize),
                    origin    : new google.maps.Point(0, 0),
                    anchor    : new google.maps.Point(markerSize / 2, markerSize / 2)
                  },
                });
                */
                function location() {
                    map.panTo(getLocation);
                }
                location();
                /*
                google.maps.event.addListener(userLocation, 'click', function() {
                  location();
                });
                */
            }

            //開啟 & 關閉監聽使用者座標位置是否移動 (GPS模式)
            function watchCurrentPosition() {
                var positionTimer = void 0;
                $gpsBtn.parent().show();
                $gpsBtn.off('click').on('click', function () {
                    // console.log('222');
                    $(this).toggleClass('active');
                    if ($(this).is('.active')) {
                        positionTimer = navigator.geolocation.watchPosition(function (position) {
                            //定位移動過後使用者座標位置
                            setMarkerPosition(userLocation, position);
                            // map.panTo(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
                            //回原點 & RWD
                            backPoint(position);
                            //console.log(position)
                        });
                    } else {
                        navigator.geolocation.clearWatch(positionTimer);
                    }
                });
                //搜尋送出後，停止GPS模式
                $('#submitMapBtn').on('click', function () {
                    $gpsBtn.removeClass('active');
                    navigator.geolocation.clearWatch(positionTimer);
                });
            }

            //定位移動後使用者座標位置
            function setMarkerPosition(marker, position) {
                //  marker.setPosition(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
                //  console.log(position);
            }
        }

        //Google Map 地理編碼城市文字回傳坐標，城市有資料時則進入重新定位
        // getCity(map, geocoder) {

    }, {
        key: 'getCity',
        value: function getCity(map) {
            var _this5 = this;

            var city = this.mapSearchForm.find('input[name=city]:checked').val(); //縣市

            var area = this.mapSearchForm.find('input[name=area]:checked').val(); //區域
            var areaRecord = this.mapSearchForm.find('.areaClass').val(); //訂閱-區域
            var areaValue = ''; //送出區域內容

            var keyword = this.mapSearchForm.find('input[name=map_keyword_value]').val(); //關鍵字
            var latlngData = '';

            var zoomValue = 12;
            if (keyword != '') {
                //關鍵字有值拉近
                zoomValue = 15;
            }

            var codeAdd = function codeAdd(cityArea) {

                //https://api.map8.zone/place/geocode/json?
                //https://api.map8.zone/v2/place/geocode/json?key=
                $.ajax({
                    url: "https://api.map8.zone/v2/place/geocode/json?key=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ3d3cuc2luZ2Z1amlhLmNvbSIsIm5hbWUiOiJnbjAxODE2NTY1QGdtYWlsLmNvbSIsImlhdCI6MTU3NjU4NDU1NCwib2JqZWN0cyI6WyJcL2RhdGEiLCJcL21hcHNcL2pzIiwiXC9zdHlsZXMiLCJcL3BsYWNlXC9maW5kcGxhY2Vmcm9tdGV4dCIsIlwvcGxhY2VcL25lYXJieXNlYXJjaCIsIlwvcGxhY2VcL3RleHRzZWFyY2giLCJcL3BsYWNlXC9hdXRvY29tcGxldGUiLCJcL3BsYWNlXC9nZW9jb2RlIiwiXC9tYXBzXC9zdGF0aWMiLCJcL3JvdXRlXC9jYXIiLCJcL3JvdXRlXC9mb290IiwiXC9yb3V0ZVwvYmljeWNsZSIsIlwvcm91dGVcL3JvYWQiLCJcL2RhdGFcL3NjaG9vbC1kaXN0cmljdCIsIlwvcHJlbWl1bVwvaG91c2luZyIsIlwvcHJlbWl1bVwvaG91c2luZ1wvc2Nob29sZGlzdHJpY3RzIl0sImV4cCI6MTg5MjIwMzc1NH0.mKErgRpPQqSp8dgRDhx-tvufuL-b1D9VzQlDYIFNEWM&address=" + cityArea,
                    context: document.body,
                    async: false
                }).done(function (results) {
                    $(this).addClass("done");
                    latlngData = results.results[0].geometry.location;
                    // map.panTo(results.results[0].geometry.location);
                    map.flyTo({
                        center: results.results[0].geometry.location, // 中心點
                        zoom: zoomValue // 縮放比例
                        // pitch: 45 // 頃斜度
                    });
                });
            }; //let codeAdd = (cityArea) => {

            var backPoint = function backPoint(txt) {
                //回原點
                _this5.backBtn.off('click').on('click', function () {
                    //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)
                    _this5.locationSearchBack();
                    codeAdd(txt);
                });
            };

            //判斷區
            if (typeof area === 'undefined') {
                if (typeof areaRecord === 'undefined') {
                    areaRecord = '';
                } else {
                    areaValue = areaRecord;
                }
            } else {
                areaValue = area;
            }

            if (city != undefined) {
                if (areaValue == '') {
                    if (city == '金門縣' || city == '澎湖縣') {
                        codeAdd(city);
                        backPoint(city);
                    } else {
                        codeAdd(city.replace(/市/, "") + '火車站');
                        backPoint(city.replace(/市/, "") + '火車站');
                    }
                } else {
                    // codeAdd(city + area+'衛生所');
                    // backPoint(city + area+'衛生所');
                    codeAdd(city + areaValue);
                    backPoint(city + areaValue);
                }
            }
            //'S'為物件編號
            if (keyword != '' && keyword.indexOf('S') == -1 && keyword.indexOf('s') == -1) {
                //console.log('丟台灣圖霸');
                //非搜尋物件編號
                codeAdd(keyword);
                backPoint(keyword);
            }
            /*
            if(keyword != '' && (keyword.indexOf('S') == 0 || keyword.indexOf('s') == 0) ){  
              console.log('丟公司資料庫');
                //非搜尋物件編號
              // codeAdd(keyword);
              // backPoint(keyword);
            }
            */
            return latlngData; //回傳中心點
        } //getCity(map) {  

        //AJAX連接資料庫引入物件資料(行為：初始，搜尋輸入框未輸入編號)
        // ajaxAllObjSearch(map, infoWindow, markerClusterer) {

    }, {
        key: 'ajaxAllObjSearch',
        value: function ajaxAllObjSearch(map, mapInfo) {
            var _this6 = this;

            // console.log('ajaxAllObjSearch進入');
            //引入資料變數
            var markerList = [];
            var markers = [];
            // console.log(map.getLayer('pois'));

            var ajaxSQL = function ajaxSQL() {
                //Loading 開啟
                _this6.loading.addClass('active');
                var ajaxFile = 'ajax_map_search.php';
                var formData = _this6.mapSearchForm.serializeArray();

                //取得畫面範圍座標
                var bounds = map.getBounds();
                var sw = bounds.getSouthWest();
                var ne = bounds.getNorthEast();
                var swLat = sw.lat;
                var swLng = sw.lng;
                var neLat = ne.lat;
                var neLng = ne.lng;

                //判斷官網與業務版
                var personalId = $('#personalIdVal').val();

                //Ajax 連結 MySQL 資料庫 (地圖 Google Map 地點標記僅引入 json 格式)
                //Ajax 連結 MySQL 資料庫 (此部份列表已完善，map8更新坐標需製作)
                // console.log('執行撈全部資料');

                $.post(ajaxFile, {
                    type: 'all',
                    sw_Lat: swLat,
                    sw_Lng: swLng,
                    ne_Lat: neLat,
                    ne_Lng: neLng,
                    // personal_id: personalId,
                    dataType: 'json',
                    contentType: 'application/json; charset=UTF-8',
                    data: JSON.stringify(formData)
                }, function (json) {
                    //搜尋完的資料陣列
                    // console.log('進到全列資料');
                    // console.log(json);

                    //去掉因Null出現的空白
                    json = json.replace(/\u0000/g, '').replace(/\\u0000/g, "");
                    json = JSON.parse(json); //編譯為json


                    //要用在map8的陣列
                    var arrayMap8Data = {
                        'type': 'FeatureCollection',
                        'features': new Array()
                    };

                    //Loading 關閉
                    _this6.loading.removeClass('active');

                    //載入資料庫物件資料
                    for (var index in json) {

                        //資料庫引入物件資料
                        // console.log(this.boundsRange.lat);
                        json[index].lat = json[index].lat - _this6.boundsRange.lat;
                        json[index].lng = json[index].lng - _this6.boundsRange.lng;
                        var objLat = json[index].lat;
                        var objLng = json[index].lng;

                        //核對經緯度是否有重覆的物件，如有就跳過 (增加效能用)
                        var isInList = function isInList(lat, lng) {
                            for (var i in markerList) {
                                if (markerList[i].t == lat && markerList[i].g == lng) {
                                    return true;
                                }
                            }
                            return false;
                        };

                        if (isInList(objLat, objLng)) {
                            continue;
                        }

                        //加入標記 & 資訊窗(使用帶出的json資料，代入map8圖層，將資料整理成適合map8的json格式)
                        var feature = _this6.markerInfoWindow(json[index]);

                        //將已點擊的圖標變為紅色

                        //加到主陣列
                        arrayMap8Data['features'].push(feature);

                        //---製作視窗內容 end
                    } //for(let index in json){

                    // console.log(arrayMap8Data);
                    //更新地圖上坐標資料

                    // markerClusterer.setGridSize(mcOptions.gridSize);
                    // markerClusterer.setMaxZoom(mcOptions.maxZoom);
                    // markerClusterer.setStyles(mcOptions.styles);
                    // markerClusterer.addMarkers(markers);
                    // console.log(arrayMap8Data); 
                    // console.log('二次');
                    // var searchList = '';

                    // 移除地圖相關數據
                    // if(map.getLayer('clusters')) {
                    //   map.removeLayer('clusters');//移除群組最大點
                    // }
                    // if(map.getLayer('cluster-count')) {
                    //   map.removeLayer('cluster-count'); //移除群組數字
                    // }
                    // if(map.getLayer('pois')) {
                    //   map.removeLayer('pois'); //移除最小坐標點
                    // }
                    // map.removeSource('housesale'); //移除舊的數據資料陣列

                    //更新地圖數據
                    if (map.getSource('housesale')) {
                        map.getSource('housesale').setData(arrayMap8Data);
                    }

                    // }, 'json');
                });

                // --- (右側物件列表)
                //Ajax 連結 MySQL 資料庫 (右側物件列表)
                var objList = function objList(nowPage) {
                    //Loading 開啟
                    _this6.loadingObjs.addClass('active');

                    $.post(ajaxFile, {
                        type: 'allList',
                        sw_Lat: swLat,
                        sw_Lng: swLng,
                        ne_Lat: neLat,
                        ne_Lng: neLng,
                        personal_id: personalId,
                        data: JSON.stringify(formData),
                        nowPage: nowPage
                    }, function (data) {
                        // console.log(data);

                        //Loading 關閉
                        _this6.loadingObjs.removeClass('active');

                        //刪除原先物件列表
                        _this6.ajaxObjsList.empty();
                        //加入物件列表
                        _this6.ajaxObjsList.append(data);
                        //圖片延遲載入並裁切
                        var lazyLoad = new _lazyload.LazyLoad();
                        lazyLoad.scrollImgLoad();
                        //頁碼點擊後換頁、引入下一筆資料
                        _this6.toggleBox.find('.pagination a').each(function (i, e) {
                            $(e).on('click', function () {
                                objList($(e).data('page'));
                            });
                        });

                        //畫面關閉按鈕
                        // this.objsListBtn_close = $('#objsListBtn_close');
                        _this6.objsListBtn_close = $('.objsListBtn_close');

                        //列表關閉
                        _this6.objsListBtn_close.on('click', function (e) {
                            $('#locationSearch').removeClass('active');
                            $('#lineDrawData').removeClass('active'); //關閉畫線說明內容
                            $('.toggleBox').removeClass('active');
                            $('#searchMapBtn').removeClass('active');
                            $('#objsListBtn').removeClass('active');
                        });
                    });
                }; //let objList = (nowPage) => {
                objList();
            }; //let ajaxSQL = () => {

            //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)
            var locationSearchBack = function locationSearchBack() {
                _this6.locationSearchBack();
            };

            //載入前先標記清空(含集合)
            var markerClear = function markerClear() {
                if (markers.length > 0) {
                    for (var i = 0; i < markers.length; i++) {
                        if (markers[i]) {
                            markers[i].setMap(null); //標記清空
                        }
                    }
                    markerList = [];
                    markers = [];
                }
            };

            //加入事件並引入資料顯示標記
            var mapupdater = void 0;

            //無任何動作
            map.on('load', function () {
                // $(document).on('load', () => {
                // console.log(map);

                // map.load( () => {  
                mapupdater = setTimeout(ajaxSQL, 500);

                //視窗拖曳事件 start
                map.on('dragstart', function () {
                    mapupdater = setTimeout(ajaxSQL, 500);
                });

                //視窗放大縮小 start
                map.on('zoomstart', function () {
                    mapupdater = setTimeout(ajaxSQL, 500);
                });
            }); //map.on('load', function() {

        } //ajaxAllObjSearch(map, mapInfo) { 

        //AJAX連接資料庫引入物件資料(行為：搜尋輸入框已輸入編號)

    }, {
        key: 'ajaxOnlyObjSearch',
        value: function ajaxOnlyObjSearch(map, infoWindow) {
            var _this7 = this;

            //Loading 開啟
            this.loading.addClass('active');
            this.loadingObjs.removeClass('active');

            var ajaxFile = 'ajax_map_search.php';
            var formData = this.mapSearchForm.serializeArray();

            //引入資料變數
            var markerList = [];

            //判斷官網與業務版
            var personalId = $('#personalIdVal').val();

            //Ajax 連結 MySQL 資料庫 (地圖 Google Map 地點標記僅引入 json 格式)
            $.post(ajaxFile, {
                type: 'only',
                dataType: 'json',
                contentType: 'application/json; charset=UTF-8',
                // personal_id: personalId,
                data: JSON.stringify(formData)
            }, function (json) {
                // },function(json) {  

                //去掉因Null出現的空白
                json = json.replace(/\u0000/g, '').replace(/\\u0000/g, "");
                json = JSON.parse(json); //編譯為json


                //要用在map8的陣列
                var arrayMap8Data = {
                    'type': 'FeatureCollection',
                    'features': new Array()
                };

                //Loading 關閉
                _this7.loading.removeClass('active');

                // console.log(json2);
                //載入資料庫物件資料

                var _loop = function _loop(index) {

                    //資料庫引入物件資料
                    // console.log(this.boundsRange.lat);
                    var objLat = json[index].lat - _this7.boundsRange.lat;
                    var objLng = json[index].lng - _this7.boundsRange.lng;

                    //核對經緯度是否有重覆的物件，如有就跳過 (增加效能用)
                    var isInList = function isInList(lat, lng) {
                        for (var i in markerList) {
                            if (markerList[i].t == lat && markerList[i].g == lng) {
                                return true;
                            }
                        }
                        return false;
                    };
                    if (isInList(objLat, objLng)) {
                        return 'continue';
                    }

                    //加入標記 & 資訊窗(使用帶出的json資料，代入map8圖層，將資料整理成適合map8的json格式)
                    var feature = _this7.markerInfoWindow(json[index]);

                    //加到主陣列
                    arrayMap8Data['features'].push(feature);

                    //更新地圖上的數據
                    map.on('load', function () {
                        if (map.getSource('housesale')) {
                            map.getSource('housesale').setData(arrayMap8Data);
                        } //if(map.getSource('housesale')) { 
                    });

                    // console.log(arrayMap8Data);

                    //中心點移置到該物件
                    map.flyTo({
                        center: [objLng, objLat], // 中心點
                        zoom: 15 // 縮放比例 
                        // pitch: 45 // 頃斜度
                    });

                    //回原點
                    _this7.backBtn.off('click').on('click', function () {
                        //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)
                        _this7.locationSearchBack();
                        // map.panTo(objLatLng);
                        map.flyTo({
                            center: [objLng, objLat], // 中心點
                            zoom: 15 // 縮放比例
                            // pitch: 45 // 頃斜度
                        });
                    });

                    //加入已核對陣列
                    /*
                    markerList.push({
                      t: objLat,
                      g: objLng
                    });
                    */

                    //RWD
                    /*
                    google.maps.event.clearInstanceListeners(window);
                    google.maps.event.addDomListener(window, 'resize', () => {
                      google.maps.event.trigger(map, 'resize');
                      map.panTo(objLatLng);
                    });
                    */
                };

                for (var index in json) {
                    var _ret = _loop(index);

                    if (_ret === 'continue') continue;
                } //for end
                // }, 'json');
            });

            //Ajax 連結 MySQL 資料庫 (右側物件列表)
            $.post(ajaxFile, {
                type: 'onlyList',
                personal_id: personalId,
                data: JSON.stringify(formData)
            }, function (data) {
                //console.log(data);

                //Loading 關閉
                _this7.loadingObjs.removeClass('active');

                //刪除原先物件列表
                _this7.ajaxObjsList.empty();
                //加入物件列表
                _this7.ajaxObjsList.append(data);
                //圖片延遲載入並裁切
                var lazyLoad = new _lazyload.LazyLoad();
                lazyLoad.scrollImgLoad();

                //畫面關閉按鈕
                // this.objsListBtn_close = $('#objsListBtn_close');
                _this7.objsListBtn_close = $('.objsListBtn_close');

                //列表關閉
                _this7.objsListBtn_close.on('click', function (e) {
                    $('#locationSearch').removeClass('active');
                    $('#lineDrawData').removeClass('active'); //關閉畫線說明內容
                    $('.toggleBox').removeClass('active');
                    $('#searchMapBtn').removeClass('active');
                    $('#objsListBtn').removeClass('active');
                });
            });
        } //ajaxOnlyObjSearch(map, infoWindow) {


        /* **************** 學區圖處理 start ************/
        /*
        schoolDist(map) {
          var schoolDistType = ["school_district_es", "school_district_jhs"];
          map.once("idle", function() {
              map.addSource("school_dist", {
                  type: "vector",
                  url: "https://api.map8.zone/data/school-district.json"
              });
              schoolDistType.forEach(function(name, i) {
                  map.addLayer({
                      'id': name,
                      'type': "fill",
                      'source': "school_dist",
                      'source-layer': name,
                      'paint': {
                            'fill-color': '#000000',
                          'fill-opacity': 0.7
                      },
                      'layout': {
                          'visibility': 'none'
                      }
                  });
                  map.addLayer({
                      'id': name + '_line_black',
                      'type': "line",
                      'source': "school_dist",
                      'source-layer': name,
                      'paint': {
                          'line-color': (name == 'school_district_es') ? '#666' : '#333',
                          'line-opacity': 1,
                          'line-width': 0.5
                      },
                      'layout': {
                          'line-join': 'miter',
                          'visibility': 'none'
                      }
                  });
                  map.addLayer({
                      'id': name + '_line',
                      'type': "line",
                      'source': "school_dist",
                      'source-layer': name,
                      'paint': {
                          'line-color': (name == 'school_district_es') ? '#ffff00' : '#ff6f00',
                          'line-opacity': 1,
                          'line-width': 3
                      },
                      'layout': {
                          'line-join': 'miter',
                          'visibility': 'none'
                      }
                  }, name + '_line_black');
                  map.addLayer({
                      'id': name + '_text',
                      'type': "symbol",
                      'source': "school_dist",
                      'source-layer': name,
                      'layout': {
                          'text-field': [
                              'format',
                              ['get', 'schoolname'], {},
                              '\n ', {},
                              '學區', {'font-scale': .8},
                          ],
                          'text-font': ["Open Sans Bold"],
                          'text-size': 15,
                          'visibility': 'none'
                      },
                      'paint': {
                          'text-color': (name == 'school_district_es') ? '#ffff00' : '#fc7c21',
                          'text-halo-color': '#000',
                          'text-halo-width': 1
                      }
                  });
              }); 
          });
            //--學區線 css 設定
          var schoolDistOptions = {
            'school_district_es': {
                'common_fill-color': '#C2C200', 
                'common_fill-opacity': 0.3,
                'common_text-color': '#333',
                'common_text-halo-color': '#fff',
                'highlight_fill-color': '#C2C200',
                'highlight_fill-opacity': 0.4,
                'highlight_text-color': '#ffff00',
                'highlight_text-halo-color': '#000',//文字
                'highlightSchool': [''],
                'darkLineColor': '#C2C200',
                'lightLineColor': '#ffff00'
            },
            'school_district_jhs': {
                'common_fill-color': '#ff6f00',
                'common_fill-opacity': 0.15,
                'common_text-color': '#333',
                'common_text-halo-color': '#fff',
                'highlight_fill-color': '#ff6f00',
                'highlight_fill-opacity': 0.5,
                'highlight_text-color': '#ff6f00',
                'highlight_text-halo-color': '#000',//文字
                'highlightSchool': [''],
                'darkLineColor': '#ff6f00',
                'lightLineColor': '#ff6f00'
            }
          } //var schoolDistOptions = {
          
          //畫圖線
          let setSchoolDistLayerVisibility = (schoolDistType, visibility) => { 
            var layerNameSuffixes = ['', '_line', '_line_black', '_text'];
            layerNameSuffixes.forEach(function(v) {
                map.setLayoutProperty(schoolDistType + v, "visibility", visibility);
            });
          } //let setSchoolDistLayerVisibility = (schoolDistType, visibility) => {
            //判斷學區圖
          let toggleSchoolDistLayers = (target) => { 
            // console.log('進到toggleSchoolDistLayers');
            if (target == schoolDistType[0]) {
                setSchoolDistLayerVisibility(schoolDistType[0], 'visible');
                setSchoolDistLayerVisibility(schoolDistType[1], 'none');
            } else if (target == schoolDistType[1]) {
                setSchoolDistLayerVisibility(schoolDistType[0], 'none');
                setSchoolDistLayerVisibility(schoolDistType[1], 'visible');
            } else {
                //不顯示
                setSchoolDistLayerVisibility(schoolDistType[0], 'none');
                setSchoolDistLayerVisibility(schoolDistType[1], 'none');
            }
          } //let toggleSchoolDistLayers= (target) => { 
        } //schoolDist(map) {
          */
        /* **************** 學區圖處理 end ************/

        //整合 & API 導入繪製地圖

    }, {
        key: 'initialize',
        value: function initialize(mapInfo, mapZoom) {
            var _this8 = this;

            // initialize(mapInfo) {  
            this.loading.addClass('active'); //一開始讀取就打開loading畫面

            var lat = mapInfo.lat;
            var lng = mapInfo.lng;
            var myLatLng = [lng, lat];
            var boundsRange = {
                lat: 0.013,
                lng: 0.022
                // console.log(mapInfo.lat);
                // console.log(mapInfo.lng);

                //台灣圖霸api key
            };gomp.accessToken = this.gompAccessToken;
            // console.log('地圖找房');
            //地圖基本設定
            var mapOptions = {
                container: 'mapCanvasSearch', // 地圖容器 ID
                // style: 'https://api.map8.zone/styles/go-life-maps-tw-style-std/style.json', // 地圖樣式檔案位置
                style: 'https://api.map8.zone/styles/go-life-maps-tw-style-singfujia-0e0150b5/style.json',
                maxBounds: [[105, 15], [138.45858, 33.4]], // 台灣地圖區域
                // maxBounds: [[center.lng - boundsRange.lng, center.lat - boundsRange.lat], [center.lng + boundsRange.lng, center.lat + boundsRange.lat]],
                center: [lng, lat], // 初始中心座標，格式為 [lng, lat]
                // center: [120.221420, 23.008305], // 初始中心座標，格式為 [lng, lat]
                zoom: 15, // 初始 ZOOM LEVEL; [0-20, 0 為最小 (遠), 20 ;最大 (近)]
                // zoom: mapZoom, // 初始 ZOOM LEVEL; [0-20, 0 為最小 (遠), 20 ;最大 (近)]
                minZoom: 6, // 限制地圖可縮放之最小等級, 可省略, [0-19.99]
                maxZoom: 19.99, // 限制地圖可縮放之最大等級, 可省略 [0-19.99]
                pitch: 0, // 攝影機仰角, 可省略, [0-60]
                bearing: 0, // 地圖角度, 可省略, [-180 ~ 180; 0 為正北朝上, 180 為正南朝上]
                attributionControl: false,
                speedLoad: false
            };

            //全螢幕(先偵測畫面大小並放置適合大小)
            this.fullscreenMap();

            //繪製地圖
            var map = new gomp.Map(mapOptions).addControl(new gomp.AttributionControl({
                compact: false
            }));

            // map.addControl(new gomp.NavigationControl(), 'top-left'); //週邊地圖拉遠拉進設定加入

            //列表 & 搜尋切換
            this.locationSearchToggle();

            //設定地圖標記點
            var markerEl = document.createElement('img');
            markerEl.src = './images/marker.png'; // 請代換為您的圖檔之 URL (例如 "https://example.com/image.png")
            markerEl.style = 'width:80px;';

            map.on('click', 'pois', function (e) {
                // 設定滑鼠游標樣式
                map.getCanvas().style.cursor = 'pointer';

                var coordinates = e.features[0].geometry.coordinates.slice();
                var description = e.features[0].properties.description;

                // 確保訊息視窗不會被遮擋
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
            });

            // this.schoolDist(map); //學區圖處理


            /****** 學區圖 start *******/
            var schoolDistType = ["school_district_es", "school_district_jhs"];
            map.once("idle", function () {
                map.addSource("school_dist", {
                    type: "vector",
                    url: "https://api.map8.zone/data/school-district.json"
                });
                schoolDistType.forEach(function (name, i) {
                    map.addLayer({
                        'id': name,
                        'type': "fill",
                        'source': "school_dist",
                        'source-layer': name,
                        'paint': {

                            'fill-color': '#000000',
                            'fill-opacity': 0.7
                        },
                        'layout': {
                            'visibility': 'none'
                        }
                    });
                    map.addLayer({
                        'id': name + '_line_black',
                        'type': "line",
                        'source': "school_dist",
                        'source-layer': name,
                        'paint': {
                            'line-color': name == 'school_district_es' ? '#666' : '#333',
                            'line-opacity': 1,
                            'line-width': 0.5
                        },
                        'layout': {
                            'line-join': 'miter',
                            'visibility': 'none'
                        }
                    });
                    map.addLayer({
                        'id': name + '_line',
                        'type': "line",
                        'source': "school_dist",
                        'source-layer': name,
                        'paint': {
                            'line-color': name == 'school_district_es' ? '#ffff00' : '#ff6f00',
                            'line-opacity': 1,
                            'line-width': 3
                        },
                        'layout': {
                            'line-join': 'miter',
                            'visibility': 'none'
                        }
                    }, name + '_line_black');
                    map.addLayer({
                        'id': name + '_text',
                        'type': "symbol",
                        'source': "school_dist",
                        'source-layer': name,
                        'layout': {
                            'text-field': ['format', ['get', 'schoolname'], {}, '\n ', {}, '學區', { 'font-scale': .8 }],
                            'text-font': ["Open Sans Bold"],
                            'text-size': 15,
                            'visibility': 'none'
                        },
                        'paint': {
                            'text-color': name == 'school_district_es' ? '#ffff00' : '#fc7c21',
                            'text-halo-color': '#000',
                            'text-halo-width': 1
                        }
                    });
                });
            });

            //--學區線 css 設定
            /*
            var schoolDistOptions = {
              'school_district_es': {
                  'common_fill-color': '#C2C200', 
                  'common_fill-opacity': 0.3,
                  'common_text-color': '#333',
                  'common_text-halo-color': '#fff',
                  'highlight_fill-color': '#C2C200',
                  'highlight_fill-opacity': 0.4,
                  'highlight_text-color': '#ffff00',
                  'highlight_text-halo-color': '#000',//文字
                  'highlightSchool': [''],
                  'darkLineColor': '#C2C200',
                  'lightLineColor': '#ffff00'
              },
              'school_district_jhs': {
                  'common_fill-color': '#ff6f00',
                  'common_fill-opacity': 0.15,
                  'common_text-color': '#333',
                  'common_text-halo-color': '#fff',
                  'highlight_fill-color': '#ff6f00',
                  'highlight_fill-opacity': 0.5,
                  'highlight_text-color': '#ff6f00',
                  'highlight_text-halo-color': '#000',//文字
                  'highlightSchool': [''],
                  'darkLineColor': '#ff6f00',
                  'lightLineColor': '#ff6f00'
              }
            } //var schoolDistOptions = {
            */
            //畫圖線
            var setSchoolDistLayerVisibility = function setSchoolDistLayerVisibility(schoolDistType, visibility) {
                var layerNameSuffixes = ['', '_line', '_line_black', '_text'];
                layerNameSuffixes.forEach(function (v) {
                    map.setLayoutProperty(schoolDistType + v, "visibility", visibility);
                });
            }; //let setSchoolDistLayerVisibility = (schoolDistType, visibility) => {

            //判斷學區圖
            var toggleSchoolDistLayers = function toggleSchoolDistLayers(target) {
                // console.log('進到toggleSchoolDistLayers');
                if (target == schoolDistType[0]) {
                    setSchoolDistLayerVisibility(schoolDistType[0], 'visible');
                    setSchoolDistLayerVisibility(schoolDistType[1], 'none');
                } else if (target == schoolDistType[1]) {
                    setSchoolDistLayerVisibility(schoolDistType[0], 'none');
                    setSchoolDistLayerVisibility(schoolDistType[1], 'visible');
                } else {
                    //不顯示
                    setSchoolDistLayerVisibility(schoolDistType[0], 'none');
                    setSchoolDistLayerVisibility(schoolDistType[1], 'none');
                }
            }; //let toggleSchoolDistLayers = (target) => { 
            /******學區圖 end ********/

            /********設定畫圖圈選設定 start ********/

            /*
            var draw = new gompDraw({
                displayControlsDefault: false,
                controls: {
                    polygon: true, //多邊形
                    trash: true
                }
            });
            
            map.addControl(draw);
              var coordinateContainer = document.getElementById('coordindate');
              map.on('draw.create', updateArea);
            map.on('draw.delete', updateArea);
            map.on('draw.update', updateArea);
              
            // updateArea() {
            let updateArea = (e) => { 
                var data = draw.getAll();
                coordinateContainer.innerHTML = '';
                if (data.features.length > 0) {
                    data.features.forEach(function(feature) {
                        feature.geometry.coordinates[0].forEach(function(coordinate) {
                            coordinateContainer.innerHTML += '[' + coordinate.join(', ') + '] (' + Math.round(map.project(coordinate).x) + ', ' + Math.round(map.project(coordinate).y) + ')<br />';
                            // console.log( Math.round(map.project(coordinate).x) + '::' +  Math.round(map.project(coordinate).y) );
                            // console.log(e);
                          });
                    });
                }
            }
            */

            /********設定畫圖控制 end ********/

            /*** 判斷一開始進頁面，自動畫圈的判斷 start */

            var drawDistanceValue = function drawDistanceValue(distanceValue, distance_lng, distance_lat) {

                //畫圈
                var radiusValue = distanceValue / 1000; //抓資料範圍
                var colorIndex = { blue: "#2970C0", green: "#4E9A54", gold: "#D28706", red: "#D63030" };

                var popup = new gomp.Popup({
                    anchor: 'bottom',
                    closeButton: true,
                    closeOnClick: false,
                    autoPan: true,
                    offset: [0, -42],
                    className: 'my-class'
                });

                //---把值放入到map8地圖

                // 繪製中心點半徑方圓範圍
                // var circle = turf.circle(turf.point([mapInfo.lng, mapInfo.lat]), radius / 1000, {});
                var circle = turf.circle(turf.point([distance_lng, distance_lat]), radiusValue, {});

                //先讓地圖加載完，再戴入style
                map.on('load', function () {
                    map.addLayer({
                        "id": "circle-fill",
                        "type": "fill",
                        "source": {
                            "type": "geojson",
                            "data": circle
                        },
                        "paint": {
                            "fill-color": colorIndex["blue"],
                            "fill-opacity": 0.2
                        }
                    });

                    map.addLayer({
                        id: "circle-text",
                        type: "symbol",
                        source: {
                            type: "geojson",
                            data: {
                                type: "FeatureCollection",
                                features: [{
                                    type: "Feature",
                                    geometry: {
                                        type: "Point",
                                        coordinates: [distance_lng, distance_lat]
                                    }
                                }]
                            }
                        },
                        layout: {
                            'text-allow-overlap': true,
                            'text-field': '半徑 ' + distanceValue + ' 公尺範圍',
                            'text-font': ["Open Sans Regular"],
                            'text-offset': [0, 1],
                            'text-size': 15
                        },
                        paint: {
                            'text-color': colorIndex["blue"],
                            'text-halo-color': '#fff',
                            'text-halo-width': 2
                        }
                    });

                    //圓圈外框線
                    map.addLayer({
                        "id": "circle-outline",
                        "type": "line",
                        "source": {
                            "type": "geojson",
                            "data": circle
                        },
                        "paint": {
                            "line-color": "blue",
                            "line-opacity": 0.3,
                            "line-width": 2,
                            "line-offset": 1
                        },
                        "layout": {}
                    });

                    //中心點移置到該範圍
                    map.setCenter([distance_lng, distance_lat]); //移動中心點
                    map.setZoom(13); //縮放
                }); // map.on('load', function() {

            }; //let drawDistanceValue = (distanceValue, distance_lng, distance_lat) => {

            //一開始加載，確認是否有資料
            var distanceRadio_val = $('.search_distance_none').find('input[name=distanceRadio]:checked').val();
            var distance_lng = $('#distance_lng').val();
            var distance_lat = $('#distance_lat').val();

            if (distanceRadio_val && distance_lng && distance_lat) {
                drawDistanceValue(distanceRadio_val, distance_lng, distance_lat); //執行進function
            }

            /*** 判斷一開始進頁面，自動畫圈的判斷 end */

            /******* 設定圈選按鈕 strt ****** */

            //按下訂閱按鈕全關(到地圖圈選)
            /*
            $('#lineDrawData').find('button').each((i, e) => {
              $(e).on('click', () => {  
                  //關閉選單
                $('#locationSearch').removeClass('active'); //畫布上層
                $('.toggleBox').removeClass('active'); //搜尋畫布
                $('.toggleBox').removeClass('active2');
                $('#searchMapBtn').removeClass('active'); //搜尋條件
                $('#objsListBtn').removeClass('active'); //物件列表
                $('#lineDrawBtn').removeClass('active'); //訂閱
                  // 移除地圖上的物件資料
                map.getSource('housesale').setData({ 'type': 'FeatureCollection', 'features': [] });
                  // 移除畫圖資料
                if( map.getLayer("circle-outline") ) {  
            
                  map.removeLayer("circle-outline");  //外圍線
                  map.removeSource("circle-outline"); //清除資料陣列
                      map.removeLayer("circle-text"); //字
                  map.removeSource("circle-text"); //清除資料陣列
                      map.removeLayer("circle-fill"); //底色
                  map.removeSource("circle-fill"); //清除資料陣列
                    } //if( map.getLayer("circle-outline") ) {  
            
                //改變滑鼠手勢
                map.getCanvas().style.cursor = 'crosshair';
                  //範圍指定給參數
                distanceValue = $(e).data('value'); 
                  //開啟畫地圖圈選
                mouseStatus = true;
                }); //$(e).on('click', () => {  
            });  //$('#lineDrawData').find('button').each((i, e) => {
            */

            var distanceValue = 500; //範圍, 預設500
            var mouseStatus = false; //切換圈選方式，預設開啟
            $('.fa-xmark').hide(); //預設把X關起來
            $('#drawRound_div').hide(); //預設按鈕不顯示

            $('#drawRound').on('click', function (e) {

                //打開X，關掉O
                $('.fa-xmark').show();
                $('.fa-o').hide();

                // 移除地圖上的物件資料
                map.getSource('housesale').setData({ 'type': 'FeatureCollection', 'features': [] });

                // 移除畫圖資料
                if (map.getLayer("circle-outline")) {

                    map.removeLayer("circle-outline"); //外圍線
                    map.removeSource("circle-outline"); //清除資料陣列

                    map.removeLayer("circle-text"); //字
                    map.removeSource("circle-text"); //清除資料陣列

                    map.removeLayer("circle-fill"); //底色
                    map.removeSource("circle-fill"); //清除資料陣列
                } //if( map.getLayer("circle-outline") ) {  

                //改變滑鼠手勢
                map.getCanvas().style.cursor = 'crosshair';

                //範圍指定給參數
                // distanceValue = $(e).data('value'); 
                distanceValue = 1000;

                //開啟畫地圖圈選
                mouseStatus = true;
            }); //$('#drawRound').on('click', () => {


            //按下條件搜尋的距離(搜尋bar關)
            $('.mapLineDrawDistance').find('button').each(function (i, e) {
                $(e).on('click', function () {

                    //開啟icon範圍button
                    $('#drawRound_div').show(); //按鈕開啟

                    //關閉選單
                    $('#locationSearch').removeClass('active'); //畫布上層
                    $('.toggleBox').removeClass('active'); //搜尋畫布
                    $('.toggleBox').removeClass('active2');
                    $('#searchMapBtn').removeClass('active'); //搜尋條件
                    $('#objsListBtn').removeClass('active'); //物件列表
                    $('#lineDrawBtn').removeClass('active'); //訂閱

                    // 移除地圖上的物件資料
                    map.getSource('housesale').setData({ 'type': 'FeatureCollection', 'features': [] });

                    // 移除畫圖資料
                    if (map.getLayer("circle-outline")) {

                        map.removeLayer("circle-outline"); //外圍線
                        map.removeSource("circle-outline"); //清除資料陣列

                        map.removeLayer("circle-text"); //字
                        map.removeSource("circle-text"); //清除資料陣列

                        map.removeLayer("circle-fill"); //底色
                        map.removeSource("circle-fill"); //清除資料陣列
                    } //if( map.getLayer("circle-outline") ) {  

                    //改變滑鼠手勢
                    map.getCanvas().style.cursor = 'crosshair';

                    //範圍指定給參數
                    distanceValue = $(e).data('value');

                    //開啟畫地圖圈選
                    mouseStatus = true;
                }); //$(e).on('click', () => {  
            }); //$('#lineDrawData').find('button').each((i, e) => {


            map.on('mousedown', function (f) {

                //打開X，關掉O
                $('.fa-xmark').hide();
                $('.fa-o').show();

                //點擊地圖 start

                //先判斷是否為連續畫圈

                if (mouseStatus == false) {
                    return false;
                } //if(mouseStatus == false) {

                // drawDistanceValue(distanceValue, f.lngLat.lng, f.lngLat.lat); //執行進function

                //畫圈
                var radiusValue = distanceValue / 1000; //抓資料範圍
                var colorIndex = { blue: "#2970C0", green: "#4E9A54", gold: "#D28706", red: "#D63030" };

                var popup = new gomp.Popup({
                    anchor: 'bottom',
                    closeButton: true,
                    closeOnClick: false,
                    autoPan: true,
                    offset: [0, -42],
                    className: 'my-class'
                });

                //---把值放入到map8地圖

                // 繪製中心點半徑方圓範圍
                // var circle = turf.circle(turf.point([mapInfo.lng, mapInfo.lat]), radius / 1000, {});
                var circle = turf.circle(turf.point([f.lngLat.lng, f.lngLat.lat]), radiusValue, {});

                map.addLayer({
                    "id": "circle-fill",
                    "type": "fill",
                    "source": {
                        "type": "geojson",
                        "data": circle
                    },
                    "paint": {
                        "fill-color": colorIndex["blue"],
                        "fill-opacity": 0.2
                    }
                });

                map.addLayer({
                    id: "circle-text",
                    type: "symbol",
                    source: {
                        type: "geojson",
                        data: {
                            type: "FeatureCollection",
                            features: [{
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: [f.lngLat.lng, f.lngLat.lat]
                                }
                            }]
                        }
                    },
                    layout: {
                        'text-allow-overlap': true,
                        'text-field': '半徑 ' + distanceValue + ' 公尺範圍',
                        'text-font': ["Open Sans Regular"],
                        'text-offset': [0, 1],
                        'text-size': 15
                    },
                    paint: {
                        'text-color': colorIndex["blue"],
                        'text-halo-color': '#fff',
                        'text-halo-width': 2
                    }
                });

                //圓圈外框線
                map.addLayer({
                    "id": "circle-outline",
                    "type": "line",
                    "source": {
                        "type": "geojson",
                        "data": circle
                    },
                    "paint": {
                        "line-color": "blue",
                        "line-opacity": 0.3,
                        "line-width": 2,
                        "line-offset": 1
                    },
                    "layout": {}
                });

                //中心點移置到該範圍
                map.setCenter([f.lngLat.lng, f.lngLat.lat]); //移動中心點
                map.setZoom(13); //縮放

                // 將圈內的物件資料列出，因使用紀有的搜尋，呼叫this.ajaxAllObjSearch，因此在此將範圍跟中心點丟進form裡去搜尋
                $('#distance_lat').val(f.lngLat.lat);
                $('#distance_lng').val(f.lngLat.lng);

                $('input[name=distanceRadio]').attr('checked', false); //先將選取的全取消
                $('input[name=distanceRadio]').each(function () {

                    if ($(this).val() == distanceValue) {
                        // console.log($(this).val() );
                        // $(this).attr('checked', 'checked'); //範圍數字一致時，就選取起來
                        $(this).attr('checked', true); //範圍數字一致時，就選取起來
                    } else {
                        $(this).attr('checked', false);
                    }
                });

                //搜尋bar的按鈕做選取
                $('.mapLineDrawDistance').find('button').removeClass('select_radio_button'); //先將選取的全取消
                $('.mapLineDrawDistance').find('button').each(function () {
                    if ($(this).val() == distanceValue) {
                        $(this).addClass('select_radio_button'); //範圍數字一致時，就選取起來
                    } else {
                        $(this).removeClass('select_radio_button'); //不一致則取消
                    }
                });

                //滑鼠還原成手指
                map.getCanvas().style.cursor = 'pointer';

                //關閉畫圖
                mouseStatus = false;

                //列出圈選區塊物件
                var ajaxFile = 'ajax_map_search.php'; //呼叫資料路徑

                //取得畫面範圍座標
                //引入資料變數
                var markerList = [];
                var markers = [];
                // console.log('更新地圖物件開始');
                // console.log('distance_value' + ':');

                $.post(ajaxFile, {
                    'type': 'distance',
                    'center_lat': f.lngLat.lat,
                    'center_lng': f.lngLat.lng,
                    'distance_value': distanceValue
                }, function (json) {
                    //搜尋完的資料陣列
                    // console.log('ajax出來數據');
                    // console.log(json);

                    //要用在map8的陣列

                    var arrayMap8Data = {
                        'type': 'FeatureCollection',
                        'features': new Array()
                    };

                    //Loading 關閉
                    _this8.loading.removeClass('active');

                    //載入資料庫物件資料
                    for (var index in json) {

                        //資料庫引入物件資料
                        var _objLat = json[index].lat;
                        var _objLng = json[index].lng;

                        //核對經緯度是否有重覆的物件，如有就跳過 (增加效能用)
                        var isInList = function isInList(lat, lng) {

                            for (var i in markerList) {
                                if (markerList[i].t == lat && markerList[i].g == lng) {
                                    return true;
                                }
                            }
                            return false;
                        };

                        if (isInList(_objLat, _objLng)) {
                            continue;
                        }

                        //加入標記 & 資訊窗(使用帶出的json資料，代入map8圖層，將資料整理成適合map8的json格式)
                        var feature = _this8.markerInfoWindow(json[index]);

                        //將已點擊的圖標變為紅色

                        //加到主陣列
                        arrayMap8Data['features'].push(feature);

                        //---製作視窗內容 end
                    } //for(let index in json){

                    // console.log(arrayMap8Data);

                    //更新地圖數據
                    if (map.getSource('housesale')) {
                        map.getSource('housesale').setData(arrayMap8Data);
                    }

                    //用完清空
                    var markerClear = function markerClear() {
                        if (markers.length > 0) {
                            for (var i = 0; i < markers.length; i++) {
                                if (markers[i]) {
                                    markers[i].setMap(null); //標記清空
                                }
                            }
                            markerList = [];
                            markers = [];
                        }
                    };
                }, 'json'); //$.post(ajaxFile, {


                // //更新地圖數據
                // if(map.getSource('housesale')) { 
                //   map.getSource('housesale').setData(arrayMap8Data);
                // }


                //觸發搜尋(地圖更新)

                // el  : map,
                // let mapInfo = {
                //   el  : "#mapCanvasSearch",
                //   zoom: 14,
                //   lat : f.lngLat.lat,
                //   lng : f.lngLat.lng
                // };
                // this.initialize(mapInfo, mapInfo.zoom);

                // console.log(mapInfo);

                // this.ajaxAllObjSearch({map, mapInfo});
            }); //map.on('mousedown', (f) => {  


            /* ****** 設定圈選按鈕 end ****** */

            /*** 清空 範圍條件 start **/
            //重置(因有連點的問題，加上unbind取消綁定點擊避免出現連點)
            $('.reSelect').unbind('click').on('click', function () {

                // 移除選按鈕的icon button 
                $('#drawRound_div').hide();

                // 移除畫圖資料
                if (map.getLayer("circle-outline")) {

                    map.removeLayer("circle-outline"); //外圍線
                    map.removeSource("circle-outline"); //清除資料陣列

                    map.removeLayer("circle-text"); //字
                    map.removeSource("circle-text"); //清除資料陣列

                    map.removeLayer("circle-fill"); //底色
                    map.removeSource("circle-fill"); //清除資料陣列
                } //if( map.getLayer("circle-outline") ) {  

                $('input[name=distanceRadio]').attr('checked', false); //先將選取的全取消   
                $('.mapLineDrawDistance').find('button').removeClass('select_radio_button'); //先將選取的全取消

                $('input[name="distanceRadio"]:checked').prop('checked', false); //清除距離
                $('.mapLineDrawDistance').find('button').removeClass('select_radio_button'); //消除距離選取的class
                //清除中心點
                $('#distance_lat').val('');
                $('#distance_lng').val('');

                //移除其它欄位的資料
                $('#map_keyword_value').val(''); //清空搜尋bar
                $('#map_keyword_value').val(''); //清空搜尋bar

                //城市選擇移除
                $('.box .city').find('span').html('縣市區域'); //改縣市title
                $('input[name=city]').prop('checked', false); //移除區//移除市
                $('input[name=area]').prop('checked', false); //移除區
                $('.searchCancel').html(' '); //移除區

                //物件類型回到預設狀態
                // $('#tbClassesAll').trigger("click");
                $('.classificationClass').prop('checked', false); //checkbox 全取消
                $('#tbClassesAll').trigger("click"); //物件類型不限觸發
                $('.class').find('span').html('類型不限'); //類型不限狀態

                //總價回到預設狀態
                $('.priceClass').prop('checked', false); //checkbox 全取消
                $('.price input[type=tel').val(''); //清掉輸入框
                $('#tbPriceAll').trigger("click"); //總價不限觸發
                $('.price').find('span').html('總價不限'); //總價不限狀態

                //建坪回到預設狀態
                $('.floorClass').prop('checked', false); //checkbox 全取消
                $('.floor input[type=tel').val(''); //清掉輸入框
                $('#tbFloorAll').trigger("click"); //建坪不限觸發
                $('.floor').find('span').html('建坪不限'); //建坪不限狀態

                //地坪回到預設狀態
                $('.floorLandClass').prop('checked', false); //checkbox 全取消
                $('.floorB input[type=tel').val(''); //清掉輸入框
                $('#tbFloorBAll').trigger("click"); //建坪不限觸發
                $('.floorB').find('span').html('地坪不限'); //建坪不限狀態

                //房數回到預設狀態
                $('.roomClass').prop('checked', false); //checkbox 全取消
                $('.room input[type=tel').val(''); //清掉輸入框
                $('#roomAll').trigger("click"); //房數不限觸發
                $('.room').find('span').html('房數不限'); //房數不限狀態

                //屋齡回到預設狀態
                $('.more_yearsClass').prop('checked', false); //checkbox 全取消
                $('.moreYears input[type=tel').val(''); //清掉輸入框
                $('#moreYearsAll').trigger("click"); //屋齡不限觸發
                $('.moreYears').find('span').html('屋齡不限'); //屋齡不限狀態

                //樓層回到預設狀態
                $('.more_fClass').prop('checked', false); //checkbox 全取消
                $('.moreF input[type=tel]').val(''); //清掉輸入框
                $('#moreFAll').trigger("click"); //樓層不限觸發
                $('.moreF').find('span').html('樓層不限'); //樓層不限狀態

                //車位回到預設不限
                $('.more_parkingClass').prop('checked', false); //checkbox 全取消
                $('#more_parking').trigger("click"); //車位不限觸發
                $('.moreParking').find('span').html('車位不限'); //車位不限

                //特色環境回到預設不限
                $('.more_featuresClass').prop('checked', false); //checkbox 全取消
                $('#moreFeaturesAll').trigger("click"); //環境不限觸發
                $('.moreFeatures').find('span').html('環境不限'); //環境不限

                //預售屋回到預設不限
                $('.more_keyWordSelectClass').prop('checked', false); //checkbox 全取消
                $('input[name=more_keyWordSelect]').prop('checked', false); //清除全選
                $('#moreKeyWordSelectAll').trigger("click"); //預售屋不限觸發
                $('.moreKeyWordSelect').find('span').html('預售屋不限'); //預售屋不限

                //按下重置，資料庫也清空
                var ajaxFile = 'ajax_map_subscription.php';
                $.post(ajaxFile, {
                    'subscription_type': 3,
                    'member_authCode': $('#member_authCode').val(),
                    'formData': _this8.mapSearchForm.serializeArray()
                }, function (json) {
                    //處理訂閱完成後回來的程式

                    if (json === 'ok') {
                        // alert('訂閱已重置');
                        Swal.fire({
                            title: '訂閱已重置',
                            icon: 'success',
                            confirmButtonText: '確定'
                        }).then(function (result) {
                            if (result.isConfirmed) {
                                // location.reload();
                                // //重新跑搜尋
                                _this8.submitMapBtn.click();
                            }
                        });
                        //重新跑搜尋
                        // this.submitMapBtn.click();
                        // location.href = '?nav=subscription_list';
                    }
                }, 'json'); //$.post(ajaxFile, {

                //重新載入搜尋
                // this.initialize(mapInfo, mapInfo.zoom); //載入地圖
            });

            /*** 清空 範圍條件 end **/
            map.on('load', function () {
                //---頁面載入完會先進到此頁(訂閱 or 一般使用皆會使用，只要有呼叫 initialize 皆會跑到這邊。此處做群組集合使用)

                //---新增資料來源 (GeoJSON 格式) 並設定 cluster (群聚選項) 為 true(幸福家物件全部座標)      
                var formDataVal = $('#mapSearchForm').serializeArray();

                //抓取物件資料方便轉入housesale數據
                var houseSaleValue = '';
                $.ajax({
                    type: "POST",
                    url: "ajax_map8Data.php",
                    cache: false,
                    async: false,
                    data: { 'search_data': formDataVal },
                    dataType: "json",
                    success: function success(data, textStatus) {
                        // houseSaleValue = msg;
                        houseSaleValue = data;
                        // console.log(data);
                    }
                });

                map.addSource("housesale", {
                    type: "geojson",
                    data: houseSaleValue, // 此範例所使用的檔案請見
                    // data: "ajax_map8Data.php", // 此範例所使用的檔案請見 https://www.map8.zone/js/vector/housesale.json
                    cluster: true,
                    clusterMaxZoom: 14, // 顯示群聚點的最大 zoom level
                    clusterRadius: 50 // 設定群聚半徑 (單位公尺 / 預設 50)
                });

                //群組圓型圖css設定

                map.addLayer({
                    id: "clusters",
                    type: "circle",
                    source: "housesale",
                    filter: ["has", "point_count"],
                    paint: {
                        "circle-color": ["step", ["get", "point_count"],
                        // 數量小於 10 為黃褐色
                        "#D6D0B2", 10,
                        // 數量 10 - 50 為淡藍色
                        "#95B1E1",
                        // 數量 50 以上 為灰藍色
                        50, "#838B98"],
                        "circle-radius": ["step", ["get", "point_count"], 20, 20, 30, 50, 40]
                    }
                });

                $(".school_district_class").click(function () {
                    // $(".school_district_class").trigger("click", function(){  
                    var iconValue = $(this).attr('data-info'); //抓取學區圖的顯示狀態

                    //判斷學區圖
                    if (iconValue == 'school_district_es') {
                        //國小
                        toggleSchoolDistLayers('school_district_es');
                    } else if (iconValue == 'school_district_jhs') {
                        //國中
                        toggleSchoolDistLayers('school_district_jhs');
                        // } else if( iconValue == 'hideAll' ) {
                        //   //不顯示學區
                        //   toggleSchoolDistLayers('hideAll');
                    } else {
                        toggleSchoolDistLayers('hideAll');
                    } //if( iconValue == 'school_district_es') {


                    // MapAround(catValue, iconValue, distanceValue);
                }); //$(".school_district_class").trigger("click")(function(){  

                //群組數字
                map.addLayer({
                    id: "cluster-count",
                    type: "symbol",
                    source: "housesale",
                    filter: ["has", "point_count"],
                    layout: {
                        "text-field": "{point_count}",
                        "text-size": 16,
                        "text-font": ["Noto Sans Regular"]
                    }
                });

                //縮到最小坐標的設定
                map.addLayer({
                    // id: "unclustered-point",
                    // type: "circle",
                    id: "pois",
                    type: "symbol",
                    source: "housesale",
                    filter: ["!", ["has", "point_count"]],
                    layout: {
                        "icon-image": "marker",
                        "icon-size": 0.25,
                        "icon-offset": [0, -21],
                        "icon-allow-overlap": true
                    }
                });

                // 查看群聚點
                map.on('click', 'clusters', function (e) {
                    var features = map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
                    var clusterId = features[0].properties.cluster_id;
                    map.getSource('housesale').getClusterExpansionZoom(clusterId, function (err, zoom) {
                        if (err) return;
                        map.easeTo({
                            center: features[0].geometry.coordinates,
                            zoom: zoom
                        });
                    });
                });

                //圖標加入自訂的icon
                map.addImage('marker', markerEl);

                map.on('mouseenter', 'clusters', function () {
                    map.getCanvas().style.cursor = 'pointer';
                });
                map.on('mouseleave', 'clusters', function () {
                    map.getCanvas().style.cursor = '';
                });
            }); //map.on('load', function(){


            //----全物件資料列出 end


            //------加入訊息視窗(點擊用)
            var popup = new gomp.Popup({
                anchor: 'bottom',
                closeButton: true,
                closeOnClick: false,
                offset: [0, -42],
                width: 300
            });

            //坐標點擊觸發程式
            map.on('click', 'pois', function (e) {

                // 設定滑鼠游標樣式
                map.getCanvas().style.cursor = 'pointer';

                var coordinates = e.features[0].geometry.coordinates.slice();
                var description = e.features[0].properties.description;

                // 確保訊息視窗不會被遮擋 
                while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                }
                //e.lngLat.lng
                //e.lngLat.lat

                // 設定訊息視窗內容並在地圖上顯示
                popup.setLngLat(coordinates).setHTML(description).addTo(map);

                //點視窗，超過時移動地圖    
                var dPWidth = popup._container.offsetWidth; //視窗寬度
                // var dPHeight = popup._container.offsetHeight; //視窗高度
                var dPHeight = 400;
                var dPX = popup._pos.x;
                var dPY = popup._pos.y;
                var mapW = map.transform.width; //地圖寬度
                var mapH = map.transform.height; //地圖高度
                var padding = 20;
                var panPoint = {
                    "x": 0,
                    "y": 0
                };
                if (dPX < dPWidth / 2 + padding) {
                    panPoint.x = dPX - (dPWidth / 2 + padding);
                }
                if (dPX > mapW - padding - dPWidth / 2) {
                    panPoint.x = dPX - (mapW - dPWidth / 2 - padding);
                }
                if (dPY < dPHeight + padding) {
                    panPoint.y = dPY - (dPHeight + padding);
                }
                if (dPY > mapH - padding) {
                    panPoint.y = dPY - (mapH - padding);
                }
                map.panBy([panPoint.x, panPoint.y]);
            }); //map.on('click', 'pois', function(e) {

            //回原點
            this.backBtn.off('click').on('click', function () {
                // alert('test');
                //列表 & 搜尋切換 (RWD 關閉 & 返回預設值)
                // this.locationSearchBack();
                // map.panTo(myLatLng);

                var lng = mapInfo.lng;
                var lat = mapInfo.lat;
                // alert(lng+':'+lat);

                /*
                if ("geolocation" in navigator) {
                  console.log(navigator.geolocation.getCurrentPosition);
                } else {
                  alert("你的裝置或瀏覽器不支援定位功能");
                }
                */

                function successHandler(position) {

                    // alert('同意定位');
                    //同意定位
                    lat = position.coords.latitude;
                    lng = position.coords.longitude;

                    map.flyTo({
                        center: [lng, lat], // 中心點
                        zoom: 15 // 縮放比例
                        // pitch: 45 // 頃斜度
                    });
                } //function successHandler(position) {

                function errorHandler(err) {
                    // alert('沒有定位');
                    //沒有定位或錯誤, 則訂位一開始的預設座標
                    lat = mapInfo.lng;
                    lng = mapInfo.lat;

                    // alert(lat, lng);
                    // var alert_msg = '定位錯誤，請進到手機設定看是否有開啟權限';

                    // var alert_msg = '定位錯誤，請進到手機設定看是否有開啟權限\n\nandroid: 設定->位置->設定為開，點應用程式權限->找到幸福家不動產進入->選項改成 [僅在使用該應用程式時允許\n\nios: 設定 -> 幸福家不動產 -> 位置 -> 選擇 使用APP期間';
                    var alert_msg = '定位錯誤，請進到手機設定看是否有開啟權限<br><br>android: 設定->位置->設定為開，點應用程式權限->找到幸福家不動產進入->選項改成 [僅在使用該應用程式時允許]。<br><br>ios: 設定 -> 幸福家不動產 -> 位置 -> 選擇 [使用APP期間]';
                    // alert(alert_msg);
                    Swal.fire(alert_msg);

                    map.flyTo({
                        center: [lng, lat], // 中心點
                        zoom: 15 // 縮放比例
                        // pitch: 45 // 頃斜度
                    });
                } //function errorHandler(err) {

                //判斷是否有定位
                // alert('開始定位前');
                navigator.geolocation.getCurrentPosition(successHandler, errorHandler);

                /*
                console.log('決定地點:');
                console.log(lat+','+lng);
                map.flyTo({
                  center: [lng, lat], // 中心點
                  zoom: 15, // 縮放比例
                  // pitch: 45 // 頃斜度
                })
                */
            }); //this.backBtn.off('click').on('click', () => {


            //城市定位
            var latlngData = this.getCity(map); //部份城市有偏差
            // console.log('中心點:'+latlngData);
            // this.getCity(map);

            //搜尋輸入框已輸入數值，並判斷是否為'S'為物件編號，無為返回地理編碼模式(列表用資料處理)
            var keyword = this.mapSearchForm.find('input[name=map_keyword_value]').val();

            if (keyword != '' && keyword.indexOf('S') != -1 || keyword.indexOf('s') != -1) {
                //AJAX連接資料庫引入物件資料(行為：搜尋輸入框已輸入編號)
                // this.ajaxOnlyObjSearch(map, infoWindow); //地圖obj、訊息框obj
                // console.log('找單一物件');
                this.ajaxOnlyObjSearch(map, mapInfo); //地圖obj、訊息框obj
            } else {
                //AJAX連接資料庫引入物件資料(行為：初始，搜尋輸入框未輸入編號)
                // console.log('找全部資料');
                this.ajaxAllObjSearch(map, mapInfo); //地圖obj、訊息框obj、API路徑(google 地圖坐標api)
                // this.ajaxAllObjSearch(map, infoWindow, markerClusterer); //地圖obj、訊息框obj、API路徑(google 地圖坐標api)
            } //if(keyword != '' && keyword.indexOf('S') != -1 || keyword.indexOf('s') != -1){

            //移除map8 logo
            $('.gomp-ctrl-bottom-right').remove();
            $('.gomp-ctrl-bottom-left').remove();
        } //initialize(mapInfo, mapZoom) {   

        //輸出(執行輸出地圖)

    }, {
        key: 'mapAPI',
        value: function mapAPI() {
            var _this9 = this;

            //預設台南火車站
            var lat = 22.99723350539961;
            var lng = 120.21316381063703;

            //總部(北門路)
            // var lat = 23.009148505419258;
            // var lng = 120.21585116219424;

            var mapInfo = {
                el: this.map,
                zoom: 15,
                lat: lat,
                lng: lng
            };

            this.initialize(mapInfo, mapInfo.zoom); //載入地圖

            //搜尋送出重新載入地圖
            var submitMap = function submitMap() {

                //搜尋框Entern送出
                _this9.mapSearchForm.find('input[name=map_keyword_value]').bind('keypress', function (e) {

                    if (e.keyCode == 13) {
                        //重新載入地圖
                        _this9.initialize(mapInfo, mapInfo.zoom);
                    }
                });

                //搜尋按鈕送出
                _this9.submitMapBtn.on('click', function () {
                    //重新載入地圖
                    _this9.initialize(mapInfo, mapInfo.zoom);
                });

                //訂閱按鈕送出
                _this9.subscriptionBtn.on('click', function () {
                    // location.href='?nav=subscription_list';
                    var ajaxFile = 'ajax_map_subscription.php';

                    //抓get的member_authcode值
                    var queryString = window.location.search;
                    var urlParams = new URLSearchParams(queryString);
                    var value = urlParams.get('member_authcode');

                    //用ajax跑訂閱資料儲存
                    $.post(ajaxFile, {
                        'subscription_type': 3,
                        'member_authCode': $('#member_authCode').val(),
                        'formData': _this9.mapSearchForm.serializeArray()
                    }, function (json) {
                        //處理訂閱完成後回來的程式
                        if (json === 'ok') {
                            // alert('訂閱已完成');
                            Swal.fire({
                                title: '訂閱已完成',
                                confirmButtonText: '確定'
                            }).then(function (result) {
                                if (result.isConfirmed) {
                                    // location.reload();
                                    // console.log(submitMap);
                                    // this.submitMap.click(); //原本有 20230307 kai 註解
                                    // submitMapBtnFunction.click();
                                    // document.getElementById("submitMapBtn").click();
                                    location.href = '?nav=map_search&subscription_status=open&member_authcode=' + value;
                                }
                            });

                            // 跑搜尋
                            // this.submitMapBtn.click(); //原本有 20230307 kai 註解
                            // location.href = '?nav=subscription_list';
                        }
                    }, 'json'); //$.post(ajaxFile, {
                });
            }; //let submitMap = () => {

            //移除map8 logo
            //$('.gomp-ctrl-bottom-right').remove();
            //$('.gomp-ctrl-bottom-left').remove();

            //搜尋送出
            submitMap();

            //判斷是否從地圖訂閱進頁面
            // this.mapScope();
        } //mapAPI() {


    }]);

    return MapRealtySearch;
}(); //class MapRealtySearch {


//輸出


exports.LightboxMap = LightboxMap;
exports.MapRealtyDetail = MapRealtyDetail;
exports.MapRealtySearch = MapRealtySearch;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//房貸試算
var Mortgage = function () {
  function Mortgage() {
    _classCallCheck(this, Mortgage);

    this.form = $('#mortgage');
    this.price = this.form.find('.price');
    this.pv = this.form.find('input[name=pv]');
    this.rate = this.form.find('input[name=rate]');
    this.year = this.form.find('select[name=year]');
    this.gYear = this.form.find('select[name=gYear]');
    this.mr1 = this.form.find('.mr1');
    this.mr2 = this.form.find('.mr2');
    this.rangeNum = 0.7;
  }
  //僅輸入數字


  _createClass(Mortgage, [{
    key: 'onlyNumKey',
    value: function onlyNumKey() {
      this.form.find('input').on('input', function (e) {
        var $this = $(e.currentTarget);
        var filterVal = $this.val().replace(/[！-～]/g, function (tmpStr) {
          return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
        });
        $this.val(filterVal.replace(/[^0-9\.]/g, ''));
      });
    }
    //貸款金額

  }, {
    key: 'filterPV',
    value: function filterPV() {
      // let price = 0;
      /*
      if(this.price != 0) {
        price = this.price;
      } else {
        price = this.inputPrice;
      }*/
      var filterPrice = this.price.text().replace(',', '');
      var realPrice = filterPrice * 10000;
      var resultPrice = Math.round(realPrice * this.rangeNum);
      this.pv.val(resultPrice);
    }
    //寬限期內每月利息

  }, {
    key: 'totalPrice1',
    value: function totalPrice1(rate, pv) {
      var result = pv * (rate / 100 / 12);
      if (result == 0 || isNaN(result)) {
        result = 0;
      }
      this.mr1.text(result.toFixed(2));
    }
    //寬限期後每月本息 (Excel PMT 公式)

  }, {
    key: 'totalPrice2',
    value: function totalPrice2(rate, nper, pv) {
      var rateFilter = rate / 100 / 12;
      var nperFilter = nper * 12;
      var result = Math.floor(pv * rateFilter / (1 - Math.pow(1 + rateFilter, -1 * nperFilter)) * 100) / 100;
      if (result == 0 || isNaN(result)) {
        result = 0;
      }
      this.mr2.text(result.toFixed(2));
    }
    //執行計算帶入各值

  }, {
    key: 'resultVal',
    value: function resultVal() {
      this.totalPrice1(this.rate.val(), this.pv.val());
      this.totalPrice2(this.rate.val(), this.year.val() - this.gYear.val(), this.pv.val());
    }
  }, {
    key: 'resultMortgage',
    value: function resultMortgage() {
      var _this = this;

      this.onlyNumKey();
      this.filterPV();
      this.resultVal();

      //總價
      this.inputPrice.on('keydown keyup', function () {
        _this.resultVal();
      });

      //貸款金額
      this.pv.on('keydown keyup', function () {
        _this.resultVal();
      });
      //銀行貸款利率
      this.rate.on('keydown keyup', function () {
        _this.resultVal();
      });
      //貸款總年限
      this.year.on('change blur', function () {
        _this.resultVal();
      });
      //寬限期
      this.gYear.on('change blur', function () {
        _this.resultVal();
      });
    }
  }]);

  return Mortgage;
}();

//房貸計算機


var Mortgage2 = function () {
  function Mortgage2() {
    _classCallCheck(this, Mortgage2);

    this.form = $('#mortgage2');
    this.price = this.form.find('input[name=price]'); //總價
    // this.inputPrice = this.form.find('input[name=price]');  //用輸入的總價
    this.pv = this.form.find('input[name=pv]'); //貸款金額
    this.rate = this.form.find('input[name=rate]'); //貸款利率
    this.year = this.form.find('select[name=year]'); //貸款年限
    this.gYear = this.form.find('select[name=gYear]'); //寬限期
    this.mr1 = this.form.find('.mr1'); //寬限期內每月利息
    this.mr2 = this.form.find('.mr2'); //寬限期後每月本息
    this.rangeNum = 0.7;
  }
  //僅輸入數字


  _createClass(Mortgage2, [{
    key: 'onlyNumKey',
    value: function onlyNumKey() {
      this.form.find('input').on('input', function (e) {
        var $this = $(e.currentTarget);
        var filterVal = $this.val().replace(/[！-～]/g, function (tmpStr) {
          return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
        });
        $this.val(filterVal.replace(/[^0-9\.]/g, ''));
      });
    }
    //貸款金額

  }, {
    key: 'filterPV',
    value: function filterPV() {
      var filterPrice = this.price.text().replace(',', '');
      var realPrice = filterPrice * 10000;
      var resultPrice = Math.round(realPrice * this.rangeNum);
      this.pv.val(resultPrice);
    }
    //寬限期內每月利息

  }, {
    key: 'totalPrice1',
    value: function totalPrice1(rate, pv) {
      var result = pv * (rate / 100 / 12);
      if (result == 0 || isNaN(result)) {
        result = 0;
      }
      this.mr1.text(result.toFixed(2));
    }
    //寬限期後每月本息 (Excel PMT 公式)

  }, {
    key: 'totalPrice2',
    value: function totalPrice2(rate, nper, pv) {
      var rateFilter = rate / 100 / 12;
      var nperFilter = nper * 12;
      var result = Math.floor(pv * rateFilter / (1 - Math.pow(1 + rateFilter, -1 * nperFilter)) * 100) / 100;
      if (result == 0 || isNaN(result)) {
        result = 0;
      }
      this.mr2.text(result.toFixed(2));
    }
    //執行計算帶入各值

  }, {
    key: 'resultVal',
    value: function resultVal() {
      this.totalPrice1(this.rate.val(), this.pv.val());
      this.totalPrice2(this.rate.val(), this.year.val() - this.gYear.val(), this.pv.val());
    }
  }, {
    key: 'resultMortgage',
    value: function resultMortgage() {
      var _this2 = this;

      this.onlyNumKey();
      this.filterPV();
      this.resultVal();

      //總價
      this.price.on('keydown keyup', function () {
        _this2.resultVal();
      });

      //貸款金額
      this.pv.on('keydown keyup', function () {
        _this2.resultVal();
      });
      //銀行貸款利率
      this.rate.on('keydown keyup', function () {
        _this2.resultVal();
      });
      //貸款總年限
      this.year.on('change blur', function () {
        _this2.resultVal();
      });
      //寬限期
      this.gYear.on('change blur', function () {
        _this2.resultVal();
      });
    }
  }]);

  return Mortgage2;
}();

//表單輸入名稱


var InputVal = function () {
  function InputVal() {
    _classCallCheck(this, InputVal);

    this.customerVal = $('input[name=customer]');
    this.telVal = $('input[name=tel]');
    this.eMailVal = $('input[name=email]');
    this.classesVal = $('select[name=classes]');
    this.messageVal = $('textarea[name=message]');
    this.checkTxtNumVal = $('#checkTxtNum>span');
    this.termsVal = $('input[name=terms]');
    this.errorVal = $('p.error');
    this.submitBtn = $('button[type=submit]');

    //正規表達式
    this.regexTxt = /^[a-zA-Z\u4e00-\u9fa5]+$/;
    this.regexNum = /[0-9]/;
    this.regexEmail = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/;
  }

  _createClass(InputVal, [{
    key: 'customerVal',
    value: function customerVal(el) {
      if (el.val() == '') {
        el.parent().next().show();
        el.parent().next().text('請填寫您的姓名。');
      } else if (el.val() != '' && this.regexTxt.test(el.val()) != true) {
        el.parent().next().show();
        el.parent().next().text('請勿輸入數字或特殊符號。');
      } else if (el.val().length < 2) {
        el.parent().next().show();
        el.parent().next().text('此欄位長度不可小於2文字。');
      } else if (el.val().length >= 10) {
        el.parent().next().show();
        el.parent().next().text('此欄位長度不可超過10文字。');
      } else {
        el.parent().next().hide();
        el.parent().next().text('');
      }
    }
  }, {
    key: 'telVal',
    value: function telVal(el) {
      if (el.val() == '') {
        el.next().show();
        el.next().text('請填寫您的聯絡電話。');
      } else if (el.val() != '' && this.regexNum.test(el.val()) != true) {
        el.next().show();
        el.next().text('您輸入的電話格式錯誤。');
      } else {
        el.next().hide();
        el.next().text('');
      }
    }
  }, {
    key: 'eMailVal',
    value: function eMailVal(el) {
      if (el.val() == '') {
        el.next().show();
        el.next().text('請輸入您常用的電子郵件。');
      } else if (el.val() != '' && this.regexEmail.test(el.val()) != true) {
        el.next().show();
        el.next().text('您輸入的電子郵件格式錯誤。');
      } else {
        el.next().hide();
        el.next().text('');
      }
    }
  }, {
    key: 'classesVal',
    value: function classesVal(el) {
      if (el.val() == '無') {
        el.parent().next().show();
        el.parent().next().text('請選擇諮詢類別。');
      } else {
        el.parent().next().hide();
        el.parent().next().text('');
      }
    }
  }, {
    key: 'messageVal',
    value: function messageVal(el) {
      if (el.val() == '') {
        el.parent().next().show();
        el.parent().next().text('請填寫您的諮詢內容。');
      } else {
        el.parent().next().hide();
        el.parent().next().text('');
      }
    }
  }, {
    key: 'realtyTxtNum',
    value: function realtyTxtNum(el) {
      var maxLength = 200;
      var nowContent = el.val();
      var nowLehgth = nowContent.length;

      this.checkTxtNum.text(maxLength - nowLehgth);

      if (nowLehgth > maxLength) {
        el.parent().next().show();
        el.parent().next().text('您的諮詢內容已超過' + maxLength + '字，請簡述。');
        this.checkTxtNum.text('已超過' + maxLength + '字。');
      } else {
        el.parent().next().hide();
        el.parent().next().text('');
      }
    }
  }, {
    key: 'contactTxtNum',
    value: function contactTxtNum(el) {
      var maxLength = 200;
      var nowContent = el.val();
      var nowLehgth = nowContent.length;

      this.checkTxtNum.text(maxLength - nowLehgth);

      if (nowLehgth > maxLength) {
        el.parent().next().show();
        el.parent().next().text('您的諮詢內容已超過' + maxLength + '字，請簡述。');
        this.checkTxtNum.text('已超過' + maxLength + '字。');
      }
    }
  }, {
    key: 'termsVal',
    value: function termsVal(el) {
      if (el.prop('checked') != true) {
        el.next().next().show();
        el.next().next().text('請確認已了解並勾選同意條款。');
      } else {
        el.next().next().hide();
        el.next().next().text('');
      }
    }
  }]);

  return InputVal;
}();

//預約看屋 & 降價通知 & 買屋留言


var RealtyFormEvent = function (_InputVal) {
  _inherits(RealtyFormEvent, _InputVal);

  function RealtyFormEvent(el) {
    _classCallCheck(this, RealtyFormEvent);

    var _this3 = _possibleConstructorReturn(this, (RealtyFormEvent.__proto__ || Object.getPrototypeOf(RealtyFormEvent)).call(this));

    _this3.form = el;
    _this3.customer = _this3.form.find(_this3.customerVal);
    _this3.tel = _this3.form.find(_this3.telVal);
    _this3.eMail = _this3.form.find(_this3.eMailVal);
    _this3.message = _this3.form.find(_this3.messageVal);
    _this3.checkTxtNum = _this3.form.find(_this3.checkTxtNumVal);
    _this3.terms = _this3.form.find(_this3.termsVal);
    _this3.error = _this3.form.find(_this3.errorVal);
    _this3.submit = _this3.form.find(_this3.submitBtn);
    return _this3;
  }

  _createClass(RealtyFormEvent, [{
    key: 'checkForm',
    value: function checkForm() {
      var _this4 = this;

      //姓名
      this.customer.focusout(function (e) {
        var $this = $(e.currentTarget);
        _get(RealtyFormEvent.prototype.__proto__ || Object.getPrototypeOf(RealtyFormEvent.prototype), 'customerVal', _this4).call(_this4, $this);
      });
      //電話
      this.tel.focusout(function (e) {
        var $this = $(e.currentTarget);
        _get(RealtyFormEvent.prototype.__proto__ || Object.getPrototypeOf(RealtyFormEvent.prototype), 'telVal', _this4).call(_this4, $this);
      });
      /*
      //信箱
      this.eMail.focusout((e) => {
        const $this = $(e.currentTarget);
        super.eMailVal($this);
      });
      */
      //備註
      _get(RealtyFormEvent.prototype.__proto__ || Object.getPrototypeOf(RealtyFormEvent.prototype), 'realtyTxtNum', this).call(this, this.message);
      this.message.focusout(function (e) {
        var $this = $(e.currentTarget);
        _get(RealtyFormEvent.prototype.__proto__ || Object.getPrototypeOf(RealtyFormEvent.prototype), 'realtyTxtNum', _this4).call(_this4, $this);
      });
      this.message.on('keydown keyup', function (e) {
        var $this = $(e.currentTarget);
        _get(RealtyFormEvent.prototype.__proto__ || Object.getPrototypeOf(RealtyFormEvent.prototype), 'realtyTxtNum', _this4).call(_this4, $this);
      });
      //同意條款
      this.terms.on('click', function (e) {
        var $this = $(e.currentTarget);
        _get(RealtyFormEvent.prototype.__proto__ || Object.getPrototypeOf(RealtyFormEvent.prototype), 'termsVal', _this4).call(_this4, $this);
      });
      //送出
      this.submit.on('click', function (e) {
        _get(RealtyFormEvent.prototype.__proto__ || Object.getPrototypeOf(RealtyFormEvent.prototype), 'customerVal', _this4).call(_this4, _this4.customer);
        _get(RealtyFormEvent.prototype.__proto__ || Object.getPrototypeOf(RealtyFormEvent.prototype), 'telVal', _this4).call(_this4, _this4.tel);
        //super.eMailVal(this.eMail);
        _get(RealtyFormEvent.prototype.__proto__ || Object.getPrototypeOf(RealtyFormEvent.prototype), 'realtyTxtNum', _this4).call(_this4, _this4.message);
        _get(RealtyFormEvent.prototype.__proto__ || Object.getPrototypeOf(RealtyFormEvent.prototype), 'termsVal', _this4).call(_this4, _this4.terms);
        if (_this4.error.filter(':hidden').length == _this4.error.length) {
          $(e.currentTarget).css({
            'pointerEvents': 'none',
            'opacity': .5
          });
          // return false;
        } else {
          return false;
        }
      });
    }
  }]);

  return RealtyFormEvent;
}(InputVal);

//物件列表 & 內頁 (RWD)


var RealtyForm = function (_RealtyFormEvent) {
  _inherits(RealtyForm, _RealtyFormEvent);

  function RealtyForm() {
    _classCallCheck(this, RealtyForm);

    return _possibleConstructorReturn(this, (RealtyForm.__proto__ || Object.getPrototypeOf(RealtyForm)).call(this, $('#realtyForm')));
  }

  _createClass(RealtyForm, [{
    key: 'checkForm',
    value: function checkForm() {
      _get(RealtyForm.prototype.__proto__ || Object.getPrototypeOf(RealtyForm.prototype), 'checkForm', this).call(this, this.form);
    }
  }]);

  return RealtyForm;
}(RealtyFormEvent);

//側邊欄


var AsideRealtyForm = function (_RealtyFormEvent2) {
  _inherits(AsideRealtyForm, _RealtyFormEvent2);

  function AsideRealtyForm() {
    _classCallCheck(this, AsideRealtyForm);

    return _possibleConstructorReturn(this, (AsideRealtyForm.__proto__ || Object.getPrototypeOf(AsideRealtyForm)).call(this, $('#asideRealtyForm')));
  }

  _createClass(AsideRealtyForm, [{
    key: 'checkForm',
    value: function checkForm() {
      _get(AsideRealtyForm.prototype.__proto__ || Object.getPrototypeOf(AsideRealtyForm.prototype), 'checkForm', this).call(this, this.form);
    }
  }]);

  return AsideRealtyForm;
}(RealtyFormEvent);

//業務個人


var PersonalForm = function (_RealtyFormEvent3) {
  _inherits(PersonalForm, _RealtyFormEvent3);

  function PersonalForm() {
    _classCallCheck(this, PersonalForm);

    return _possibleConstructorReturn(this, (PersonalForm.__proto__ || Object.getPrototypeOf(PersonalForm)).call(this, $('#personalForm')));
  }

  _createClass(PersonalForm, [{
    key: 'checkForm',
    value: function checkForm() {
      _get(PersonalForm.prototype.__proto__ || Object.getPrototypeOf(PersonalForm.prototype), 'checkForm', this).call(this, this.form);
    }
  }]);

  return PersonalForm;
}(RealtyFormEvent);

//客服信箱


var ContactForm = function (_InputVal2) {
  _inherits(ContactForm, _InputVal2);

  function ContactForm() {
    _classCallCheck(this, ContactForm);

    var _this8 = _possibleConstructorReturn(this, (ContactForm.__proto__ || Object.getPrototypeOf(ContactForm)).call(this));

    _this8.form = $('#contactForm');
    _this8.customer = _this8.form.find(_this8.customerVal);
    _this8.tel = _this8.form.find(_this8.telVal);
    _this8.eMail = _this8.form.find(_this8.eMailVal);
    _this8.classes = _this8.form.find(_this8.classesVal);
    _this8.message = _this8.form.find(_this8.messageVal);
    _this8.checkTxtNum = _this8.form.find(_this8.checkTxtNumVal);
    _this8.terms = _this8.form.find(_this8.termsVal);
    _this8.error = _this8.form.find(_this8.errorVal);
    _this8.submit = _this8.form.find(_this8.submitBtn);
    return _this8;
  }

  _createClass(ContactForm, [{
    key: 'checkForm',
    value: function checkForm() {
      var _this9 = this;

      //姓名
      this.customer.focusout(function (e) {
        var $this = $(e.currentTarget);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'customerVal', _this9).call(_this9, $this);
      });
      //電話
      this.tel.focusout(function (e) {
        var $this = $(e.currentTarget);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'telVal', _this9).call(_this9, $this);
      });
      /*
      //信箱
      this.eMail.focusout((e) => {
        const $this = $(e.currentTarget);
        super.eMailVal($this);
      });
      */
      //類別
      this.classes.on('change blur', function (e) {
        var $this = $(e.currentTarget);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'classesVal', _this9).call(_this9, $this);
      });
      //內容
      this.message.focusout(function (e) {
        var $this = $(e.currentTarget);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'messageVal', _this9).call(_this9, $this);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'contactTxtNum', _this9).call(_this9, $this);
      });
      this.message.on('keydown keyup', function (e) {
        var $this = $(e.currentTarget);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'contactTxtNum', _this9).call(_this9, $this);
      });
      //同意條款
      this.terms.on('click', function (e) {
        var $this = $(e.currentTarget);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'termsVal', _this9).call(_this9, $this);
      });
      //送出
      this.submit.on('click', function (e) {
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'customerVal', _this9).call(_this9, _this9.customer);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'telVal', _this9).call(_this9, _this9.tel);
        //super.eMailVal(this.eMail);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'classesVal', _this9).call(_this9, _this9.classes);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'messageVal', _this9).call(_this9, _this9.message);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'contactTxtNum', _this9).call(_this9, _this9.message);
        _get(ContactForm.prototype.__proto__ || Object.getPrototypeOf(ContactForm.prototype), 'termsVal', _this9).call(_this9, _this9.terms);
        if (_this9.error.filter(':hidden').length == _this9.error.length) {
          $(e.currentTarget).css({
            'pointerEvents': 'none',
            'opacity': .5
          });
          return true;
        } else {
          return false;
        }
      });
    }
  }]);

  return ContactForm;
}(InputVal);

//輸出


exports.Mortgage = Mortgage;
exports.Mortgage2 = Mortgage2;
exports.PersonalForm = PersonalForm;
exports.RealtyForm = RealtyForm;
exports.AsideRealtyForm = AsideRealtyForm;
exports.ContactForm = ContactForm;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//Header搜尋條件 (昀寬多加)
var HeaderSearchVal = function () {
  function HeaderSearchVal() {
    _classCallCheck(this, HeaderSearchVal);

    this.nav = $('#navVal').val();
    this.tabs = $('.tabs input:radio');
    // this.searchForm    = $('#rwdSearchForm'); //右側側邊搜尋
    this.searchForm = $('.searchForm'); //全部form底下的搜尋
    // this.searchForm    = $('form'); //全部form底下的搜尋
    this.webSearchForm = $('#webSearchForm'); //網頁版上方搜尋
    this.submitBtn = $('#submitSearchButton');
    this.ajaxBtn = $('#searchButton');
    this.getBtn = $('.searchFormButton'); //get搜尋處理,移除掉post跟ajax
  }

  //搜尋條件處理


  _createClass(HeaderSearchVal, [{
    key: 'searchConditionProcess',
    value: function searchConditionProcess() {
      var _this = this;

      this.getBtn.on('click', function () {
        //把該名字的所有name值加總為陣列，並轉為字串輸出
        function GetCheckedValue(checkBoxName) {
          var returnVal = $("input[name='" + checkBoxName + "']:checked").map(function () {
            // let returnVal = $("input[name='" + checkBoxName + "']").is(":checked").prop('checked',true).map(function () {
            return $(this).val();
          }).get();
          //過濾重覆值
          var result = returnVal.filter(function (element, index, arr) {
            return arr.indexOf(element) === index;
          });
          return result.join(',');
        } //function GetCheckedValue(checkBoxName)  {

        //處理參數
        var keyName = ''; //暫存key值，判斷是否有重覆
        var getURL = _this.searchForm.find("input").map(function () {
          // console.log( $(this).attr('name') );
          if ($(this).attr('type') === 'radio' || $(this).attr('type') === 'checkbox') {
            //radio、checkbox的陣列處理
            if ($(this).is(':checked') == true && $(this).val() != '不限') {
              //判斷是否有選取
              return $(this).attr('name') + '=' + GetCheckedValue($(this).attr('name'));
            }
          } else {
            //非陣列處理
            //判斷空值
            if ($(this).val() != '' && $(this).length != 0 && $(this).attr('name') != 'nav') {
              // console.log($(this).attr('name')+'(a)='+encodeURIComponent( $(this).val() ));
              return $(this).attr('name') + '=' + $(this).val();
            }
          }
        }).get(); //傳回時字串，用逗號分隔
        // console.log(getURL);
        //過濾重覆值
        var result = getURL.filter(function (element, index, arr) {
          return arr.indexOf(element) === index;
        });

        //判斷業務版
        if ($('input[name="personalId"]').val() != '') {
          var person_id_val = $('input[name="personalId"]').val();
        } else {
          var person_id_val = '';
        }

        var getURLString = Array.from(result).join('&'); //篩選完重覆，陣列轉字串
        var formAction = _this.searchForm.attr('action'); //抓傳值路徑(買屋、租屋、新成屋頁面)
        location.href = './' + person_id_val + formAction + '&q=' + encodeURIComponent(getURLString); //轉址
      });
    }

    //搜尋物件類別

  }, {
    key: 'selectRealtyClass',
    value: function selectRealtyClass() {
      var _this2 = this;

      //判斷form的action路徑(一開始進入的頁面)
      var classNumberValString = $('#areaSearch').attr('vv'); //選取的中文字
      var navValue = $('.scrollBox #nav').val(); //目前頁面
      // console.log(classNumberValString+":::"+navValue);
      if (classNumberValString && classNumberValString != 'Array') {
        if (classNumberValString === '租屋') {
          this.searchForm.attr('action', '?nav=rent'); //租屋頁面
        } else if (classNumberValString === '新成屋') {
          this.searchForm.attr('action', '?nav=new'); //新成屋頁面
        } else {
          this.searchForm.attr('action', '?nav=buy'); //買屋頁面
        }
      } else {
        if (navValue == 'buy' || navValue == 'rent' || navValue == 'all_object') {
          if (navValue == 'rent') {
            this.searchForm.attr('action', '?nav=rent'); //租屋頁面
          } else if (navValue == 'all_object') {
            this.searchForm.attr('action', '?nav=all_object'); //全物件頁面  
          } else {
            this.searchForm.attr('action', '?nav=buy'); //買屋頁面
          }
        }
      }

      this.tabs.each(function (i, e) {
        $(e).on('click', function () {
          var $menuValue = $(e).val(); //抓出選擇的項目
          var $nav = $('.scrollBox #nav').val(); //目前所在的頁面
          var $moreClasses = $('.more_classes input:checkbox');

          //---判斷其它form是否有一樣的項目，並做同步選取
          var checkName = $(e).attr('name'); //找出選取的name值
          var checkVal = $(e).attr('value'); //找出選取的值
          var checkStatus = $(e).prop('checked'); //勾選狀態

          $('form input[name="' + checkName + '"]').each(function (index, element) {
            if (checkVal == $(element).attr('value')) {
              $(element).prop('checked', checkStatus);
            } //if(checkVal == $(element).attr('value')) {
          });
          //---判斷其它form是否有一樣的項目，並做同步選取

          if ($menuValue === '租屋') {
            if ($nav != 'rent') {
              _this2.searchForm.attr('action', '?nav=rent'); //租屋頁面
            }
          } else if ($menuValue === '新成屋') {
            if ($nav != 'new') {
              _this2.searchForm.attr('action', '?nav=new'); //新成屋頁面
            }
          } else {
            // if($nav != 'buy'){
            _this2.searchForm.attr('action', '?nav=buy'); //買屋頁面
            // }

            switch ($menuValue) {
              case '住宅':
                $moreClasses.each(function (i, e) {
                  if ($(e).val() === '套房' || $(e).val() === '大樓華廈' || $(e).val() === '無電梯公寓' || $(e).val() === '透天別墅' || $(e).val() === '土地(其他)') {
                    $(e).attr('checked', true);
                  }
                });
                break;
              case '店面':
                $moreClasses.each(function (i, e) {
                  if ($(e).val() === '套房' || $(e).val() === '大樓華廈' || $(e).val() === '無電梯公寓' || $(e).val() === '透天別墅' || $(e).val() === '透天店面' || $(e).val() === '樓店' || $(e).val() === '土地(其他)') {
                    $(e).attr('checked', true);
                  }
                });
                break;
              case '辦公':
                $moreClasses.each(function (i, e) {
                  if ($(e).val() === '套房' || $(e).val() === '大樓華廈' || $(e).val() === '無電梯公寓' || $(e).val() === '透天別墅' || $(e).val() === '土地(其他)') {
                    $(e).attr('checked', true);
                  }
                });
                break;
              case '工業地':
                $moreClasses.each(function (i, e) {
                  if ($(e).val() === '廠房' || $(e).val() === '工業地' || $(e).val() === '土地(其他)' || $(e).val() === '其他') {
                    $(e).attr('checked', true);
                  }
                });
                break;

              // case '車位':
              //   break;

              case '土地':
              case '其它':
                $moreClasses.each(function (i, e) {
                  if ($(e).val() === '土地(其他)' || $(e).val() === '其他') {
                    $(e).attr('checked', true);
                  }
                });
                break;
            }
          }
        }); //$(e).on('click', () => {
      });
    }
  }, {
    key: 'sendSearch',
    value: function sendSearch() {
      var _this3 = this;

      //搜尋物件類別
      this.selectRealtyClass();
      this.searchConditionProcess(); //搜尋條件處理(get方式)

      //送出搜尋
      this.searchForm.find('input[name=keyword_value]').bind('keypress', function (e) {

        if (e.keyCode == 13 && _this3.nav == '') {
          $('body').addClass('active');
          $('.searchFormButton').click(); //按下enter後觸發送出鈕
        }
      });
      this.submitBtn.on('click', function () {
        $('body').addClass('active');
      });
    }
  }]);

  return HeaderSearchVal;
}();

//表單送出 - 客服信箱 / 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)


var SendForm = function () {
  function SendForm() {
    _classCallCheck(this, SendForm);

    this.msg = '資料送出後將無法修改，是否確定送出？';
    this.fc1Ajax = 'ajax_buy_reserve.php';
    this.fc2Ajax = 'ajax_buy_pr.php';
    this.fc3Ajax = 'ajax_buy_message.php';
    this.contactAjax = 'ajax_service.php';
    // this.personalAjax = 'ajax_personal_form_process.php';
    this.personalAjax = 'ajax_buy_reserve.php';
  }
  //Ajax 


  _createClass(SendForm, [{
    key: 'ajaxFormData',
    value: function ajaxFormData(ajaxFile, formData) {
      // console.log('進入ajax');
      $.post(ajaxFile, formData, function (json) {
        // alert(json.msg);
        // location.reload();
        Swal.fire({
          title: json.msg,
          icon: 'success',
          confirmButtonText: '確定',
          customClass: {
            popup: 'my-swal-popup-class',
            container: 'my-swal-container-class',
            content: 'my-swal-content-class'
          }

        }).then(function (result) {
          if (result.isConfirmed) {
            location.reload();
          }
        });
      }, 'json').fail(function (xhr, status, error) {
        //console.log(xhr.responseText); 
      });
    }
    //Lightbox表單送出 - 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)

  }, {
    key: 'realtyForm',
    value: function realtyForm() {
      var _this4 = this;

      // console.log('進入realy');
      var $form = $('#realtyForm');
      $form.submit(function (e) {
        e.preventDefault();
        Swal.fire({
          title: _this4.msg,
          showDenyButton: true,
          confirmButtonText: '是',
          denyButtonText: '\u5426',
          customClass: {
            popup: 'my-swal-popup-class',
            container: 'my-swal-container-class',
            content: 'my-swal-content-class'
          }
        }).then(function (result) {
          if (result.isConfirmed) {
            var type = $form.data('type');
            var data = $form.serialize(); //序列化資料傳送
            if (type == 'fc1') {
              //預約看屋
              _this4.ajaxFormData(_this4.fc1Ajax, data);
            } else if (type == 'fc2') {
              //降價通知
              _this4.ajaxFormData(_this4.fc2Ajax, data);
            } else if (type == 'fc3') {
              //買屋留言
              _this4.ajaxFormData(_this4.fc3Ajax, data);
            }
            return false;
          } else {
            return false;
          }
        });
        /*
        if(confirm(this.msg)){
          let type = $form.data('type');
          let data = $form.serialize(); //序列化資料傳送
          if(type == 'fc1'){
            //預約看屋
            this.ajaxFormData(this.fc1Ajax, data);
          }else if(type == 'fc2'){
            //降價通知
            this.ajaxFormData(this.fc2Ajax, data);
          }else if(type == 'fc3'){
            //買屋留言
            this.ajaxFormData(this.fc3Ajax, data);
          }
          return false;
        }else{
          return false;
        }
        */
      });
    }

    //Aside表單送出 - 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)

  }, {
    key: 'asideRealtyForm',
    value: function asideRealtyForm() {
      var _this5 = this;

      // console.log('進入aside');
      var $form = $('#asideRealtyForm');
      $form.submit(function (e) {
        e.preventDefault();
        Swal.fire({
          title: _this5.msg,
          showDenyButton: true,
          confirmButtonText: '是',
          denyButtonText: '\u5426',
          customClass: {
            popup: 'my-swal-popup-class',
            container: 'my-swal-container-class',
            content: 'my-swal-content-class'
          }
        }).then(function (result) {
          if (result.isConfirmed) {
            var type = $form.find('.typeBtn input:checked').val();
            var data = $form.serialize(); //序列化資料傳送
            if (type == 'fc1') {
              //預約看屋
              // console.log('fc1');
              _this5.ajaxFormData(_this5.fc1Ajax, data);
            } else if (type == 'fc2') {
              //降價通知
              // console.log('fc2');
              _this5.ajaxFormData(_this5.fc2Ajax, data);
            } else if (type == 'fc3') {
              //買屋留言
              // console.log('fc3');
              _this5.ajaxFormData(_this5.fc3Ajax, data);
            }
            return false;
          } else {
            return false;
          }
        });
        /*
        if(confirm(this.msg)){
        let type = $form.find('.typeBtn input:checked').val();
        let data = $form.serialize(); //序列化資料傳送
        if(type == 'fc1'){
          //預約看屋
          // console.log('fc1');
          this.ajaxFormData(this.fc1Ajax, data);
        }else if(type == 'fc2'){
          //降價通知
          // console.log('fc2');
          this.ajaxFormData(this.fc2Ajax, data);
        }else if(type == 'fc3'){
          //買屋留言
          // console.log('fc3');
          this.ajaxFormData(this.fc3Ajax, data);
        }
        return false;
        }else{
        return false;
        }
        */
      });
    }

    //客服信箱

  }, {
    key: 'contactForm',
    value: function contactForm() {
      var _this6 = this;

      // console.log('進入客服');
      var $form = $('#contactForm');
      $form.submit(function (e) {
        e.preventDefault();
        Swal.fire({
          title: _this6.msg,
          showDenyButton: true,
          confirmButtonText: '是',
          denyButtonText: '\u5426',
          customClass: {
            popup: 'my-swal-popup-class',
            container: 'my-swal-container-class',
            content: 'my-swal-content-class'
          }
        }).then(function (result) {
          if (result.isConfirmed) {
            var data = $form.serialize(); //序列化資料傳送
            _this6.ajaxFormData(_this6.contactAjax, data);
          } else {
            return false;
          }
        });
        /*
        if(confirm(this.msg)){
          let data = $form.serialize(); //序列化資料傳送
          this.ajaxFormData(this.contactAjax, data);
        }else{
          return false;
        }
        */
      });
    }
    //業務個人

  }, {
    key: 'personalForm',
    value: function personalForm() {
      var _this7 = this;

      // console.log('業務個人');
      var $form = $('#personalForm');
      $form.submit(function (e) {

        e.preventDefault();
        if (confirm(_this7.msg)) {
          var type = $form.data('type'); //表單類型
          var data = $form.serialize(); //序列化資料傳送
          // this.ajaxFormData(this.personalAjax, data);
          if (type == 'fc1') {
            //預約看屋
            _this7.ajaxFormData(_this7.fc1Ajax, data);
          } else if (type == 'fc2') {
            //降價通知
            _this7.ajaxFormData(_this7.fc2Ajax, data);
          } else if (type == 'fc3') {
            //買屋留言
            _this7.ajaxFormData(_this7.fc3Ajax, data);
          }
        } else {
          return false;
        }
      });
    }
  }]);

  return SendForm;
}();

//輸出


exports.HeaderSearchVal = HeaderSearchVal;
exports.SendForm = SendForm;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//物件追蹤
var Track = function () {
  function Track() {
    _classCallCheck(this, Track);

    this.objs = $('.objRealty article');
    this.btns = $('.trackBtns');
    this.objsH = $('#objHeader');
    this.objBtn = $('.objTrackBtn');
    this.objMore = $('.objRealtyMore .box');
    this.asideObjs = $('aside .realty>li');
    this.cancelBtn = $('.cancelTrack');
  }
  //加入 & 取消追蹤


  _createClass(Track, [{
    key: 'status',
    value: function status(btn, title) {
      if (btn.is('.active')) {
        // alert('【 ' + title + ' 】已加入追蹤！');
        Swal.fire({
          title: '【 ' + title + ' 】已加入追蹤！',
          icon: 'success',
          confirmButtonText: '確定'
        }).then(function (result) {
          if (result.isConfirmed) {
            location.reload();
          }
        });
      } else {
        // alert('【 ' + title + ' 】已移除追蹤！');
        Swal.fire({
          title: '【 ' + title + ' 】已移除追蹤！',
          icon: 'success',
          confirmButtonText: '確定'
        }).then(function (result) {
          if (result.isConfirmed) {
            location.reload();
          }
        });
      }
    }
    //物件cookie加入移除追蹤 (昀寬多加

  }, {
    key: 'cookieTrack',
    value: function cookieTrack(trackid) {
      $.post('ajax_objectinfo_cookie.php', { id: trackid }).done(function (e) {
        // $('body').addClass('active');
        // console.log(e);
        // location.reload();
      }, 'json');
    }
    //列表

  }, {
    key: 'toggleTrack',
    value: function toggleTrack() {
      var _this = this;

      this.objs.each(function (i, e) {
        $(e).find(_this.btns).on('click', function (j) {
          var $this = $(j.currentTarget);
          $this.toggleClass('active');
          _this.status($this, $(e).find('h3').text());
          _this.cookieTrack($this.data('trackid'));
        });
      });
    }
    //物件內頁 & 側邊攔

  }, {
    key: 'toggleAsideTrack',
    value: function toggleAsideTrack() {
      var _this2 = this;

      //物件內頁
      var objBtnTxt = this.objBtn.parent().find('span');
      if (this.objBtn.is('.active')) {
        objBtnTxt.text('移除追蹤');
      } else {
        objBtnTxt.text('加入追蹤');
      }
      this.objBtn.on('click', function () {
        _this2.objBtn.toggleClass('active');
        _this2.cookieTrack(_this2.objBtn.data('trackid'));
        _this2.status(_this2.objBtn, _this2.objsH.find('h3').text()); ////追蹤
      });
      var itemsTrack = function itemsTrack(el) {
        el.each(function (i, e) {
          $(e).find(_this2.btns).on('click', function (j) {
            var $this = $(j.currentTarget);
            $this.toggleClass('active');
            _this2.cookieTrack($this.data('trackid'));
            _this2.status($this, $(e).find('h3').text()); //追蹤
          });
        });
      };
      //物件內頁(其它推薦)
      itemsTrack(this.objMore);
      //文章內頁-側邊攔
      itemsTrack(this.asideObjs);
    }
    //移除追蹤(Header追蹤列表)

  }, {
    key: 'cancelTrack',
    value: function cancelTrack() {
      var _this3 = this;

      this.cancelBtn.on('click', function (e) {
        var $this = $(e.currentTarget);
        var objName = $this.parent().find('h3').text();
        /*
        if(confirm('移除【 ' + objName + ' 】追蹤？')){
          this.cookieTrack($this.data('trackid'));
        }else{
          return false;
        }
        */
        Swal.fire({
          title: '移除【 ' + objName + ' 】追蹤？',
          showDenyButton: true,
          confirmButtonText: '是',
          denyButtonText: '\u5426'
        }).then(function (result) {
          if (result.isConfirmed) {
            _this3.cookieTrack($this.data('trackid'));
          } else if (result.isDenied) {
            return false;
          }
        });
      });
    }
  }]);

  return Track;
}();

//輸出


exports.Track = Track;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var scope = typeof global !== "undefined" && global || typeof self !== "undefined" && self || window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function () {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function () {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout = exports.clearInterval = function (timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function () {};
Timeout.prototype.close = function () {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function (item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function (item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function (item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout) item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(55);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = typeof self !== "undefined" && self.setImmediate || typeof global !== "undefined" && global.setImmediate || undefined && undefined.setImmediate;
exports.clearImmediate = typeof self !== "undefined" && self.clearImmediate || typeof global !== "undefined" && global.clearImmediate || undefined && undefined.clearImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部SCSS

// import 'scss/app.scss';
//引入外部模組

// import {Personal} from '@/personal';


__webpack_require__(21);

var _common = __webpack_require__(1);

var _preloader = __webpack_require__(22);

var _link_effect = __webpack_require__(8);

var _fixed_tools = __webpack_require__(23);

var _header = __webpack_require__(24);

var _search_list = __webpack_require__(25);

var _lazyload = __webpack_require__(3);

var _txt_crop = __webpack_require__(28);

var _txt_zoom = __webpack_require__(29);

var _index_cover = __webpack_require__(30);

var _slider = __webpack_require__(31);

var _parallax = __webpack_require__(39);

var _lightbox = __webpack_require__(9);

var _qrcode = __webpack_require__(41);

var _vr = __webpack_require__(42);

var _track = __webpack_require__(16);

var _obj_list_ajax = __webpack_require__(46);

var _map = __webpack_require__(12);

var _form = __webpack_require__(13);

var _same_height = __webpack_require__(47);

var _tabs = __webpack_require__(48);

var _sticky = __webpack_require__(49);

var _textarea_auto_height = __webpack_require__(51);

var _other = __webpack_require__(14);

var _speech_form = __webpack_require__(52);

var _subscription = __webpack_require__(53);

var _sweetalert = __webpack_require__(54);

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import {useRef} from '../node_modules/infinite-scroll';


//子網站
// import NewRealty from '@/new_realty/app';
// import LineAI from '@/line_ai/app';


//各頁面控制項
var NavController = function () {
  function NavController() {
    _classCallCheck(this, NavController);

    this.nav = $('#navVal').val();
    // this.subsite    = $('#subsiteVal').val();
    // this.personalId = $('#personalIdVal').val();
  }
  //全域模組


  _createClass(NavController, [{
    key: 'commonModules',
    value: function commonModules() {
      //使用外部模組
      var iosFixed = new _common.IosFixed();
      var preloader = new _preloader.Preloader();
      var linkEffect = new _link_effect.LinkEffect();
      var fixedTools = new _fixed_tools.FixedTools();
      var navSearch = new _header.NavSearch();
      var search = new _search_list.Search();
      var lazyLoad = new _lazyload.LazyLoad();
      var lightbox = new _lightbox.Lightbox();
      var qrcode = new _qrcode.QRcode();
      var track = new _track.Track();
      // let footerAds       = new FooterAds;
      var headerSearchVal = new _other.HeaderSearchVal();
      // let subscription    = new Subscription; //訂閱相關

      iosFixed.metaViewport(); //iOS(iPad, iPhone) Meta Viewport 鎖定縮放拖曳
      preloader.loading(); //讀取頁面
      linkEffect.effect(); //頁面淡入淡出
      fixedTools.tools(); //視窗右下角固定工具列
      navSearch.navSearch(); //Rwd 導航列 & 搜尋列
      search.searchObj(); //Search
      lazyLoad.imgLoad(); //圖片延遲載入並裁切
      lazyLoad.scrollImgLoad(); //圖片延遲載入並裁切
      lightbox.qrcode(); //Lightbox-QR Code
      qrcode.webQRcode(); //QR Code-主體
      track.cancelTrack(); //加入追蹤-移除追蹤(Header追蹤列表)
      // footerAds.sliderModule();     //Footer Ads
      headerSearchVal.sendSearch(); //Header搜尋條件 (昀寬多加)
      //業務個人
      /*
      if(this.personalId !== undefined){
        //引入外部模組
        let personal = new Personal;
          personal.info();         //業務個人資訊
        lightbox.personal();     //Lightbox-業務個人資訊
        qrcode.personalQRcode(); //QR Code-業務個人
      }
      */
    } //commonModules() {

    //區域模組

  }, {
    key: 'navModules',
    value: function navModules() {
      //使用外部模組
      var iosFixed = new _common.IosFixed();
      var preloader = new _preloader.Preloader();
      var linkEffect = new _link_effect.LinkEffect();
      var navSearch = new _header.NavSearch();
      var search = new _search_list.Search();
      var txtCrop = new _txt_crop.TxtCrop();
      var txtZoom = new _txt_zoom.TxtZoom();
      var mapSearch = new _search_list.MapSearch();
      var acturlSearch = new _search_list.ActualSearch();
      var videoCover = new _index_cover.VideoCover();
      var indexBanner = new _slider.IndexBanner(); //預定刪除
      var indexObjsSlide = new _slider.IndexObjsSlider();
      var objsBannerImg = new _slider.ObjsBannerImg(); //預定刪除
      var parallaxBG = new _parallax.ParallaxBG();
      var lightbox = new _lightbox.Lightbox();
      var qrcode = new _qrcode.QRcode();
      var track = new _track.Track();
      var objListAJAX = new _obj_list_ajax.ObjListAJAX();
      var mapRealtyDetail = new _map.MapRealtyDetail();
      var mapRealtySearch = new _map.MapRealtySearch();
      var vr720 = new _vr.VR720();
      var asideRealtyForm = new _form.AsideRealtyForm();
      var contactForm = new _form.ContactForm();
      var sameHeight = new _same_height.SameHeight();
      var tabs = new _tabs.Tabs();
      var toggleSlide = new _tabs.ToggleSlide();
      var sticky = new _sticky.Sticky();
      var textareaAutoHeight = new _textarea_auto_height.TextareaAutoHeight();
      var sendForm = new _other.SendForm();
      var speechForm = new _speech_form.SpeechForm();
      var mortgage2 = new _form.Mortgage2();
      var subscription = new _subscription.Subscription(); //訂閱相關

      //判斷是否是空值
      if (this.nav == '') {
        this.nav = 'index';
      }

      switch (this.nav) {
        //首頁
        case 'index':
          this.commonModules(); //全域jQuery
          txtCrop.crop(); //文字裁切
          indexObjsSlide.sliderModule(); //觸控式物件
          track.toggleTrack(); //加入追蹤
          lightbox.map(); //Lightbox-Google Map
          lightbox.form(); //Lightbox-表單
          vr720.vr720(); //VR720
          sameHeight.resultHeight(); //列表物件相同高度

          /*
          if(this.subsite === undefined || this.subsite === ''){
            if(this.personalId === undefined){
              indexBanner.sliderModule();      //輪播Banner-首頁
              videoCover.videoCover();         //首頁CM影片
              lightbox.video();                //Lightbox-Video
              parallaxBG.parallax();           //背景圖滾差
            }
          }
          */
          break;
        //買屋 / 租屋 / 新成屋
        case 'buy':
        case 'rent':
        case 'all_object':
          // case 'new':
          this.commonModules(); //全域jQuery
          track.toggleTrack(); //加入追蹤
          objListAJAX.ajaxSearch(); //AJAX 物件列表
          lightbox.map(); //Lightbox-Google Map
          lightbox.form(); //Lightbox-表單
          break;
        case 'buy_d':
        case 'rent_d':
        case 'all_object_d':
          // case 'new_d':
          this.commonModules(); //全域jQuery
          objsBannerImg.sliderModule(); //觸控式物件
          qrcode.realtyQRcode(); //QR Code
          lightbox.image(); //Lightbox-圖片
          lightbox.map(); //Lightbox-Google Map
          lightbox.form(); //Lightbox-表單
          track.toggleTrack(); //加入追蹤-其它推薦
          track.toggleAsideTrack(); //加入追蹤-側邊攔
          mapRealtyDetail.mapAPI(); //週邊地圖
          vr720.vr720(); //VR720
          // asideRealtyForm.checkForm();  //表單欄位判斷
          tabs.tabsToggle(); //Tabs 切換 DIV
          sticky.move(); //捲軸區塊定位
          sendForm.asideRealtyForm(); //Aside表單送出 - 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)
          break;

        //買屋內的地圖  
        case 'ajax_realty_map':
          // this.commonModules();         //全域jQuery
          mapRealtyDetail.mapAPI(); //週邊地圖
          break;

        //地圖找屋
        case 'map_search':
          iosFixed.metaViewport(); //iOS(iPad, iPhone) Meta Viewport 鎖定縮放拖曳
          preloader.loading(); //讀取頁面
          linkEffect.effect(); //頁面淡入淡出
          navSearch.navSearch(); //Rwd 導航列 & 搜尋列
          search.searchObj(); //Search
          lightbox.qrcode(); //Lightbox-QR Code
          qrcode.webQRcode(); //QR Code-主體
          track.cancelTrack(); //加入追蹤-移除追蹤(Header追蹤列表)
          mapSearch.selected(); //地圖找屋搜尋列
          mapRealtySearch.mapAPI(); //地圖找屋-Google Map
          break;

        //企業徵才 / 關於幸福家
        case 'recruitment':
        case 'about':
          this.commonModules(); //全域jQuery
          lightbox.image(); //Lightbox-圖片
          break;

        //文章專欄(業務個人) / 企業社會責任 / 幸福新鮮事 / 房仲達人 / 房市新聞 / 購屋指南 / 室內好設計 / 相關法規
        case 'personal_articles':
        case 'csr':
        case 'activity':
        case 'expert':
        case 'news':
        case 'guide':
        case 'design':
        case 'law':
          this.commonModules(); //全域jQuery
          txtCrop.crop(); //文字裁切
          sameHeight.resultHeight(); //列表物件相同高度
          break;
        case 'personal_articles_d':
        case 'csr_d':
        case 'activity_d':
        case 'expert_d':
        case 'news_d':
        case 'guide_d':
        case 'design_d':
        case 'law_d':
          this.commonModules(); //全域jQuery
          txtCrop.crop(); //文字裁切
          txtZoom.zoom(); //文字大小
          lightbox.image(); //Lightbox-圖片
          lightbox.map(); //Lightbox-Google Map
          lightbox.form(); //Lightbox-表單
          track.toggleAsideTrack(); //加入追蹤-側邊攔
          sameHeight.resultHeight(); //列表物件相同高度
          sticky.move(); //捲軸區塊定位
          break;

        //服務據點
        case 'stores':
          this.commonModules(); //全域jQuery
          lightbox.map(); //Lightbox-Google Map
          break;

        //本月之星 / 百萬超級戰將 / 龍虎榜超級戰將 / 優質專員
        /*
        case 'star':
        case 'star_m':
        case 'star_m_d':
        case 'star_dt':
        case 'star_dt_d':
        case 'personal':
          this.commonModules(); //全域jQuery
          break;
        */

        //實價登錄
        case 'actual_buy':
        case 'actual_rent':
          this.commonModules(); //全域jQuery
          acturlSearch.selected(); //實價登錄搜尋列
          toggleSlide.toggleSlide(); //Toggle Slide
          break;

        //客服信箱
        case 'contact':
          this.commonModules(); //全域jQuery
          textareaAutoHeight.autoHeight(); //文字欄位高度自動
          contactForm.checkForm(); //表單欄位判斷
          sendForm.contactForm(); //表單送出 - 客服信箱 (朝凱多加)
          break;

        //隱私權暨服務條款
        //隱私全條款 20230208 kai 改
        case 'private':
          this.commonModules(); //全域jQuery
          break;
        //隱私權暨服務條款
        //服務條款 20230208 kai 改
        case 'service_terms':
          this.commonModules(); //全域jQuery
          break;

        //房貸試算
        case 'formAlculate':
          this.commonModules(); //全域jQuery
          mortgage2.resultMortgage();
          // lightbox.form();  //Lightbox-表單
          break;

        //演講報名表
        /*
        case 'speech_form':
          this.commonModules(); //全域jQuery
          speechForm.form();
          break;
        */

        //app 我的訂閱條件表 - 增加
        case 'subscription_onsale_add':
          navSearch.navSearch(); //Rwd 導航列 & 搜尋列
          search.searchObj(); //Search
          mapSearch.selected(); //地圖找屋搜尋列
          subscription.addCondition(); //訂閱儲存處理
          break;

        //app 我的訂閱條件表 - 編輯
        case 'subscription_onsale_edit':
          navSearch.navSearch(); //Rwd 導航列 & 搜尋列
          search.searchObj(); //Search
          mapSearch.selected(); //地圖找屋搜尋列
          subscription.editCondition(); //訂閱儲存處理
          break;

        //app 我的訂閱條件表 - 列表
        case 'subscription_onsale':
          navSearch.navSearch(); //Rwd 導航列 & 搜尋列
          search.searchObj(); //Search
          mapSearch.selected(); //地圖找屋搜尋列
          subscription.delCondition(); //訂閱刪除處理
          subscription.noticeChange(); //訂閱通知處理
          break;

        case 'subscription_onsale_objs':
          subscription.jsonLoading(); //下拉ajax
          break;
        case 'subscription_onsale_objs_priceChange':
          // subscription.jsonLoading(); //下拉ajax
          break;

        //我的訂閱-地圖列表
        case 'subscription_map_objs':
          subscription.jsonLoading(); //下拉ajax
          break;
        case 'subscription_map':
          subscription.noticeChange(); //訂閱通知處理
          subscription.delCondition(); //訂閱刪除處理
          break;

      } //switch(this.nav) {

      //子網站
      /*
      switch(this.subsite) {
        //新建案
        case 'new_realty':
        case 'new_realty_years':
        case 'new_realty_d':
          //全域模組
          this.commonModules();
          //QR Code
          qrcode.realtyQRcode();
          //加入追蹤-側邊攔
          track.toggleAsideTrack();
          //Lightbox-圖片
          lightbox.image();
           //Lightbox-表單
          lightbox.form();
          //使用外部模組
          let newRealty= new NewRealty;
          newRealty.publicModules();
          break;
          //智慧房產
        case 'line_ai':
          //全域模組
          this.commonModules();
          //使用外部模組
          let lineAI = new LineAI;
          lineAI.publicModules();
          break;
      }
      */
    }
    //整合

  }, {
    key: 'publicModules',
    value: function publicModules() {
      this.navModules();
    }
  }]);

  return NavController;
}();

//輸出


var navController = new NavController();
navController.publicModules();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Preloader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


var _common = __webpack_require__(1);

var _body_ctrl = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//引入外部模組
var bodyCtrl = new _body_ctrl.BodyCtrl();

//讀取頁面

var Preloader = function () {
  function Preloader() {
    _classCallCheck(this, Preloader);

    this.preloader = $('#preloader');
    this.logo = this.preloader.find('.icon');
    this.time = 500;
  }

  _createClass(Preloader, [{
    key: 'loading',
    value: function loading() {
      /*
      (checkDevice.ios || checkDevice.android) ? bodyCtrl.ctrl('scrollHideF') : bodyCtrl.ctrl('scrollHide');
      this.logo.addClass('active');
      $(window).on('load', () => {
        setTimeout(() => {
          this.logo.removeClass('active');
          this.preloader.addClass('active');
          bodyCtrl.ctrl('scrollShow');  //控制瀏覽器捲軸
          bodyCtrl.ctrl('scrollShowF'); //控制瀏覽器捲軸
        }, this.time);
      });
      */
      this.logo.removeClass('active');
      this.preloader.addClass('active');
    }
  }]);

  return Preloader;
}();

//輸出


exports.Preloader = Preloader;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FixedTools = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


__webpack_require__(5);

var _body_ctrl = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//引入外部模組
var bodyCtrl = new _body_ctrl.BodyCtrl();

//視窗右下角固定工具列

var FixedTools = function () {
  function FixedTools() {
    _classCallCheck(this, FixedTools);

    this.window = $(window);
    this.fixedTools = $('#fixedTools');
    this.scrollTopBtn = this.fixedTools.find('.scrollTopBtn');
    this.onlineServiceBtn = this.fixedTools.find('.onlineServiceBtn');
    this.onlineServiceTip = this.onlineServiceBtn.find('.tip');
    this.onlineService = $('#onlineService');
    this.serviceContant = this.onlineService.find('.contant');
    this.headerP = $('#personalHeader');
    this.infoFixed = $('#personalInfoFixed');
  }

  _createClass(FixedTools, [{
    key: 'tools',
    value: function tools() {
      var _this = this;

      //工具列顯示 & 隱藏
      var showHide = function showHide() {
        _this.window.scrollTop() > 100 ? _this.scrollTopBtn.show() : _this.scrollTopBtn.hide();
      };
      showHide();

      //RWD 業務個人資訊
      var rwdPersonal = function rwdPersonal() {
        if (window.matchMedia('(max-width: 1023px)').matches) {
          var bottomPosition = function bottomPosition(position) {
            _this.fixedTools.css('bottom', _this.infoFixed.outerHeight() + position);
            if (_this.headerP.length != 0) {
              if (_this.infoFixed.is('.hide')) {
                if (_this.infoFixed.is('.active')) {
                  _this.fixedTools.css('bottom', _this.infoFixed.outerHeight() + position);
                } else {
                  _this.fixedTools.css('bottom', position);
                }
              }
            }
          };
          if (window.matchMedia('(max-width: 600px)').matches) {
            bottomPosition(10);
          } else {
            bottomPosition(20);
          }
        } else {
          _this.fixedTools.css('bottom', '');
        }
      };
      rwdPersonal();

      this.window.on('scroll', function () {
        showHide();
        rwdPersonal();
      });
      //RWD 業務個人資訊
      this.window.on('resize', rwdPersonal);

      //回最上面
      this.scrollTopBtn.on('click', function () {
        bodyCtrl.ctrl('scrollHide'); //控制瀏覽器捲軸
        bodyCtrl.ctrl('btnLock'); //控制瀏覽器按鈕
        $('html, body').animate({
          scrollTop: 0
        }, 500, 'easeOutExpo', function () {
          bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
          bodyCtrl.ctrl('btnUnlock'); //控制瀏覽器按鈕
        });
        return false;
      });

      //線上客服提示初始顯示
      this.onlineServiceBtn.find('span').addClass('active');
      setTimeout(function () {
        _this.onlineServiceBtn.find('span').removeClass('active');
      }, 5000);

      //線上客服
      if (this.onlineService.is('.login')) {
        //開啟
        this.onlineServiceBtn.on('click', function () {
          _this.onlineServiceTip.removeClass('active');
          _this.onlineService.addClass('active');
          if (window.matchMedia('(max-width: 767px)').matches) {
            if (_this.onlineService.is('.active')) {
              bodyCtrl.ctrl('scrollHide'); //控制瀏覽器捲軸
            }
          } else {
            bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
          }
        });
        //關閉
        this.onlineService.find('.titleBar button').on('click', function () {
          _this.onlineService.removeClass('active');
          bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
        });
        this.onlineService.find('.loginInfo button').on('click', function () {
          _this.onlineService.removeClass('active');
          bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
        });
        //點擊外圍關閉
        $(document).on('click', function () {
          _this.onlineService.removeClass('active');
        });
        this.onlineService.add(this.onlineServiceBtn).on('click', function (e) {
          e.stopPropagation();
        });

        //RWD
        var rwdOnlineService = function rwdOnlineService() {
          //控制瀏覽器捲軸
          if (_this.onlineService.is('.active')) {
            if (window.matchMedia('(max-width: 767px)').matches) {
              bodyCtrl.ctrl('scrollHide');
            } else {
              bodyCtrl.ctrl('scrollShow');
            }
          }
          //對話框長度
          if (window.matchMedia('(max-width: 767px)').matches) {
            _this.serviceContant.find('ul').css('height', '');
          } else {
            _this.serviceContant.find('ul').css('height', $(window).height() / 2.5);
          }
        };
        rwdOnlineService();
        this.window.on('resize', rwdOnlineService);
      }
    }
  }]);

  return FixedTools;
}();

//輸出


exports.FixedTools = FixedTools;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavSearch = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


var _common = __webpack_require__(1);

var _body_ctrl = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//引入外部模組
var bodyCtrl = new _body_ctrl.BodyCtrl();

//Header 顯示 & 影藏
/*
class HeaderParallax {
  constructor() {
    this.body      = $('body');
    this.header    = $('header');
    this.container = $('#container>section, #container>div');
  }
  toggleActive(scrollTop, prev) {
    this.header.toggleClass('active', scrollTop > prev);
    if(scrollTop == 0 || scrollTop < 0){
      this.header.removeClass('active');
    }
  }
  showHide() {
    let prev = 0;
    $(window).on('scroll', (e) => {
      const $this   = $(e.currentTarget);
      let scrollTop = $this.scrollTop();
      if(scrollTop >= this.container.offset().top){
        this.toggleActive(scrollTop, prev);
        prev = scrollTop;
      }else{
        this.header.removeClass('active');
      }
      if(this.body.is('.scrollHide') || this.body.is('.scrollHideF')){
        this.header.removeClass('active');
        prev = scrollTop;
      }
    });
  }
}
*/

//Rwd 導航列 & 搜尋列

var NavSearch = function () {
  function NavSearch() {
    _classCallCheck(this, NavSearch);

    //搜尋列
    this.search = $('#rwdSearch');
    this.searchOpen = $('#rwdSearchOpen'); //手機板搜尋選單
    this.searchOpenHref = $('#hrefSearchOpen'); //電腦版搜尋選單
    this.searchClose = $('#rwdSearchClose');
    this.searchTabs = this.search.find('.tabs input:radio');
    this.selectBtn = this.search.find('button');
    this.selectBox = this.search.find('.selectBox');

    //追蹤列表
    this.track = $('#rwdTrack');
    this.trackOpen = $('#rwdTrackOpen');
    this.trackClose = $('#rwdTrackClose');

    //導航列
    this.nav = $('#rwdNav');
    this.navOpen = $('#rwdNavOpen');
    this.navClose = $('#rwdNavClose');
    this.scrollBox = this.nav.find('.scrollBox');

    this.lightbox = $('#rwdLightbox');
  }

  _createClass(NavSearch, [{
    key: 'action',
    value: function action(el, open, close) {
      var _this = this;

      var removeRwd = function removeRwd() {
        bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
        bodyCtrl.ctrl('scrollShowF'); //控制瀏覽器捲軸
        el.removeClass('active');
        _this.lightbox.removeClass('active');
        _this.selectBtn.removeClass('active');
        _this.selectBox.removeClass('active');
      };
      open.on('click', function () {
        _common.checkDevice.ios || _common.checkDevice.android ? bodyCtrl.ctrl('scrollHideF') : bodyCtrl.ctrl('scrollHide');
        _this.selectBtn.removeClass('active');
        _this.scrollBox.scrollTop(0);
        _this.selectBox.removeClass('active');
        _this.lightbox.addClass('active');
        el.addClass('active');
      });
      this.lightbox.on('click', function () {
        removeRwd();
      });
      close.on('click', function () {
        removeRwd();
      });
    }
  }, {
    key: 'hrefLocation',
    value: function hrefLocation(ahref) {
      ahref.on('click', function () {
        if ($('input[name=personalId]').val() != '') {
          location.href = './' + $('input[name=personalId]').val() + '?nav=buy';
        } else {
          location.href = './?nav=buy';
        }
      });
    }
  }, {
    key: 'navSearch',
    value: function navSearch() {
      //搜尋列
      this.action(this.search, this.searchOpen, this.searchClose);
      //追蹤列表
      this.action(this.track, this.trackOpen, this.trackClose);
      //導航列
      this.action(this.nav, this.navOpen, this.navClose);
      //給值
      this.hrefLocation(this.searchOpenHref);
    }
  }]);

  return NavSearch;
}();

//輸出


exports.NavSearch = NavSearch;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActualSearch = exports.MapSearch = exports.Search = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


var _common = __webpack_require__(1);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//縣市區域
var City = function () {
  function City(el, thisEl, idA) {
    _classCallCheck(this, City);

    this.el = el;
    this.thisEl = thisEl;
    // this.printEl       = this.thisEl.find('span');
    this.cityEl = this.el.find('.selectCity');
    this.areaEl = this.el.find('.selectArea');
    this.printEl = $('.city').find('span');
    // this.cityEl        = $('.selectCity');
    // this.areaEl        = $('.selectArea');
    this.idA = idA;
    this.allEl = this.areaEl.find('#' + this.idA + 'All');
    this.dataAreaEl = this.areaEl.find('.data');
    // this.dataAreaEl    = $('.city').find('.data');

    this.searchForm = $('#rwdSearchForm'); //右側側邊搜尋
    this.webSearchForm = $('#webSearchForm'); //網頁版上方搜尋

    this.resoultCity = '';
    this.resoultArea = '';
  }
  //搜尋類別-初始化


  _createClass(City, [{
    key: 'tabsReturn',
    value: function tabsReturn(el) {
      var _this = this;

      el.on('change', function () {
        _this.dataAreaEl.empty();
        _this.printEl.html('縣市區域');
      });
    }
    //返回縣市

  }, {
    key: 'backCity',
    value: function backCity(areaSelect) {
      var _this2 = this;

      this.areaEl.find('.back').on('click', function () {
        _this2.areaEl.removeClass('active').one(_common.transitionEnd, function () {
          //清空區域 DOM & 選取
          _this2.areaEl.find(areaSelect).prop('checked', false);
          _this2.dataAreaEl.empty();
          //返回清空縣市選取
          _this2.cityEl.find('input[type=radio]').prop('checked', false);
          _this2.cityEl.addClass('active');
          _this2.printEl.html('縣市區域');
        });
      });
    }
    //模組1

  }, {
    key: 'cityModule1',
    value: function cityModule1(cityType) {
      var _this3 = this;

      //判斷是否有選取，如無選取，引入縣市資料
      //如有選取，直接跳入區域選取
      var checkedNum = this.areaEl.find(':checkbox:checked').length;
      // let checkedNum = $('.selectArea').find(':checkbox:checked').length;

      if (checkedNum != 0) {
        this.areaEl.addClass('active');
        // $('.selectArea').addClass('active');
      } else {
        //尚未選取，開起城市選單
        this.thisEl.next(this.cityEl).addClass('active');
        // console.log('打開城市');
        //縣市區域切換選取
        this.cityEl.find(':radio').each(function (i, j) {
          $(j).off('change').on('change', function () {

            //跳出縣市選項時，則清空舊有條件(昀寬多加)
            // console.log('打開區選單');
            // $('.searchCancel').html(''); //清除舊有資料區(城市、區都清)
            if ($(j).is(':checked')) {
              $('.cityAreaInput').val(''); //舊有條件移除(縣市、區皆移除)
              //記錄縣市並顯示縣市文字
              _this3.resoultCity = $(j).val();
              _this3.printEl.html(_this3.resoultCity);
              $('#cityString').val($(j).val()); //將城市資料丟進input

              //切換區域選取
              _this3.cityEl.removeClass('active').one(_common.transitionEnd, function () {
                _this3.areaEl.addClass('active');
              });

              /*
              $('.selectCity').removeClass('active').one(transitionEnd, () => {
                $('.selectArea').addClass('active');
              }); 
              */
              //引入區域資料
              $.post('ajax_obj_realty_area.php', { cityId: i, type: cityType }, function (areaData) {
                //清除原有資料(城市、縣市)

                $('.searchCancel').html('');
                //產生 DOM
                _this3.dataAreaEl.append(areaData);
                //改成開啟兩邊的area選擇
                // $('.city').find('.data').append(areaData);

                //預設區域不限
                _this3.allEl.prop('checked', true);
                // $('.selectArea .selectAll').find(':checkbox').prop('checked', true); //兩邊全選

                //區域選項
                // $('.selectArea').find(':checkbox').change((e) => {
                _this3.areaEl.find(':checkbox').change(function (e) {
                  // console.log('點擊cehckbox進入');
                  // console.log('join');
                  var $this = $(e.currentTarget);
                  var $cbEl = _this3.dataAreaEl.find(':checkbox');
                  var checkedLength = _this3.dataAreaEl.find(':checkbox:checked').length;
                  // const $cbEl       = $('.selectArea').find(':checkbox');
                  // let checkedLength = $('.selectArea').find(':checkbox:checked').length;
                  // let checkedLength = this.el.find('.data :checkbox:checked').length; //記算筆數
                  //已選擇數組
                  // let areaVal =  this.dataAreaEl.find(':checkbox:checked').map(function() { return $(this).val() }).get().join(","); //抓取已有的區域資料
                  //---判斷其它form是否以一樣的項目，並做同步選取
                  var checkName = $this.attr('name'); //找出選取的name值
                  var checkVal = $this.attr('value'); //找出選取的值
                  var checkStatus = $this.prop('checked'); //勾選狀態
                  // console.log( checkName +":"+ checkVal +":"+ checkStatus );

                  $('form input[name="' + checkName + '"]').each(function (index, element) {
                    if (checkVal == $(element).attr('value')) {
                      // $(element).attr('checked',checkStatus); 
                      $(element).prop('checked', checkStatus);
                    } //if(checkVal == $(element).attr('value')) {
                  });
                  //---判斷其它form是否以一樣的項目，並做同步選取

                  // console.log('這是那裡,我是誰,我在幹嘛1');

                  //顯示縣市 & 已選取區域總數目結果文字
                  var printTxt = function printTxt() {
                    _this3.resoultArea = ' 已選擇<i>' + checkedLength + '</i>筆';
                    _this3.printEl.html(_this3.resoultCity + _this3.resoultArea);
                  };
                  //若其它區域無選取，則返回區域不限
                  var checkBackAll = function checkBackAll() {
                    if (checkedLength == 0) {
                      _this3.allEl.prop('checked', true);
                      // $('.selectArea .selectAll checkbox').prop('checked', true);
                      _this3.printEl.html(_this3.resoultCity);
                    }
                  };
                  if ($this.is('#' + _this3.idA + 'All')) {
                    //選取區域不限
                    if ($this.is(':checked')) {
                      $cbEl.prop('checked', false);
                      _this3.printEl.html(_this3.resoultCity);
                    } else {
                      checkBackAll();
                    }
                  } else if (checkedLength >= $cbEl.length) {
                    //若選取全部，則返回區域不限
                    $cbEl.prop('checked', false);
                    _this3.allEl.prop('checked', true);
                    _this3.printEl.html(_this3.resoultCity);
                  } else {
                    //選取其它區域
                    if ($this.is(':checked')) {
                      _this3.allEl.prop('checked', false);
                      printTxt();
                    } else {
                      printTxt();
                      checkBackAll();
                    }
                  }
                });
              });
            }
          });
        });
        //返回縣市
        this.backCity('input[type=checkbox]');
      }
    }
    //模組2

  }, {
    key: 'cityModule2',
    value: function cityModule2(cityType) {
      var _this4 = this;

      //判斷是否有選取，如無選取，引入縣市資料
      //如有選取，直接跳入區域選取
      var checkedNum = this.areaEl.find(':radio:checked').length;
      if (checkedNum != 0) {
        this.areaEl.addClass('active');
      } else {
        this.thisEl.next(this.cityEl).addClass('active');

        // $('.cityAreaInput').val('');//舊有條件移除(縣市、區皆移除)
        this.cityEl.find(':radio').prop('checked', false); //舊有條件移除(縣移除)

        //縣市區域切換選取
        this.cityEl.find(':radio').each(function (i, j) {
          $(j).off('change').on('change', function () {
            if ($(j).is(':checked')) {
              //記錄縣市並顯示縣市文字
              _this4.resoultCity = $(j).val();
              _this4.printEl.html(_this4.resoultCity);

              //切換區域選取
              _this4.cityEl.removeClass('active').one(_common.transitionEnd, function () {
                _this4.areaEl.addClass('active');
              });
              //引入區域資料
              $.post('ajax_obj_realty_area.php', { cityId: i, type: cityType }, function (areaData) {
                //產生 DOM
                // this.dataAreaEl.append(areaData);
                _this4.dataAreaEl.html(areaData);

                //比對是否有訂閱此輸出的區域
                var areaClassArray = $('.areaClass').val(); //只會有一筆

                if (areaClassArray) {
                  //有訂閱 - 區
                  _this4.areaEl.find(':radio').each(function (i, e) {
                    if (e.value == areaClassArray) {
                      //e為物件型態
                      e.setAttribute('checked', true);
                    }
                  }); //areaData.find(':radio').each((e) => {
                } else {
                  //無訂閱 - 預設區域不限
                  _this4.allEl.prop('checked', true);
                }

                //區域選項
                _this4.areaEl.find(':radio').change(function (e) {
                  var $this = $(e.currentTarget);
                  var $cbEl = _this4.dataAreaEl.find(':radio');
                  var cbVal = _this4.dataAreaEl.find(':radio:checked').val();
                  var checkedLength = _this4.dataAreaEl.find(':radio:checked').length;

                  //清空舊有條件
                  $('.searchCancel').html(' ');
                  //顯示縣市 & 已選取區域結果文字
                  var printTxt = function printTxt() {
                    _this4.resoultArea = ' -<i>' + cbVal + '</i>';
                    _this4.printEl.html(_this4.resoultCity + _this4.resoultArea);
                  };
                  //若其它區域無選取，則返回區域不限
                  var checkBackAll = function checkBackAll() {
                    if (checkedLength == 0) {
                      _this4.allEl.prop('checked', true);
                      _this4.printEl.html(_this4.resoultCity);
                    }
                  };
                  if ($this.is('#' + _this4.idA + 'All')) {
                    //選取區域不限
                    if ($this.is(':checked')) {
                      $cbEl.prop('checked', false);
                      _this4.printEl.html(_this4.resoultCity);
                    } else {
                      checkBackAll();
                    }
                  } else if (checkedLength >= $cbEl.length) {
                    //若選取全部，則返回區域不限
                    $cbEl.prop('checked', false);
                    _this4.allEl.prop('checked', true);
                    _this4.printEl.html(_this4.resoultCity);
                  } else {
                    //選取其它區域
                    if ($this.is(':checked')) {
                      _this4.allEl.prop('checked', false);
                      printTxt();
                    } else {
                      printTxt();
                      checkBackAll();
                    }
                  }
                });
              });
            }
          });
        });
        //返回縣市
        this.backCity('input[type=radio]');
      }
    }
  }]);

  return City;
}();

//建立模組


var SelectModule = function () {
  function SelectModule(thisEl, idS, idL, returnTxt, idTxt, unit) {
    _classCallCheck(this, SelectModule);

    this.thisEl = thisEl;
    this.printEl = this.thisEl.find('span');
    this.selectEl = this.thisEl.next('.selectBox');
    this.dataEl = this.selectEl.find('.data');
    this.cbEl = this.dataEl.find(':checkbox');
    this.allCBL = this.dataEl.find(':checkbox:checked').length;
    this.allCBLRad = this.dataEl.find(':radio:checked').length;

    this.idS = idS;
    this.idL = idL;
    this.returnTxt = returnTxt;
    this.idTxt = idTxt;
    this.unit = unit;
    this.allEl = this.selectEl.find('#' + this.idS + 'All'); //全部選取checkbox
    // this.allEl     = $('#' + this.idS + 'All'); //全部選取checkbox
    this.minEl = $('#min' + this.idL); //最小值
    this.maxEl = $('#max' + this.idL); //最大值
    this.moreEl = this.selectEl.find('li.' + this.idS);

    this.searchForm = $('#rwdSearchForm'); //右側側邊搜尋
    this.webSearchForm = $('#webSearchForm'); //網頁版上方搜尋

    this.divName = this.printEl.parents('div').attr('class'); //抓出目前所在範圍的div名稱
    this.objName = $('.' + this.divName); //宣告成object
    this.inputText = $('.' + this.divName).find('.inputBox input[type=tel]'); //此區塊的數字欄位

    this.resoult = ''; //最後結果
    this.pushArray = []; //選取後加入陣列(篩選比對用)
    this.filterArray = []; //篩選比對後陣列
    this.min = ''; //最小值
    this.max = ''; //最大值
  }

  //點擊搜尋類別初始化


  _createClass(SelectModule, [{
    key: 'tabsReturn',
    value: function tabsReturn(el) {
      var _this5 = this;

      el.on('change', function () {
        _this5.printEl.html(_this5.returnTxt);
      });
    }

    //顯示結果文字

  }, {
    key: 'printTxt',
    value: function printTxt(txt) {
      switch (txt) {
        case 'between':
          this.resoult = '<i>' + this.minEl.val() + '</i>' + this.unit + ' -' + '<i>' + this.maxEl.val() + '</i>' + this.unit;
          break;
        case 'up':
          this.resoult = '<i>' + this.minEl.val() + '</i>' + this.unit + '以上';
          break;
        case 'down':
          this.resoult = '<i>' + this.maxEl.val() + '</i>' + this.unit + '以下';
          break;
        case 'only':
          this.resoult = '<i>' + this.maxEl.val() + '</i>' + this.unit;
          break;
      }
      // this.printEl.html(this.resoult);
      this.objName.find('.selectBtn span').html(this.resoult);
    }
    //預設選取不限

  }, {
    key: 'checkAll',
    value: function checkAll() {
      if (this.allCBL == 0 && this.minEl.val() == '' && this.maxEl.val() == '') {
        this.allEl.prop('checked', true);
        this.printEl.html(this.idTxt + '不限');
        // this.objName.find('.selectAll :checkbox').prop('checked', true); //選取底下的checkbox all
        // this.objName.find('.selectBtn span').html('<i>'+this.idTxt + '不限</i>'); //改變span的範圍標題
      }
    }
    //若其它無選取，則返回不限

  }, {
    key: 'checkBackAll',
    value: function checkBackAll() {
      this.pushArray.length = 0;
      this.filterArray.length = 0;
      // this.cbEl.prop('checked', false);
      // this.allEl.prop('checked', true);
      // this.minEl.val('');
      // this.maxEl.val('');
      //一起處理有同名的divname
      // console.log(this.objName);
      this.objName.find(':checkbox').prop('checked', false); //將底下所有checkbox取消選取
      this.objName.find(':radio').prop('checked', false); //將底下所有radio取消選取
      this.objName.find('.selectAll :checkbox').prop('checked', true); //選取底下的checkbox all
      this.objName.find('.inputBox input').val('');
      this.objName.find('.inputBox input').val('');
    }
    //僅輸入數字

  }, {
    key: 'onlyNumber',
    value: function onlyNumber() {
      this.minEl.add(this.maxEl).on('input', function (e) {
        var $this = $(e.currentTarget);
        var filterVal = $this.val().replace(/[！-～]/g, function (tmpStr) {
          return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
        });
        $this.val(filterVal.replace(/[^0-9]/g, ''));
      });
    }
    //欄位輸入(輸出文字)

  }, {
    key: 'inputCheckPublic',
    value: function inputCheckPublic() {
      var _this6 = this;

      var check = function check(e, range, m1, m2) {
        var $this = $(e.currentTarget);
        _this6.pushArray.length = 0;
        _this6.filterArray.length = 0;
        _this6.allEl.prop('checked', false);
        _this6.cbEl.prop('checked', false);
        //顯示結果文字
        if ($this.val() != '' && range.val() == '') {
          _this6.printTxt(m1);
        } else if ($this.val() == '' && range.val() != '') {
          _this6.printTxt(m2);
        } else if ($this.val() == '' && range.val() == '') {
          _this6.allEl.prop('checked', true);
          _this6.printEl.html(_this6.idTxt + '不限');
        } else {
          _this6.printTxt('between');
        }
      };
      this.minEl.keyup(function (e) {
        check(e, _this6.maxEl, 'up', 'down');
      });
      this.maxEl.keyup(function (e) {
        check(e, _this6.minEl, 'down', 'up');
      });
      //僅輸入數字
      this.onlyNumber();
    }
    //欄位輸入

  }, {
    key: 'inputCheck',
    value: function inputCheck() {
      var _this7 = this;

      var check = function check(e, range) {
        var $this = $(e.currentTarget);
        _this7.pushArray.length = 0;
        _this7.filterArray.length = 0;
        _this7.allEl.prop('checked', false);
        _this7.cbEl.prop('checked', false);
        //無輸入返回不限
        if ($this.val() == '' && range.val() == '') {
          _this7.allEl.prop('checked', true);
        }
      };
      this.minEl.keyup(function (e) {
        check(e, _this7.maxEl);
      });
      this.maxEl.keyup(function (e) {
        check(e, _this7.minEl);
      });
      //僅輸入數字
      this.onlyNumber();
    }
    //最小最大值

  }, {
    key: 'minMax',
    value: function minMax() {
      var _this8 = this;

      //設為空陣列
      this.pushArray.length = 0;
      this.filterArray.length = 0;
      //移除文字，僅留下數字
      this.dataEl.find(':checkbox:checked').each(function (index, el) {
        var num = $(el).val().match(/\d+/g);
        if (num != null) {
          $.map(num, function (x, y) {
            //傳至陣列
            return _this8.pushArray.push(x);
          });
        } else {
          return;
        }
        //過濾重覆數字
        _this8.filterArray = _this8.pushArray.filter(function (x, y, z) {
          return z.indexOf(x) === y;
        });
      });
      //最小最大值
      this.min = Math.min.apply(Math, _toConsumableArray(this.filterArray));
      this.max = Math.max.apply(Math, _toConsumableArray(this.filterArray));
    }
    //模組1(總價、建坪)

  }, {
    key: 'module1',
    value: function module1() {
      var _this9 = this;

      //打開
      this.selectEl.addClass('active');
      //預設選取不限
      this.checkAll();
      //欄位輸入(輸出文字)
      this.inputCheckPublic();
      //選取後動作
      this.selectEl.find(':checkbox').on('change', function (e) {
        var $this = $(e.currentTarget);
        var dataCBL = _this9.dataEl.find(':checkbox:checked').length;

        //---判斷其它form是否以一樣的項目，並做同步選取
        var checkName = $this.attr('name'); //找出選取的name值
        var checkVal = $this.attr('value'); //找出選取的值
        var checkStatus = $this.prop('checked'); //勾選狀態

        $('form input[name="' + checkName + '"]').each(function (index, element) {
          if (checkVal == $(element).attr('value')) {
            // $(element).attr('checked',checkStatus); 
            $(element).prop('checked', checkStatus);
          } //if(checkVal == $(element).attr('value')) {
        });
        //---判斷其它form是否以一樣的項目，並做同步選取
        if ($this.is(_this9.allEl)) {
          //選取不限
          _this9.checkBackAll();
          // this.printEl.html(this.idTxt + '不限');
          _this9.objName.find('.selectBtn span').html('<i>' + _this9.idTxt + '不限</i>'); //改變span的範圍標題
        } else {
          // this.allEl.prop('checked', false); //取消選取all

          _this9.objName.find('.selectAll :checkbox').prop('checked', false); //選取底下的checkbox all改為false

          //選取比對後顯示
          var resoultTxt = function resoultTxt() {
            //最小最大值
            _this9.minMax();
            // if($('#' + this.idS + 'Down').is(':checked')){
            if (_this9.objName.find('.data input[type=checkbox]:first').is(':checked')) {
              //XXX以下
              _this9.inputText.eq(0).val('');
              _this9.inputText.eq(1).val(_this9.max);
              _this9.inputText.eq(2).val('');
              _this9.inputText.eq(3).val(_this9.max);
              // this.minEl.val('');
              // this.maxEl.val(this.max);
              //顯示結果文字
              //$('.'+this.divName).find('.selectBtn span').html();
              _this9.printTxt('down');
              // }else if($('#' + this.idS + 'Up').is(':checked')){
            } else if (_this9.objName.find('.data input[type=checkbox]:last').is(':checked')) {
              //XXX以上
              // this.minEl.val(this.min);
              // this.maxEl.val('');
              _this9.inputText.eq(0).val(_this9.min);
              _this9.inputText.eq(1).val();
              _this9.inputText.eq(2).val(_this9.min);
              _this9.inputText.eq(3).val();
              //顯示結果文字
              _this9.printTxt('up');
            } else {
              // this.minEl.val(this.min);
              // this.maxEl.val(this.max);
              _this9.inputText.eq(0).val(_this9.min);
              _this9.inputText.eq(1).val(_this9.max);
              _this9.inputText.eq(2).val(_this9.min);
              _this9.inputText.eq(3).val(_this9.max);
              //顯示結果文字
              _this9.printTxt('between');
            }
            //XXX以下 & XXX以上同時選取，則返回不限
            if ($('#' + _this9.idS + 'Down').is(':checked') && $('#' + _this9.idS + 'Up').is(':checked')) {
              // this.cbEl.prop('checked', false);
              _this9.objName.find('.selectAll :checkbox').prop('checked', false); //選取底下的checkbox all改為false
              //若其它無選取，則返回不限
              _this9.checkBackAll();
              // this.printEl.html(this.idTxt + '不限');
              _this9.objName.find('.selectBtn span').html('<i>' + _this9.idTxt + '不限</i>'); //改變span的範圍標題
            }
          };
          //選取其它
          if ($this.is(':checked')) {
            //選取比對後顯示
            resoultTxt();
          } else {
            //選取比對後顯示
            resoultTxt();
            //若其它無選取，則返回不限
            if (dataCBL == 0) {
              _this9.checkBackAll();
              // this.printEl.html(this.idTxt + '不限');
              _this9.objName.find('.selectBtn span').html('<i>' + _this9.idTxt + '不限</i>'); //改變span的範圍標題
            }
          }
        }
      }); // this.selectEl.find(':checkbox').on('change', (e) => {
    }
    //模組2(房數)

  }, {
    key: 'module2',
    value: function module2() {
      var _this10 = this;

      //打開
      this.selectEl.addClass('active');
      //預設選取不限
      this.checkAll();
      //欄位輸入(輸出文字)
      this.inputCheckPublic();
      //選取後動作
      this.selectEl.find(':checkbox').on('change', function (e) {
        var $this = $(e.currentTarget);
        var dataCBL = _this10.dataEl.find(':checkbox:checked').length;

        //---判斷其它form是否以一樣的項目，並做同步選取
        var checkName = $this.attr('name'); //找出選取的name值
        var checkVal = $this.attr('value'); //找出選取的值
        var checkStatus = $this.prop('checked'); //勾選狀態

        $('form input[name="' + checkName + '"]').each(function (index, element) {
          if (checkVal == $(element).attr('value')) {
            $(element).prop('checked', checkStatus);
          } //if(checkVal == $(element).attr('value')) {
        });

        //---判斷其它form是否以一樣的項目，並做同步選取

        if ($this.is(_this10.allEl)) {
          //選取不限
          _this10.checkBackAll();
          _this10.objName.find('.selectBtn span').html('<i>' + _this10.idTxt + '不限</i>'); //改變span的範圍標題
          // this.printEl.html(this.idTxt + '不限');
        } else {
          // this.allEl.prop('checked', false);
          _this10.objName.find('.selectAll :checkbox').prop('checked', false); //選取底下的checkbox all改為false

          //選取比對後顯示
          var resoultTxt = function resoultTxt() {
            //最小最大值
            _this10.minMax();
            if ($('#' + _this10.idS + 'Up').is(':checked')) {
              // if(  this.objName.find('.data input[type=checkbox]:first').is(':checked')){
              //XXX以上
              // this.minEl.val(this.min);
              // this.maxEl.val('');
              _this10.inputText.eq(0).val(_this10.min);
              _this10.inputText.eq(1).val('');
              _this10.inputText.eq(2).val(_this10.min);
              _this10.inputText.eq(3).val('');
              //顯示結果文字
              _this10.printTxt('up');
            } else {
              if (dataCBL >= 2) {
                // this.minEl.val(this.min);
                // this.maxEl.val(this.max);
                _this10.inputText.eq(0).val(_this10.min);
                _this10.inputText.eq(1).val(_this10.max);
                _this10.inputText.eq(2).val(_this10.min);
                _this10.inputText.eq(3).val(_this10.max);
                //顯示結果文字
                _this10.printTxt('between');
              } else {
                // this.minEl.val('');
                // this.maxEl.val(this.max);
                _this10.inputText.eq(0).val('');
                _this10.inputText.eq(1).val(_this10.max);
                _this10.inputText.eq(2).val('');
                _this10.inputText.eq(3).val(_this10.max);
                //顯示結果文字
                _this10.printTxt('only');
              }
            }
          };
          //選取其它
          if ($this.is(':checked')) {
            //選取比對後顯示
            resoultTxt();
          } else {
            //選取比對後顯示
            resoultTxt();
            //若其它無選取，則返回不限
            if (dataCBL == 0) {
              _this10.checkBackAll();
              // this.printEl.html(this.idTxt + '不限');
              _this10.objName.find('.selectBtn span').html('<i>' + _this10.idTxt + '不限</i>'); //改變span的範圍標題
            }
          }
        }
      });
    }
    //模組3(物件類型)(地圖用)

  }, {
    key: 'module3',
    value: function module3() {
      var _this11 = this;

      //打開
      this.selectEl.addClass('active');
      //預設選取不限
      if (this.allCBL == 0) {
        this.allEl.prop('checked', true);
        this.printEl.html('類型不限');
      }
      //選取後動作
      this.selectEl.find(':checkbox').on('change', function (e) {
        var $this = $(e.currentTarget);
        var dataCBL = _this11.dataEl.find(':checkbox:checked').length;
        //顯示總數目結果文字
        var printTxt = function printTxt() {
          _this11.printEl.html('類型 已選擇<i>' + dataCBL + '</i>筆');
        };
        //若其它無選取，則返回不限
        var checkBackAll = function checkBackAll() {
          _this11.cbEl.prop('checked', false);
          _this11.allEl.prop('checked', true);
          _this11.printEl.html('類型不限');
        };
        if ($this.is(_this11.allEl)) {
          //選取不限
          checkBackAll();
        } else if (dataCBL >= _this11.cbEl.length) {
          //若選取全部，則返回不限
          checkBackAll();
        } else {
          //選取其它
          if ($this.is(':checked')) {
            _this11.allEl.prop('checked', false);
            printTxt();
          } else {
            printTxt();
            if (dataCBL == 0) {
              checkBackAll();
            }
          }
        }
      });
    }
    //模組4(直接顯示內容在title上, 內容為checkbox)(地圖用)

  }, {
    key: 'module4',
    value: function module4() {
      var _this12 = this;

      //打開
      this.selectEl.addClass('active');
      //預設選取不限
      // this.checkAll();
      // this.allEl.prop('checked', true);

      if (this.allCBL == 0) {
        this.allEl.prop('checked', true);
        // this.printEl.html('類型不限');
      }

      //選取後動作
      this.selectEl.find(':checkbox').on('change', function (e) {
        var $this = $(e.currentTarget);
        var dataCBL = _this12.dataEl.find(':checkbox:checked').length;
        //顯示總數目結果文字
        var printTxt = function printTxt() {
          _this12.printEl.html(' 已選擇<i>' + dataCBL + '</i>筆');
        };
        //若其它無選取，則返回不限
        var checkBackAll = function checkBackAll() {
          _this12.cbEl.prop('checked', false);
          _this12.allEl.prop('checked', true);
          _this12.printEl.html(_this12.idTxt + '不限');
        };
        if ($this.is(_this12.allEl)) {
          //選取不限
          checkBackAll();
        } else if (dataCBL >= _this12.cbEl.length) {
          //若選取全部，則返回不限
          checkBackAll();
        } else {
          //選取其它
          if ($this.is(':checked')) {
            _this12.allEl.prop('checked', false);
            printTxt();
          } else {
            printTxt();
            if (dataCBL == 0) {
              checkBackAll();
            }
          }
        }
      });
    }
    //模組5(直接顯示內容在title上, 內容為radio)(地圖用)

  }, {
    key: 'module5',
    value: function module5() {
      var _this13 = this;

      // console.log('進入module5');
      //打開
      this.selectEl.addClass('active');
      //預設選取不限
      // this.checkAll();
      // this.allEl.prop('checked', true);
      //看radio是否已經有選取的數量，若未選取擇預設不限
      if (this.allCBLRad == 0) {
        this.allEl.prop('checked', true);
        // this.printEl.html('類型不限');
      }

      //選取後動作
      this.selectEl.find(':radio').on('change', function (e) {

        var $this = $(e.currentTarget);
        var dataCBL = _this13.dataEl.find(':radio:checked').length; //選取數量
        //this.cbEl.length : 全部長度
        //顯示總數目結果文字


        //若其它無選取，則返回不限
        var checkBackAll = function checkBackAll() {
          _this13.cbEl.prop('checked', false);
          _this13.allEl.prop('checked', true);
          _this13.printEl.html(_this13.idTxt + ' 不限');
        };

        if ($this.is(_this13.allEl)) {
          //選取不限
          checkBackAll();
        } else {
          //單一選單，將value送回標題
          _this13.printEl.html(_this13.idTxt + ' ' + e.currentTarget.defaultValue);
        }
      }); //this.selectEl.find(':radio').on('change', (e) => {
    }

    //進階搜尋-模組1

  }, {
    key: 'moduleMore1',
    value: function moduleMore1() {
      var _this14 = this;

      this.dataEl = this.moreEl.find('.data');
      this.cbEl = this.dataEl.find(':checkbox');
      this.thisAllCBL = this.dataEl.find(':checkbox:checked').length;

      //打開
      this.selectEl.addClass('active');
      //欄位輸入
      this.inputCheck();
      //預設選取不限
      // if(this.allCBL == 0 && this.minEl.val() == '' && this.maxEl.val() == ''){
      if (this.thisAllCBL == 0 && this.minEl.val() == '' && this.maxEl.val() == '') {
        this.allEl.prop('checked', true);
      }

      //選取後動作(屋齡)
      // console.log(this.moreEl);

      this.moreEl.find(':checkbox').on('change', function (e) {
        var $this = $(e.currentTarget);
        var dataCBL = _this14.dataEl.find(':checkbox:checked').length;
        // console.log('123');
        // console.log(this.dataEl);
        //---判斷其它form是否以一樣的項目，並做同步選取
        var checkName = $this.attr('name'); //找出選取的name值
        var checkVal = $this.attr('value'); //找出選取的值
        var checkStatus = $this.prop('checked'); //勾選狀態

        $('form input[name="' + checkName + '"]').each(function (index, element) {
          if (checkVal == $(element).attr('value')) {
            $(element).prop('checked', checkStatus);
          } //if(checkVal == $(element).attr('value')) {
        });
        //---判斷其它form是否以一樣的項目，並做同步選取

        if ($this.is(_this14.allEl)) {
          //選取不限
          // this.checkBackAll();
          var name_div = _this14.allEl.parents('li').find('.data li input').attr('name'); //取消底下所選的checkbox的name值
          $('input[name="' + name_div + '"]').prop('checked', false); //取消選取(電腦、手機都要)
          $('#objMoreYearsAll').prop('checked', true); //電腦版(全選勾選)
          $('#moreYearsAll').prop('checked', true); //手機版(全選勾選)
          $('input[name="house_year_start"]').val(' '); //取消input
          $('input[name="house_year_end"]').val(' '); //取消input
        } else {
          _this14.allEl.prop('checked', false);
          // $('input[name="'+checkName+'"]').prop('checked', false);
          // this.objName.find('.selectAll :checkbox').prop('checked', false); //選取底下的checkbox all改為false
          //選取比對後顯示
          var resoultTxt = function resoultTxt() {
            //最小最大值
            _this14.minMax();
            if ($('#' + _this14.idS + 'Down').is(':checked')) {
              //XXX以下
              // this.minEl.val('');
              // this.maxEl.val(this.max);
              $('#minObjMoreYears').val('');
              $('#maxObjMoreYears').val(_this14.max);
              $('#minMoreYears').val('');
              $('#maxMoreYears').val(_this14.max);
            } else if ($('#' + _this14.idS + 'Up').is(':checked')) {
              //XXX以上
              // this.minEl.val(this.min);
              // this.maxEl.val('');
              $('#minObjMoreYears').val(_this14.min);
              $('#maxObjMoreYears').val('');
              $('#minMoreYears').val(_this14.min);
              $('#maxMoreYears').val('');
            } else {
              // this.minEl.val(this.min);
              // this.maxEl.val(this.max);
              // console.log(this.inputText);
              $('#minObjMoreYears').val(_this14.min);
              $('#maxObjMoreYears').val(_this14.max);
              $('#minMoreYears').val(_this14.min);
              $('#maxMoreYears').val(_this14.max);
            }
            //XXX以下 & XXX以上同時選取，則返回不限
            if ($('#' + _this14.idS + 'Down').is(':checked') && $('#' + _this14.idS + 'Up').is(':checked')) {
              _this14.cbEl.prop('checked', false);
              //若其它無選取，則返回不限
              _this14.checkBackAll();
            }
          };
          //選取其它
          if ($this.is(':checked')) {
            //選取比對後顯示
            resoultTxt();
          } else {
            //選取比對後顯示
            resoultTxt();
            //若其它無選取，則返回不限
            if (dataCBL == 0) {
              _this14.checkBackAll();
            }
          }
        }
      });
    }
    //進階搜尋-模組2(樓層)

  }, {
    key: 'moduleMore2',
    value: function moduleMore2() {
      var _this15 = this;

      this.dataEl = this.moreEl.find('.data');
      this.cbEl = this.dataEl.find(':checkbox');
      this.thisAllCBL = this.dataEl.find(':checkbox:checked').length;

      //打開
      this.selectEl.addClass('active');
      //欄位輸入
      this.inputCheck();
      //預設選取不限
      // if(this.allCBL == 0 && this.minEl.val() == '' && this.maxEl.val() == ''){
      if (this.thisAllCBL == 0 && this.minEl.val() == '' && this.maxEl.val() == '') {
        this.allEl.prop('checked', true);
      }
      //選取後動作
      this.moreEl.find(':checkbox').on('change', function (e) {
        var $this = $(e.currentTarget);
        var dataCBL = _this15.dataEl.find(':checkbox:checked').length;

        //---判斷其它form是否以一樣的項目，並做同步選取
        var checkName = $this.attr('name'); //找出選取的name值
        var checkVal = $this.attr('value'); //找出選取的值
        var checkStatus = $this.prop('checked'); //勾選狀態
        // console.log( checkName +":"+ checkVal +":"+ checkStatus );

        $('form input[name="' + checkName + '"]').each(function (index, element) {
          if (checkVal == $(element).attr('value')) {
            $(element).prop('checked', checkStatus);
          } //if(checkVal == $(element).attr('value')) {
        });
        //---判斷其它form是否以一樣的項目，並做同步選取

        if ($this.is(_this15.allEl)) {
          //選取不限
          // this.checkBackAll();
          var name_div = _this15.allEl.parents('li').find('.data li input').attr('name'); //取消底下所選的checkbox的name值
          $('input[name="' + name_div + '"]').prop('checked', false); //取消選取(電腦、手機都要)
          $('#objMoreFAll').prop('checked', true); //電腦版(全選勾選)
          $('#moreFAll').prop('checked', true); //手機版(全選勾選)
          $('input[name="floor_nums_start"]').val(' '); //取消input
          $('input[name="floor_nums_end"]').val(' '); //取消input
        } else {
          // this.allEl.prop('checked', false);
          $('#objMoreFAll').prop('checked', false); //取消樓層不限
          $('#moreFAll').prop('checked', false); //取消樓層不限


          //選取比對後顯示
          var resoultTxt = function resoultTxt() {
            //最小最大值
            _this15.minMax();
            if ($('#' + _this15.idS + 'Up').is(':checked')) {
              //XXX以上
              // this.minEl.val(this.min);
              // this.maxEl.val('');
              $('#minObjMoreF').val(_this15.min);
              $('#maxObjMoreF').val('');
              $('#minMoreF').val(_this15.min);
              $('#maxMoreF').val('');
            } else {
              if (_this15.filterArray.length >= 2) {
                // this.minEl.val(this.min);
                // this.maxEl.val(this.max);
                $('#minObjMoreF').val(_this15.min);
                $('#maxObjMoreF').val(_this15.max);
                $('#minMoreF').val(_this15.min);
                $('#maxMoreF').val(_this15.max);
              } else {
                // this.minEl.val('');
                // this.maxEl.val(this.max);
                $('#minObjMoreF').val('');
                $('#maxObjMoreF').val(_this15.max);
                $('#minMoreF').val('');
                $('#maxMoreF').val(_this15.max);
              }
            }
          };
          //選取其它
          if ($this.is(':checked')) {
            //選取比對後顯示
            resoultTxt();
          } else {
            //選取比對後顯示
            resoultTxt();
            //若其它無選取，則返回不限
            if (dataCBL == 0) {
              _this15.checkBackAll();
            }
          }
        }
      });
    }
    //進階搜尋-模組3(車位、預售屋)

  }, {
    key: 'moduleMore3',
    value: function moduleMore3() {
      this.dataEl = this.moreEl.find('.data');
      this.thisAllCBL = this.dataEl.find(':radio:checked').length; //檢查選取的長度

      //打開
      this.selectEl.addClass('active');
      //預設選取不限
      // if(this.allCBL == 0){
      if (this.thisAllCBL == 0) {
        this.allEl.prop('checked', true);
      }
      this.moreEl.find(':radio').on('change', function (e) {
        var $this = $(e.currentTarget);

        //---判斷其它form是否以一樣的項目，並做同步選取
        var checkName = $this.attr('name'); //找出選取的name值
        var checkVal = $this.attr('value'); //找出選取的值
        var checkStatus = $this.prop('checked'); //勾選狀態

        $('form input[name="' + checkName + '"]').each(function (index, element) {
          if (checkVal == $(element).attr('value')) {
            $(element).prop('checked', checkStatus);
          } //if(checkVal == $(element).attr('value')) {
        });
        //---判斷其它form是否以一樣的項目，並做同步選取
      });
    }
    //進階搜尋-模組4(特色環境)

  }, {
    key: 'moduleMore4',
    value: function moduleMore4() {
      var _this16 = this;

      this.dataEl = this.moreEl.find('.data');
      this.thisAllCBL = this.dataEl.find(':checkbox:checked').length; //檢查選取的長度
      this.cbEl = this.dataEl.find(':checkbox');
      //打開
      this.selectEl.addClass('active');
      //預設選取不限
      // if(this.allCBL == 0){
      if (this.thisAllCBL == 0) {
        this.allEl.prop('checked', true);
      }
      //選取後動作
      this.moreEl.find(':checkbox').on('change', function (e) {
        var $this = $(e.currentTarget);
        var dataCBL = _this16.dataEl.find(':checkbox:checked').length;

        //---判斷其它form是否以一樣的項目，並做同步選取
        var checkName = $this.attr('name'); //找出選取的name值
        var checkVal = $this.attr('value'); //找出選取的值
        var checkStatus = $this.prop('checked'); //勾選狀態

        $('form input[name="' + checkName + '"]').each(function (index, element) {
          if (checkVal == $(element).attr('value')) {
            $(element).prop('checked', checkStatus);
          } //if(checkVal == $(element).attr('value')) {
        });
        //---判斷其它form是否以一樣的項目，並做同步選取

        // console.log(checkName);
        // alert(checkName); 

        //若其它無選取，則返回不限
        var checkBackAll = function checkBackAll() {
          // this.cbEl.prop('checked', false); //將checkbox取消選取
          // this.allEl.prop('checked', true); //將all選取
          $('form input[name="more_features"]').prop('checked', false); //底下的checkbox取消選取
          $('#moreFeaturesAll').prop('checked', true);
          $('#objMoreFeaturesAll').prop('checked', true);
        };
        if ($this.is(_this16.allEl)) {
          //選取不限
          checkBackAll();
        } else if (dataCBL >= _this16.cbEl.length) {
          //若選取全部，則返回不限
          checkBackAll();
        } else {
          //選取其它
          if ($this.is(':checked')) {
            // this.allEl.prop('checked', false); //將all取消選取
            $('#moreFeaturesAll').prop('checked', false);
            $('#objMoreFeaturesAll').prop('checked', false);
          } else {
            if (dataCBL == 0) {
              checkBackAll();
            }
          }
        }
      });
    }
  }]);

  return SelectModule;
}();

//搜尋類別


var SearchCategory = function () {
  function SearchCategory(el) {
    _classCallCheck(this, SearchCategory);

    this.searchEl = el;
    this.tabs = this.searchEl.find('.tabs label');
    this.tabsRD = this.searchEl.find('.tabs :radio');

    this.selectCity = this.searchEl.find('.city');
    this.selectPrice = this.searchEl.find('.price');
    this.selectRent = this.searchEl.find('.rent');
    this.selectFloor = this.searchEl.find('.floor'); //建坪
    this.selectFloorB = this.searchEl.find('.floorB'); //地坪
    this.selectRoom = this.searchEl.find('.room');
    this.bar = this.searchEl.find('.bar');
    this.searchInput = this.bar.find('input');
    this.selectMore = this.searchEl.find('.more');
    this.btn = this.searchEl.find('.btn');

    this.selectTxt = this.searchEl.find(':text, input[type="tel"]');
    this.selectBtn = this.searchEl.find('.selectBtn');
    this.selectBox = this.searchEl.find('.selectBox');
    this.selectCB = this.selectBox.find(':checkbox');
    this.selectRD = this.selectBox.find(':radio');
  }
  //初始化


  _createClass(SearchCategory, [{
    key: 'tabsReturn',
    value: function tabsReturn() {
      var _this17 = this;

      this.tabsRD.on('change', function () {
        _this17.selectBtn.removeClass('active');
        _this17.selectBox.removeClass('active');
        _this17.selectTxt.val('');
        _this17.selectCB.prop('checked', false);
        _this17.selectRD.prop('checked', false);
      });
    }
    //控制

  }, {
    key: 'selectCtrl',
    value: function selectCtrl(i) {
      this.searchEl.find('.box >div').hide();
      this.selectCity.show();
      this.bar.show();
      this.btn.show();
      switch (i) {
        case 1:
          this.selectRent.show();
          this.selectFloor.show();
          this.selectRoom.show();
          this.selectMore.show();
          break;
        case 10:
        case 11:
        case 12:
        case 13:
          this.selectPrice.show();
          this.selectFloorB.show();
          break;
        case 14:
        default:
          this.selectPrice.show();
          this.selectFloor.show();
          this.selectRoom.show();
          this.selectMore.show();
          break;
      }
    }
    //切換

  }, {
    key: 'toggleSelected',
    value: function toggleSelected() {
      var _this18 = this;

      //判斷是否有帶進來的值，做初始選取(若無則預設全部)
      var classNumberValue = $('#class_number').val(); //類別值
      var classNumberValString = $('#areaSearch').attr('vv'); //選取的中文字
      var navValue = $('.scrollBox #nav').val(); //目前頁面

      if (classNumberValue != 0) {
        $('.searchBox .tabs li').find('label').eq(classNumberValue).addClass('active'); //變色選取(網頁版)
        $('.scrollBox .tabs li').find('label').eq(classNumberValue).addClass('active'); //變色選取(手機版)
        this.selectCtrl(parseInt(classNumberValue));
      } else {
        //預設「全部」類別(分為買屋、租屋)
        if (navValue == 'rent') {
          $('.searchBox .tabs li').find('label').eq(1).addClass('active'); //變色選取(網頁版)
          $('.scrollBox .tabs li').find('label').eq(1).addClass('active'); //變色選取(手機版)
          this.selectCtrl(1);
          $('#class_number').val(1); //儲存物件類型的編號，預設0 kai
        } else {
          $('.searchBox .tabs li').find('label').eq(0).addClass('active'); //變色選取(網頁版)
          $('.scrollBox .tabs li').find('label').eq(0).addClass('active'); //變色選取(手機版)
          this.selectCtrl(0);
          $('#class_number').val(0); //儲存物件類型的編號，預設0 kai
        }
      }

      //切換類別
      this.tabs.each(function (i, e) {
        $(e).on('click', function () {
          _this18.tabs.removeClass('active');
          $(e).addClass('active');
          _this18.selectCtrl(i);
          $('#class_number').val(i); //儲存物件類型的編號 kai
        });
      });
    }
    //打開選取 & 關閉

  }, {
    key: 'selected',
    value: function selected() {
      var _this19 = this;

      //搜尋類別-初始化
      this.tabsReturn();
      //搜尋類別-切換
      this.toggleSelected();
      //狀態預設
      var removeSelectBox = function removeSelectBox() {
        _this19.selectBtn.removeClass('active');
        _this19.selectBox.removeClass('active');
      };
      //關閉選取
      //Body
      $('body').on('click', function () {
        removeSelectBox();
      });
      //輸入欄位
      this.searchInput.focusin(function () {
        // console.log(this.searchInput.attr('name'));
        removeSelectBox();
      });
      //同步輸入欄位(關鍵字)
      this.searchInput.on('keyup blur', function (event) {
        var $this = $(event.currentTarget);
        var inputName = $this.attr('name'); //name值
        $('input[name="' + inputName + '"]').val($this.val());
      });

      //選取框
      this.selectBox.on('click', function (event) {
        //點擊外圍關閉Bug
        event.stopPropagation();
      });

      //打開選取
      this.selectBtn.each(function (i, e) {
        $(e).off('click').on('click', function (event) {
          // $(e).on('click', (event) => {
          // console.log('點擊處1');
          // console.log($(e));
          //點擊外圍關閉Bug
          event.stopPropagation();
          $(e).toggleClass('active');
          if ($(e).is('.active')) {
            removeSelectBox();
            $(e).addClass('active');
            if (_this19.searchEl.is('#rwdSearch')) {
              //Rwd Menu (手機版本)
              switch (i) {
                //縣市區域
                case 0:
                  var city = new City(_this19.searchEl, $(e), 'area');
                  city.tabsReturn(_this19.tabsRD);
                  // city.cityModule1('search');//header
                  city.cityModule1('header'); //header
                  break;
                //總價預算
                case 1:

                  var price = new SelectModule($(e), 'price', 'Price', '總價預算', '總價', '萬');
                  price.tabsReturn(_this19.tabsRD);
                  price.module1();
                  break;
                //租金預算
                case 2:
                  var rent = new SelectModule($(e), 'rent', 'Rent', '租金預算', '租金', '元');
                  rent.tabsReturn(_this19.tabsRD);
                  rent.module1();
                  break;
                //建坪
                case 3:
                  var floor = new SelectModule($(e), 'floor', 'Floor', '建坪', '建坪', '坪');
                  floor.tabsReturn(_this19.tabsRD);
                  floor.module1();
                  break;
                //地坪
                case 4:
                  var floorB = new SelectModule($(e), 'floorB', 'FloorB', '地坪', '地坪', '坪');
                  floorB.tabsReturn(_this19.tabsRD);
                  floorB.module1();
                  break;
                //房數
                case 5:
                  var room = new SelectModule($(e), 'room', 'Room', '房數', '房數', '房');
                  room.tabsReturn(_this19.tabsRD);
                  room.module2();
                  break;
                //進階搜尋
                case 6:
                  var moreYears = new SelectModule($(e), 'moreYears', 'MoreYears', '', '', '');
                  var moreF = new SelectModule($(e), 'moreF', 'MoreF', '', '', '');
                  var moreParking = new SelectModule($(e), 'moreParking', '', '', '', '');
                  var moreFeatures = new SelectModule($(e), 'moreFeatures', '', '', '', '');
                  var moreKeyWordSelect = new SelectModule($(e), 'moreKeyWordSelect', '', '', '', '');
                  moreYears.moduleMore1();
                  moreF.moduleMore2();
                  moreParking.moduleMore3();
                  moreFeatures.moduleMore4();
                  moreKeyWordSelect.moduleMore3();
                  break;
              }
            } else if (_this19.searchEl.is('#objSearch')) {
              //物件列表 (網頁版) 
              switch (i) {
                //縣市區域
                case 0:
                  var _city = new City(_this19.searchEl, $(e), 'objArea');
                  _city.tabsReturn(_this19.tabsRD);
                  // city.cityModule1('search');
                  _city.cityModule1('header');
                  break;
                //總價預算
                case 1:
                  var _price = new SelectModule($(e), 'objPrice', 'ObjPrice', '總價預算', '總價', '萬');
                  _price.tabsReturn(_this19.tabsRD);
                  _price.module1();
                  break;
                //租金預算
                case 2:
                  var _rent = new SelectModule($(e), 'objRent', 'ObjRent', '租金預算', '租金', '元');
                  _rent.tabsReturn(_this19.tabsRD);
                  _rent.module1();
                  break;
                //建坪
                case 3:
                  var _floor = new SelectModule($(e), 'objFloor', 'ObjFloor', '建坪', '建坪', '坪');
                  _floor.tabsReturn(_this19.tabsRD);
                  _floor.module1();
                  break;
                //地坪
                case 4:
                  var _floorB = new SelectModule($(e), 'objFloorB', 'ObjFloorB', '地坪', '地坪', '坪');
                  _floorB.tabsReturn(_this19.tabsRD);
                  _floorB.module1();
                  break;
                //房數
                case 5:
                  var _room = new SelectModule($(e), 'objRoom', 'ObjRoom', '房數', '房數', '房');
                  _room.tabsReturn(_this19.tabsRD);
                  _room.module2();
                  break;
                //進階搜尋
                case 6:
                  var _moreYears = new SelectModule($(e), 'objMoreYears', 'ObjMoreYears', '', '', '');
                  var _moreF = new SelectModule($(e), 'objMoreF', 'ObjMoreF', '', '', '');
                  var _moreParking = new SelectModule($(e), 'objMoreParking', '', '', '', '');
                  var _moreFeatures = new SelectModule($(e), 'objMoreFeatures', '', '', '', '');
                  var _moreKeyWordSelect = new SelectModule($(e), 'objMoreKeyWordSelect', '', '', '', '');
                  _moreYears.moduleMore1();
                  _moreF.moduleMore2();
                  _moreParking.moduleMore3();
                  _moreFeatures.moduleMore4();
                  _moreKeyWordSelect.moduleMore3();
                  break;
              }
            }
          } else {
            removeSelectBox();
          }
        });
      });
      //送出搜尋
      this.btn.find('button').on('click', function () {
        $('body').addClass('active');
      });

      //點擊移除搜尋結果的條件
      $('.delSearch').parents('li').on('click', function (e) {
        var $this = $(e.currentTarget);
        var className = $this.attr('data-info');
        if (className == 'city') {
          //城市被取消時，區也要取消

          $('.box .city').find('span').html('縣市區域'); //改搜尋條件title
          $('.searchCancel').html(' '); //搜尋條件欄位歸0
          $this.remove(); //搜尋結果:移除城市
          $('.searchStatus[data-info=area]').remove(); //搜尋結果:移除區
        } else if (className == 'area') {
          //因區有多選問題，需再判斷那一區的

          $this.remove(); //搜尋結果:移除區
          // console.log('區');
          $('#areaSearch').find('input').each(function () {
            // console.log($(this).val()+'==='+$this.find('.delSearch').attr('data-info'));
            if ($(this).val() == $this.find('.delSearch').attr('data-info')) {
              $(this).remove();
              // console.log( $(this).val() );
            }
          });
          //移除搜尋條件
        } else {
            //直接勾選不選

          }
      });
    }
  }]);

  return SearchCategory;
}();

//Search


var Search = function () {
  function Search() {
    _classCallCheck(this, Search);
  }

  _createClass(Search, [{
    key: 'searchObj',
    value: function searchObj() {
      //Rwd Menu
      var rwdSearch = new SearchCategory($('#rwdSearch'));
      rwdSearch.selected();

      //物件列表
      var objSearch = new SearchCategory($('#objSearch'));
      objSearch.selected();
    }
  }]);

  return Search;
}();

//---地圖找屋


var MapSearch = function () {
  function MapSearch() {
    _classCallCheck(this, MapSearch);

    this.searchEl = $('#mapSelectBar');
    this.selectBtn = this.searchEl.find('.selectBtn');
    this.selectBox = this.searchEl.find('.selectBox');
  }
  //打開選取 & 關閉


  _createClass(MapSearch, [{
    key: 'selected',
    value: function selected() {
      var _this20 = this;

      //狀態預設
      var removeSelectBox = function removeSelectBox() {
        _this20.selectBtn.removeClass('active');
        _this20.selectBox.removeClass('active');
      };
      //打開選取
      this.selectBtn.each(function (i, e) {
        $(e).on('click', function (event) {
          //點擊外圍關閉Bug
          // console.log('點擊開啟&關閉選單');
          event.stopPropagation();
          $(e).toggleClass('active'); //切換外圍選單的方向icon
          if ($(e).is('.active')) {
            removeSelectBox();
            $(e).addClass('active');
            switch (i) {
              //縣市區域
              case 0:
                var city = new City(_this20.searchEl, $(e), 'tbArea');
                city.cityModule2('mapSearch');
                break;
              //物件類型
              case 1:
                var classes = new SelectModule($(e), 'tbClasses', '', '物件類型', '', '');
                classes.module3();
                break;
              //總價預算
              case 2:
                var price = new SelectModule($(e), 'tbPrice', 'Price_tb', '總價預算', '總價', '萬');
                price.module1();
                break;
              //坪數
              case 3:
                var floor = new SelectModule($(e), 'tbFloor', 'Floor_tb', '坪數', '建坪', '坪');
                floor.module1();
                break;

              //地坪
              case 4:
                var floorB = new SelectModule($(e), 'floorB', 'FloorB', '地坪', '地坪', '坪');
                // floorB.tabsReturn(this.tabsRD);
                floorB.module1();
                break;

              //房數
              case 5:
                var room = new SelectModule($(e), 'room', 'Room', '房數', '房數', '房');
                // room.tabsReturn(this.tabsRD);
                room.module1();
                break;

              //屋齡
              case 6:
                var moreYears = new SelectModule($(e), 'moreYears', 'MoreYears', '屋齡', '屋齡', '年');
                // room.tabsReturn(this.tabsRD);
                moreYears.module1();
                break;
              //樓層
              case 7:
                var moreF = new SelectModule($(e), 'moreF', 'MoreF', '樓層', '樓層', '層');
                // room.tabsReturn(this.tabsRD);
                moreF.module1();
                break;
              //車位
              case 8:
                var moreParking = new SelectModule($(e), 'moreParking', 'MoreParking', '車位', '車位', '');
                // room.tabsReturn(this.tabsRD);
                moreParking.module5();
                break;
              //特色環境
              case 9:
                var moreFeatures = new SelectModule($(e), 'moreFeatures', 'MoreFeatures', '環境', '環境', '');
                // room.tabsReturn(this.tabsRD);
                moreFeatures.module4();
                break;
              //預售屋
              case 10:
                var moreKeyWordSelect = new SelectModule($(e), 'moreKeyWordSelect', 'MoreKeyWordSelect', '預售屋', '預售屋', '');
                // room.tabsReturn(this.tabsRD);
                moreKeyWordSelect.module5();
                break;

            }
            _this20.selectBox.on('click', function (event) {
              //點擊外圍關閉Bug
              event.stopPropagation();
            });
            //關閉
            $(document).on('click', function () {
              removeSelectBox();
            });
          } else {
            removeSelectBox();
          }
        });
      });
    }
  }]);

  return MapSearch;
}();

//實價登錄


var ActualSearch = function () {
  function ActualSearch() {
    _classCallCheck(this, ActualSearch);

    this.nav = $('#navVal').val();
    this.searchEl = $('#toggleSelectBar');
    this.selectBtn = this.searchEl.find('.selectBtn');
    this.selectBox = this.searchEl.find('.selectBox');
    this.closeBtn = this.selectBox.find('.close');
  }
  //打開選取 & 關閉


  _createClass(ActualSearch, [{
    key: 'selected',
    value: function selected() {
      var _this21 = this;

      //狀態預設
      var removeSelectBox = function removeSelectBox() {
        _this21.selectBtn.removeClass('active');
        _this21.selectBox.removeClass('active');
      };
      //打開選取
      this.selectBtn.each(function (i, e) {
        $(e).off('click').on('click', function (event) {
          // console.log('切換');
          // console.log($(e));
          //點擊外圍關閉Bug
          event.stopPropagation();
          $(e).toggleClass('active');
          if ($(e).is('.active')) {
            removeSelectBox();
            $(e).addClass('active');
            $(e).next('.selectBox').toggleClass('active'); //增加選擇底下的selectBox並給class
            switch (i) {
              //縣市區域
              case 0:
                var city = new City(_this21.searchEl, $(e), 'tbArea');
                city.cityModule1('actual');
                break;
              //總價預算 / 租金預算 (成交總價) 
              case 1:
                if (_this21.nav == 'actual_buy') {
                  //let price = new SelectModule(this.searchEl, $(e), 'tbPrice', 'Price_tb', '總價預算', '總價', '萬');
                  var price = new SelectModule($(e), 'tbPrice', 'Price_tb', '總價預算', '總價', '萬');
                  console.log(price);
                  price.module1();
                } else if (_this21.nav == 'actual_rent') {
                  // let rent = new SelectModule(this.searchEl, $(e), 'tbRent', 'Rent_tb', '租金預算', '租金', '元');
                  var rent = new SelectModule($(e), 'tbRent', 'Rent_tb', '租金預算', '租金', '元');
                  rent.module1();
                }
                break;
              //坪數
              case 2:
                // let floor = new SelectModule(this.searchEl, $(e), 'tbFloor', 'Floor_tb', '坪數', '建坪', '坪');
                var floor = new SelectModule($(e), 'tbFloor', 'Floor_tb', '坪數', '建坪', '坪');
                floor.module1();
                break;
            }
            _this21.selectBox.on('click', function (event) {
              //點擊外圍關閉Bug
              event.stopPropagation();
            });
            //關閉
            $(document).on('click', function () {
              removeSelectBox();
            });
            _this21.closeBtn.on('click', function () {
              removeSelectBox();
            });
          } else {
            removeSelectBox();
          }
        });
      });
    }
  }]);

  return ActualSearch;
}();

//輸出


exports.Search = Search;
exports.MapSearch = MapSearch;
exports.ActualSearch = ActualSearch;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {

/*! jQuery & Zepto Lazy v1.7.10 - http://jquery.eisbehr.de/lazy - MIT&GPL-2.0 license - Copyright 2012-2018 Daniel 'Eisbehr' Kern */
!function (t, e) {
  "use strict";
  function r(r, a, i, u, l) {
    function f() {
      L = t.devicePixelRatio > 1, i = c(i), a.delay >= 0 && setTimeout(function () {
        s(!0);
      }, a.delay), (a.delay < 0 || a.combined) && (u.e = v(a.throttle, function (t) {
        "resize" === t.type && (w = B = -1), s(t.all);
      }), u.a = function (t) {
        t = c(t), i.push.apply(i, t);
      }, u.g = function () {
        return i = n(i).filter(function () {
          return !n(this).data(a.loadedName);
        });
      }, u.f = function (t) {
        for (var e = 0; e < t.length; e++) {
          var r = i.filter(function () {
            return this === t[e];
          });r.length && s(!1, r);
        }
      }, s(), n(a.appendScroll).on("scroll." + l + " resize." + l, u.e));
    }function c(t) {
      var i = a.defaultImage,
          o = a.placeholder,
          u = a.imageBase,
          l = a.srcsetAttribute,
          f = a.loaderAttribute,
          c = a._f || {};t = n(t).filter(function () {
        var t = n(this),
            r = m(this);return !t.data(a.handledName) && (t.attr(a.attribute) || t.attr(l) || t.attr(f) || c[r] !== e);
      }).data("plugin_" + a.name, r);for (var s = 0, d = t.length; s < d; s++) {
        var A = n(t[s]),
            g = m(t[s]),
            h = A.attr(a.imageBaseAttribute) || u;g === N && h && A.attr(l) && A.attr(l, b(A.attr(l), h)), c[g] === e || A.attr(f) || A.attr(f, c[g]), g === N && i && !A.attr(E) ? A.attr(E, i) : g === N || !o || A.css(O) && "none" !== A.css(O) || A.css(O, "url('" + o + "')");
      }return t;
    }function s(t, e) {
      if (!i.length) return void (a.autoDestroy && r.destroy());for (var o = e || i, u = !1, l = a.imageBase || "", f = a.srcsetAttribute, c = a.handledName, s = 0; s < o.length; s++) {
        if (t || e || A(o[s])) {
          var g = n(o[s]),
              h = m(o[s]),
              b = g.attr(a.attribute),
              v = g.attr(a.imageBaseAttribute) || l,
              p = g.attr(a.loaderAttribute);g.data(c) || a.visibleOnly && !g.is(":visible") || !((b || g.attr(f)) && (h === N && (v + b !== g.attr(E) || g.attr(f) !== g.attr(F)) || h !== N && v + b !== g.css(O)) || p) || (u = !0, g.data(c, !0), d(g, h, v, p));
        }
      }u && (i = n(i).filter(function () {
        return !n(this).data(c);
      }));
    }function d(t, e, r, i) {
      ++z;var _o = function o() {
        y("onError", t), p(), _o = n.noop;
      };y("beforeLoad", t);var u = a.attribute,
          l = a.srcsetAttribute,
          f = a.sizesAttribute,
          c = a.retinaAttribute,
          s = a.removeAttribute,
          d = a.loadedName,
          A = t.attr(c);if (i) {
        var _g = function g() {
          s && t.removeAttr(a.loaderAttribute), t.data(d, !0), y(T, t), setTimeout(p, 1), _g = n.noop;
        };t.off(I).one(I, _o).one(D, _g), y(i, t, function (e) {
          e ? (t.off(D), _g()) : (t.off(I), _o());
        }) || t.trigger(I);
      } else {
        var h = n(new Image());h.one(I, _o).one(D, function () {
          t.hide(), e === N ? t.attr(C, h.attr(C)).attr(F, h.attr(F)).attr(E, h.attr(E)) : t.css(O, "url('" + h.attr(E) + "')"), t[a.effect](a.effectTime), s && (t.removeAttr(u + " " + l + " " + c + " " + a.imageBaseAttribute), f !== C && t.removeAttr(f)), t.data(d, !0), y(T, t), h.remove(), p();
        });var m = (L && A ? A : t.attr(u)) || "";h.attr(C, t.attr(f)).attr(F, t.attr(l)).attr(E, m ? r + m : null), h.complete && h.trigger(D);
      }
    }function A(t) {
      var e = t.getBoundingClientRect(),
          r = a.scrollDirection,
          n = a.threshold,
          i = h() + n > e.top && -n < e.bottom,
          o = g() + n > e.left && -n < e.right;return "vertical" === r ? i : "horizontal" === r ? o : i && o;
    }function g() {
      return w >= 0 ? w : w = n(t).width();
    }function h() {
      return B >= 0 ? B : B = n(t).height();
    }function m(t) {
      return t.tagName.toLowerCase();
    }function b(t, e) {
      if (e) {
        var r = t.split(",");t = "";for (var a = 0, n = r.length; a < n; a++) {
          t += e + r[a].trim() + (a !== n - 1 ? "," : "");
        }
      }return t;
    }function v(t, e) {
      var n,
          i = 0;return function (o, u) {
        function l() {
          i = +new Date(), e.call(r, o);
        }var f = +new Date() - i;n && clearTimeout(n), f > t || !a.enableThrottle || u ? l() : n = setTimeout(l, t - f);
      };
    }function p() {
      --z, i.length || z || y("onFinishedAll");
    }function y(t, e, n) {
      return !!(t = a[t]) && (t.apply(r, [].slice.call(arguments, 1)), !0);
    }var z = 0,
        w = -1,
        B = -1,
        L = !1,
        T = "afterLoad",
        D = "load",
        I = "error",
        N = "img",
        E = "src",
        F = "srcset",
        C = "sizes",
        O = "background-image";"event" === a.bind || o ? f() : n(t).on(D + "." + l, f);
  }function a(a, o) {
    var u = this,
        l = n.extend({}, u.config, o),
        f = {},
        c = l.name + "-" + ++i;return u.config = function (t, r) {
      return r === e ? l[t] : (l[t] = r, u);
    }, u.addItems = function (t) {
      return f.a && f.a("string" === n.type(t) ? n(t) : t), u;
    }, u.getItems = function () {
      return f.g ? f.g() : {};
    }, u.update = function (t) {
      return f.e && f.e({}, !t), u;
    }, u.force = function (t) {
      return f.f && f.f("string" === n.type(t) ? n(t) : t), u;
    }, u.loadAll = function () {
      return f.e && f.e({ all: !0 }, !0), u;
    }, u.destroy = function () {
      return n(l.appendScroll).off("." + c, f.e), n(t).off("." + c), f = {}, e;
    }, r(u, l, a, f, c), l.chainable ? a : u;
  }var n = __webpack_provided_window_dot_jQuery || t.Zepto,
      i = 0,
      o = !1;n.fn.Lazy = n.fn.lazy = function (t) {
    return new a(this, t);
  }, n.Lazy = n.lazy = function (t, r, i) {
    if (n.isFunction(r) && (i = r, r = []), n.isFunction(i)) {
      t = n.isArray(t) ? t : [t], r = n.isArray(r) ? r : [r];for (var o = a.prototype.config, u = o._f || (o._f = {}), l = 0, f = t.length; l < f; l++) {
        (o[t[l]] === e || n.isFunction(o[t[l]])) && (o[t[l]] = i);
      }for (var c = 0, s = r.length; c < s; c++) {
        u[r[c]] = t[0];
      }
    }
  }, a.prototype.config = { name: "lazy", chainable: !0, autoDestroy: !0, bind: "load", threshold: 500, visibleOnly: !1, appendScroll: t, scrollDirection: "both", imageBase: null, defaultImage: "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==", placeholder: null, delay: -1, combined: !1, attribute: "data-src", srcsetAttribute: "data-srcset", sizesAttribute: "data-sizes", retinaAttribute: "data-retina", loaderAttribute: "data-loader", imageBaseAttribute: "data-imagebase", removeAttribute: !0, handledName: "handled", loadedName: "loaded", effect: "show", effectTime: 0, enableThrottle: !0, throttle: 250, beforeLoad: e, afterLoad: e, onError: e, onFinishedAll: e }, n(t).on("load", function () {
    o = !0;
  });
}(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {

/*! jQuery & Zepto Lazy - All Plugins v1.7.10 - http://jquery.eisbehr.de/lazy - MIT&GPL-2.0 license - Copyright 2012-2018 Daniel 'Eisbehr' Kern */
!function (t) {
  function a(a, e, r, o) {
    o = o ? o.toUpperCase() : "GET";var i;"POST" !== o && "PUT" !== o || !a.config("ajaxCreateData") || (i = a.config("ajaxCreateData").apply(a, [e])), t.ajax({ url: e.attr("data-src"), type: "POST" === o || "PUT" === o ? o : "GET", data: i, dataType: e.attr("data-type") || "html", success: function success(t) {
        e.html(t), r(!0), a.config("removeAttribute") && e.removeAttr("data-src data-method data-type");
      }, error: function error() {
        r(!1);
      } });
  }t.lazy("ajax", function (t, e) {
    a(this, t, e, t.attr("data-method"));
  }), t.lazy("get", function (t, e) {
    a(this, t, e, "GET");
  }), t.lazy("post", function (t, e) {
    a(this, t, e, "POST");
  }), t.lazy("put", function (t, e) {
    a(this, t, e, "PUT");
  });
}(__webpack_provided_window_dot_jQuery || window.Zepto), function (t) {
  t.lazy(["av", "audio", "video"], ["audio", "video"], function (a, e) {
    var r = a[0].tagName.toLowerCase();if ("audio" === r || "video" === r) {
      var o = a.find("data-src"),
          i = a.find("data-track"),
          n = 0,
          c = function c() {
        ++n === o.length && e(!1);
      },
          s = function s() {
        var a = t(this),
            e = a[0].tagName.toLowerCase(),
            r = a.prop("attributes"),
            o = t("data-src" === e ? "<source>" : "<track>");"data-src" === e && o.one("error", c), t.each(r, function (t, a) {
          o.attr(a.name, a.value);
        }), a.replaceWith(o);
      };a.one("loadedmetadata", function () {
        e(!0);
      }).off("load error").attr("poster", a.attr("data-poster")), o.length ? o.each(s) : a.attr("data-src") ? (t.each(a.attr("data-src").split(","), function (e, r) {
        var o = r.split("|");a.append(t("<source>").one("error", c).attr({ src: o[0].trim(), type: o[1].trim() }));
      }), this.config("removeAttribute") && a.removeAttr("data-src")) : e(!1), i.length && i.each(s);
    } else e(!1);
  });
}(__webpack_provided_window_dot_jQuery || window.Zepto), function (t) {
  t.lazy(["frame", "iframe"], "iframe", function (a, e) {
    var r = this;if ("iframe" === a[0].tagName.toLowerCase()) {
      var o = a.attr("data-error-detect");"true" !== o && "1" !== o ? (a.attr("src", a.attr("data-src")), r.config("removeAttribute") && a.removeAttr("data-src data-error-detect")) : t.ajax({ url: a.attr("data-src"), dataType: "html", crossDomain: !0, xhrFields: { withCredentials: !0 }, success: function success(t) {
          a.html(t).attr("src", a.attr("data-src")), r.config("removeAttribute") && a.removeAttr("data-src data-error-detect");
        }, error: function error() {
          e(!1);
        } });
    } else e(!1);
  });
}(__webpack_provided_window_dot_jQuery || window.Zepto), function (t) {
  t.lazy("noop", function () {}), t.lazy("noop-success", function (t, a) {
    a(!0);
  }), t.lazy("noop-error", function (t, a) {
    a(!1);
  });
}(__webpack_provided_window_dot_jQuery || window.Zepto), function (t) {
  function a(a, e, i) {
    var n = a.prop("attributes"),
        c = t("<" + e + ">");return t.each(n, function (t, a) {
      "srcset" !== a.name && a.name !== o || (a.value = r(a.value, i)), c.attr(a.name, a.value);
    }), a.replaceWith(c), c;
  }function e(a, e, r) {
    var o = t("<img>").one("load", function () {
      r(!0);
    }).one("error", function () {
      r(!1);
    }).appendTo(a).attr("src", e);o.complete && o.load();
  }function r(t, a) {
    if (a) {
      var e = t.split(",");t = "";for (var r = 0, o = e.length; r < o; r++) {
        t += a + e[r].trim() + (r !== o - 1 ? "," : "");
      }
    }return t;
  }var o = "data-src";t.lazy(["pic", "picture"], ["picture"], function (i, n) {
    if ("picture" === i[0].tagName.toLowerCase()) {
      var c = i.find(o),
          s = i.find("data-img"),
          d = this.config("imageBase") || "";c.length ? (c.each(function () {
        a(t(this), "source", d);
      }), 1 === s.length ? (s = a(s, "img", d), s.on("load", function () {
        n(!0);
      }).on("error", function () {
        n(!1);
      }), s.attr("src", s.attr(o)), this.config("removeAttribute") && s.removeAttr(o)) : i.attr(o) ? (e(i, d + i.attr(o), n), this.config("removeAttribute") && i.removeAttr(o)) : n(!1)) : i.attr("data-srcset") ? (t("<source>").attr({ media: i.attr("data-media"), sizes: i.attr("data-sizes"), type: i.attr("data-type"), srcset: r(i.attr("data-srcset"), d) }).appendTo(i), e(i, d + i.attr(o), n), this.config("removeAttribute") && i.removeAttr(o + " data-srcset data-media data-sizes data-type")) : n(!1);
    } else n(!1);
  });
}(__webpack_provided_window_dot_jQuery || window.Zepto), function (t) {
  t.lazy(["js", "javascript", "script"], "script", function (t, a) {
    "script" === t[0].tagName.toLowerCase() ? (t.attr("src", t.attr("data-src")), this.config("removeAttribute") && t.removeAttr("data-src")) : a(!1);
  });
}(__webpack_provided_window_dot_jQuery || window.Zepto), function (t) {
  t.lazy("vimeo", function (t, a) {
    "iframe" === t[0].tagName.toLowerCase() ? (t.attr("src", "https://player.vimeo.com/video/" + t.attr("data-src")), this.config("removeAttribute") && t.removeAttr("data-src")) : a(!1);
  });
}(__webpack_provided_window_dot_jQuery || window.Zepto), function (t) {
  t.lazy(["yt", "youtube"], function (t, a) {
    if ("iframe" === t[0].tagName.toLowerCase()) {
      var e = /1|true/.test(t.attr("data-nocookie"));t.attr("src", "https://www.youtube" + (e ? "-nocookie" : "") + ".com/embed/" + t.attr("data-src") + "?rel=0&amp;showinfo=0"), this.config("removeAttribute") && t.removeAttr("data-src");
    } else a(!1);
  });
}(__webpack_provided_window_dot_jQuery || window.Zepto);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//文字裁切
var Crop = function () {
  function Crop() {
    _classCallCheck(this, Crop);

    this.txtIndex = $('.txtCropIndex');
    this.txt = $('.txtCrop');
    this.charIndex = 100;
    this.char = 75;
    this.mark = '...';
  }

  _createClass(Crop, [{
    key: 'cropResult',
    value: function cropResult(el, charNum) {
      var _this = this;

      el.each(function (i, e) {
        if ($(e).text().length > charNum) {
          $(e).text($(e).text().substr(0, charNum) + _this.mark);
        }
      });
    }
  }]);

  return Crop;
}();

//整合


var TxtCrop = function (_Crop) {
  _inherits(TxtCrop, _Crop);

  function TxtCrop() {
    _classCallCheck(this, TxtCrop);

    return _possibleConstructorReturn(this, (TxtCrop.__proto__ || Object.getPrototypeOf(TxtCrop)).apply(this, arguments));
  }

  _createClass(TxtCrop, [{
    key: 'crop',
    value: function crop() {
      _get(TxtCrop.prototype.__proto__ || Object.getPrototypeOf(TxtCrop.prototype), 'cropResult', this).call(this, this.txtIndex, this.charIndex);
      _get(TxtCrop.prototype.__proto__ || Object.getPrototypeOf(TxtCrop.prototype), 'cropResult', this).call(this, this.txt, this.char);
    }
  }]);

  return TxtCrop;
}(Crop);

//輸出


exports.TxtCrop = TxtCrop;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//文字大小
var TxtZoom = function () {
  function TxtZoom() {
    _classCallCheck(this, TxtZoom);

    this.txtZoom = $('#txtZoom');
    this.txtarea = $('.txtZoomArea');
  }

  _createClass(TxtZoom, [{
    key: 'zoom',
    value: function zoom() {
      var _this = this;

      this.txtZoom.find('button').each(function (i, e) {
        //預設為小
        if (i == 2) {
          $(e).addClass('active');
        }
        $(e).on('click', function () {
          _this.txtZoom.find('button').removeClass('active');
          $(e).addClass('active');
          if (i == 0) {
            //大
            _this.txtarea.css({
              lineHeight: '40px',
              fontSize: '20px'
            });
          } else if (i == 1) {
            //中
            _this.txtarea.css({
              lineHeight: '40px',
              fontSize: '18px'
            });
          } else if (i == 2) {
            _this.txtarea.css({
              lineHeight: '30px',
              fontSize: '16px'
            });
          }
        });
      });
    }
  }]);

  return TxtZoom;
}();

//輸出


exports.TxtZoom = TxtZoom;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoCover = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


__webpack_require__(5);

var _body_ctrl = __webpack_require__(2);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//引入外部模組
var bodyCtrl = new _body_ctrl.BodyCtrl();

//CM背景影片

var VideoCM = function () {
  function VideoCM() {
    _classCallCheck(this, VideoCM);

    this.header = $('header');
    this.cover = $('#indexCover');
    this.vedio = this.cover.find('video');
    this.slider = this.cover.find('.sliderBox');
    this.slogan = this.cover.find('.slogan');
    this.parallax = $('#parallax');
    this.scrollDown = $('#scrollDown');
    this.videoW = 1920;
    this.videoH = 1080;
    this.rwdH = 750;
    this.easing = 'easeOutExpo';
    this.duration = 500;
    this.stopPlay = true;
  }
  //RWD高度判斷


  _createClass(VideoCM, [{
    key: 'rwdHeight',
    value: function rwdHeight() {
      if (window.matchMedia('(max-height:' + this.rwdH + 'px)').matches) {
        this.cover.css('height', $(window).innerHeight() - this.header.outerHeight());
        this.cover.addClass('removeParallax');
        this.parallax.addClass('removeParallax');
      } else {
        this.cover.css('height', $(window).innerHeight());
        this.cover.removeClass('removeParallax');
        this.parallax.removeClass('removeParallax');
        this.parallax.css('margin-top', this.cover.outerHeight() - this.header.outerHeight());
      }
    }
    //滾差

  }, {
    key: 'op',
    value: function op(scrollPosition) {
      var st = scrollPosition;
      var scaleEase1 = st / 30;
      var scaleEase2 = st / 10;
      if (scaleEase1 >= 50) {
        scaleEase1 = 50;
      }
      if (scaleEase2 >= 300) {
        scaleEase2 = 300;
      }
      var scaleCss1 = 'translate3d(-50%, ' + -scaleEase1 + '%, 0)';
      var scaleCss2 = 'translate3d(0, ' + -scaleEase2 + '%, 0)';
      this.slider.css({
        webkitTransform: scaleCss1,
        mozTransform: scaleCss1,
        msTransform: scaleCss1,
        oTransform: scaleCss1,
        transform: scaleCss1
      });
      this.slogan.css({
        webkitTransform: scaleCss2,
        mozTransform: scaleCss2,
        msTransform: scaleCss2,
        oTransform: scaleCss2,
        transform: scaleCss2
      });
    }
  }, {
    key: 'action',
    value: function action() {
      var _this = this;

      //RWD高度判斷
      var rwdParallax = function rwdParallax() {
        if (window.matchMedia('(max-height:' + _this.rwdH + 'px)').matches) {
          //移除滾差
          _this.op(0);
        } else {
          //引入滾差
          _this.op($(window).scrollTop());
        }
      };
      rwdParallax();
      $(window).on('scroll', function () {
        rwdParallax();
      });
    }
  }, {
    key: 'down',
    value: function down() {
      var _this2 = this;

      this.scrollDown.on('click', function (event) {
        bodyCtrl.ctrl('scrollHide'); //控制瀏覽器捲軸
        bodyCtrl.ctrl('btnLock'); //控制瀏覽器按鈕
        $('html, body').animate({
          scrollTop: _this2.parallax.offset().top - _this2.header.outerHeight()
        }, _this2.duration, _this2.easing, function () {
          bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
          bodyCtrl.ctrl('btnUnlock'); //控制瀏覽器按鈕
        });
        return false;
      });
    }
  }]);

  return VideoCM;
}();

//整合


var VideoCover = function (_VideoCM) {
  _inherits(VideoCover, _VideoCM);

  function VideoCover() {
    _classCallCheck(this, VideoCover);

    return _possibleConstructorReturn(this, (VideoCover.__proto__ || Object.getPrototypeOf(VideoCover)).apply(this, arguments));
  }

  _createClass(VideoCover, [{
    key: 'videoCover',
    value: function videoCover() {
      var _this4 = this;

      _get(VideoCover.prototype.__proto__ || Object.getPrototypeOf(VideoCover.prototype), 'rwdHeight', this).call(this);
      _get(VideoCover.prototype.__proto__ || Object.getPrototypeOf(VideoCover.prototype), 'action', this).call(this);
      _get(VideoCover.prototype.__proto__ || Object.getPrototypeOf(VideoCover.prototype), 'down', this).call(this);
      //RWD
      $(window).on('resize', function () {
        _get(VideoCover.prototype.__proto__ || Object.getPrototypeOf(VideoCover.prototype), 'rwdHeight', _this4).call(_this4);
        _get(VideoCover.prototype.__proto__ || Object.getPrototypeOf(VideoCover.prototype), 'action', _this4).call(_this4);
      });
    }
  }]);

  return VideoCover;
}(VideoCM);

//輸出


exports.VideoCover = VideoCover;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterAds = exports.ObjsBannerImg = exports.IndexObjsSlider = exports.IndexBanner = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


var _swiper = __webpack_require__(32);

var _swiper2 = _interopRequireDefault(_swiper);

__webpack_require__(36);

var _lazyload = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//Banner-首頁
var IndexBanner = function () {
  function IndexBanner() {
    _classCallCheck(this, IndexBanner);

    this.window = $(window);
    this.slideEl = $('#indexBanner');

    //輪播圖片
    this.slide = this.slideEl.find('.slide');
    this.pb = this.slideEl.find('.prevBtn');
    this.nb = this.slideEl.find('.nextBtn');
    this.ds = this.slideEl.find('.dots');
  }

  _createClass(IndexBanner, [{
    key: 'sliderModule',
    value: function sliderModule() {
      var _this = this;

      //輪播圖片
      var slide = new _swiper2.default(this.slide, {
        navigation: {
          prevEl: this.pb,
          nextEl: this.nb
        },
        pagination: {
          el: this.ds,
          clickable: true,
          dynamicBullets: true
        },
        autoplay: {
          delay: 3000
        },
        effect: 'coverflow',
        grabCursor: true,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        observer: true,
        observeParents: true,
        roundLengths: true
      });

      //滑入本區塊開啟 & 關閉自動播放
      var rwdResize = function rwdResize() {
        slide.autoplay.start();
        if (window.matchMedia('(max-width: 1023px)').matches) {
          _this.slide.off('mouseover');
          _this.slide.off('mouseout');
        } else {
          _this.slide.on('mouseover', function () {
            slide.autoplay.stop();
          });
          _this.slide.on('mouseout', function () {
            slide.autoplay.start();
          });
        }
      };
      rwdResize();
      this.window.on('resize', rwdResize);
    }
  }]);

  return IndexBanner;
}();

//物件-首頁


var IndexObjsSlider = function () {
  function IndexObjsSlider() {
    _classCallCheck(this, IndexObjsSlider);

    //優質物件
    this.itemsNew = $('#indexObjsNew');
    //中古降價屋
    this.itemsOnSale = $('#indexObjsOnSale');
    //實境環景看屋
    this.itemsVR720 = $('#indexObjsVR720');
  }

  _createClass(IndexObjsSlider, [{
    key: 'objsSlider',
    value: function objsSlider(slideEl) {
      //輪播物件
      var slide = new _swiper2.default(slideEl.find('.slide'), {
        navigation: {
          prevEl: slideEl.find('.prevBtn'),
          nextEl: slideEl.find('.nextBtn')
        },
        pagination: {
          el: slideEl.find('.dots'),
          clickable: true,
          dynamicBullets: true
        },
        grabCursor: true,
        loop: true,
        loopAdditionalSlides: 4,
        slidesPerView: 4,
        spaceBetween: 0,
        autoHeight: true,
        observer: true,
        observeParents: true,
        on: {
          slideChangeTransitionEnd: function slideChangeTransitionEnd() {
            //圖片延遲載入並裁切
            var lazyLoad = new _lazyload.LazyLoad();
            lazyLoad.imgLoad();
          }
        },
        breakpoints: {
          1279: {
            slidesPerView: 3,
            loopAdditionalSlides: 3
          },
          1023: {
            slidesPerView: 2,
            loopAdditionalSlides: 2
          },
          600: {
            slidesPerView: 1,
            loopAdditionalSlides: 1
          }
        }
      });
    }
  }, {
    key: 'sliderModule',
    value: function sliderModule() {
      //優質物件
      this.objsSlider(this.itemsNew);
      //中古降價屋
      this.objsSlider(this.itemsOnSale);
      //實境環景看屋
      this.objsSlider(this.itemsVR720);
    }
  }]);

  return IndexObjsSlider;
}();

//物件-內頁


var ObjsBannerImg = function () {
  function ObjsBannerImg() {
    _classCallCheck(this, ObjsBannerImg);

    this.slideEl = $('#objRealtyDetail');
    this.banner = this.slideEl.find('.slideBanner');
    // this.thumbs    = this.slideEl.find('.slideThumbs');
    // this.imgT      = this.slideEl.find('.imgT');
    // this.thumbsBtn = this.imgT.find('.thumbsBtn');

    //輪播圖片
    this.pb = this.slideEl.find('.prevBtn');
    this.nb = this.slideEl.find('.nextBtn');
  }
  //開啟關閉小圖列表
  /*
  thumbsCtrl() {
    this.imgT.hover(() => {
      this.imgT.addClass('active');
    }, () => {
      this.imgT.removeClass('active');
    });
    this.thumbsBtn.on('click', () => {
      if(this.imgT.is('.active')){
        this.imgT.removeClass('active');
      }else{
        this.imgT.addClass('active');
      }
    });
  }
  */


  _createClass(ObjsBannerImg, [{
    key: 'sliderModule',
    value: function sliderModule() {
      //開啟關閉小圖列表
      // this.thumbsCtrl();

      //大圖
      var slideB = new _swiper2.default(this.banner, {
        navigation: {
          prevEl: this.pb,
          nextEl: this.nb
        },
        grabCursor: true,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        roundLengths: true,
        on: {
          init: function init() {
            //圖片延遲載入
            var lazyLoad = new _lazyload.LazyLoad();
            lazyLoad.noImgCropLoad();
          },
          slideChangeTransitionEnd: function slideChangeTransitionEnd() {
            //圖片延遲載入
            var lazyLoad = new _lazyload.LazyLoad();
            lazyLoad.noImgCropLoad();
            // 目前頁數 & 總數
            // this.thumbsBtn.find('span').html((slideT.realIndex + 1) + ' / ' + slideT.slides.length);
          }
        }
      });

      //小圖列表
      /*
      let slideT = new Swiper(this.thumbs, {
        grabCursor         : true,
        slidesPerView      : 5,
        spaceBetween       : 0,
        centeredSlides     : true,
        slideToClickedSlide: true,
        observer           : true,
        observeParents     : true,
        roundLengths       : true,
        on: {
          init: () => {
            //圖片延遲載入並裁切
            let lazyLoad = new LazyLoad;
            lazyLoad.imgLoad();
          },
          slideChangeTransitionEnd: () => {
            //圖片延遲載入並裁切
            let lazyLoad = new LazyLoad;
            lazyLoad.imgLoad();
            //目前頁數 & 總數
            this.thumbsBtn.find('span').html((slideT.realIndex + 1) + ' / ' + slideT.slides.length);
          }
        }
      });
      
        //目前頁數 & 總數 (初始化)
      this.thumbsBtn.find('span').html((slideT.realIndex + 1) + ' / ' + slideT.slides.length);
        //同步控制
      slideB.controller.control = slideT;
      slideT.controller.control = slideB;
      */
    }
  }]);

  return ObjsBannerImg;
}();

//Footer Ads


var FooterAds = function () {
  function FooterAds() {
    _classCallCheck(this, FooterAds);

    this.window = $(window);
    this.slideEl = $('#footerAds');

    //輪播圖
    this.slide = this.slideEl.find('.slide');
    this.pb = this.slideEl.find('.prevBtn');
    this.nb = this.slideEl.find('.nextBtn');
    this.ds = this.slideEl.find('.dots');
  }

  _createClass(FooterAds, [{
    key: 'sliderModule',
    value: function sliderModule() {
      var _this2 = this;

      //輪播圖片
      var slide = new _swiper2.default(this.slide, {
        navigation: {
          prevEl: this.pb,
          nextEl: this.nb
        },
        pagination: {
          el: this.ds,
          clickable: true,
          dynamicBullets: true
        },
        grabCursor: true,
        loop: true,
        loopAdditionalSlides: 4,
        autoplay: {
          delay: 3000
        },
        slidesPerView: 4,
        spaceBetween: 0,
        autoHeight: true,
        observer: true,
        observeParents: true,
        roundLengths: true,
        breakpoints: {
          1279: {
            slidesPerView: 3,
            loopAdditionalSlides: 3
          },
          1023: {
            slidesPerView: 2,
            loopAdditionalSlides: 2
          },
          600: {
            slidesPerView: 1,
            loopAdditionalSlides: 1
          }
        }
      });

      //滑入本區塊開啟 & 關閉自動播放
      var rwdResize = function rwdResize() {
        slide.autoplay.start();
        if (window.matchMedia('(max-width: 1023px)').matches) {
          _this2.slide.off('mouseover');
          _this2.slide.off('mouseout');
        } else {
          _this2.slide.on('mouseover', function () {
            slide.autoplay.stop();
          });
          _this2.slide.on('mouseout', function () {
            slide.autoplay.start();
          });
        }
      };
      rwdResize();
      this.window.on('resize', rwdResize);
    }
  }]);

  return FooterAds;
}();

//輸出


exports.IndexBanner = IndexBanner;
exports.IndexObjsSlider = IndexObjsSlider;
exports.ObjsBannerImg = ObjsBannerImg;
exports.FooterAds = FooterAds;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Swiper 4.5.1
                                                                                                                                                                                                                                                                               * Most modern mobile touch slider and framework with hardware accelerated transitions
                                                                                                                                                                                                                                                                               * http://www.idangero.us/swiper/
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Copyright 2014-2019 Vladimir Kharlampidi
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Released under the MIT License
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Released on: September 13, 2019
                                                                                                                                                                                                                                                                               */

var _dom = __webpack_require__(33);

var _ssrWindow = __webpack_require__(35);

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Methods = {
  addClass: _dom.addClass,
  removeClass: _dom.removeClass,
  hasClass: _dom.hasClass,
  toggleClass: _dom.toggleClass,
  attr: _dom.attr,
  removeAttr: _dom.removeAttr,
  data: _dom.data,
  transform: _dom.transform,
  transition: _dom.transition,
  on: _dom.on,
  off: _dom.off,
  trigger: _dom.trigger,
  transitionEnd: _dom.transitionEnd,
  outerWidth: _dom.outerWidth,
  outerHeight: _dom.outerHeight,
  offset: _dom.offset,
  css: _dom.css,
  each: _dom.each,
  html: _dom.html,
  text: _dom.text,
  is: _dom.is,
  index: _dom.index,
  eq: _dom.eq,
  append: _dom.append,
  prepend: _dom.prepend,
  next: _dom.next,
  nextAll: _dom.nextAll,
  prev: _dom.prev,
  prevAll: _dom.prevAll,
  parent: _dom.parent,
  parents: _dom.parents,
  closest: _dom.closest,
  find: _dom.find,
  children: _dom.children,
  remove: _dom.remove,
  add: _dom.add,
  styles: _dom.styles
};

Object.keys(Methods).forEach(function (methodName) {
  _dom.$.fn[methodName] = _dom.$.fn[methodName] || Methods[methodName];
});

var Utils = {
  deleteProps: function deleteProps(obj) {
    var object = obj;
    Object.keys(object).forEach(function (key) {
      try {
        object[key] = null;
      } catch (e) {
        // no getter for object
      }
      try {
        delete object[key];
      } catch (e) {
        // something got wrong
      }
    });
  },
  nextTick: function nextTick(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    return setTimeout(callback, delay);
  },
  now: function now() {
    return Date.now();
  },
  getTranslate: function getTranslate(el) {
    var axis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';

    var matrix = void 0;
    var curTransform = void 0;
    var transformMatrix = void 0;

    var curStyle = _ssrWindow.window.getComputedStyle(el, null);

    if (_ssrWindow.window.WebKitCSSMatrix) {
      curTransform = curStyle.transform || curStyle.webkitTransform;
      if (curTransform.split(',').length > 6) {
        curTransform = curTransform.split(', ').map(function (a) {
          return a.replace(',', '.');
        }).join(', ');
      }
      // Some old versions of Webkit choke when 'none' is passed; pass
      // empty string instead in this case
      transformMatrix = new _ssrWindow.window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
      transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
      matrix = transformMatrix.toString().split(',');
    }

    if (axis === 'x') {
      // Latest Chrome and webkits Fix
      if (_ssrWindow.window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
      // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
      // Latest Chrome and webkits Fix
      if (_ssrWindow.window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
      // Crazy IE10 Matrix
      else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
  },
  parseUrlQuery: function parseUrlQuery(url) {
    var query = {};
    var urlToParse = url || _ssrWindow.window.location.href;
    var i = void 0;
    var params = void 0;
    var param = void 0;
    var length = void 0;
    if (typeof urlToParse === 'string' && urlToParse.length) {
      urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
      params = urlToParse.split('&').filter(function (paramsPart) {
        return paramsPart !== '';
      });
      length = params.length;

      for (i = 0; i < length; i += 1) {
        param = params[i].replace(/#\S+/g, '').split('=');
        query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
      }
    }
    return query;
  },
  isObject: function isObject(o) {
    return (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && o !== null && o.constructor && o.constructor === Object;
  },
  extend: function extend() {
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    for (var i = 1; i < arguments.length; i += 1) {
      var nextSource = arguments.length <= i ? undefined : arguments[i];
      if (nextSource !== undefined && nextSource !== null) {
        var keysArray = Object.keys(Object(nextSource));
        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable) {
            if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
              to[nextKey] = {};
              Utils.extend(to[nextKey], nextSource[nextKey]);
            } else {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
    }
    return to;
  }
};

var Support = function Support() {
  var testDiv = _ssrWindow.document.createElement('div');
  return {
    touch: _ssrWindow.window.Modernizr && _ssrWindow.window.Modernizr.touch === true || function checkTouch() {
      return !!(_ssrWindow.window.navigator.maxTouchPoints > 0 || 'ontouchstart' in _ssrWindow.window || _ssrWindow.window.DocumentTouch && _ssrWindow.document instanceof _ssrWindow.window.DocumentTouch);
    }(),

    pointerEvents: !!(_ssrWindow.window.navigator.pointerEnabled || _ssrWindow.window.PointerEvent || 'maxTouchPoints' in _ssrWindow.window.navigator && _ssrWindow.window.navigator.maxTouchPoints > 0),
    prefixedPointerEvents: !!_ssrWindow.window.navigator.msPointerEnabled,

    transition: function checkTransition() {
      var style = testDiv.style;
      return 'transition' in style || 'webkitTransition' in style || 'MozTransition' in style;
    }(),
    transforms3d: _ssrWindow.window.Modernizr && _ssrWindow.window.Modernizr.csstransforms3d === true || function checkTransforms3d() {
      var style = testDiv.style;
      return 'webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style;
    }(),

    flexbox: function checkFlexbox() {
      var style = testDiv.style;
      var styles = 'alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient'.split(' ');
      for (var i = 0; i < styles.length; i += 1) {
        if (styles[i] in style) return true;
      }
      return false;
    }(),

    observer: function checkObserver() {
      return 'MutationObserver' in _ssrWindow.window || 'WebkitMutationObserver' in _ssrWindow.window;
    }(),

    passiveListener: function checkPassiveListener() {
      var supportsPassive = false;
      try {
        var opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get: function get() {
            supportsPassive = true;
          }
        });
        _ssrWindow.window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {
        // No support
      }
      return supportsPassive;
    }(),

    gestures: function checkGestures() {
      return 'ongesturestart' in _ssrWindow.window;
    }()
  };
}();

var Browser = function Browser() {
  function isSafari() {
    var ua = _ssrWindow.window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  return {
    isIE: !!_ssrWindow.window.navigator.userAgent.match(/Trident/g) || !!_ssrWindow.window.navigator.userAgent.match(/MSIE/g),
    isEdge: !!_ssrWindow.window.navigator.userAgent.match(/Edge/g),
    isSafari: isSafari(),
    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(_ssrWindow.window.navigator.userAgent)
  };
}();

var SwiperClass = function () {
  function SwiperClass() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SwiperClass);

    var self = this;
    self.params = params;

    // Events
    self.eventsListeners = {};

    if (self.params && self.params.on) {
      Object.keys(self.params.on).forEach(function (eventName) {
        self.on(eventName, self.params.on[eventName]);
      });
    }
  }

  _createClass(SwiperClass, [{
    key: 'on',
    value: function on(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      var method = priority ? 'unshift' : 'push';
      events.split(' ').forEach(function (event) {
        if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
        self.eventsListeners[event][method](handler);
      });
      return self;
    }
  }, {
    key: 'once',
    value: function once(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') return self;
      function onceHandler() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        handler.apply(self, args);
        self.off(events, onceHandler);
        if (onceHandler.f7proxy) {
          delete onceHandler.f7proxy;
        }
      }
      onceHandler.f7proxy = handler;
      return self.on(events, onceHandler, priority);
    }
  }, {
    key: 'off',
    value: function off(events, handler) {
      var self = this;
      if (!self.eventsListeners) return self;
      events.split(' ').forEach(function (event) {
        if (typeof handler === 'undefined') {
          self.eventsListeners[event] = [];
        } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
          self.eventsListeners[event].forEach(function (eventHandler, index) {
            if (eventHandler === handler || eventHandler.f7proxy && eventHandler.f7proxy === handler) {
              self.eventsListeners[event].splice(index, 1);
            }
          });
        }
      });
      return self;
    }
  }, {
    key: 'emit',
    value: function emit() {
      var self = this;
      if (!self.eventsListeners) return self;
      var events = void 0;
      var data = void 0;
      var context = void 0;

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (typeof args[0] === 'string' || Array.isArray(args[0])) {
        events = args[0];
        data = args.slice(1, args.length);
        context = self;
      } else {
        events = args[0].events;
        data = args[0].data;
        context = args[0].context || self;
      }
      var eventsArray = Array.isArray(events) ? events : events.split(' ');
      eventsArray.forEach(function (event) {
        if (self.eventsListeners && self.eventsListeners[event]) {
          var handlers = [];
          self.eventsListeners[event].forEach(function (eventHandler) {
            handlers.push(eventHandler);
          });
          handlers.forEach(function (eventHandler) {
            eventHandler.apply(context, data);
          });
        }
      });
      return self;
    }
  }, {
    key: 'useModulesParams',
    value: function useModulesParams(instanceParams) {
      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        // Extend params
        if (module.params) {
          Utils.extend(instanceParams, module.params);
        }
      });
    }
  }, {
    key: 'useModules',
    value: function useModules() {
      var modulesParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var instance = this;
      if (!instance.modules) return;
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        var moduleParams = modulesParams[moduleName] || {};
        // Extend instance methods and props
        if (module.instance) {
          Object.keys(module.instance).forEach(function (modulePropName) {
            var moduleProp = module.instance[modulePropName];
            if (typeof moduleProp === 'function') {
              instance[modulePropName] = moduleProp.bind(instance);
            } else {
              instance[modulePropName] = moduleProp;
            }
          });
        }
        // Add event listeners
        if (module.on && instance.on) {
          Object.keys(module.on).forEach(function (moduleEventName) {
            instance.on(moduleEventName, module.on[moduleEventName]);
          });
        }

        // Module create callback
        if (module.create) {
          module.create.bind(instance)(moduleParams);
        }
      });
    }
  }], [{
    key: 'installModule',
    value: function installModule(module) {
      var Class = this;
      if (!Class.prototype.modules) Class.prototype.modules = {};
      var name = module.name || Object.keys(Class.prototype.modules).length + '_' + Utils.now();
      Class.prototype.modules[name] = module;
      // Prototype
      if (module.proto) {
        Object.keys(module.proto).forEach(function (key) {
          Class.prototype[key] = module.proto[key];
        });
      }
      // Class
      if (module.static) {
        Object.keys(module.static).forEach(function (key) {
          Class[key] = module.static[key];
        });
      }
      // Callback
      if (module.install) {
        for (var _len3 = arguments.length, params = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          params[_key3 - 1] = arguments[_key3];
        }

        module.install.apply(Class, params);
      }
      return Class;
    }
  }, {
    key: 'use',
    value: function use(module) {
      var Class = this;
      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Class.installModule(m);
        });
        return Class;
      }

      for (var _len4 = arguments.length, params = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        params[_key4 - 1] = arguments[_key4];
      }

      return Class.installModule.apply(Class, [module].concat(params));
    }
  }, {
    key: 'components',
    set: function set(components) {
      var Class = this;
      if (!Class.use) return;
      Class.use(components);
    }
  }]);

  return SwiperClass;
}();

function updateSize() {
  var swiper = this;
  var width = void 0;
  var height = void 0;
  var $el = swiper.$el;
  if (typeof swiper.params.width !== 'undefined') {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined') {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }

  // Subtract paddings
  width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
  height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);

  Utils.extend(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;
  var params = swiper.params;

  var $wrapperEl = swiper.$wrapperEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;

  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = $wrapperEl.children('.' + swiper.params.slideClass);
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];

  var offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  var offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.snapGrid.length;

  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween;

  // reset margins
  if (rtl) slides.css({ marginLeft: '', marginTop: '' });else slides.css({ marginRight: '', marginBottom: '' });

  var slidesNumberEvenToRows = void 0;
  if (params.slidesPerColumn > 1) {
    if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
      slidesNumberEvenToRows = slidesLength;
    } else {
      slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
    }
    if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
      slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    }
  }

  // Calc slides
  var slideSize = void 0;
  var slidesPerColumn = params.slidesPerColumn;
  var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
  var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var _slide = slides.eq(i);
    if (params.slidesPerColumn > 1) {
      // Set slides order
      var newSlideOrderIndex = void 0;
      var column = void 0;
      var row = void 0;
      if (params.slidesPerColumnFill === 'column' || params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
        if (params.slidesPerColumnFill === 'column') {
          column = Math.floor(i / slidesPerColumn);
          row = i - column * slidesPerColumn;
          if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
            row += 1;
            if (row >= slidesPerColumn) {
              row = 0;
              column += 1;
            }
          }
        } else {
          var groupIndex = Math.floor(i / params.slidesPerGroup);
          row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
          column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
        }
        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
        _slide.css({
          '-webkit-box-ordinal-group': newSlideOrderIndex,
          '-moz-box-ordinal-group': newSlideOrderIndex,
          '-ms-flex-order': newSlideOrderIndex,
          '-webkit-order': newSlideOrderIndex,
          order: newSlideOrderIndex
        });
      } else {
        row = Math.floor(i / slidesPerRow);
        column = i - row * slidesPerRow;
      }
      _slide.css('margin-' + (swiper.isHorizontal() ? 'top' : 'left'), row !== 0 && params.spaceBetween && params.spaceBetween + 'px').attr('data-swiper-column', column).attr('data-swiper-row', row);
    }
    if (_slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      var slideStyles = _ssrWindow.window.getComputedStyle(_slide[0], null);
      var currentTransform = _slide[0].style.transform;
      var currentWebKitTransform = _slide[0].style.webkitTransform;
      if (currentTransform) {
        _slide[0].style.transform = 'none';
      }
      if (currentWebKitTransform) {
        _slide[0].style.webkitTransform = 'none';
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? _slide.outerWidth(true) : _slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        if (swiper.isHorizontal()) {
          var width = parseFloat(slideStyles.getPropertyValue('width'));
          var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
          var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
          var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
          var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
          var boxSizing = slideStyles.getPropertyValue('box-sizing');
          if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
            slideSize = width + marginLeft + marginRight;
          } else {
            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
          }
        } else {
          var height = parseFloat(slideStyles.getPropertyValue('height'));
          var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
          var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
          var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
          var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
          var _boxSizing = slideStyles.getPropertyValue('box-sizing');
          if (_boxSizing && _boxSizing === 'border-box' && !Browser.isIE) {
            slideSize = height + marginTop + marginBottom;
          } else {
            slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
          }
        }
      }
      if (currentTransform) {
        _slide[0].style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        _slide[0].style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        if (swiper.isHorizontal()) {
          slides[i].style.width = slideSize + 'px';
        } else {
          slides[i].style.height = slideSize + 'px';
        }
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;

    prevSlideSize = slideSize;

    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  var newSlidesGrid = void 0;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + 'px' });
  }
  if (!Support.flexbox || params.setWrapperSize) {
    if (swiper.isHorizontal()) $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + 'px' });else $wrapperEl.css({ height: swiper.virtualSize + params.spaceBetween + 'px' });
  }

  if (params.slidesPerColumn > 1) {
    swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
    swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
    if (swiper.isHorizontal()) $wrapperEl.css({ width: swiper.virtualSize + params.spaceBetween + 'px' });else $wrapperEl.css({ height: swiper.virtualSize + params.spaceBetween + 'px' });
    if (params.centeredSlides) {
      newSlidesGrid = [];
      for (var _i = 0; _i < snapGrid.length; _i += 1) {
        var slidesGridItem = snapGrid[_i];
        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
      }
      snapGrid = newSlidesGrid;
    }
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    newSlidesGrid = [];
    for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
      var _slidesGridItem = snapGrid[_i2];
      if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);
      if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(_slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    if (swiper.isHorizontal()) {
      if (rtl) slides.css({ marginLeft: spaceBetween + 'px' });else slides.css({ marginRight: spaceBetween + 'px' });
    } else slides.css({ marginBottom: spaceBetween + 'px' });
  }

  if (params.centerInsufficientSlides) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    if (allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Utils.extend(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateSlidesOffset();
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var newHeight = 0;
  var i = void 0;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
      var _index = swiper.activeIndex + i;
      if (_index > swiper.slides.length) break;
      activeSlides.push(swiper.slides.eq(_index)[0]);
    }
  } else {
    activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight) swiper.$wrapperEl.css('height', newHeight + 'px');
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;
  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress() {
  var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this && this.translate || 0;

  var swiper = this;
  var params = swiper.params;

  var slides = swiper.slides,
      rtl = swiper.rtlTranslate;


  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();

  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate;

  // Visible Slides
  slides.removeClass(params.slideVisibleClass);

  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (var i = 0; i < slides.length; i += 1) {
    var _slide2 = slides[i];
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - _slide2.swiperSlideOffset) / (_slide2.swiperSlideSize + params.spaceBetween);
    if (params.watchSlidesVisibility) {
      var slideBefore = -(offsetCenter - _slide2.swiperSlideOffset);
      var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
      var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
      if (isVisible) {
        swiper.visibleSlides.push(_slide2);
        swiper.visibleSlidesIndexes.push(i);
        slides.eq(i).addClass(params.slideVisibleClass);
      }
    }
    _slide2.progress = rtl ? -slideProgress : slideProgress;
  }
  swiper.visibleSlides = (0, _dom.$)(swiper.visibleSlides);
}

function updateProgress() {
  var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this && this.translate || 0;

  var swiper = this;
  var params = swiper.params;

  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd;

  var wasBeginning = isBeginning;
  var wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }
  Utils.extend(swiper, {
    progress: progress,
    isBeginning: isBeginning,
    isEnd: isEnd
  });

  if (params.watchSlidesProgress || params.watchSlidesVisibility) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;

  var slides = swiper.slides,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex,
      realIndex = swiper.realIndex;

  var isVirtual = swiper.virtual && params.virtual.enabled;

  slides.removeClass(params.slideActiveClass + ' ' + params.slideNextClass + ' ' + params.slidePrevClass + ' ' + params.slideDuplicateActiveClass + ' ' + params.slideDuplicateNextClass + ' ' + params.slideDuplicatePrevClass);

  var activeSlide = void 0;
  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find('.' + params.slideClass + '[data-swiper-slide-index="' + activeIndex + '"]');
  } else {
    activeSlide = slides.eq(activeIndex);
  }

  // Active classes
  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children('.' + params.slideClass + ':not(.' + params.slideDuplicateClass + ')[data-swiper-slide-index="' + realIndex + '"]').addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass + '[data-swiper-slide-index="' + realIndex + '"]').addClass(params.slideDuplicateActiveClass);
    }
  }
  // Next Slide
  var nextSlide = activeSlide.nextAll('.' + params.slideClass).eq(0).addClass(params.slideNextClass);
  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  }
  // Prev Slide
  var prevSlide = activeSlide.prevAll('.' + params.slideClass).eq(0).addClass(params.slidePrevClass);
  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }
  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children('.' + params.slideClass + ':not(.' + params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicateNextClass);
    }
    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children('.' + params.slideClass + ':not(.' + params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(params.slideDuplicatePrevClass);
    }
  }
}

function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;

  var activeIndex = newActiveIndex;
  var snapIndex = void 0;
  if (typeof activeIndex === 'undefined') {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  }

  // Get real index
  var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);

  Utils.extend(swiper, {
    snapIndex: snapIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }
  if (swiper.initialized || swiper.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(e) {
  var swiper = this;
  var params = swiper.params;
  var slide = (0, _dom.$)(e.target).closest('.' + params.slideClass)[0];
  var slideFound = false;
  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) slideFound = true;
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt((0, _dom.$)(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = (0, _dom.$)(slide).index();
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getTranslate() {
  var axis = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.isHorizontal() ? 'x' : 'y';

  var swiper = this;

  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      $wrapperEl = swiper.$wrapperEl;


  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;

  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      progress = swiper.progress;

  var x = 0;
  var y = 0;
  var z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (!params.virtualTranslate) {
    if (Support.transforms3d) $wrapperEl.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');else $wrapperEl.transform('translate(' + x + 'px, ' + y + 'px)');
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;

  // Check if we need to update progress
  var newProgress = void 0;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

var translate = {
  getTranslate: getTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate
};

function setTransition(duration, byController) {
  var swiper = this;

  swiper.$wrapperEl.transition(duration);

  swiper.emit('setTransition', duration, byController);
}

function transitionStart() {
  var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var direction = arguments[1];

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      params = swiper.params,
      previousIndex = swiper.previousIndex;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  var dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionStart');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionStart');
      return;
    }
    swiper.emit('slideChangeTransitionStart');
    if (dir === 'next') {
      swiper.emit('slideNextTransitionStart');
    } else {
      swiper.emit('slidePrevTransitionStart');
    }
  }
}

function transitionEnd() {
  var runCallbacks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var direction = arguments[1];

  var swiper = this;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex;

  swiper.animating = false;
  swiper.setTransition(0);

  var dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit('transitionEnd');

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransitionEnd');
      return;
    }
    swiper.emit('slideChangeTransitionEnd');
    if (dir === 'next') {
      swiper.emit('slideNextTransitionEnd');
    } else {
      swiper.emit('slidePrevTransitionEnd');
    }
  }
}

var transition = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};

function slideTo() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var internal = arguments[3];

  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;

  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  var translate = -snapGrid[snapIndex];

  // Update progress
  swiper.updateProgress(translate);

  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  var direction = void 0;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';

  // Update Index
  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }

  if (speed === 0 || !Support.transition) {
    swiper.setTransition(0);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    swiper.transitionEnd(runCallbacks, direction);
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onSlideToWrapperTransitionEnd) {
        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
          swiper.onSlideToWrapperTransitionEnd = null;
          delete swiper.onSlideToWrapperTransitionEnd;
          swiper.transitionEnd(runCallbacks, direction);
        };
      }
      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
  }

  return true;
}

function slideToLoop() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.params.speed;
  var runCallbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var internal = arguments[3];

  var swiper = this;
  var newIndex = index;
  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating;

  if (params.loop) {
    if (animating) return false;
    swiper.loopFix();
    // eslint-disable-next-line
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  var params = swiper.params,
      animating = swiper.animating,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate;


  if (params.loop) {
    if (animating) return false;
    swiper.loopFix();
    // eslint-disable-next-line
    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }
  var translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var normalizedSlidesGrid = slidesGrid.map(function (val) {
    return normalize(val);
  });

  var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  var prevIndex = void 0;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest() {
  var speed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;
  var runCallbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var internal = arguments[2];

  var swiper = this;
  var index = swiper.activeIndex;
  var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

  if (snapIndex < swiper.snapGrid.length - 1) {
    var _translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];

    if (_translate - currentSnap > (nextSnap - currentSnap) / 2) {
      index = swiper.params.slidesPerGroup;
    }
  }

  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;


  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex = void 0;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt((0, _dom.$)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + params.slideDuplicateClass + ')').eq(0).index();

        Utils.nextTick(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children('.' + params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + params.slideDuplicateClass + ')').eq(0).index();

      Utils.nextTick(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate() {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl;
  // Remove duplicated slides

  $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass).remove();

  var slides = $wrapperEl.children('.' + params.slideClass);

  if (params.loopFillGroupWithBlank) {
    var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
    if (blankSlidesNum !== params.slidesPerGroup) {
      for (var i = 0; i < blankSlidesNum; i += 1) {
        var blankNode = (0, _dom.$)(_ssrWindow.document.createElement('div')).addClass(params.slideClass + ' ' + params.slideBlankClass);
        $wrapperEl.append(blankNode);
      }
      slides = $wrapperEl.children('.' + params.slideClass);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;

  swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
  swiper.loopedSlides += params.loopAdditionalSlides;
  if (swiper.loopedSlides > slides.length) {
    swiper.loopedSlides = slides.length;
  }

  var prependSlides = [];
  var appendSlides = [];
  slides.each(function (index, el) {
    var slide = (0, _dom.$)(el);
    if (index < swiper.loopedSlides) appendSlides.push(el);
    if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
    slide.attr('data-swiper-slide-index', index);
  });
  for (var _i3 = 0; _i3 < appendSlides.length; _i3 += 1) {
    $wrapperEl.append((0, _dom.$)(appendSlides[_i3].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
  for (var _i4 = prependSlides.length - 1; _i4 >= 0; _i4 -= 1) {
    $wrapperEl.prepend((0, _dom.$)(prependSlides[_i4].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix() {
  var swiper = this;
  var params = swiper.params,
      activeIndex = swiper.activeIndex,
      slides = swiper.slides,
      loopedSlides = swiper.loopedSlides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      snapGrid = swiper.snapGrid,
      rtl = swiper.rtlTranslate;

  var newIndex = void 0;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;

  var snapTranslate = -snapGrid[activeIndex];
  var diff = snapTranslate - swiper.getTranslate();

  // Fix For Negative Oversliding
  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    var slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2 || activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    var _slideChanged = swiper.slideTo(newIndex, 0, false, true);
    if (_slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
}

function loopDestroy() {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      slides = swiper.slides;

  $wrapperEl.children('.' + params.slideClass + '.' + params.slideDuplicateClass + ',.' + params.slideClass + '.' + params.slideBlankClass).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (Support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked) return;
  var el = swiper.el;
  el.style.cursor = 'move';
  el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
  el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  var swiper = this;
  if (Support.touch || swiper.params.watchOverflow && swiper.isLocked) return;
  swiper.el.style.cursor = '';
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

function appendSlide(slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params;

  if (params.loop) {
    swiper.loopDestroy();
  }
  if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.append(slides[i]);
    }
  } else {
    $wrapperEl.append(slides);
  }
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
}

function prependSlide(slides) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;


  if (params.loop) {
    swiper.loopDestroy();
  }
  var newActiveIndex = activeIndex + 1;
  if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
    for (var i = 0; i < slides.length; i += 1) {
      if (slides[i]) $wrapperEl.prepend(slides[i]);
    }
    newActiveIndex = activeIndex + slides.length;
  } else {
    $wrapperEl.prepend(slides);
  }
  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  swiper.slideTo(newActiveIndex, 0, false);
}

function addSlide(index, slides) {
  var swiper = this;
  var $wrapperEl = swiper.$wrapperEl,
      params = swiper.params,
      activeIndex = swiper.activeIndex;

  var activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children('.' + params.slideClass);
  }
  var baseLength = swiper.slides.length;
  if (index <= 0) {
    swiper.prependSlide(slides);
    return;
  }
  if (index >= baseLength) {
    swiper.appendSlide(slides);
    return;
  }
  var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;

  var slidesBuffer = [];
  for (var i = baseLength - 1; i >= index; i -= 1) {
    var currentSlide = swiper.slides.eq(i);
    currentSlide.remove();
    slidesBuffer.unshift(currentSlide);
  }

  if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
    for (var _i5 = 0; _i5 < slides.length; _i5 += 1) {
      if (slides[_i5]) $wrapperEl.append(slides[_i5]);
    }
    newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
  } else {
    $wrapperEl.append(slides);
  }

  for (var _i6 = 0; _i6 < slidesBuffer.length; _i6 += 1) {
    $wrapperEl.append(slidesBuffer[_i6]);
  }

  if (params.loop) {
    swiper.loopCreate();
  }
  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeSlide(slidesIndexes) {
  var swiper = this;
  var params = swiper.params,
      $wrapperEl = swiper.$wrapperEl,
      activeIndex = swiper.activeIndex;


  var activeIndexBuffer = activeIndex;
  if (params.loop) {
    activeIndexBuffer -= swiper.loopedSlides;
    swiper.loopDestroy();
    swiper.slides = $wrapperEl.children('.' + params.slideClass);
  }
  var newActiveIndex = activeIndexBuffer;
  var indexToRemove = void 0;

  if ((typeof slidesIndexes === 'undefined' ? 'undefined' : _typeof(slidesIndexes)) === 'object' && 'length' in slidesIndexes) {
    for (var i = 0; i < slidesIndexes.length; i += 1) {
      indexToRemove = slidesIndexes[i];
      if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
      if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    }
    newActiveIndex = Math.max(newActiveIndex, 0);
  } else {
    indexToRemove = slidesIndexes;
    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
    newActiveIndex = Math.max(newActiveIndex, 0);
  }

  if (params.loop) {
    swiper.loopCreate();
  }

  if (!(params.observer && Support.observer)) {
    swiper.update();
  }
  if (params.loop) {
    swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
  } else {
    swiper.slideTo(newActiveIndex, 0, false);
  }
}

function removeAllSlides() {
  var swiper = this;

  var slidesIndexes = [];
  for (var i = 0; i < swiper.slides.length; i += 1) {
    slidesIndexes.push(i);
  }
  swiper.removeSlide(slidesIndexes);
}

var manipulation = {
  appendSlide: appendSlide,
  prependSlide: prependSlide,
  addSlide: addSlide,
  removeSlide: removeSlide,
  removeAllSlides: removeAllSlides
};

var Device = function Device() {
  var ua = _ssrWindow.window.navigator.userAgent;

  var device = {
    ios: false,
    android: false,
    androidChrome: false,
    desktop: false,
    windows: false,
    iphone: false,
    ipod: false,
    ipad: false,
    cordova: _ssrWindow.window.cordova || _ssrWindow.window.phonegap,
    phonegap: _ssrWindow.window.cordova || _ssrWindow.window.phonegap
  };

  var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);

  // Windows
  if (windows) {
    device.os = 'windows';
    device.osVersion = windows[2];
    device.windows = true;
  }
  // Android
  if (android && !windows) {
    device.os = 'android';
    device.osVersion = android[2];
    device.android = true;
    device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }
  // iOS
  if (iphone && !ipod) {
    device.osVersion = iphone[2].replace(/_/g, '.');
    device.iphone = true;
  }
  if (ipad) {
    device.osVersion = ipad[2].replace(/_/g, '.');
    device.ipad = true;
  }
  if (ipod) {
    device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
    device.iphone = true;
  }
  // iOS 8+ changed UA
  if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
    if (device.osVersion.split('.')[0] === '10') {
      device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
    }
  }

  // Desktop
  device.desktop = !(device.os || device.android || device.webView);

  // Webview
  device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

  // Minimal UI
  if (device.os && device.os === 'ios') {
    var osVersionArr = device.osVersion.split('.');
    var metaViewport = _ssrWindow.document.querySelector('meta[name="viewport"]');
    device.minimalUi = !device.webView && (ipod || iphone) && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
  }

  // Pixel Ratio
  device.pixelRatio = _ssrWindow.window.devicePixelRatio || 1;

  // Export object
  return device;
}();

function onTouchStart(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;
  if (params.noSwiping && (0, _dom.$)(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : '.' + params.noSwipingClass)[0]) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!(0, _dom.$)(e).closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

  var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= _ssrWindow.window.screen.width - edgeSwipeThreshold)) {
    return;
  }

  Utils.extend(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });

  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = Utils.now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;
  if (e.type !== 'touchstart') {
    var preventDefault = true;
    if ((0, _dom.$)(e.target).is(data.formElements)) preventDefault = false;
    if (_ssrWindow.document.activeElement && (0, _dom.$)(_ssrWindow.document.activeElement).is(data.formElements) && _ssrWindow.document.activeElement !== e.target) {
      _ssrWindow.document.activeElement.blur();
    }

    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if (params.touchStartForcePreventDefault || shouldPreventDefault) {
      e.preventDefault();
    }
  }
  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate;

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  if (data.isTouchEvent && e.type === 'mousemove') return;
  var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
  var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    // isMoved = true;
    swiper.allowClick = false;
    if (data.isTouched) {
      Utils.extend(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = Utils.now();
    }
    return;
  }
  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (data.isTouchEvent && _ssrWindow.document.activeElement) {
    if (e.target === _ssrWindow.document.activeElement && (0, _dom.$)(e.target).is(data.formElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  if (e.targetTouches && e.targetTouches.length > 1) return;

  touches.currentX = pageX;
  touches.currentY = pageY;

  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    var touchAngle = void 0;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  e.preventDefault();
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop) {
      swiper.loopFix();
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }
    data.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;

  var diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;

  diff *= params.touchRatio;
  if (rtl) diff = -diff;

  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;

  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger) return;

  // Update active index in free mode
  if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode) {
    // Velocity
    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }
    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: Utils.now()
    });
  }
  // Update progress
  swiper.updateProgress(data.currentTranslate);
  // Update translate
  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;

  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      $wrapperEl = swiper.$wrapperEl,
      slidesGrid = swiper.slidesGrid,
      snapGrid = swiper.snapGrid;

  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  // Return Grab Cursor
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  var touchEndTime = Utils.now();
  var timeDiff = touchEndTime - data.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    swiper.updateClickedSlide(e);
    swiper.emit('tap', e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime > 300) {
      if (data.clickTimeout) clearTimeout(data.clickTimeout);
      data.clickTimeout = Utils.nextTick(function () {
        if (!swiper || swiper.destroyed) return;
        swiper.emit('click', e);
      }, 300);
    }
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      if (data.clickTimeout) clearTimeout(data.clickTimeout);
      swiper.emit('doubleTap', e);
    }
  }

  data.lastClickTime = Utils.now();
  Utils.nextTick(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;

  var currentPos = void 0;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.freeMode) {
    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }
      return;
    }

    if (params.freeModeMomentum) {
      if (data.velocities.length > 1) {
        var lastMoveEvent = data.velocities.pop();
        var velocityEvent = data.velocities.pop();

        var distance = lastMoveEvent.position - velocityEvent.position;
        var time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;
        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
          swiper.velocity = 0;
        }
        // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.
        if (time > 150 || Utils.now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }
      swiper.velocity *= params.freeModeMomentumVelocityRatio;

      data.velocities.length = 0;
      var momentumDuration = 1000 * params.freeModeMomentumRatio;
      var momentumDistance = swiper.velocity * momentumDuration;

      var newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;

      var doBounce = false;
      var afterBouncePosition = void 0;
      var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
      var needsLoopFix = void 0;
      if (newPosition < swiper.maxTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }
          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeModeMomentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }
          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }
        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeModeSticky) {
        var nextSlide = void 0;
        for (var j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }
        newPosition = -newPosition;
      }
      if (needsLoopFix) {
        swiper.once('transitionEnd', function () {
          swiper.loopFix();
        });
      }
      // Fix duration
      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }
      } else if (params.freeModeSticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeModeMomentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(function () {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          swiper.emit('momentumBounce');

          swiper.setTransition(params.speed);
          swiper.setTranslate(afterBouncePosition);
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        });
      } else if (swiper.velocity) {
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(function () {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeModeSticky) {
      swiper.slideToClosest();
      return;
    }

    if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
    return;
  }

  // Find current slide
  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];
  for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
    if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
        stopIndex = i;
        groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  // Find current slide size
  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + params.slidesPerGroup);else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + params.slidesPerGroup);else swiper.slideTo(stopIndex);
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      swiper.slideTo(stopIndex + params.slidesPerGroup);
    }
    if (swiper.swipeDirection === 'prev') {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;

  var params = swiper.params,
      el = swiper.el;


  if (el && el.offsetWidth === 0) return;

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid;

  // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;

  swiper.updateSize();
  swiper.updateSlides();

  if (params.freeMode) {
    var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
    swiper.setTranslate(newTranslate);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
  } else {
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
      swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function attachEvents() {
  var swiper = this;
  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl;


  {
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
  var capture = !!params.nested;

  // Touch Events
  {
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
      _ssrWindow.document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
      _ssrWindow.document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? { passive: false, capture: capture } : capture);
        target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
      }
      if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
        target.addEventListener('mousedown', swiper.onTouchStart, false);
        _ssrWindow.document.addEventListener('mousemove', swiper.onTouchMove, capture);
        _ssrWindow.document.addEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      target.addEventListener('click', swiper.onClick, true);
    }
  }

  // Resize handler
  swiper.on(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
}

function detachEvents() {
  var swiper = this;

  var params = swiper.params,
      touchEvents = swiper.touchEvents,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl;


  var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
  var capture = !!params.nested;

  // Touch Events
  {
    if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
      target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
      _ssrWindow.document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
      _ssrWindow.document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
      if (Support.touch) {
        var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
        target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
        target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
      }
      if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
        target.removeEventListener('mousedown', swiper.onTouchStart, false);
        _ssrWindow.document.removeEventListener('mousemove', swiper.onTouchMove, capture);
        _ssrWindow.document.removeEventListener('mouseup', swiper.onTouchEnd, false);
      }
    }
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
      target.removeEventListener('click', swiper.onClick, true);
    }
  }

  // Resize handler
  swiper.off(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
}

var events = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

function setBreakpoint() {
  var swiper = this;
  var activeIndex = swiper.activeIndex,
      initialized = swiper.initialized,
      _swiper$loopedSlides = swiper.loopedSlides,
      loopedSlides = _swiper$loopedSlides === undefined ? 0 : _swiper$loopedSlides,
      params = swiper.params;

  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;

  // Set breakpoint for window width and update parameters
  var breakpoint = swiper.getBreakpoint(breakpoints);

  if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    if (breakpointOnlyParams) {
      ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
        var paramValue = breakpointOnlyParams[param];
        if (typeof paramValue === 'undefined') return;
        if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
          breakpointOnlyParams[param] = 'auto';
        } else if (param === 'slidesPerView') {
          breakpointOnlyParams[param] = parseFloat(paramValue);
        } else {
          breakpointOnlyParams[param] = parseInt(paramValue, 10);
        }
      });
    }

    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

    if (directionChanged && initialized) {
      swiper.changeDirection();
    }

    Utils.extend(swiper.params, breakpointParams);

    Utils.extend(swiper, {
      allowTouchMove: swiper.params.allowTouchMove,
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev
    });

    swiper.currentBreakpoint = breakpoint;

    if (needsReLoop && initialized) {
      swiper.loopDestroy();
      swiper.loopCreate();
      swiper.updateSlides();
      swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }

    swiper.emit('breakpoint', breakpointParams);
  }
}

function getBreakpoint(breakpoints) {
  var swiper = this;
  // Get breakpoint for window width
  if (!breakpoints) return undefined;
  var breakpoint = false;
  var points = [];
  Object.keys(breakpoints).forEach(function (point) {
    points.push(point);
  });
  points.sort(function (a, b) {
    return parseInt(a, 10) - parseInt(b, 10);
  });
  for (var i = 0; i < points.length; i += 1) {
    var point = points[i];
    if (swiper.params.breakpointsInverse) {
      if (point <= _ssrWindow.window.innerWidth) {
        breakpoint = point;
      }
    } else if (point >= _ssrWindow.window.innerWidth && !breakpoint) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = { setBreakpoint: setBreakpoint, getBreakpoint: getBreakpoint };

function addClasses() {
  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      $el = swiper.$el;

  var suffixes = [];

  suffixes.push('initialized');
  suffixes.push(params.direction);

  if (params.freeMode) {
    suffixes.push('free-mode');
  }
  if (!Support.flexbox) {
    suffixes.push('no-flexbox');
  }
  if (params.autoHeight) {
    suffixes.push('autoheight');
  }
  if (rtl) {
    suffixes.push('rtl');
  }
  if (params.slidesPerColumn > 1) {
    suffixes.push('multirow');
  }
  if (Device.android) {
    suffixes.push('android');
  }
  if (Device.ios) {
    suffixes.push('ios');
  }
  // WP8 Touch Events Fix
  if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
    suffixes.push('wp8-' + params.direction);
  }

  suffixes.forEach(function (suffix) {
    classNames.push(params.containerModifierClass + suffix);
  });

  $el.addClass(classNames.join(' '));
}

function removeClasses() {
  var swiper = this;
  var $el = swiper.$el,
      classNames = swiper.classNames;


  $el.removeClass(classNames.join(' '));
}

var classes = { addClasses: addClasses, removeClasses: removeClasses };

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  var image = void 0;
  function onReady() {
    if (callback) callback();
  }
  if (!imageEl.complete || !checkForComplete) {
    if (src) {
      image = new _ssrWindow.window.Image();
      image.onload = onReady;
      image.onerror = onReady;
      if (sizes) {
        image.sizes = sizes;
      }
      if (srcset) {
        image.srcset = srcset;
      }
      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  var swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');
  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }
  for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
    var imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage: loadImage,
  preloadImages: preloadImages
};

function checkOverflow() {
  var swiper = this;
  var wasLocked = swiper.isLocked;

  swiper.isLocked = swiper.snapGrid.length === 1;
  swiper.allowSlideNext = !swiper.isLocked;
  swiper.allowSlidePrev = !swiper.isLocked;

  // events
  if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
    swiper.navigation.update();
  }
}

var checkOverflow$1 = { checkOverflow: checkOverflow };

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'container',
  initialSlide: 0,
  speed: 300,
  //
  preventInteractionOnTransition: false,

  // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,

  // Free mode
  freeMode: false,
  freeModeMomentum: true,
  freeModeMomentumRatio: 1,
  freeModeMomentumBounce: true,
  freeModeMomentumBounceRatio: 1,
  freeModeMomentumVelocityRatio: 1,
  freeModeSticky: false,
  freeModeMinimumVelocity: 0.02,

  // Autoheight
  autoHeight: false,

  // Set wrapper width
  setWrapperSize: false,

  // Virtual Translate
  virtualTranslate: false,

  // Effects
  effect: 'slide', // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,
  breakpointsInverse: false,

  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerColumn: 1,
  slidesPerColumnFill: 'column',
  slidesPerGroup: 1,
  centeredSlides: false,
  slidesOffsetBefore: 0, // in px
  slidesOffsetAfter: 0, // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,

  // Disable swiper and hide navigation when container not overflow
  watchOverflow: false,

  // Round length
  roundLengths: false,

  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: true,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,

  // Unique Navigation Elements
  uniqueNavElements: true,

  // Resistance
  resistance: true,
  resistanceRatio: 0.85,

  // Progress
  watchSlidesProgress: false,
  watchSlidesVisibility: false,

  // Cursor
  grabCursor: false,

  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,

  // Images
  preloadImages: true,
  updateOnImagesReady: true,

  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopFillGroupWithBlank: false,

  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null, // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,

  // Passive Listeners
  passiveListeners: true,

  // NS
  containerModifierClass: 'swiper-container-', // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',

  // Callbacks
  runCallbacksOnInit: true
};

/* eslint no-param-reassign: "off" */

var prototypes = {
  update: update,
  translate: translate,
  transition: transition,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  manipulation: manipulation,
  events: events,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes,
  images: images
};

var extendedDefaults = {};

var Swiper = function (_SwiperClass) {
  _inherits(Swiper, _SwiperClass);

  function Swiper() {
    var _ret3;

    _classCallCheck(this, Swiper);

    var el = void 0;
    var params = void 0;

    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }
    if (!params) params = {};

    params = Utils.extend({}, params);
    if (el && !params.el) params.el = el;

    var _this = _possibleConstructorReturn(this, (Swiper.__proto__ || Object.getPrototypeOf(Swiper)).call(this, params));

    Object.keys(prototypes).forEach(function (prototypeGroup) {
      Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
        if (!Swiper.prototype[protoMethod]) {
          Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
        }
      });
    });

    // Swiper Instance
    var swiper = _this;
    if (typeof swiper.modules === 'undefined') {
      swiper.modules = {};
    }
    Object.keys(swiper.modules).forEach(function (moduleName) {
      var module = swiper.modules[moduleName];
      if (module.params) {
        var moduleParamName = Object.keys(module.params)[0];
        var moduleParams = module.params[moduleParamName];
        if ((typeof moduleParams === 'undefined' ? 'undefined' : _typeof(moduleParams)) !== 'object' || moduleParams === null) return;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
        if (params[moduleParamName] === true) {
          params[moduleParamName] = { enabled: true };
        }
        if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
          params[moduleParamName].enabled = true;
        }
        if (!params[moduleParamName]) params[moduleParamName] = { enabled: false };
      }
    });

    // Extend defaults with modules params
    var swiperParams = Utils.extend({}, defaults);
    swiper.useModulesParams(swiperParams);

    // Extend defaults with passed params
    swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = Utils.extend({}, swiper.params);
    swiper.passedParams = Utils.extend({}, params);

    // Save Dom lib
    swiper.$ = _dom.$;

    // Find el
    var $el = (0, _dom.$)(swiper.params.el);
    el = $el[0];

    if (!el) {
      var _ret;

      return _ret = undefined, _possibleConstructorReturn(_this, _ret);
    }

    if ($el.length > 1) {
      var _ret2;

      var swipers = [];
      $el.each(function (index, containerEl) {
        var newParams = Utils.extend({}, params, { el: containerEl });
        swipers.push(new Swiper(newParams));
      });
      return _ret2 = swipers, _possibleConstructorReturn(_this, _ret2);
    }

    el.swiper = swiper;
    $el.data('swiper', swiper);

    // Find Wrapper
    var $wrapperEl = $el.children('.' + swiper.params.wrapperClass);

    // Extend Swiper
    Utils.extend(swiper, {
      $el: $el,
      el: el,
      $wrapperEl: $wrapperEl,
      wrapperEl: $wrapperEl[0],

      // Classes
      classNames: [],

      // Slides
      slides: (0, _dom.$)(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box',

      // Indexes
      activeIndex: 0,
      realIndex: 0,

      //
      isBeginning: true,
      isEnd: false,

      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,

      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,

      // Touch Events
      touchEvents: function touchEvents() {
        var touch = ['touchstart', 'touchmove', 'touchend'];
        var desktop = ['mousedown', 'mousemove', 'mouseup'];
        if (Support.pointerEvents) {
          desktop = ['pointerdown', 'pointermove', 'pointerup'];
        } else if (Support.prefixedPointerEvents) {
          desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
        }
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        formElements: 'input, select, option, textarea, button, video',
        // Last click time
        lastClickTime: Utils.now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },

      // Clicks
      allowClick: true,

      // Touches
      allowTouchMove: swiper.params.allowTouchMove,

      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },

      // Images
      imagesToLoad: [],
      imagesLoaded: 0

    });

    // Install Modules
    swiper.useModules();

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    return _ret3 = swiper, _possibleConstructorReturn(_this, _ret3);
  }

  _createClass(Swiper, [{
    key: 'slidesPerViewDynamic',
    value: function slidesPerViewDynamic() {
      var swiper = this;
      var params = swiper.params,
          slides = swiper.slides,
          slidesGrid = swiper.slidesGrid,
          swiperSize = swiper.size,
          activeIndex = swiper.activeIndex;

      var spv = 1;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex].swiperSlideSize;
        var breakLoop = void 0;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += slides[i].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
        for (var _i7 = activeIndex - 1; _i7 >= 0; _i7 -= 1) {
          if (slides[_i7] && !breakLoop) {
            slideSize += slides[_i7].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        for (var _i8 = activeIndex + 1; _i8 < slides.length; _i8 += 1) {
          if (slidesGrid[_i8] - slidesGrid[activeIndex] < swiperSize) {
            spv += 1;
          }
        }
      }
      return spv;
    }
  }, {
    key: 'update',
    value: function update() {
      var swiper = this;
      if (!swiper || swiper.destroyed) return;
      var snapGrid = swiper.snapGrid,
          params = swiper.params;
      // Breakpoints

      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();

      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated = void 0;
      if (swiper.params.freeMode) {
        setTranslate();
        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    }
  }, {
    key: 'changeDirection',
    value: function changeDirection(newDirection) {
      var needUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
        return swiper;
      }

      swiper.$el.removeClass('' + swiper.params.containerModifierClass + currentDirection + ' wp8-' + currentDirection).addClass('' + swiper.params.containerModifierClass + newDirection);

      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        swiper.$el.addClass(swiper.params.containerModifierClass + 'wp8-' + newDirection);
      }

      swiper.params.direction = newDirection;

      swiper.slides.each(function (slideIndex, slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });

      swiper.emit('changeDirection');
      if (needUpdate) swiper.update();

      return swiper;
    }
  }, {
    key: 'init',
    value: function init() {
      var swiper = this;
      if (swiper.initialized) return;

      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();

      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }

      if (swiper.params.preloadImages) {
        swiper.preloadImages();
      }

      // Slide To Initial Slide
      if (swiper.params.loop) {
        swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
      }

      // Attach events
      swiper.attachEvents();

      // Init Flag
      swiper.initialized = true;

      // Emit
      swiper.emit('init');
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var deleteInstance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var cleanStyles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var swiper = this;
      var params = swiper.params,
          $el = swiper.$el,
          $wrapperEl = swiper.$wrapperEl,
          slides = swiper.slides;


      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }

      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        $el.removeAttr('style');
        $wrapperEl.removeAttr('style');
        if (slides && slides.length) {
          slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index').removeAttr('data-swiper-column').removeAttr('data-swiper-row');
        }
      }

      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });

      if (deleteInstance !== false) {
        swiper.$el[0].swiper = null;
        swiper.$el.data('swiper', null);
        Utils.deleteProps(swiper);
      }
      swiper.destroyed = true;

      return null;
    }
  }], [{
    key: 'extendDefaults',
    value: function extendDefaults(newDefaults) {
      Utils.extend(extendedDefaults, newDefaults);
    }
  }, {
    key: 'extendedDefaults',
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: 'defaults',
    get: function get() {
      return defaults;
    }
  }, {
    key: 'Class',
    get: function get() {
      return SwiperClass;
    }
  }, {
    key: '$',
    get: function get() {
      return _dom.$;
    }
  }]);

  return Swiper;
}(SwiperClass);

var Device$1 = {
  name: 'device',
  proto: {
    device: Device
  },
  static: {
    device: Device
  }
};

var Support$1 = {
  name: 'support',
  proto: {
    support: Support
  },
  static: {
    support: Support
  }
};

var Browser$1 = {
  name: 'browser',
  proto: {
    browser: Browser
  },
  static: {
    browser: Browser
  }
};

var Resize = {
  name: 'resize',
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      resize: {
        resizeHandler: function resizeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('beforeResize');
          swiper.emit('resize');
        },
        orientationChangeHandler: function orientationChangeHandler() {
          if (!swiper || swiper.destroyed || !swiper.initialized) return;
          swiper.emit('orientationchange');
        }
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      // Emit resize
      _ssrWindow.window.addEventListener('resize', swiper.resize.resizeHandler);

      // Emit orientationchange
      _ssrWindow.window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    },
    destroy: function destroy() {
      var swiper = this;
      _ssrWindow.window.removeEventListener('resize', swiper.resize.resizeHandler);
      _ssrWindow.window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
    }
  }
};

var Observer = {
  func: _ssrWindow.window.MutationObserver || _ssrWindow.window.WebkitMutationObserver,
  attach: function attach(target) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var swiper = this;

    var ObserverFunc = Observer.func;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        swiper.emit('observerUpdate', mutations[0]);
        return;
      }
      var observerUpdate = function observerUpdate() {
        swiper.emit('observerUpdate', mutations[0]);
      };

      if (_ssrWindow.window.requestAnimationFrame) {
        _ssrWindow.window.requestAnimationFrame(observerUpdate);
      } else {
        _ssrWindow.window.setTimeout(observerUpdate, 0);
      }
    });

    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });

    swiper.observer.observers.push(observer);
  },
  init: function init() {
    var swiper = this;
    if (!Support.observer || !swiper.params.observer) return;
    if (swiper.params.observeParents) {
      var containerParents = swiper.$el.parents();
      for (var i = 0; i < containerParents.length; i += 1) {
        swiper.observer.attach(containerParents[i]);
      }
    }
    // Observe container
    swiper.observer.attach(swiper.$el[0], { childList: swiper.params.observeSlideChildren });

    // Observe wrapper
    swiper.observer.attach(swiper.$wrapperEl[0], { attributes: false });
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.observer.observers.forEach(function (observer) {
      observer.disconnect();
    });
    swiper.observer.observers = [];
  }
};

var Observer$1 = {
  name: 'observer',
  params: {
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      observer: {
        init: Observer.init.bind(swiper),
        attach: Observer.attach.bind(swiper),
        destroy: Observer.destroy.bind(swiper),
        observers: []
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.observer.init();
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.observer.destroy();
    }
  }
};

var Virtual = {
  update: function update(force) {
    var swiper = this;
    var _swiper$params = swiper.params,
        slidesPerView = _swiper$params.slidesPerView,
        slidesPerGroup = _swiper$params.slidesPerGroup,
        centeredSlides = _swiper$params.centeredSlides;
    var _swiper$params$virtua = swiper.params.virtual,
        addSlidesBefore = _swiper$params$virtua.addSlidesBefore,
        addSlidesAfter = _swiper$params$virtua.addSlidesAfter;
    var _swiper$virtual = swiper.virtual,
        previousFrom = _swiper$virtual.from,
        previousTo = _swiper$virtual.to,
        slides = _swiper$virtual.slides,
        previousSlidesGrid = _swiper$virtual.slidesGrid,
        renderSlide = _swiper$virtual.renderSlide,
        previousOffset = _swiper$virtual.offset;

    swiper.updateActiveIndex();
    var activeIndex = swiper.activeIndex || 0;

    var offsetProp = void 0;
    if (swiper.rtlTranslate) offsetProp = 'right';else offsetProp = swiper.isHorizontal() ? 'left' : 'top';

    var slidesAfter = void 0;
    var slidesBefore = void 0;
    if (centeredSlides) {
      slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
      slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
    } else {
      slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
      slidesBefore = slidesPerGroup + addSlidesAfter;
    }
    var from = Math.max((activeIndex || 0) - slidesBefore, 0);
    var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
    var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);

    Utils.extend(swiper.virtual, {
      from: from,
      to: to,
      offset: offset,
      slidesGrid: swiper.slidesGrid
    });

    function onRendered() {
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      if (swiper.lazy && swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    }

    if (previousFrom === from && previousTo === to && !force) {
      if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
        swiper.slides.css(offsetProp, offset + 'px');
      }
      swiper.updateProgress();
      return;
    }
    if (swiper.params.virtual.renderExternal) {
      swiper.params.virtual.renderExternal.call(swiper, {
        offset: offset,
        from: from,
        to: to,
        slides: function getSlides() {
          var slidesToRender = [];
          for (var i = from; i <= to; i += 1) {
            slidesToRender.push(slides[i]);
          }
          return slidesToRender;
        }()
      });
      onRendered();
      return;
    }
    var prependIndexes = [];
    var appendIndexes = [];
    if (force) {
      swiper.$wrapperEl.find('.' + swiper.params.slideClass).remove();
    } else {
      for (var i = previousFrom; i <= previousTo; i += 1) {
        if (i < from || i > to) {
          swiper.$wrapperEl.find('.' + swiper.params.slideClass + '[data-swiper-slide-index="' + i + '"]').remove();
        }
      }
    }
    for (var _i9 = 0; _i9 < slides.length; _i9 += 1) {
      if (_i9 >= from && _i9 <= to) {
        if (typeof previousTo === 'undefined' || force) {
          appendIndexes.push(_i9);
        } else {
          if (_i9 > previousTo) appendIndexes.push(_i9);
          if (_i9 < previousFrom) prependIndexes.push(_i9);
        }
      }
    }
    appendIndexes.forEach(function (index) {
      swiper.$wrapperEl.append(renderSlide(slides[index], index));
    });
    prependIndexes.sort(function (a, b) {
      return b - a;
    }).forEach(function (index) {
      swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
    });
    swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + 'px');
    onRendered();
  },
  renderSlide: function renderSlide(slide, index) {
    var swiper = this;
    var params = swiper.params.virtual;
    if (params.cache && swiper.virtual.cache[index]) {
      return swiper.virtual.cache[index];
    }
    var $slideEl = params.renderSlide ? (0, _dom.$)(params.renderSlide.call(swiper, slide, index)) : (0, _dom.$)('<div class="' + swiper.params.slideClass + '" data-swiper-slide-index="' + index + '">' + slide + '</div>');
    if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
    if (params.cache) swiper.virtual.cache[index] = $slideEl;
    return $slideEl;
  },
  appendSlide: function appendSlide(slides) {
    var swiper = this;
    if ((typeof slides === 'undefined' ? 'undefined' : _typeof(slides)) === 'object' && 'length' in slides) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.push(slides[i]);
      }
    } else {
      swiper.virtual.slides.push(slides);
    }
    swiper.virtual.update(true);
  },
  prependSlide: function prependSlide(slides) {
    var swiper = this;
    var activeIndex = swiper.activeIndex;
    var newActiveIndex = activeIndex + 1;
    var numberOfNewSlides = 1;

    if (Array.isArray(slides)) {
      for (var i = 0; i < slides.length; i += 1) {
        if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
      }
      newActiveIndex = activeIndex + slides.length;
      numberOfNewSlides = slides.length;
    } else {
      swiper.virtual.slides.unshift(slides);
    }
    if (swiper.params.virtual.cache) {
      var cache = swiper.virtual.cache;
      var newCache = {};
      Object.keys(cache).forEach(function (cachedIndex) {
        newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
      });
      swiper.virtual.cache = newCache;
    }
    swiper.virtual.update(true);
    swiper.slideTo(newActiveIndex, 0);
  },
  removeSlide: function removeSlide(slidesIndexes) {
    var swiper = this;
    if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
    var activeIndex = swiper.activeIndex;
    if (Array.isArray(slidesIndexes)) {
      for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
        swiper.virtual.slides.splice(slidesIndexes[i], 1);
        if (swiper.params.virtual.cache) {
          delete swiper.virtual.cache[slidesIndexes[i]];
        }
        if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
        activeIndex = Math.max(activeIndex, 0);
      }
    } else {
      swiper.virtual.slides.splice(slidesIndexes, 1);
      if (swiper.params.virtual.cache) {
        delete swiper.virtual.cache[slidesIndexes];
      }
      if (slidesIndexes < activeIndex) activeIndex -= 1;
      activeIndex = Math.max(activeIndex, 0);
    }
    swiper.virtual.update(true);
    swiper.slideTo(activeIndex, 0);
  },
  removeAllSlides: function removeAllSlides() {
    var swiper = this;
    swiper.virtual.slides = [];
    if (swiper.params.virtual.cache) {
      swiper.virtual.cache = {};
    }
    swiper.virtual.update(true);
    swiper.slideTo(0, 0);
  }
};

var Virtual$1 = {
  name: 'virtual',
  params: {
    virtual: {
      enabled: false,
      slides: [],
      cache: true,
      renderSlide: null,
      renderExternal: null,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      virtual: {
        update: Virtual.update.bind(swiper),
        appendSlide: Virtual.appendSlide.bind(swiper),
        prependSlide: Virtual.prependSlide.bind(swiper),
        removeSlide: Virtual.removeSlide.bind(swiper),
        removeAllSlides: Virtual.removeAllSlides.bind(swiper),
        renderSlide: Virtual.renderSlide.bind(swiper),
        slides: swiper.params.virtual.slides,
        cache: {}
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (!swiper.params.virtual.enabled) return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'virtual');
      var overwriteParams = {
        watchSlidesProgress: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);

      if (!swiper.params.initialSlide) {
        swiper.virtual.update();
      }
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.virtual.enabled) return;
      swiper.virtual.update();
    }
  }
};

var Keyboard = {
  handle: function handle(event) {
    var swiper = this;
    var rtl = swiper.rtlTranslate;

    var e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix
    var kc = e.keyCode || e.charCode;
    // Directions locks
    if (!swiper.allowSlideNext && (swiper.isHorizontal() && kc === 39 || swiper.isVertical() && kc === 40 || kc === 34)) {
      return false;
    }
    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && kc === 37 || swiper.isVertical() && kc === 38 || kc === 33)) {
      return false;
    }
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }
    if (_ssrWindow.document.activeElement && _ssrWindow.document.activeElement.nodeName && (_ssrWindow.document.activeElement.nodeName.toLowerCase() === 'input' || _ssrWindow.document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }
    if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
      var inView = false;
      // Check that swiper should be inside of visible area of window
      if (swiper.$el.parents('.' + swiper.params.slideClass).length > 0 && swiper.$el.parents('.' + swiper.params.slideActiveClass).length === 0) {
        return undefined;
      }
      var windowWidth = _ssrWindow.window.innerWidth;
      var windowHeight = _ssrWindow.window.innerHeight;
      var swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
      for (var i = 0; i < swiperCoord.length; i += 1) {
        var point = swiperCoord[i];
        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          inView = true;
        }
      }
      if (!inView) return undefined;
    }
    if (swiper.isHorizontal()) {
      if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if ((kc === 34 || kc === 39) && !rtl || (kc === 33 || kc === 37) && rtl) swiper.slideNext();
      if ((kc === 33 || kc === 37) && !rtl || (kc === 34 || kc === 39) && rtl) swiper.slidePrev();
    } else {
      if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }
      if (kc === 34 || kc === 40) swiper.slideNext();
      if (kc === 33 || kc === 38) swiper.slidePrev();
    }
    swiper.emit('keyPress', kc);
    return undefined;
  },
  enable: function enable() {
    var swiper = this;
    if (swiper.keyboard.enabled) return;
    (0, _dom.$)(_ssrWindow.document).on('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = true;
  },
  disable: function disable() {
    var swiper = this;
    if (!swiper.keyboard.enabled) return;
    (0, _dom.$)(_ssrWindow.document).off('keydown', swiper.keyboard.handle);
    swiper.keyboard.enabled = false;
  }
};

var Keyboard$1 = {
  name: 'keyboard',
  params: {
    keyboard: {
      enabled: false,
      onlyInViewport: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      keyboard: {
        enabled: false,
        enable: Keyboard.enable.bind(swiper),
        disable: Keyboard.disable.bind(swiper),
        handle: Keyboard.handle.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.keyboard.enabled) {
        swiper.keyboard.enable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.keyboard.enabled) {
        swiper.keyboard.disable();
      }
    }
  }
};

function isEventSupported() {
  var eventName = 'onwheel';
  var isSupported = eventName in _ssrWindow.document;

  if (!isSupported) {
    var element = _ssrWindow.document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && _ssrWindow.document.implementation && _ssrWindow.document.implementation.hasFeature
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  && _ssrWindow.document.implementation.hasFeature('', '') !== true) {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = _ssrWindow.document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}
var Mousewheel = {
  lastScrollTime: Utils.now(),
  event: function getEvent() {
    if (_ssrWindow.window.navigator.userAgent.indexOf('firefox') > -1) return 'DOMMouseScroll';
    return isEventSupported() ? 'wheel' : 'mousewheel';
  }(),
  normalize: function normalize(e) {
    // Reasonable defaults
    var PIXEL_STEP = 10;
    var LINE_HEIGHT = 40;
    var PAGE_HEIGHT = 800;

    var sX = 0;
    var sY = 0; // spinX, spinY
    var pX = 0;
    var pY = 0; // pixelX, pixelY

    // Legacy
    if ('detail' in e) {
      sY = e.detail;
    }
    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }
    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }
    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    }

    // side scrolling on FF with DOMMouseScroll
    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }
    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    }

    // Fall-back if spin cannot be determined
    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }
    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  },
  handleMouseEnter: function handleMouseEnter() {
    var swiper = this;
    swiper.mouseEntered = true;
  },
  handleMouseLeave: function handleMouseLeave() {
    var swiper = this;
    swiper.mouseEntered = false;
  },
  handle: function handle(event) {
    var e = event;
    var swiper = this;
    var params = swiper.params.mousewheel;

    if (!swiper.mouseEntered && !params.releaseOnEdges) return true;

    if (e.originalEvent) e = e.originalEvent; // jquery fix
    var delta = 0;
    var rtlFactor = swiper.rtlTranslate ? -1 : 1;

    var data = Mousewheel.normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;

    if (params.invert) delta = -delta;

    if (!swiper.params.freeMode) {
      if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
        if (delta < 0) {
          if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
            swiper.slideNext();
            swiper.emit('scroll', e);
          } else if (params.releaseOnEdges) return true;
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
          swiper.slidePrev();
          swiper.emit('scroll', e);
        } else if (params.releaseOnEdges) return true;
      }
      swiper.mousewheel.lastScrollTime = new _ssrWindow.window.Date().getTime();
    } else {
      // Freemode or scrollContainer:
      if (swiper.params.loop) {
        swiper.loopFix();
      }
      var position = swiper.getTranslate() + delta * params.sensitivity;
      var wasBeginning = swiper.isBeginning;
      var wasEnd = swiper.isEnd;

      if (position >= swiper.minTranslate()) position = swiper.minTranslate();
      if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();

      swiper.setTransition(0);
      swiper.setTranslate(position);
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();

      if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
        swiper.updateSlidesClasses();
      }

      if (swiper.params.freeModeSticky) {
        clearTimeout(swiper.mousewheel.timeout);
        swiper.mousewheel.timeout = Utils.nextTick(function () {
          swiper.slideToClosest();
        }, 300);
      }
      // Emit event
      swiper.emit('scroll', e);

      // Stop autoplay
      if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
      // Return page scroll on edge positions
      if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  },
  enable: function enable() {
    var swiper = this;
    if (!Mousewheel.event) return false;
    if (swiper.mousewheel.enabled) return false;
    var target = swiper.$el;
    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = (0, _dom.$)(swiper.params.mousewheel.eventsTarged);
    }
    target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
    target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
    target.on(Mousewheel.event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = true;
    return true;
  },
  disable: function disable() {
    var swiper = this;
    if (!Mousewheel.event) return false;
    if (!swiper.mousewheel.enabled) return false;
    var target = swiper.$el;
    if (swiper.params.mousewheel.eventsTarged !== 'container') {
      target = (0, _dom.$)(swiper.params.mousewheel.eventsTarged);
    }
    target.off(Mousewheel.event, swiper.mousewheel.handle);
    swiper.mousewheel.enabled = false;
    return true;
  }
};

var Mousewheel$1 = {
  name: 'mousewheel',
  params: {
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarged: 'container'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      mousewheel: {
        enabled: false,
        enable: Mousewheel.enable.bind(swiper),
        disable: Mousewheel.disable.bind(swiper),
        handle: Mousewheel.handle.bind(swiper),
        handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
        handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
        lastScrollTime: Utils.now()
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.mousewheel.enabled) swiper.mousewheel.enable();
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
    }
  }
};

var Navigation = {
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;

    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;


    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        $prevEl.addClass(params.disabledClass);
      } else {
        $prevEl.removeClass(params.disabledClass);
      }
      $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        $nextEl.addClass(params.disabledClass);
      } else {
        $nextEl.removeClass(params.disabledClass);
      }
      $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    if (!(params.nextEl || params.prevEl)) return;

    var $nextEl = void 0;
    var $prevEl = void 0;
    if (params.nextEl) {
      $nextEl = (0, _dom.$)(params.nextEl);
      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }
    if (params.prevEl) {
      $prevEl = (0, _dom.$)(params.prevEl);
      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }
    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    Utils.extend(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }
    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};

var Navigation$1 = {
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,

      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      navigation: {
        init: Navigation.init.bind(swiper),
        update: Navigation.update.bind(swiper),
        destroy: Navigation.destroy.bind(swiper),
        onNextClick: Navigation.onNextClick.bind(swiper),
        onPrevClick: Navigation.onPrevClick.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge() {
      var swiper = this;
      swiper.navigation.update();
    },
    fromEdge: function fromEdge() {
      var swiper = this;
      swiper.navigation.update();
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.navigation.destroy();
    },
    click: function click(e) {
      var swiper = this;
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if (swiper.params.navigation.hideOnClick && !(0, _dom.$)(e.target).is($prevEl) && !(0, _dom.$)(e.target).is($nextEl)) {
        var isHidden = void 0;
        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }
        if (isHidden === true) {
          swiper.emit('navigationShow', swiper);
        } else {
          swiper.emit('navigationHide', swiper);
        }
        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
};

var Pagination = {
  update: function update() {
    // Render || Update Pagination bullets/items
    var swiper = this;
    var rtl = swiper.rtl;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    var $el = swiper.pagination.$el;
    // Current/Total
    var current = void 0;
    var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }
      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    }
    // Types
    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      var bullets = swiper.pagination.bullets;
      var firstIndex = void 0;
      var lastIndex = void 0;
      var midIndex = void 0;
      if (params.dynamicBullets) {
        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + 'px');
        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
          if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
            swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (swiper.pagination.dynamicBulletIndex < 0) {
            swiper.pagination.dynamicBulletIndex = 0;
          }
        }
        firstIndex = current - swiper.pagination.dynamicBulletIndex;
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }
      bullets.removeClass(params.bulletActiveClass + ' ' + params.bulletActiveClass + '-next ' + params.bulletActiveClass + '-next-next ' + params.bulletActiveClass + '-prev ' + params.bulletActiveClass + '-prev-prev ' + params.bulletActiveClass + '-main');
      if ($el.length > 1) {
        bullets.each(function (index, bullet) {
          var $bullet = (0, _dom.$)(bullet);
          var bulletIndex = $bullet.index();
          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }
          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(params.bulletActiveClass + '-main');
            }
            if (bulletIndex === firstIndex) {
              $bullet.prev().addClass(params.bulletActiveClass + '-prev').prev().addClass(params.bulletActiveClass + '-prev-prev');
            }
            if (bulletIndex === lastIndex) {
              $bullet.next().addClass(params.bulletActiveClass + '-next').next().addClass(params.bulletActiveClass + '-next-next');
            }
          }
        });
      } else {
        var $bullet = bullets.eq(current);
        $bullet.addClass(params.bulletActiveClass);
        if (params.dynamicBullets) {
          var $firstDisplayedBullet = bullets.eq(firstIndex);
          var $lastDisplayedBullet = bullets.eq(lastIndex);
          for (var i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(params.bulletActiveClass + '-main');
          }
          $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + '-prev').prev().addClass(params.bulletActiveClass + '-prev-prev');
          $lastDisplayedBullet.next().addClass(params.bulletActiveClass + '-next').next().addClass(params.bulletActiveClass + '-next-next');
        }
      }
      if (params.dynamicBullets) {
        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
        var offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + 'px');
      }
    }
    if (params.type === 'fraction') {
      $el.find('.' + params.currentClass).text(params.formatFractionCurrent(current + 1));
      $el.find('.' + params.totalClass).text(params.formatFractionTotal(total));
    }
    if (params.type === 'progressbar') {
      var progressbarDirection = void 0;
      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }
      var scale = (current + 1) / total;
      var scaleX = 1;
      var scaleY = 1;
      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }
      $el.find('.' + params.progressbarFillClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(swiper.params.speed);
    }
    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      swiper.emit('paginationRender', swiper, $el[0]);
    } else {
      swiper.emit('paginationUpdate', swiper, $el[0]);
    }
    $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
  },
  render: function render() {
    // Render Container
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;

    var $el = swiper.pagination.$el;
    var paginationHTML = '';
    if (params.type === 'bullets') {
      var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
      for (var i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += '<' + params.bulletElement + ' class="' + params.bulletClass + '"></' + params.bulletElement + '>';
        }
      }
      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find('.' + params.bulletClass);
    }
    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = '<span class="' + params.currentClass + '"></span>' + ' / ' + ('<span class="' + params.totalClass + '"></span>');
      }
      $el.html(paginationHTML);
    }
    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = '<span class="' + params.progressbarFillClass + '"></span>';
      }
      $el.html(paginationHTML);
    }
    if (params.type !== 'custom') {
      swiper.emit('paginationRender', swiper.pagination.$el[0]);
    }
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el) return;

    var $el = (0, _dom.$)(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && swiper.$el.find(params.el).length === 1) {
      $el = swiper.$el.find(params.el);
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass('' + params.modifierClass + params.type + '-dynamic');
      swiper.pagination.dynamicBulletIndex = 0;
      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }
    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', '.' + params.bulletClass, function onClick(e) {
        e.preventDefault();
        var index = (0, _dom.$)(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Utils.extend(swiper.pagination, {
      $el: $el,
      el: $el[0]
    });
  },
  destroy: function destroy() {
    var swiper = this;
    var params = swiper.params.pagination;
    if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
    var $el = swiper.pagination.$el;

    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
    if (params.clickable) {
      $el.off('click', '.' + params.bulletClass);
    }
  }
};

var Pagination$1 = {
  name: 'pagination',
  params: {
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: function formatFractionCurrent(number) {
        return number;
      },
      formatFractionTotal: function formatFractionTotal(number) {
        return number;
      },
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      modifierClass: 'swiper-pagination-', // NEW
      currentClass: 'swiper-pagination-current',
      totalClass: 'swiper-pagination-total',
      hiddenClass: 'swiper-pagination-hidden',
      progressbarFillClass: 'swiper-pagination-progressbar-fill',
      progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
      clickableClass: 'swiper-pagination-clickable', // NEW
      lockClass: 'swiper-pagination-lock'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      pagination: {
        init: Pagination.init.bind(swiper),
        render: Pagination.render.bind(swiper),
        update: Pagination.update.bind(swiper),
        destroy: Pagination.destroy.bind(swiper),
        dynamicBulletIndex: 0
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.pagination.init();
      swiper.pagination.render();
      swiper.pagination.update();
    },
    activeIndexChange: function activeIndexChange() {
      var swiper = this;
      if (swiper.params.loop) {
        swiper.pagination.update();
      } else if (typeof swiper.snapIndex === 'undefined') {
        swiper.pagination.update();
      }
    },
    snapIndexChange: function snapIndexChange() {
      var swiper = this;
      if (!swiper.params.loop) {
        swiper.pagination.update();
      }
    },
    slidesLengthChange: function slidesLengthChange() {
      var swiper = this;
      if (swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    snapGridLengthChange: function snapGridLengthChange() {
      var swiper = this;
      if (!swiper.params.loop) {
        swiper.pagination.render();
        swiper.pagination.update();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.pagination.destroy();
    },
    click: function click(e) {
      var swiper = this;
      if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0, _dom.$)(e.target).hasClass(swiper.params.pagination.bulletClass)) {
        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
        if (isHidden === true) {
          swiper.emit('paginationShow', swiper);
        } else {
          swiper.emit('paginationHide', swiper);
        }
        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
      }
    }
  }
};

var Scrollbar = {
  setTranslate: function setTranslate() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate,
        progress = swiper.progress;
    var dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;

    var params = swiper.params.scrollbar;

    var newSize = dragSize;
    var newPos = (trackSize - dragSize) * progress;
    if (rtl) {
      newPos = -newPos;
      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }
    if (swiper.isHorizontal()) {
      if (Support.transforms3d) {
        $dragEl.transform('translate3d(' + newPos + 'px, 0, 0)');
      } else {
        $dragEl.transform('translateX(' + newPos + 'px)');
      }
      $dragEl[0].style.width = newSize + 'px';
    } else {
      if (Support.transforms3d) {
        $dragEl.transform('translate3d(0px, ' + newPos + 'px, 0)');
      } else {
        $dragEl.transform('translateY(' + newPos + 'px)');
      }
      $dragEl[0].style.height = newSize + 'px';
    }
    if (params.hide) {
      clearTimeout(swiper.scrollbar.timeout);
      $el[0].style.opacity = 1;
      swiper.scrollbar.timeout = setTimeout(function () {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  },
  updateSize: function updateSize() {
    var swiper = this;
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;

    var scrollbar = swiper.scrollbar;
    var $dragEl = scrollbar.$dragEl,
        $el = scrollbar.$el;


    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;

    var divider = swiper.size / swiper.virtualSize;
    var moveDivider = divider * (trackSize / swiper.size);
    var dragSize = void 0;
    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = dragSize + 'px';
    } else {
      $dragEl[0].style.height = dragSize + 'px';
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }
    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }
    Utils.extend(scrollbar, {
      trackSize: trackSize,
      divider: divider,
      moveDivider: moveDivider,
      dragSize: dragSize
    });
    scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
  },
  getPointerPosition: function getPointerPosition(e) {
    var swiper = this;
    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX || e.clientX;
    }
    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY || e.clientY;
  },
  setDragPosition: function setDragPosition(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        rtl = swiper.rtlTranslate;
    var $el = scrollbar.$el,
        dragSize = scrollbar.dragSize,
        trackSize = scrollbar.trackSize,
        dragStartPos = scrollbar.dragStartPos;


    var positionRatio = void 0;
    positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);
    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;

    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  },
  onDragStart: function onDragStart(e) {
    var swiper = this;
    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;

    swiper.scrollbar.isTouched = true;
    swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();

    $wrapperEl.transition(100);
    $dragEl.transition(100);
    scrollbar.setDragPosition(e);

    clearTimeout(swiper.scrollbar.dragTimeout);

    $el.transition(0);
    if (params.hide) {
      $el.css('opacity', 1);
    }
    swiper.emit('scrollbarDragStart', e);
  },
  onDragMove: function onDragMove(e) {
    var swiper = this;
    var scrollbar = swiper.scrollbar,
        $wrapperEl = swiper.$wrapperEl;
    var $el = scrollbar.$el,
        $dragEl = scrollbar.$dragEl;


    if (!swiper.scrollbar.isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    scrollbar.setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    swiper.emit('scrollbarDragMove', e);
  },
  onDragEnd: function onDragEnd(e) {
    var swiper = this;

    var params = swiper.params.scrollbar;
    var scrollbar = swiper.scrollbar;
    var $el = scrollbar.$el;


    if (!swiper.scrollbar.isTouched) return;
    swiper.scrollbar.isTouched = false;
    if (params.hide) {
      clearTimeout(swiper.scrollbar.dragTimeout);
      swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }
    swiper.emit('scrollbarDragEnd', e);
    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  },
  enableDraggable: function enableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params;

    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
    var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
    if (!Support.touch) {
      target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      _ssrWindow.document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      _ssrWindow.document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  disableDraggable: function disableDraggable() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        touchEventsTouch = swiper.touchEventsTouch,
        touchEventsDesktop = swiper.touchEventsDesktop,
        params = swiper.params;

    var $el = scrollbar.$el;
    var target = $el[0];
    var activeListener = Support.passiveListener && params.passiveListeners ? { passive: false, capture: false } : false;
    var passiveListener = Support.passiveListener && params.passiveListeners ? { passive: true, capture: false } : false;
    if (!Support.touch) {
      target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
      _ssrWindow.document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
      _ssrWindow.document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
    } else {
      target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
      target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
      target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
    }
  },
  init: function init() {
    var swiper = this;
    if (!swiper.params.scrollbar.el) return;
    var scrollbar = swiper.scrollbar,
        $swiperEl = swiper.$el;

    var params = swiper.params.scrollbar;

    var $el = (0, _dom.$)(params.el);
    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    var $dragEl = $el.find('.' + swiper.params.scrollbar.dragClass);
    if ($dragEl.length === 0) {
      $dragEl = (0, _dom.$)('<div class="' + swiper.params.scrollbar.dragClass + '"></div>');
      $el.append($dragEl);
    }

    Utils.extend(scrollbar, {
      $el: $el,
      el: $el[0],
      $dragEl: $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      scrollbar.enableDraggable();
    }
  },
  destroy: function destroy() {
    var swiper = this;
    swiper.scrollbar.disableDraggable();
  }
};

var Scrollbar$1 = {
  name: 'scrollbar',
  params: {
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      scrollbar: {
        init: Scrollbar.init.bind(swiper),
        destroy: Scrollbar.destroy.bind(swiper),
        updateSize: Scrollbar.updateSize.bind(swiper),
        setTranslate: Scrollbar.setTranslate.bind(swiper),
        setTransition: Scrollbar.setTransition.bind(swiper),
        enableDraggable: Scrollbar.enableDraggable.bind(swiper),
        disableDraggable: Scrollbar.disableDraggable.bind(swiper),
        setDragPosition: Scrollbar.setDragPosition.bind(swiper),
        getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
        onDragStart: Scrollbar.onDragStart.bind(swiper),
        onDragMove: Scrollbar.onDragMove.bind(swiper),
        onDragEnd: Scrollbar.onDragEnd.bind(swiper),
        isTouched: false,
        timeout: null,
        dragTimeout: null
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      swiper.scrollbar.init();
      swiper.scrollbar.updateSize();
      swiper.scrollbar.setTranslate();
    },
    update: function update() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    resize: function resize() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      swiper.scrollbar.updateSize();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      swiper.scrollbar.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      swiper.scrollbar.setTransition(duration);
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.scrollbar.destroy();
    }
  }
};

var Parallax = {
  setTransform: function setTransform(el, progress) {
    var swiper = this;
    var rtl = swiper.rtl;


    var $el = (0, _dom.$)(el);
    var rtlFactor = rtl ? -1 : 1;

    var p = $el.attr('data-swiper-parallax') || '0';
    var x = $el.attr('data-swiper-parallax-x');
    var y = $el.attr('data-swiper-parallax-y');
    var scale = $el.attr('data-swiper-parallax-scale');
    var opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = parseInt(x, 10) * progress * rtlFactor + '%';
    } else {
      x = x * progress * rtlFactor + 'px';
    }
    if (y.indexOf('%') >= 0) {
      y = parseInt(y, 10) * progress + '%';
    } else {
      y = y * progress + 'px';
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }
    if (typeof scale === 'undefined' || scale === null) {
      $el.transform('translate3d(' + x + ', ' + y + ', 0px)');
    } else {
      var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform('translate3d(' + x + ', ' + y + ', 0px) scale(' + currentScale + ')');
    }
  },
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el,
        slides = swiper.slides,
        progress = swiper.progress,
        snapGrid = swiper.snapGrid;

    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
      swiper.parallax.setTransform(el, progress);
    });
    slides.each(function (slideIndex, slideEl) {
      var slideProgress = slideEl.progress;
      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }
      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      (0, _dom.$)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
        swiper.parallax.setTransform(el, slideProgress);
      });
    });
  },
  setTransition: function setTransition() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.speed;

    var swiper = this;
    var $el = swiper.$el;

    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, parallaxEl) {
      var $parallaxEl = (0, _dom.$)(parallaxEl);
      var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  }
};

var Parallax$1 = {
  name: 'parallax',
  params: {
    parallax: {
      enabled: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      parallax: {
        setTransform: Parallax.setTransform.bind(swiper),
        setTranslate: Parallax.setTranslate.bind(swiper),
        setTransition: Parallax.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    init: function init() {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTranslate();
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (!swiper.params.parallax.enabled) return;
      swiper.parallax.setTransition(duration);
    }
  }
};

var Zoom = {
  // Calc Scale From Multi-touches
  getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
    if (e.targetTouches.length < 2) return 1;
    var x1 = e.targetTouches[0].pageX;
    var y1 = e.targetTouches[0].pageY;
    var x2 = e.targetTouches[1].pageX;
    var y2 = e.targetTouches[1].pageY;
    var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
    return distance;
  },

  // Events
  onGestureStart: function onGestureStart(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    zoom.fakeGestureTouched = false;
    zoom.fakeGestureMoved = false;
    if (!Support.gestures) {
      if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
        return;
      }
      zoom.fakeGestureTouched = true;
      gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
    }
    if (!gesture.$slideEl || !gesture.$slideEl.length) {
      gesture.$slideEl = (0, _dom.$)(e.target).closest('.swiper-slide');
      if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent('.' + params.containerClass);
      gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
      if (gesture.$imageWrapEl.length === 0) {
        gesture.$imageEl = undefined;
        return;
      }
    }
    gesture.$imageEl.transition(0);
    swiper.zoom.isScaling = true;
  },
  onGestureChange: function onGestureChange(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (!Support.gestures) {
      if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
        return;
      }
      zoom.fakeGestureMoved = true;
      gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (Support.gestures) {
      zoom.scale = e.scale * zoom.currentScale;
    } else {
      zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
    }
    if (zoom.scale > gesture.maxRatio) {
      zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
    }
    if (zoom.scale < params.minRatio) {
      zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
    }
    gesture.$imageEl.transform('translate3d(0,0,0) scale(' + zoom.scale + ')');
  },
  onGestureEnd: function onGestureEnd(e) {
    var swiper = this;
    var params = swiper.params.zoom;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (!Support.gestures) {
      if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
        return;
      }
      if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android) {
        return;
      }
      zoom.fakeGestureTouched = false;
      zoom.fakeGestureMoved = false;
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
    gesture.$imageEl.transition(swiper.params.speed).transform('translate3d(0,0,0) scale(' + zoom.scale + ')');
    zoom.currentScale = zoom.scale;
    zoom.isScaling = false;
    if (zoom.scale === 1) gesture.$slideEl = undefined;
  },
  onTouchStart: function onTouchStart(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image;

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (image.isTouched) return;
    if (Device.android) e.preventDefault();
    image.isTouched = true;
    image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  },
  onTouchMove: function onTouchMove(e) {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    swiper.allowClick = false;
    if (!image.isTouched || !gesture.$slideEl) return;

    if (!image.isMoved) {
      image.width = gesture.$imageEl[0].offsetWidth;
      image.height = gesture.$imageEl[0].offsetHeight;
      image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
      image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
      gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
      gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
      gesture.$imageWrapEl.transition(0);
      if (swiper.rtl) {
        image.startX = -image.startX;
        image.startY = -image.startY;
      }
    }
    // Define if we need image drag
    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;

    if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;

    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;

    image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
    image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

    if (!image.isMoved && !zoom.isScaling) {
      if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
        image.isTouched = false;
        return;
      }if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
        image.isTouched = false;
        return;
      }
    }
    e.preventDefault();
    e.stopPropagation();

    image.isMoved = true;
    image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
    image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

    if (image.currentX < image.minX) {
      image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
    }
    if (image.currentX > image.maxX) {
      image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
    }

    if (image.currentY < image.minY) {
      image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
    }
    if (image.currentY > image.maxY) {
      image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
    }

    // Velocity
    if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
    if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
    if (!velocity.prevTime) velocity.prevTime = Date.now();
    velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
    velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
    if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
    if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
    velocity.prevPositionX = image.touchesCurrent.x;
    velocity.prevPositionY = image.touchesCurrent.y;
    velocity.prevTime = Date.now();

    gesture.$imageWrapEl.transform('translate3d(' + image.currentX + 'px, ' + image.currentY + 'px,0)');
  },
  onTouchEnd: function onTouchEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture,
        image = zoom.image,
        velocity = zoom.velocity;

    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
    if (!image.isTouched || !image.isMoved) {
      image.isTouched = false;
      image.isMoved = false;
      return;
    }
    image.isTouched = false;
    image.isMoved = false;
    var momentumDurationX = 300;
    var momentumDurationY = 300;
    var momentumDistanceX = velocity.x * momentumDurationX;
    var newPositionX = image.currentX + momentumDistanceX;
    var momentumDistanceY = velocity.y * momentumDurationY;
    var newPositionY = image.currentY + momentumDistanceY;

    // Fix duration
    if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
    if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
    var momentumDuration = Math.max(momentumDurationX, momentumDurationY);

    image.currentX = newPositionX;
    image.currentY = newPositionY;

    // Define if we need image drag
    var scaledWidth = image.width * zoom.scale;
    var scaledHeight = image.height * zoom.scale;
    image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
    image.maxX = -image.minX;
    image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
    image.maxY = -image.minY;
    image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
    image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);

    gesture.$imageWrapEl.transition(momentumDuration).transform('translate3d(' + image.currentX + 'px, ' + image.currentY + 'px,0)');
  },
  onTransitionEnd: function onTransitionEnd() {
    var swiper = this;
    var zoom = swiper.zoom;
    var gesture = zoom.gesture;

    if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
      gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
      gesture.$imageWrapEl.transform('translate3d(0,0,0)');

      zoom.scale = 1;
      zoom.currentScale = 1;

      gesture.$slideEl = undefined;
      gesture.$imageEl = undefined;
      gesture.$imageWrapEl = undefined;
    }
  },

  // Toggle Zoom
  toggle: function toggle(e) {
    var swiper = this;
    var zoom = swiper.zoom;

    if (zoom.scale && zoom.scale !== 1) {
      // Zoom Out
      zoom.out();
    } else {
      // Zoom In
      zoom.in(e);
    }
  },
  in: function _in(e) {
    var swiper = this;

    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture,
        image = zoom.image;


    if (!gesture.$slideEl) {
      gesture.$slideEl = swiper.clickedSlide ? (0, _dom.$)(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent('.' + params.containerClass);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    gesture.$slideEl.addClass('' + params.zoomedSlideClass);

    var touchX = void 0;
    var touchY = void 0;
    var offsetX = void 0;
    var offsetY = void 0;
    var diffX = void 0;
    var diffY = void 0;
    var translateX = void 0;
    var translateY = void 0;
    var imageWidth = void 0;
    var imageHeight = void 0;
    var scaledWidth = void 0;
    var scaledHeight = void 0;
    var translateMinX = void 0;
    var translateMinY = void 0;
    var translateMaxX = void 0;
    var translateMaxY = void 0;
    var slideWidth = void 0;
    var slideHeight = void 0;

    if (typeof image.touchesStart.x === 'undefined' && e) {
      touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
      touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
    } else {
      touchX = image.touchesStart.x;
      touchY = image.touchesStart.y;
    }

    zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
    if (e) {
      slideWidth = gesture.$slideEl[0].offsetWidth;
      slideHeight = gesture.$slideEl[0].offsetHeight;
      offsetX = gesture.$slideEl.offset().left;
      offsetY = gesture.$slideEl.offset().top;
      diffX = offsetX + slideWidth / 2 - touchX;
      diffY = offsetY + slideHeight / 2 - touchY;

      imageWidth = gesture.$imageEl[0].offsetWidth;
      imageHeight = gesture.$imageEl[0].offsetHeight;
      scaledWidth = imageWidth * zoom.scale;
      scaledHeight = imageHeight * zoom.scale;

      translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
      translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
      translateMaxX = -translateMinX;
      translateMaxY = -translateMinY;

      translateX = diffX * zoom.scale;
      translateY = diffY * zoom.scale;

      if (translateX < translateMinX) {
        translateX = translateMinX;
      }
      if (translateX > translateMaxX) {
        translateX = translateMaxX;
      }

      if (translateY < translateMinY) {
        translateY = translateMinY;
      }
      if (translateY > translateMaxY) {
        translateY = translateMaxY;
      }
    } else {
      translateX = 0;
      translateY = 0;
    }
    gesture.$imageWrapEl.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(' + zoom.scale + ')');
  },
  out: function out() {
    var swiper = this;

    var zoom = swiper.zoom;
    var params = swiper.params.zoom;
    var gesture = zoom.gesture;


    if (!gesture.$slideEl) {
      gesture.$slideEl = swiper.clickedSlide ? (0, _dom.$)(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
      gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
      gesture.$imageWrapEl = gesture.$imageEl.parent('.' + params.containerClass);
    }
    if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;

    zoom.scale = 1;
    zoom.currentScale = 1;
    gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
    gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
    gesture.$slideEl.removeClass('' + params.zoomedSlideClass);
    gesture.$slideEl = undefined;
  },

  // Attach/Detach Events
  enable: function enable() {
    var swiper = this;
    var zoom = swiper.zoom;
    if (zoom.enabled) return;
    zoom.enabled = true;

    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

    // Scale image
    if (Support.gestures) {
      swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
    }

    // Move image
    swiper.$wrapperEl.on(swiper.touchEvents.move, '.' + swiper.params.zoom.containerClass, zoom.onTouchMove);
  },
  disable: function disable() {
    var swiper = this;
    var zoom = swiper.zoom;
    if (!zoom.enabled) return;

    swiper.zoom.enabled = false;

    var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? { passive: true, capture: false } : false;

    // Scale image
    if (Support.gestures) {
      swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
    } else if (swiper.touchEvents.start === 'touchstart') {
      swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
      swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
    }

    // Move image
    swiper.$wrapperEl.off(swiper.touchEvents.move, '.' + swiper.params.zoom.containerClass, zoom.onTouchMove);
  }
};

var Zoom$1 = {
  name: 'zoom',
  params: {
    zoom: {
      enabled: false,
      maxRatio: 3,
      minRatio: 1,
      toggle: true,
      containerClass: 'swiper-zoom-container',
      zoomedSlideClass: 'swiper-slide-zoomed'
    }
  },
  create: function create() {
    var swiper = this;
    var zoom = {
      enabled: false,
      scale: 1,
      currentScale: 1,
      isScaling: false,
      gesture: {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
      },
      image: {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
      },
      velocity: {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
      }
    };

    'onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out'.split(' ').forEach(function (methodName) {
      zoom[methodName] = Zoom[methodName].bind(swiper);
    });
    Utils.extend(swiper, {
      zoom: zoom
    });

    var scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
      get: function get() {
        return scale;
      },
      set: function set(value) {
        if (scale !== value) {
          var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
          var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
          swiper.emit('zoomChange', value, imageEl, slideEl);
        }
        scale = value;
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.zoom.enabled) {
        swiper.zoom.enable();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      swiper.zoom.disable();
    },
    touchStart: function touchStart(e) {
      var swiper = this;
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchStart(e);
    },
    touchEnd: function touchEnd(e) {
      var swiper = this;
      if (!swiper.zoom.enabled) return;
      swiper.zoom.onTouchEnd(e);
    },
    doubleTap: function doubleTap(e) {
      var swiper = this;
      if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
        swiper.zoom.toggle(e);
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
        swiper.zoom.onTransitionEnd();
      }
    }
  }
};

var Lazy = {
  loadInSlide: function loadInSlide(index) {
    var loadInDuplicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var swiper = this;
    var params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

    var $slideEl = isVirtual ? swiper.$wrapperEl.children('.' + swiper.params.slideClass + '[data-swiper-slide-index="' + index + '"]') : swiper.slides.eq(index);

    var $images = $slideEl.find('.' + params.elementClass + ':not(.' + params.loadedClass + '):not(.' + params.loadingClass + ')');
    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images = $images.add($slideEl[0]);
    }
    if ($images.length === 0) return;

    $images.each(function (imageIndex, imageEl) {
      var $imageEl = (0, _dom.$)(imageEl);
      $imageEl.addClass(params.loadingClass);

      var background = $imageEl.attr('data-background');
      var src = $imageEl.attr('data-src');
      var srcset = $imageEl.attr('data-srcset');
      var sizes = $imageEl.attr('data-sizes');

      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
        if (background) {
          $imageEl.css('background-image', 'url("' + background + '")');
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }
          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }
          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find('.' + params.preloaderClass).remove();
        if (swiper.params.loop && loadInDuplicate) {
          var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            var originalSlide = swiper.$wrapperEl.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + swiper.params.slideDuplicateClass + ')');
            swiper.lazy.loadInSlide(originalSlide.index(), false);
          } else {
            var duplicatedSlide = swiper.$wrapperEl.children('.' + swiper.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
            swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
          }
        }
        swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
      });

      swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  },
  load: function load() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl,
        swiperParams = swiper.params,
        slides = swiper.slides,
        activeIndex = swiper.activeIndex;

    var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    var params = swiperParams.lazy;

    var slidesPerView = swiperParams.slidesPerView;
    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children('.' + swiperParams.slideClass + '[data-swiper-slide-index="' + index + '"]').length) {
          return true;
        }
      } else if (slides[index]) return true;
      return false;
    }
    function slideIndex(slideEl) {
      if (isVirtual) {
        return (0, _dom.$)(slideEl).attr('data-swiper-slide-index');
      }
      return (0, _dom.$)(slideEl).index();
    }

    if (!swiper.lazy.initialImageLoaded) swiper.lazy.initialImageLoaded = true;
    if (swiper.params.watchSlidesVisibility) {
      $wrapperEl.children('.' + swiperParams.slideVisibleClass).each(function (elIndex, slideEl) {
        var index = isVirtual ? (0, _dom.$)(slideEl).attr('data-swiper-slide-index') : (0, _dom.$)(slideEl).index();
        swiper.lazy.loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) swiper.lazy.loadInSlide(i);
      }
    } else {
      swiper.lazy.loadInSlide(activeIndex);
    }
    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        var amount = params.loadPrevNextAmount;
        var spv = slidesPerView;
        var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
        // Next Slides
        for (var _i10 = activeIndex + slidesPerView; _i10 < maxIndex; _i10 += 1) {
          if (slideExist(_i10)) swiper.lazy.loadInSlide(_i10);
        }
        // Prev Slides
        for (var _i11 = minIndex; _i11 < activeIndex; _i11 += 1) {
          if (slideExist(_i11)) swiper.lazy.loadInSlide(_i11);
        }
      } else {
        var nextSlide = $wrapperEl.children('.' + swiperParams.slideNextClass);
        if (nextSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(nextSlide));

        var prevSlide = $wrapperEl.children('.' + swiperParams.slidePrevClass);
        if (prevSlide.length > 0) swiper.lazy.loadInSlide(slideIndex(prevSlide));
      }
    }
  }
};

var Lazy$1 = {
  name: 'lazy',
  params: {
    lazy: {
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,

      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      lazy: {
        initialImageLoaded: false,
        load: Lazy.load.bind(swiper),
        loadInSlide: Lazy.loadInSlide.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
        swiper.params.preloadImages = false;
      }
    },
    init: function init() {
      var swiper = this;
      if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
        swiper.lazy.load();
      }
    },
    scroll: function scroll() {
      var swiper = this;
      if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
        swiper.lazy.load();
      }
    },
    resize: function resize() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    scrollbarDragMove: function scrollbarDragMove() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        swiper.lazy.load();
      }
    },
    transitionStart: function transitionStart() {
      var swiper = this;
      if (swiper.params.lazy.enabled) {
        if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
          swiper.lazy.load();
        }
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
        swiper.lazy.load();
      }
    }
  }
};

/* eslint no-bitwise: ["error", { "allow": [">>"] }] */

var Controller = {
  LinearSpline: function LinearSpline(x, y) {
    var binarySearch = function search() {
      var maxIndex = void 0;
      var minIndex = void 0;
      var guess = void 0;
      return function (array, val) {
        minIndex = -1;
        maxIndex = array.length;
        while (maxIndex - minIndex > 1) {
          guess = maxIndex + minIndex >> 1;
          if (array[guess] <= val) {
            minIndex = guess;
          } else {
            maxIndex = guess;
          }
        }
        return maxIndex;
      };
    }();
    this.x = x;
    this.y = y;
    this.lastIndex = x.length - 1;
    // Given an x value (x2), return the expected y2 value:
    // (x1,y1) is the known point before given value,
    // (x3,y3) is the known point after given value.
    var i1 = void 0;
    var i3 = void 0;

    this.interpolate = function interpolate(x2) {
      if (!x2) return 0;

      // Get the indexes of x1 and x3 (the array indexes before and after given x2):
      i3 = binarySearch(this.x, x2);
      i1 = i3 - 1;

      // We have our indexes i1 & i3, so we can calculate already:
      // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
      return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
    };
    return this;
  },
  // xxx: for now i will just save one spline function to to
  getInterpolateFunction: function getInterpolateFunction(c) {
    var swiper = this;
    if (!swiper.controller.spline) {
      swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
    }
  },
  setTranslate: function setTranslate(_setTranslate, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var multiplier = void 0;
    var controlledTranslate = void 0;
    function setControlledTranslate(c) {
      // this will create an Interpolate function based on the snapGrids
      // x is the Grid of the scrolled scroller and y will be the controlled scroller
      // it makes sense to create this only once and recall it for the interpolation
      // the function does a lot of value caching for performance
      var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
      if (swiper.params.controller.by === 'slide') {
        swiper.controller.getInterpolateFunction(c);
        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
        // but it did not work out
        controlledTranslate = -swiper.controller.spline.interpolate(-translate);
      }

      if (!controlledTranslate || swiper.params.controller.by === 'container') {
        multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
        controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
      }

      if (swiper.params.controller.inverse) {
        controlledTranslate = c.maxTranslate() - controlledTranslate;
      }
      c.updateProgress(controlledTranslate);
      c.setTranslate(controlledTranslate, swiper);
      c.updateActiveIndex();
      c.updateSlidesClasses();
    }
    if (Array.isArray(controlled)) {
      for (var i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTranslate(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTranslate(controlled);
    }
  },
  setTransition: function setTransition(duration, byController) {
    var swiper = this;
    var controlled = swiper.controller.control;
    var i = void 0;
    function setControlledTransition(c) {
      c.setTransition(duration, swiper);
      if (duration !== 0) {
        c.transitionStart();
        if (c.params.autoHeight) {
          Utils.nextTick(function () {
            c.updateAutoHeight();
          });
        }
        c.$wrapperEl.transitionEnd(function () {
          if (!controlled) return;
          if (c.params.loop && swiper.params.controller.by === 'slide') {
            c.loopFix();
          }
          c.transitionEnd();
        });
      }
    }
    if (Array.isArray(controlled)) {
      for (i = 0; i < controlled.length; i += 1) {
        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
          setControlledTransition(controlled[i]);
        }
      }
    } else if (controlled instanceof Swiper && byController !== controlled) {
      setControlledTransition(controlled);
    }
  }
};
var Controller$1 = {
  name: 'controller',
  params: {
    controller: {
      control: undefined,
      inverse: false,
      by: 'slide' // or 'container'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      controller: {
        control: swiper.params.controller.control,
        getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
        setTranslate: Controller.setTranslate.bind(swiper),
        setTransition: Controller.setTransition.bind(swiper)
      }
    });
  },

  on: {
    update: function update() {
      var swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    resize: function resize() {
      var swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      if (!swiper.controller.control) return;
      if (swiper.controller.spline) {
        swiper.controller.spline = undefined;
        delete swiper.controller.spline;
      }
    },
    setTranslate: function setTranslate(translate, byController) {
      var swiper = this;
      if (!swiper.controller.control) return;
      swiper.controller.setTranslate(translate, byController);
    },
    setTransition: function setTransition(duration, byController) {
      var swiper = this;
      if (!swiper.controller.control) return;
      swiper.controller.setTransition(duration, byController);
    }
  }
};

var a11y = {
  makeElFocusable: function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
    return $el;
  },
  addElRole: function addElRole($el, role) {
    $el.attr('role', role);
    return $el;
  },
  addElLabel: function addElLabel($el, label) {
    $el.attr('aria-label', label);
    return $el;
  },
  disableEl: function disableEl($el) {
    $el.attr('aria-disabled', true);
    return $el;
  },
  enableEl: function enableEl($el) {
    $el.attr('aria-disabled', false);
    return $el;
  },
  onEnterKey: function onEnterKey(e) {
    var swiper = this;
    var params = swiper.params.a11y;
    if (e.keyCode !== 13) return;
    var $targetEl = (0, _dom.$)(e.target);
    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }
      if (swiper.isEnd) {
        swiper.a11y.notify(params.lastSlideMessage);
      } else {
        swiper.a11y.notify(params.nextSlideMessage);
      }
    }
    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }
      if (swiper.isBeginning) {
        swiper.a11y.notify(params.firstSlideMessage);
      } else {
        swiper.a11y.notify(params.prevSlideMessage);
      }
    }
    if (swiper.pagination && $targetEl.is('.' + swiper.params.pagination.bulletClass)) {
      $targetEl[0].click();
    }
  },
  notify: function notify(message) {
    var swiper = this;
    var notification = swiper.a11y.liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  },
  updateNavigation: function updateNavigation() {
    var swiper = this;

    if (swiper.params.loop) return;
    var _swiper$navigation4 = swiper.navigation,
        $nextEl = _swiper$navigation4.$nextEl,
        $prevEl = _swiper$navigation4.$prevEl;


    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        swiper.a11y.disableEl($prevEl);
      } else {
        swiper.a11y.enableEl($prevEl);
      }
    }
    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        swiper.a11y.disableEl($nextEl);
      } else {
        swiper.a11y.enableEl($nextEl);
      }
    }
  },
  updatePagination: function updatePagination() {
    var swiper = this;
    var params = swiper.params.a11y;
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
        var $bulletEl = (0, _dom.$)(bulletEl);
        swiper.a11y.makeElFocusable($bulletEl);
        swiper.a11y.addElRole($bulletEl, 'button');
        swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
      });
    }
  },
  init: function init() {
    var swiper = this;

    swiper.$el.append(swiper.a11y.liveRegion);

    // Navigation
    var params = swiper.params.a11y;
    var $nextEl = void 0;
    var $prevEl = void 0;
    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }
    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }
    if ($nextEl) {
      swiper.a11y.makeElFocusable($nextEl);
      swiper.a11y.addElRole($nextEl, 'button');
      swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
      $nextEl.on('keydown', swiper.a11y.onEnterKey);
    }
    if ($prevEl) {
      swiper.a11y.makeElFocusable($prevEl);
      swiper.a11y.addElRole($prevEl, 'button');
      swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
      $prevEl.on('keydown', swiper.a11y.onEnterKey);
    }

    // Pagination
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.on('keydown', '.' + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) swiper.a11y.liveRegion.remove();

    var $nextEl = void 0;
    var $prevEl = void 0;
    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }
    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }
    if ($nextEl) {
      $nextEl.off('keydown', swiper.a11y.onEnterKey);
    }
    if ($prevEl) {
      $prevEl.off('keydown', swiper.a11y.onEnterKey);
    }

    // Pagination
    if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
      swiper.pagination.$el.off('keydown', '.' + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
    }
  }
};
var A11y = {
  name: 'a11y',
  params: {
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      a11y: {
        liveRegion: (0, _dom.$)('<span class="' + swiper.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
      }
    });
    Object.keys(a11y).forEach(function (methodName) {
      swiper.a11y[methodName] = a11y[methodName].bind(swiper);
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.init();
      swiper.a11y.updateNavigation();
    },
    toEdge: function toEdge() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    fromEdge: function fromEdge() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updateNavigation();
    },
    paginationUpdate: function paginationUpdate() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.updatePagination();
    },
    destroy: function destroy() {
      var swiper = this;
      if (!swiper.params.a11y.enabled) return;
      swiper.a11y.destroy();
    }
  }
};

var History = {
  init: function init() {
    var swiper = this;
    if (!swiper.params.history) return;
    if (!_ssrWindow.window.history || !_ssrWindow.window.history.pushState) {
      swiper.params.history.enabled = false;
      swiper.params.hashNavigation.enabled = true;
      return;
    }
    var history = swiper.history;
    history.initialized = true;
    history.paths = History.getPathValues();
    if (!history.paths.key && !history.paths.value) return;
    history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
    if (!swiper.params.history.replaceState) {
      _ssrWindow.window.addEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (!swiper.params.history.replaceState) {
      _ssrWindow.window.removeEventListener('popstate', swiper.history.setHistoryPopState);
    }
  },
  setHistoryPopState: function setHistoryPopState() {
    var swiper = this;
    swiper.history.paths = History.getPathValues();
    swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
  },
  getPathValues: function getPathValues() {
    var pathArray = _ssrWindow.window.location.pathname.slice(1).split('/').filter(function (part) {
      return part !== '';
    });
    var total = pathArray.length;
    var key = pathArray[total - 2];
    var value = pathArray[total - 1];
    return { key: key, value: value };
  },
  setHistory: function setHistory(key, index) {
    var swiper = this;
    if (!swiper.history.initialized || !swiper.params.history.enabled) return;
    var slide = swiper.slides.eq(index);
    var value = History.slugify(slide.attr('data-history'));
    if (!_ssrWindow.window.location.pathname.includes(key)) {
      value = key + '/' + value;
    }
    var currentState = _ssrWindow.window.history.state;
    if (currentState && currentState.value === value) {
      return;
    }
    if (swiper.params.history.replaceState) {
      _ssrWindow.window.history.replaceState({ value: value }, null, value);
    } else {
      _ssrWindow.window.history.pushState({ value: value }, null, value);
    }
  },
  slugify: function slugify(text) {
    return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
  },
  scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
    var swiper = this;
    if (value) {
      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var _slide3 = swiper.slides.eq(i);
        var slideHistory = History.slugify(_slide3.attr('data-history'));
        if (slideHistory === value && !_slide3.hasClass(swiper.params.slideDuplicateClass)) {
          var _index2 = _slide3.index();
          swiper.slideTo(_index2, speed, runCallbacks);
        }
      }
    } else {
      swiper.slideTo(0, speed, runCallbacks);
    }
  }
};

var History$1 = {
  name: 'history',
  params: {
    history: {
      enabled: false,
      replaceState: false,
      key: 'slides'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      history: {
        init: History.init.bind(swiper),
        setHistory: History.setHistory.bind(swiper),
        setHistoryPopState: History.setHistoryPopState.bind(swiper),
        scrollToSlide: History.scrollToSlide.bind(swiper),
        destroy: History.destroy.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.history.enabled) {
        swiper.history.init();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.history.enabled) {
        swiper.history.destroy();
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.history.initialized) {
        swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
      }
    }
  }
};

var HashNavigation = {
  onHashCange: function onHashCange() {
    var swiper = this;
    var newHash = _ssrWindow.document.location.hash.replace('#', '');
    var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
    if (newHash !== activeSlideHash) {
      var newIndex = swiper.$wrapperEl.children('.' + swiper.params.slideClass + '[data-hash="' + newHash + '"]').index();
      if (typeof newIndex === 'undefined') return;
      swiper.slideTo(newIndex);
    }
  },
  setHash: function setHash() {
    var swiper = this;
    if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) return;
    if (swiper.params.hashNavigation.replaceState && _ssrWindow.window.history && _ssrWindow.window.history.replaceState) {
      _ssrWindow.window.history.replaceState(null, null, '#' + swiper.slides.eq(swiper.activeIndex).attr('data-hash') || '');
    } else {
      var _slide4 = swiper.slides.eq(swiper.activeIndex);
      var hash = _slide4.attr('data-hash') || _slide4.attr('data-history');
      _ssrWindow.document.location.hash = hash || '';
    }
  },
  init: function init() {
    var swiper = this;
    if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
    swiper.hashNavigation.initialized = true;
    var hash = _ssrWindow.document.location.hash.replace('#', '');
    if (hash) {
      var speed = 0;
      for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
        var _slide5 = swiper.slides.eq(i);
        var slideHash = _slide5.attr('data-hash') || _slide5.attr('data-history');
        if (slideHash === hash && !_slide5.hasClass(swiper.params.slideDuplicateClass)) {
          var _index3 = _slide5.index();
          swiper.slideTo(_index3, speed, swiper.params.runCallbacksOnInit, true);
        }
      }
    }
    if (swiper.params.hashNavigation.watchState) {
      (0, _dom.$)(_ssrWindow.window).on('hashchange', swiper.hashNavigation.onHashCange);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    if (swiper.params.hashNavigation.watchState) {
      (0, _dom.$)(_ssrWindow.window).off('hashchange', swiper.hashNavigation.onHashCange);
    }
  }
};
var HashNavigation$1 = {
  name: 'hash-navigation',
  params: {
    hashNavigation: {
      enabled: false,
      replaceState: false,
      watchState: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      hashNavigation: {
        initialized: false,
        init: HashNavigation.init.bind(swiper),
        destroy: HashNavigation.destroy.bind(swiper),
        setHash: HashNavigation.setHash.bind(swiper),
        onHashCange: HashNavigation.onHashCange.bind(swiper)
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.init();
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.params.hashNavigation.enabled) {
        swiper.hashNavigation.destroy();
      }
    },
    transitionEnd: function transitionEnd() {
      var swiper = this;
      if (swiper.hashNavigation.initialized) {
        swiper.hashNavigation.setHash();
      }
    }
  }
};

/* eslint no-underscore-dangle: "off" */

var Autoplay = {
  run: function run() {
    var swiper = this;
    var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
    var delay = swiper.params.autoplay.delay;
    if ($activeSlideEl.attr('data-swiper-autoplay')) {
      delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
    }
    clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.timeout = Utils.nextTick(function () {
      if (swiper.params.autoplay.reverseDirection) {
        if (swiper.params.loop) {
          swiper.loopFix();
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.isBeginning) {
          swiper.slidePrev(swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else if (!swiper.params.autoplay.stopOnLastSlide) {
          swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
          swiper.emit('autoplay');
        } else {
          swiper.autoplay.stop();
        }
      } else if (swiper.params.loop) {
        swiper.loopFix();
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.isEnd) {
        swiper.slideNext(swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else if (!swiper.params.autoplay.stopOnLastSlide) {
        swiper.slideTo(0, swiper.params.speed, true, true);
        swiper.emit('autoplay');
      } else {
        swiper.autoplay.stop();
      }
    }, delay);
  },
  start: function start() {
    var swiper = this;
    if (typeof swiper.autoplay.timeout !== 'undefined') return false;
    if (swiper.autoplay.running) return false;
    swiper.autoplay.running = true;
    swiper.emit('autoplayStart');
    swiper.autoplay.run();
    return true;
  },
  stop: function stop() {
    var swiper = this;
    if (!swiper.autoplay.running) return false;
    if (typeof swiper.autoplay.timeout === 'undefined') return false;

    if (swiper.autoplay.timeout) {
      clearTimeout(swiper.autoplay.timeout);
      swiper.autoplay.timeout = undefined;
    }
    swiper.autoplay.running = false;
    swiper.emit('autoplayStop');
    return true;
  },
  pause: function pause(speed) {
    var swiper = this;
    if (!swiper.autoplay.running) return;
    if (swiper.autoplay.paused) return;
    if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
    swiper.autoplay.paused = true;
    if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
      swiper.autoplay.paused = false;
      swiper.autoplay.run();
    } else {
      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
    }
  }
};

var Autoplay$1 = {
  name: 'autoplay',
  params: {
    autoplay: {
      enabled: false,
      delay: 3000,
      waitForTransition: true,
      disableOnInteraction: true,
      stopOnLastSlide: false,
      reverseDirection: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      autoplay: {
        running: false,
        paused: false,
        run: Autoplay.run.bind(swiper),
        start: Autoplay.start.bind(swiper),
        stop: Autoplay.stop.bind(swiper),
        pause: Autoplay.pause.bind(swiper),
        onTransitionEnd: function onTransitionEnd(e) {
          if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
          swiper.autoplay.paused = false;
          if (!swiper.autoplay.running) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.run();
          }
        }
      }
    });
  },

  on: {
    init: function init() {
      var swiper = this;
      if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
      }
    },
    beforeTransitionStart: function beforeTransitionStart(speed, internal) {
      var swiper = this;
      if (swiper.autoplay.running) {
        if (internal || !swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.pause(speed);
        } else {
          swiper.autoplay.stop();
        }
      }
    },
    sliderFirstMove: function sliderFirstMove() {
      var swiper = this;
      if (swiper.autoplay.running) {
        if (swiper.params.autoplay.disableOnInteraction) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.pause();
        }
      }
    },
    destroy: function destroy() {
      var swiper = this;
      if (swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    }
  }
};

var Fade = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = swiper.slides.eq(i);
      var _offset = $slideEl[0].swiperSlideOffset;
      var tx = -_offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      var ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }
      var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      $slideEl.css({
        opacity: slideOpacity
      }).transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl;

    slides.transition(duration);
    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      slides.transitionEnd(function () {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};

var EffectFade = {
  name: 'effect-fade',
  params: {
    fadeEffect: {
      crossFade: false
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      fadeEffect: {
        setTranslate: Fade.setTranslate.bind(swiper),
        setTransition: Fade.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'fade');
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'fade') return;
      swiper.fadeEffect.setTransition(duration);
    }
  }
};

var Cube = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var $el = swiper.$el,
        $wrapperEl = swiper.$wrapperEl,
        slides = swiper.slides,
        swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        rtl = swiper.rtlTranslate,
        swiperSize = swiper.size;

    var params = swiper.params.cubeEffect;
    var isHorizontal = swiper.isHorizontal();
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var wrapperRotate = 0;
    var $cubeShadowEl = void 0;
    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = (0, _dom.$)('<div class="swiper-cube-shadow"></div>');
          $wrapperEl.append($cubeShadowEl);
        }
        $cubeShadowEl.css({ height: swiperWidth + 'px' });
      } else {
        $cubeShadowEl = $el.find('.swiper-cube-shadow');
        if ($cubeShadowEl.length === 0) {
          $cubeShadowEl = (0, _dom.$)('<div class="swiper-cube-shadow"></div>');
          $el.append($cubeShadowEl);
        }
      }
    }
    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideIndex = i;
      if (isVirtual) {
        slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
      }
      var slideAngle = slideIndex * 90;
      var round = Math.floor(slideAngle / 360);
      if (rtl) {
        slideAngle = -slideAngle;
        round = Math.floor(-slideAngle / 360);
      }
      var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      var tx = 0;
      var ty = 0;
      var tz = 0;
      if (slideIndex % 4 === 0) {
        tx = -round * 4 * swiperSize;
        tz = 0;
      } else if ((slideIndex - 1) % 4 === 0) {
        tx = 0;
        tz = -round * 4 * swiperSize;
      } else if ((slideIndex - 2) % 4 === 0) {
        tx = swiperSize + round * 4 * swiperSize;
        tz = swiperSize;
      } else if ((slideIndex - 3) % 4 === 0) {
        tx = -swiperSize;
        tz = 3 * swiperSize + swiperSize * 4 * round;
      }
      if (rtl) {
        tx = -tx;
      }

      if (!isHorizontal) {
        ty = tx;
        tx = 0;
      }

      var _transform = 'rotateX(' + (isHorizontal ? 0 : -slideAngle) + 'deg) rotateY(' + (isHorizontal ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
      if (progress <= 1 && progress > -1) {
        wrapperRotate = slideIndex * 90 + progress * 90;
        if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
      }
      $slideEl.transform(_transform);
      if (params.slideShadows) {
        // Set shadows
        var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
          shadowBefore = (0, _dom.$)('<div class="swiper-slide-shadow-' + (isHorizontal ? 'left' : 'top') + '"></div>');
          $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
          shadowAfter = (0, _dom.$)('<div class="swiper-slide-shadow-' + (isHorizontal ? 'right' : 'bottom') + '"></div>');
          $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }
    }
    $wrapperEl.css({
      '-webkit-transform-origin': '50% 50% -' + swiperSize / 2 + 'px',
      '-moz-transform-origin': '50% 50% -' + swiperSize / 2 + 'px',
      '-ms-transform-origin': '50% 50% -' + swiperSize / 2 + 'px',
      'transform-origin': '50% 50% -' + swiperSize / 2 + 'px'
    });

    if (params.shadow) {
      if (isHorizontal) {
        $cubeShadowEl.transform('translate3d(0px, ' + (swiperWidth / 2 + params.shadowOffset) + 'px, ' + -swiperWidth / 2 + 'px) rotateX(90deg) rotateZ(0deg) scale(' + params.shadowScale + ')');
      } else {
        var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
        var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
        var scale1 = params.shadowScale;
        var scale2 = params.shadowScale / multiplier;
        var _offset2 = params.shadowOffset;
        $cubeShadowEl.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (swiperHeight / 2 + _offset2) + 'px, ' + -swiperHeight / 2 / scale2 + 'px) rotateX(-90deg)');
      }
    }
    var zFactor = Browser.isSafari || Browser.isUiWebView ? -swiperSize / 2 : 0;
    $wrapperEl.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (swiper.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (swiper.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var $el = swiper.$el,
        slides = swiper.slides;

    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
      $el.find('.swiper-cube-shadow').transition(duration);
    }
  }
};

var EffectCube = {
  name: 'effect-cube',
  params: {
    cubeEffect: {
      slideShadows: true,
      shadow: true,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      cubeEffect: {
        setTranslate: Cube.setTranslate.bind(swiper),
        setTransition: Cube.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'cube');
      swiper.classNames.push(swiper.params.containerModifierClass + '3d');
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        resistanceRatio: 0,
        spaceBetween: 0,
        centeredSlides: false,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'cube') return;
      swiper.cubeEffect.setTransition(duration);
    }
  }
};

var Flip = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var slides = swiper.slides,
        rtl = swiper.rtlTranslate;

    for (var i = 0; i < slides.length; i += 1) {
      var $slideEl = slides.eq(i);
      var progress = $slideEl[0].progress;
      if (swiper.params.flipEffect.limitRotation) {
        progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
      }
      var _offset3 = $slideEl[0].swiperSlideOffset;
      var rotate = -180 * progress;
      var rotateY = rotate;
      var rotateX = 0;
      var tx = -_offset3;
      var ty = 0;
      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
        rotateX = -rotateY;
        rotateY = 0;
      } else if (rtl) {
        rotateY = -rotateY;
      }

      $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

      if (swiper.params.flipEffect.slideShadows) {
        // Set shadows
        var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
          shadowBefore = (0, _dom.$)('<div class="swiper-slide-shadow-' + (swiper.isHorizontal() ? 'left' : 'top') + '"></div>');
          $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
          shadowAfter = (0, _dom.$)('<div class="swiper-slide-shadow-' + (swiper.isHorizontal() ? 'right' : 'bottom') + '"></div>');
          $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
      }
      $slideEl.transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    var slides = swiper.slides,
        activeIndex = swiper.activeIndex,
        $wrapperEl = swiper.$wrapperEl;

    slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    if (swiper.params.virtualTranslate && duration !== 0) {
      var eventTriggered = false;
      // eslint-disable-next-line
      slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
        if (eventTriggered) return;
        if (!swiper || swiper.destroyed) return;
        // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
        eventTriggered = true;
        swiper.animating = false;
        var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
        for (var i = 0; i < triggerEvents.length; i += 1) {
          $wrapperEl.trigger(triggerEvents[i]);
        }
      });
    }
  }
};

var EffectFlip = {
  name: 'effect-flip',
  params: {
    flipEffect: {
      slideShadows: true,
      limitRotation: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      flipEffect: {
        setTranslate: Flip.setTranslate.bind(swiper),
        setTransition: Flip.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.classNames.push(swiper.params.containerModifierClass + 'flip');
      swiper.classNames.push(swiper.params.containerModifierClass + '3d');
      var overwriteParams = {
        slidesPerView: 1,
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        spaceBetween: 0,
        virtualTranslate: true
      };
      Utils.extend(swiper.params, overwriteParams);
      Utils.extend(swiper.originalParams, overwriteParams);
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'flip') return;
      swiper.flipEffect.setTransition(duration);
    }
  }
};

var Coverflow = {
  setTranslate: function setTranslate() {
    var swiper = this;
    var swiperWidth = swiper.width,
        swiperHeight = swiper.height,
        slides = swiper.slides,
        $wrapperEl = swiper.$wrapperEl,
        slidesSizesGrid = swiper.slidesSizesGrid;

    var params = swiper.params.coverflowEffect;
    var isHorizontal = swiper.isHorizontal();
    var transform = swiper.translate;
    var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
    var rotate = isHorizontal ? params.rotate : -params.rotate;
    var translate = params.depth;
    // Each slide offset from center
    for (var i = 0, length = slides.length; i < length; i += 1) {
      var $slideEl = slides.eq(i);
      var slideSize = slidesSizesGrid[i];
      var slideOffset = $slideEl[0].swiperSlideOffset;
      var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;

      var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
      var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
      // var rotateZ = 0
      var translateZ = -translate * Math.abs(offsetMultiplier);

      var translateY = isHorizontal ? 0 : params.stretch * offsetMultiplier;
      var translateX = isHorizontal ? params.stretch * offsetMultiplier : 0;

      // Fix for ultra small values
      if (Math.abs(translateX) < 0.001) translateX = 0;
      if (Math.abs(translateY) < 0.001) translateY = 0;
      if (Math.abs(translateZ) < 0.001) translateZ = 0;
      if (Math.abs(rotateY) < 0.001) rotateY = 0;
      if (Math.abs(rotateX) < 0.001) rotateX = 0;

      var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';

      $slideEl.transform(slideTransform);
      $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
      if (params.slideShadows) {
        // Set shadows
        var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if ($shadowBeforeEl.length === 0) {
          $shadowBeforeEl = (0, _dom.$)('<div class="swiper-slide-shadow-' + (isHorizontal ? 'left' : 'top') + '"></div>');
          $slideEl.append($shadowBeforeEl);
        }
        if ($shadowAfterEl.length === 0) {
          $shadowAfterEl = (0, _dom.$)('<div class="swiper-slide-shadow-' + (isHorizontal ? 'right' : 'bottom') + '"></div>');
          $slideEl.append($shadowAfterEl);
        }
        if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
        if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
      }
    }

    // Set correct perspective for IE10
    if (Support.pointerEvents || Support.prefixedPointerEvents) {
      var ws = $wrapperEl[0].style;
      ws.perspectiveOrigin = center + 'px 50%';
    }
  },
  setTransition: function setTransition(duration) {
    var swiper = this;
    swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
  }
};

var EffectCoverflow = {
  name: 'effect-coverflow',
  params: {
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      coverflowEffect: {
        setTranslate: Coverflow.setTranslate.bind(swiper),
        setTransition: Coverflow.setTransition.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;

      swiper.classNames.push(swiper.params.containerModifierClass + 'coverflow');
      swiper.classNames.push(swiper.params.containerModifierClass + '3d');

      swiper.params.watchSlidesProgress = true;
      swiper.originalParams.watchSlidesProgress = true;
    },
    setTranslate: function setTranslate() {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTranslate();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      if (swiper.params.effect !== 'coverflow') return;
      swiper.coverflowEffect.setTransition(duration);
    }
  }
};

var Thumbs = {
  init: function init() {
    var swiper = this;
    var thumbsParams = swiper.params.thumbs;

    var SwiperClass = swiper.constructor;
    if (thumbsParams.swiper instanceof SwiperClass) {
      swiper.thumbs.swiper = thumbsParams.swiper;
      Utils.extend(swiper.thumbs.swiper.originalParams, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
      Utils.extend(swiper.thumbs.swiper.params, {
        watchSlidesProgress: true,
        slideToClickedSlide: false
      });
    } else if (Utils.isObject(thumbsParams.swiper)) {
      swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: false
      }));
      swiper.thumbs.swiperCreated = true;
    }
    swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
    swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
  },
  onThumbClick: function onThumbClick() {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;
    var clickedIndex = thumbsSwiper.clickedIndex;
    var clickedSlide = thumbsSwiper.clickedSlide;
    if (clickedSlide && (0, _dom.$)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
    if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
    var slideToIndex = void 0;
    if (thumbsSwiper.params.loop) {
      slideToIndex = parseInt((0, _dom.$)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
    } else {
      slideToIndex = clickedIndex;
    }
    if (swiper.params.loop) {
      var currentIndex = swiper.activeIndex;
      if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
        swiper.loopFix();
        // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        currentIndex = swiper.activeIndex;
      }
      var prevIndex = swiper.slides.eq(currentIndex).prevAll('[data-swiper-slide-index="' + slideToIndex + '"]').eq(0).index();
      var nextIndex = swiper.slides.eq(currentIndex).nextAll('[data-swiper-slide-index="' + slideToIndex + '"]').eq(0).index();
      if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;else slideToIndex = prevIndex;
    }
    swiper.slideTo(slideToIndex);
  },
  update: function update(initial) {
    var swiper = this;
    var thumbsSwiper = swiper.thumbs.swiper;
    if (!thumbsSwiper) return;

    var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;

    if (swiper.realIndex !== thumbsSwiper.realIndex) {
      var currentThumbsIndex = thumbsSwiper.activeIndex;
      var newThumbsIndex = void 0;
      if (thumbsSwiper.params.loop) {
        if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
          thumbsSwiper.loopFix();
          // eslint-disable-next-line
          thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
          currentThumbsIndex = thumbsSwiper.activeIndex;
        }
        // Find actual thumbs index to slide to
        var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll('[data-swiper-slide-index="' + swiper.realIndex + '"]').eq(0).index();
        var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll('[data-swiper-slide-index="' + swiper.realIndex + '"]').eq(0).index();
        if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = currentThumbsIndex;else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;else newThumbsIndex = prevThumbsIndex;
      } else {
        newThumbsIndex = swiper.realIndex;
      }
      if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
        if (thumbsSwiper.params.centeredSlides) {
          if (newThumbsIndex > currentThumbsIndex) {
            newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
          } else {
            newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
          }
        } else if (newThumbsIndex > currentThumbsIndex) {
          newThumbsIndex = newThumbsIndex - slidesPerView + 1;
        }
        thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
      }
    }

    // Activate thumbs
    var thumbsToActivate = 1;
    var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

    if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
      thumbsToActivate = swiper.params.slidesPerView;
    }

    thumbsSwiper.slides.removeClass(thumbActiveClass);
    if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
      for (var i = 0; i < thumbsToActivate; i += 1) {
        thumbsSwiper.$wrapperEl.children('[data-swiper-slide-index="' + (swiper.realIndex + i) + '"]').addClass(thumbActiveClass);
      }
    } else {
      for (var _i12 = 0; _i12 < thumbsToActivate; _i12 += 1) {
        thumbsSwiper.slides.eq(swiper.realIndex + _i12).addClass(thumbActiveClass);
      }
    }
  }
};
var Thumbs$1 = {
  name: 'thumbs',
  params: {
    thumbs: {
      swiper: null,
      slideThumbActiveClass: 'swiper-slide-thumb-active',
      thumbsContainerClass: 'swiper-container-thumbs'
    }
  },
  create: function create() {
    var swiper = this;
    Utils.extend(swiper, {
      thumbs: {
        swiper: null,
        init: Thumbs.init.bind(swiper),
        update: Thumbs.update.bind(swiper),
        onThumbClick: Thumbs.onThumbClick.bind(swiper)
      }
    });
  },

  on: {
    beforeInit: function beforeInit() {
      var swiper = this;
      var thumbs = swiper.params.thumbs;

      if (!thumbs || !thumbs.swiper) return;
      swiper.thumbs.init();
      swiper.thumbs.update(true);
    },
    slideChange: function slideChange() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    update: function update() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    resize: function resize() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    observerUpdate: function observerUpdate() {
      var swiper = this;
      if (!swiper.thumbs.swiper) return;
      swiper.thumbs.update();
    },
    setTransition: function setTransition(duration) {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      thumbsSwiper.setTransition(duration);
    },
    beforeDestroy: function beforeDestroy() {
      var swiper = this;
      var thumbsSwiper = swiper.thumbs.swiper;
      if (!thumbsSwiper) return;
      if (swiper.thumbs.swiperCreated && thumbsSwiper) {
        thumbsSwiper.destroy();
      }
    }
  }
};

// Swiper Class

var components = [Device$1, Support$1, Browser$1, Resize, Observer$1, Virtual$1, Keyboard$1, Mousewheel$1, Navigation$1, Pagination$1, Scrollbar$1, Parallax$1, Zoom$1, Lazy$1, Controller$1, A11y, History$1, HashNavigation$1, Autoplay$1, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Thumbs$1];

if (typeof Swiper.use === 'undefined') {
  Swiper.use = Swiper.Class.use;
  Swiper.installModule = Swiper.Class.installModule;
}

Swiper.use(components);

exports.default = Swiper;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scroll = exports.resize = exports.touchmove = exports.touchend = exports.touchstart = exports.mouseover = exports.mouseout = exports.mouseleave = exports.mouseenter = exports.mouseup = exports.mousemove = exports.mousedown = exports.change = exports.submit = exports.keypress = exports.keydown = exports.keyup = exports.focusout = exports.focusin = exports.focus = exports.blur = exports.click = exports.stop = exports.animate = exports.scrollLeft = exports.scrollTop = exports.scrollTo = exports.empty = exports.add = exports.detach = exports.remove = exports.children = exports.find = exports.closest = exports.parents = exports.parent = exports.siblings = exports.prevAll = exports.prev = exports.nextAll = exports.next = exports.insertAfter = exports.insertBefore = exports.prependTo = exports.prepend = exports.appendTo = exports.append = exports.eq = exports.index = exports.indexOf = exports.is = exports.text = exports.html = exports.map = exports.filter = exports.forEach = exports.each = exports.toArray = exports.css = exports.styles = exports.show = exports.hide = exports.offset = exports.outerHeight = exports.height = exports.outerWidth = exports.width = exports.animationEnd = exports.transitionEnd = exports.trigger = exports.once = exports.off = exports.on = exports.transition = exports.transform = exports.val = exports.dataset = exports.removeData = exports.data = exports.prop = exports.removeAttr = exports.attr = exports.toggleClass = exports.hasClass = exports.removeClass = exports.addClass = exports.$ = undefined;

var _ssrWindow = __webpack_require__(34);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Dom7 2.1.5
                                                                                                                                                           * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
                                                                                                                                                           * http://framework7.io/docs/dom.html
                                                                                                                                                           *
                                                                                                                                                           * Copyright 2020, Vladimir Kharlampidi
                                                                                                                                                           * The iDangero.us
                                                                                                                                                           * http://www.idangero.us/
                                                                                                                                                           *
                                                                                                                                                           * Licensed under MIT
                                                                                                                                                           *
                                                                                                                                                           * Released on: May 15, 2020
                                                                                                                                                           */


var Dom7 = function Dom7(arr) {
  _classCallCheck(this, Dom7);

  var self = this;
  // Create array-like object
  for (var i = 0; i < arr.length; i += 1) {
    self[i] = arr[i];
  }
  self.length = arr.length;
  // Return collection with methods
  return this;
};

function $(selector, context) {
  var arr = [];
  var i = 0;
  if (selector && !context) {
    if (selector instanceof Dom7) {
      return selector;
    }
  }
  if (selector) {
    // String
    if (typeof selector === 'string') {
      var els = void 0;
      var tempParent = void 0;
      var _html = selector.trim();
      if (_html.indexOf('<') >= 0 && _html.indexOf('>') >= 0) {
        var toCreate = 'div';
        if (_html.indexOf('<li') === 0) toCreate = 'ul';
        if (_html.indexOf('<tr') === 0) toCreate = 'tbody';
        if (_html.indexOf('<td') === 0 || _html.indexOf('<th') === 0) toCreate = 'tr';
        if (_html.indexOf('<tbody') === 0) toCreate = 'table';
        if (_html.indexOf('<option') === 0) toCreate = 'select';
        tempParent = _ssrWindow.document.createElement(toCreate);
        tempParent.innerHTML = _html;
        for (i = 0; i < tempParent.childNodes.length; i += 1) {
          arr.push(tempParent.childNodes[i]);
        }
      } else {
        if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
          // Pure ID selector
          els = [_ssrWindow.document.getElementById(selector.trim().split('#')[1])];
        } else {
          // Other selectors
          els = (context || _ssrWindow.document).querySelectorAll(selector.trim());
        }
        for (i = 0; i < els.length; i += 1) {
          if (els[i]) arr.push(els[i]);
        }
      }
    } else if (selector.nodeType || selector === _ssrWindow.window || selector === _ssrWindow.document) {
      // Node/element
      arr.push(selector);
    } else if (selector.length > 0 && selector[0].nodeType) {
      // Array of elements or instance of Dom
      for (i = 0; i < selector.length; i += 1) {
        arr.push(selector[i]);
      }
    }
  }
  return new Dom7(arr);
}

$.fn = Dom7.prototype;
$.Class = Dom7;
$.Dom7 = Dom7;

function unique(arr) {
  var uniqueArray = [];
  for (var i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }
  return uniqueArray;
}
function toCamelCase(string) {
  return string.toLowerCase().replace(/-(.)/g, function (match, group1) {
    return group1.toUpperCase();
  });
}

function requestAnimationFrame(callback) {
  if (_ssrWindow.window.requestAnimationFrame) return _ssrWindow.window.requestAnimationFrame(callback);else if (_ssrWindow.window.webkitRequestAnimationFrame) return _ssrWindow.window.webkitRequestAnimationFrame(callback);
  return _ssrWindow.window.setTimeout(callback, 1000 / 60);
}
function cancelAnimationFrame(id) {
  if (_ssrWindow.window.cancelAnimationFrame) return _ssrWindow.window.cancelAnimationFrame(id);else if (_ssrWindow.window.webkitCancelAnimationFrame) return _ssrWindow.window.webkitCancelAnimationFrame(id);
  return _ssrWindow.window.clearTimeout(id);
}

// Classes and attributes
function addClass(className) {
  if (typeof className === 'undefined') {
    return this;
  }
  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.add(classes[i]);
    }
  }
  return this;
}
function removeClass(className) {
  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.remove(classes[i]);
    }
  }
  return this;
}
function hasClass(className) {
  if (!this[0]) return false;
  return this[0].classList.contains(className);
}
function toggleClass(className) {
  var classes = className.split(' ');
  for (var i = 0; i < classes.length; i += 1) {
    for (var j = 0; j < this.length; j += 1) {
      if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') this[j].classList.toggle(classes[i]);
    }
  }
  return this;
}
function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  }

  // Set attrs
  for (var i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      // eslint-disable-next-line
      for (var attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }
  return this;
}
// eslint-disable-next-line
function removeAttr(attr) {
  for (var i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }
  return this;
}
// eslint-disable-next-line
function prop(props, value) {
  if (arguments.length === 1 && typeof props === 'string') {
    // Get prop
    if (this[0]) return this[0][props];
  } else {
    // Set props
    for (var i = 0; i < this.length; i += 1) {
      if (arguments.length === 2) {
        // String
        this[i][props] = value;
      } else {
        // Object
        // eslint-disable-next-line
        for (var propName in props) {
          this[i][propName] = props[propName];
        }
      }
    }
    return this;
  }
}
function data(key, value) {
  var el = void 0;
  if (typeof value === 'undefined') {
    el = this[0];
    // Get value
    if (el) {
      if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
        return el.dom7ElementDataStorage[key];
      }

      var dataKey = el.getAttribute('data-' + key);
      if (dataKey) {
        return dataKey;
      }
      return undefined;
    }
    return undefined;
  }

  // Set value
  for (var i = 0; i < this.length; i += 1) {
    el = this[i];
    if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
    el.dom7ElementDataStorage[key] = value;
  }
  return this;
}
function removeData(key) {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
      el.dom7ElementDataStorage[key] = null;
      delete el.dom7ElementDataStorage[key];
    }
  }
}
function dataset() {
  var el = this[0];
  if (!el) return undefined;
  var dataset = {}; // eslint-disable-line
  if (el.dataset) {
    // eslint-disable-next-line
    for (var dataKey in el.dataset) {
      dataset[dataKey] = el.dataset[dataKey];
    }
  } else {
    for (var i = 0; i < el.attributes.length; i += 1) {
      // eslint-disable-next-line
      var _attr = el.attributes[i];
      if (_attr.name.indexOf('data-') >= 0) {
        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
      }
    }
  }
  // eslint-disable-next-line
  for (var key in dataset) {
    if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
  }
  return dataset;
}
function val(value) {
  var dom = this;
  if (typeof value === 'undefined') {
    if (dom[0]) {
      if (dom[0].multiple && dom[0].nodeName.toLowerCase() === 'select') {
        var values = [];
        for (var i = 0; i < dom[0].selectedOptions.length; i += 1) {
          values.push(dom[0].selectedOptions[i].value);
        }
        return values;
      }
      return dom[0].value;
    }
    return undefined;
  }

  for (var _i = 0; _i < dom.length; _i += 1) {
    var el = dom[_i];
    if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') {
      for (var j = 0; j < el.options.length; j += 1) {
        el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
      }
    } else {
      el.value = value;
    }
  }
  return dom;
}
// Transforms
// eslint-disable-next-line
function transform(transform) {
  for (var i = 0; i < this.length; i += 1) {
    var elStyle = this[i].style;
    elStyle.webkitTransform = transform;
    elStyle.transform = transform;
  }
  return this;
}
function transition(duration) {
  if (typeof duration !== 'string') {
    duration = duration + 'ms'; // eslint-disable-line
  }
  for (var i = 0; i < this.length; i += 1) {
    var elStyle = this[i].style;
    elStyle.webkitTransitionDuration = duration;
    elStyle.transitionDuration = duration;
  }
  return this;
}
// Events
function on() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];

    targetSelector = undefined;
  }
  if (!capture) capture = false;

  function handleLiveEvent(e) {
    var target = e.target;
    if (!target) return;
    var eventData = e.target.dom7EventData || [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      var _parents = $(target).parents(); // eslint-disable-line
      for (var k = 0; k < _parents.length; k += 1) {
        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
      }
    }
  }
  function handleEvent(e) {
    var eventData = e && e.target ? e.target.dom7EventData || [] : [];
    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }
    listener.apply(this, eventData);
  }
  var events = eventType.split(' ');
  var j = void 0;
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        var event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener: listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        var _event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];
        el.dom7LiveListeners[_event].push({
          listener: listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(_event, handleLiveEvent, capture);
      }
    }
  }
  return this;
}
function off() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var eventType = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventType = args[0];
    listener = args[1];
    capture = args[2];

    targetSelector = undefined;
  }
  if (!capture) capture = false;

  var events = eventType.split(' ');
  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];
    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var handlers = void 0;
      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }
      if (handlers && handlers.length) {
        for (var k = handlers.length - 1; k >= 0; k -= 1) {
          var handler = handlers[k];
          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }
  return this;
}
function once() {
  var dom = this;

  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var eventName = args[0],
      targetSelector = args[1],
      listener = args[2],
      capture = args[3];

  if (typeof args[1] === 'function') {
    eventName = args[0];
    listener = args[1];
    capture = args[2];

    targetSelector = undefined;
  }
  function onceHandler() {
    for (var _len4 = arguments.length, eventArgs = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      eventArgs[_key4] = arguments[_key4];
    }

    listener.apply(this, eventArgs);
    dom.off(eventName, targetSelector, onceHandler, capture);
    if (onceHandler.dom7proxy) {
      delete onceHandler.dom7proxy;
    }
  }
  onceHandler.dom7proxy = listener;
  return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger() {
  for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var events = args[0].split(' ');
  var eventData = args[1];
  for (var i = 0; i < events.length; i += 1) {
    var event = events[i];
    for (var j = 0; j < this.length; j += 1) {
      var el = this[j];
      var evt = void 0;
      try {
        evt = new _ssrWindow.window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
      } catch (e) {
        evt = _ssrWindow.document.createEvent('Event');
        evt.initEvent(event, true, true);
        evt.detail = eventData;
      }
      // eslint-disable-next-line
      el.dom7EventData = args.filter(function (data, dataIndex) {
        return dataIndex > 0;
      });
      el.dispatchEvent(evt);
      el.dom7EventData = [];
      delete el.dom7EventData;
    }
  }
  return this;
}
function transitionEnd(callback) {
  var events = ['webkitTransitionEnd', 'transitionend'];
  var dom = this;
  var i = void 0;
  function fireCallBack(e) {
    /* jshint validthis:true */
    if (e.target !== this) return;
    callback.call(this, e);
    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }
  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }
  return this;
}
function animationEnd(callback) {
  var events = ['webkitAnimationEnd', 'animationend'];
  var dom = this;
  var i = void 0;
  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    for (i = 0; i < events.length; i += 1) {
      dom.off(events[i], fireCallBack);
    }
  }
  if (callback) {
    for (i = 0; i < events.length; i += 1) {
      dom.on(events[i], fireCallBack);
    }
  }
  return this;
}
// Sizing/Styles
function width() {
  if (this[0] === _ssrWindow.window) {
    return _ssrWindow.window.innerWidth;
  }

  if (this.length > 0) {
    return parseFloat(this.css('width'));
  }

  return null;
}
function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      var _styles = this.styles();
      return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
    }
    return this[0].offsetWidth;
  }
  return null;
}
function height() {
  if (this[0] === _ssrWindow.window) {
    return _ssrWindow.window.innerHeight;
  }

  if (this.length > 0) {
    return parseFloat(this.css('height'));
  }

  return null;
}
function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      // eslint-disable-next-line
      var _styles2 = this.styles();
      return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
    }
    return this[0].offsetHeight;
  }
  return null;
}
function offset() {
  if (this.length > 0) {
    var el = this[0];
    var box = el.getBoundingClientRect();
    var body = _ssrWindow.document.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var _scrollTop = el === _ssrWindow.window ? _ssrWindow.window.scrollY : el.scrollTop;
    var _scrollLeft = el === _ssrWindow.window ? _ssrWindow.window.scrollX : el.scrollLeft;
    return {
      top: box.top + _scrollTop - clientTop,
      left: box.left + _scrollLeft - clientLeft
    };
  }

  return null;
}
function hide() {
  for (var i = 0; i < this.length; i += 1) {
    this[i].style.display = 'none';
  }
  return this;
}
function show() {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (el.style.display === 'none') {
      el.style.display = '';
    }
    if (_ssrWindow.window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
      // Still not visible
      el.style.display = 'block';
    }
  }
  return this;
}
function styles() {
  if (this[0]) return _ssrWindow.window.getComputedStyle(this[0], null);
  return {};
}
function css(props, value) {
  var i = void 0;
  if (arguments.length === 1) {
    if (typeof props === 'string') {
      if (this[0]) return _ssrWindow.window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      for (i = 0; i < this.length; i += 1) {
        // eslint-disable-next-line
        for (var _prop in props) {
          this[i].style[_prop] = props[_prop];
        }
      }
      return this;
    }
  }
  if (arguments.length === 2 && typeof props === 'string') {
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }
    return this;
  }
  return this;
}

// Dom manipulation
function toArray() {
  var arr = [];
  for (var i = 0; i < this.length; i += 1) {
    arr.push(this[i]);
  }
  return arr;
}
// Iterate over the collection passing elements to `callback`
function each(callback) {
  // Don't bother continuing without a callback
  if (!callback) return this;
  // Iterate over the current collection
  for (var i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this[i], i, this[i]) === false) {
      // End the loop early
      return this;
    }
  }
  // Return `this` to allow chained DOM operations
  return this;
}
function forEach(callback) {
  // Don't bother continuing without a callback
  if (!callback) return this;
  // Iterate over the current collection
  for (var i = 0; i < this.length; i += 1) {
    // If the callback returns false
    if (callback.call(this[i], this[i], i) === false) {
      // End the loop early
      return this;
    }
  }
  // Return `this` to allow chained DOM operations
  return this;
}
function filter(callback) {
  var matchedItems = [];
  var dom = this;
  for (var i = 0; i < dom.length; i += 1) {
    if (callback.call(dom[i], i, dom[i])) matchedItems.push(dom[i]);
  }
  return new Dom7(matchedItems);
}
function map(callback) {
  var modifiedItems = [];
  var dom = this;
  for (var i = 0; i < dom.length; i += 1) {
    modifiedItems.push(callback.call(dom[i], i, dom[i]));
  }
  return new Dom7(modifiedItems);
}
// eslint-disable-next-line
function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : undefined;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }
  return this;
}
// eslint-disable-next-line
function text(text) {
  if (typeof text === 'undefined') {
    if (this[0]) {
      return this[0].textContent.trim();
    }
    return null;
  }

  for (var i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }
  return this;
}
function is(selector) {
  var el = this[0];
  var compareWith = void 0;
  var i = void 0;
  if (!el || typeof selector === 'undefined') return false;
  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);else if (el.msMatchesSelector) return el.msMatchesSelector(selector);

    compareWith = $(selector);
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  } else if (selector === _ssrWindow.document) return el === _ssrWindow.document;else if (selector === _ssrWindow.window) return el === _ssrWindow.window;

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;
    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }
    return false;
  }
  return false;
}
function indexOf(el) {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i] === el) return i;
  }
  return -1;
}
function index() {
  var child = this[0];
  var i = void 0;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
// eslint-disable-next-line
function eq(index) {
  if (typeof index === 'undefined') return this;
  var length = this.length;
  var returnIndex = void 0;
  if (index > length - 1) {
    return new Dom7([]);
  }
  if (index < 0) {
    returnIndex = length + index;
    if (returnIndex < 0) return new Dom7([]);
    return new Dom7([this[returnIndex]]);
  }
  return new Dom7([this[index]]);
}
function append() {
  var newChild = void 0;

  for (var k = 0; k < arguments.length; k += 1) {
    newChild = arguments.length <= k ? undefined : arguments[k];
    for (var i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        var tempDiv = _ssrWindow.document.createElement('div');
        tempDiv.innerHTML = newChild;
        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (var j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}
// eslint-disable-next-line
function appendTo(parent) {
  $(parent).append(this);
  return this;
}
function prepend(newChild) {
  var i = void 0;
  var j = void 0;
  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      var tempDiv = _ssrWindow.document.createElement('div');
      tempDiv.innerHTML = newChild;
      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }
  return this;
}
// eslint-disable-next-line
function prependTo(parent) {
  $(parent).prepend(this);
  return this;
}
function insertBefore(selector) {
  var before = $(selector);
  for (var i = 0; i < this.length; i += 1) {
    if (before.length === 1) {
      before[0].parentNode.insertBefore(this[i], before[0]);
    } else if (before.length > 1) {
      for (var j = 0; j < before.length; j += 1) {
        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
      }
    }
  }
}
function insertAfter(selector) {
  var after = $(selector);
  for (var i = 0; i < this.length; i += 1) {
    if (after.length === 1) {
      after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
    } else if (after.length > 1) {
      for (var j = 0; j < after.length; j += 1) {
        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
      }
    }
  }
}
function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return new Dom7([this[0].nextElementSibling]);
      }
      return new Dom7([]);
    }

    if (this[0].nextElementSibling) return new Dom7([this[0].nextElementSibling]);
    return new Dom7([]);
  }
  return new Dom7([]);
}
function nextAll(selector) {
  var nextEls = [];
  var el = this[0];
  if (!el) return new Dom7([]);
  while (el.nextElementSibling) {
    var _next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if ($(_next).is(selector)) nextEls.push(_next);
    } else nextEls.push(_next);
    el = _next;
  }
  return new Dom7(nextEls);
}
function prev(selector) {
  if (this.length > 0) {
    var el = this[0];
    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return new Dom7([el.previousElementSibling]);
      }
      return new Dom7([]);
    }

    if (el.previousElementSibling) return new Dom7([el.previousElementSibling]);
    return new Dom7([]);
  }
  return new Dom7([]);
}
function prevAll(selector) {
  var prevEls = [];
  var el = this[0];
  if (!el) return new Dom7([]);
  while (el.previousElementSibling) {
    var _prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if ($(_prev).is(selector)) prevEls.push(_prev);
    } else prevEls.push(_prev);
    el = _prev;
  }
  return new Dom7(prevEls);
}
function siblings(selector) {
  return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
  var parents = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }
  return $(unique(parents));
}
function parents(selector) {
  var parents = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    var _parent = this[i].parentNode; // eslint-disable-line
    while (_parent) {
      if (selector) {
        if ($(_parent).is(selector)) parents.push(_parent);
      } else {
        parents.push(_parent);
      }
      _parent = _parent.parentNode;
    }
  }
  return $(unique(parents));
}
function closest(selector) {
  var closest = this; // eslint-disable-line
  if (typeof selector === 'undefined') {
    return new Dom7([]);
  }
  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }
  return closest;
}
function find(selector) {
  var foundElements = [];
  for (var i = 0; i < this.length; i += 1) {
    var found = this[i].querySelectorAll(selector);
    for (var j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }
  return new Dom7(foundElements);
}
function children(selector) {
  var children = []; // eslint-disable-line
  for (var i = 0; i < this.length; i += 1) {
    var childNodes = this[i].childNodes;

    for (var j = 0; j < childNodes.length; j += 1) {
      if (!selector) {
        if (childNodes[j].nodeType === 1) children.push(childNodes[j]);
      } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }
  return new Dom7(unique(children));
}
function remove() {
  for (var i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }
  return this;
}
function detach() {
  return this.remove();
}
function add() {
  var dom = this;
  var i = void 0;
  var j = void 0;

  for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  for (i = 0; i < args.length; i += 1) {
    var toAdd = $(args[i]);
    for (j = 0; j < toAdd.length; j += 1) {
      dom[dom.length] = toAdd[j];
      dom.length += 1;
    }
  }
  return dom;
}
function empty() {
  for (var i = 0; i < this.length; i += 1) {
    var el = this[i];
    if (el.nodeType === 1) {
      for (var j = 0; j < el.childNodes.length; j += 1) {
        if (el.childNodes[j].parentNode) {
          el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
        }
      }
      el.textContent = '';
    }
  }
  return this;
}

function scrollTo() {
  for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  var left = args[0],
      top = args[1],
      duration = args[2],
      easing = args[3],
      callback = args[4];

  if (args.length === 4 && typeof easing === 'function') {
    callback = easing;
    left = args[0];
    top = args[1];
    duration = args[2];
    callback = args[3];
    easing = args[4];
  }
  if (typeof easing === 'undefined') easing = 'swing';

  return this.each(function animate() {
    var el = this;
    var currentTop = void 0;
    var currentLeft = void 0;
    var maxTop = void 0;
    var maxLeft = void 0;
    var newTop = void 0;
    var newLeft = void 0;
    var scrollTop = void 0; // eslint-disable-line
    var scrollLeft = void 0; // eslint-disable-line
    var animateTop = top > 0 || top === 0;
    var animateLeft = left > 0 || left === 0;
    if (typeof easing === 'undefined') {
      easing = 'swing';
    }
    if (animateTop) {
      currentTop = el.scrollTop;
      if (!duration) {
        el.scrollTop = top;
      }
    }
    if (animateLeft) {
      currentLeft = el.scrollLeft;
      if (!duration) {
        el.scrollLeft = left;
      }
    }
    if (!duration) return;
    if (animateTop) {
      maxTop = el.scrollHeight - el.offsetHeight;
      newTop = Math.max(Math.min(top, maxTop), 0);
    }
    if (animateLeft) {
      maxLeft = el.scrollWidth - el.offsetWidth;
      newLeft = Math.max(Math.min(left, maxLeft), 0);
    }
    var startTime = null;
    if (animateTop && newTop === currentTop) animateTop = false;
    if (animateLeft && newLeft === currentLeft) animateLeft = false;
    function render() {
      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date().getTime();

      if (startTime === null) {
        startTime = time;
      }
      var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
      var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
      var done = void 0;
      if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
      if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
      if (animateTop && newTop > currentTop && scrollTop >= newTop) {
        el.scrollTop = newTop;
        done = true;
      }
      if (animateTop && newTop < currentTop && scrollTop <= newTop) {
        el.scrollTop = newTop;
        done = true;
      }
      if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }
      if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
        el.scrollLeft = newLeft;
        done = true;
      }

      if (done) {
        if (callback) callback();
        return;
      }
      if (animateTop) el.scrollTop = scrollTop;
      if (animateLeft) el.scrollLeft = scrollLeft;
      requestAnimationFrame(render);
    }
    requestAnimationFrame(render);
  });
}
// scrollTop(top, duration, easing, callback) {
function scrollTop() {
  for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }

  var top = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    top = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }
  var dom = this;
  if (typeof top === 'undefined') {
    if (dom.length > 0) return dom[0].scrollTop;
    return null;
  }
  return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft() {
  for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
    args[_key9] = arguments[_key9];
  }

  var left = args[0],
      duration = args[1],
      easing = args[2],
      callback = args[3];

  if (args.length === 3 && typeof easing === 'function') {
    left = args[0];
    duration = args[1];
    callback = args[2];
    easing = args[3];
  }
  var dom = this;
  if (typeof left === 'undefined') {
    if (dom.length > 0) return dom[0].scrollLeft;
    return null;
  }
  return dom.scrollTo(left, undefined, duration, easing, callback);
}

function animate(initialProps, initialParams) {
  var els = this;
  var a = {
    props: Object.assign({}, initialProps),
    params: Object.assign({
      duration: 300,
      easing: 'swing' // or 'linear'
      /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */
    }, initialParams),

    elements: els,
    animating: false,
    que: [],

    easingProgress: function easingProgress(easing, progress) {
      if (easing === 'swing') {
        return 0.5 - Math.cos(progress * Math.PI) / 2;
      }
      if (typeof easing === 'function') {
        return easing(progress);
      }
      return progress;
    },
    stop: function stop() {
      if (a.frameId) {
        cancelAnimationFrame(a.frameId);
      }
      a.animating = false;
      a.elements.each(function (index, el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      a.que = [];
    },
    done: function done(complete) {
      a.animating = false;
      a.elements.each(function (index, el) {
        var element = el;
        delete element.dom7AnimateInstance;
      });
      if (complete) complete(els);
      if (a.que.length > 0) {
        var que = a.que.shift();
        a.animate(que[0], que[1]);
      }
    },
    animate: function animate(props, params) {
      if (a.animating) {
        a.que.push([props, params]);
        return a;
      }
      var elements = [];

      // Define & Cache Initials & Units
      a.elements.each(function (index, el) {
        var initialFullValue = void 0;
        var initialValue = void 0;
        var unit = void 0;
        var finalValue = void 0;
        var finalFullValue = void 0;

        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;

        elements[index] = {
          container: el
        };
        Object.keys(props).forEach(function (prop) {
          initialFullValue = _ssrWindow.window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
          initialValue = parseFloat(initialFullValue);
          unit = initialFullValue.replace(initialValue, '');
          finalValue = parseFloat(props[prop]);
          finalFullValue = props[prop] + unit;
          elements[index][prop] = {
            initialFullValue: initialFullValue,
            initialValue: initialValue,
            unit: unit,
            finalValue: finalValue,
            finalFullValue: finalFullValue,
            currentValue: initialValue
          };
        });
      });

      var startTime = null;
      var time = void 0;
      var elementsDone = 0;
      var propsDone = 0;
      var done = void 0;
      var began = false;

      a.animating = true;

      function render() {
        time = new Date().getTime();
        var progress = void 0;
        var easeProgress = void 0;
        // let el;
        if (!began) {
          began = true;
          if (params.begin) params.begin(els);
        }
        if (startTime === null) {
          startTime = time;
        }
        if (params.progress) {
          // eslint-disable-next-line
          params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
        }

        elements.forEach(function (element) {
          var el = element;
          if (done || el.done) return;
          Object.keys(props).forEach(function (prop) {
            if (done || el.done) return;
            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
            easeProgress = a.easingProgress(params.easing, progress);
            var _el$prop = el[prop],
                initialValue = _el$prop.initialValue,
                finalValue = _el$prop.finalValue,
                unit = _el$prop.unit;

            el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
            var currentValue = el[prop].currentValue;

            if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
              el.container.style[prop] = finalValue + unit;
              propsDone += 1;
              if (propsDone === Object.keys(props).length) {
                el.done = true;
                elementsDone += 1;
              }
              if (elementsDone === elements.length) {
                done = true;
              }
            }
            if (done) {
              a.done(params.complete);
              return;
            }
            el.container.style[prop] = currentValue + unit;
          });
        });
        if (done) return;
        // Then call
        a.frameId = requestAnimationFrame(render);
      }
      a.frameId = requestAnimationFrame(render);
      return a;
    }
  };

  if (a.elements.length === 0) {
    return els;
  }

  var animateInstance = void 0;
  for (var i = 0; i < a.elements.length; i += 1) {
    if (a.elements[i].dom7AnimateInstance) {
      animateInstance = a.elements[i].dom7AnimateInstance;
    } else a.elements[i].dom7AnimateInstance = a;
  }
  if (!animateInstance) {
    animateInstance = a;
  }

  if (initialProps === 'stop') {
    animateInstance.stop();
  } else {
    animateInstance.animate(a.props, a.params);
  }

  return els;
}

function stop() {
  var els = this;
  for (var i = 0; i < els.length; i += 1) {
    if (els[i].dom7AnimateInstance) {
      els[i].dom7AnimateInstance.stop();
    }
  }
}

var noTrigger = 'resize scroll'.split(' ');
function eventShortcut(name) {
  for (var _len10 = arguments.length, args = Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
    args[_key10 - 1] = arguments[_key10];
  }

  if (typeof args[0] === 'undefined') {
    for (var i = 0; i < this.length; i += 1) {
      if (noTrigger.indexOf(name) < 0) {
        if (name in this[i]) this[i][name]();else {
          $(this[i]).trigger(name);
        }
      }
    }
    return this;
  }
  return this.on.apply(this, [name].concat(args));
}

function click() {
  for (var _len11 = arguments.length, args = Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    args[_key11] = arguments[_key11];
  }

  return eventShortcut.bind(this).apply(undefined, ['click'].concat(args));
}
function blur() {
  for (var _len12 = arguments.length, args = Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
    args[_key12] = arguments[_key12];
  }

  return eventShortcut.bind(this).apply(undefined, ['blur'].concat(args));
}
function focus() {
  for (var _len13 = arguments.length, args = Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
    args[_key13] = arguments[_key13];
  }

  return eventShortcut.bind(this).apply(undefined, ['focus'].concat(args));
}
function focusin() {
  for (var _len14 = arguments.length, args = Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
    args[_key14] = arguments[_key14];
  }

  return eventShortcut.bind(this).apply(undefined, ['focusin'].concat(args));
}
function focusout() {
  for (var _len15 = arguments.length, args = Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
    args[_key15] = arguments[_key15];
  }

  return eventShortcut.bind(this).apply(undefined, ['focusout'].concat(args));
}
function keyup() {
  for (var _len16 = arguments.length, args = Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
    args[_key16] = arguments[_key16];
  }

  return eventShortcut.bind(this).apply(undefined, ['keyup'].concat(args));
}
function keydown() {
  for (var _len17 = arguments.length, args = Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
    args[_key17] = arguments[_key17];
  }

  return eventShortcut.bind(this).apply(undefined, ['keydown'].concat(args));
}
function keypress() {
  for (var _len18 = arguments.length, args = Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
    args[_key18] = arguments[_key18];
  }

  return eventShortcut.bind(this).apply(undefined, ['keypress'].concat(args));
}
function submit() {
  for (var _len19 = arguments.length, args = Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
    args[_key19] = arguments[_key19];
  }

  return eventShortcut.bind(this).apply(undefined, ['submit'].concat(args));
}
function change() {
  for (var _len20 = arguments.length, args = Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
    args[_key20] = arguments[_key20];
  }

  return eventShortcut.bind(this).apply(undefined, ['change'].concat(args));
}
function mousedown() {
  for (var _len21 = arguments.length, args = Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
    args[_key21] = arguments[_key21];
  }

  return eventShortcut.bind(this).apply(undefined, ['mousedown'].concat(args));
}
function mousemove() {
  for (var _len22 = arguments.length, args = Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
    args[_key22] = arguments[_key22];
  }

  return eventShortcut.bind(this).apply(undefined, ['mousemove'].concat(args));
}
function mouseup() {
  for (var _len23 = arguments.length, args = Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
    args[_key23] = arguments[_key23];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseup'].concat(args));
}
function mouseenter() {
  for (var _len24 = arguments.length, args = Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
    args[_key24] = arguments[_key24];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseenter'].concat(args));
}
function mouseleave() {
  for (var _len25 = arguments.length, args = Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
    args[_key25] = arguments[_key25];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseleave'].concat(args));
}
function mouseout() {
  for (var _len26 = arguments.length, args = Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
    args[_key26] = arguments[_key26];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseout'].concat(args));
}
function mouseover() {
  for (var _len27 = arguments.length, args = Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
    args[_key27] = arguments[_key27];
  }

  return eventShortcut.bind(this).apply(undefined, ['mouseover'].concat(args));
}
function touchstart() {
  for (var _len28 = arguments.length, args = Array(_len28), _key28 = 0; _key28 < _len28; _key28++) {
    args[_key28] = arguments[_key28];
  }

  return eventShortcut.bind(this).apply(undefined, ['touchstart'].concat(args));
}
function touchend() {
  for (var _len29 = arguments.length, args = Array(_len29), _key29 = 0; _key29 < _len29; _key29++) {
    args[_key29] = arguments[_key29];
  }

  return eventShortcut.bind(this).apply(undefined, ['touchend'].concat(args));
}
function touchmove() {
  for (var _len30 = arguments.length, args = Array(_len30), _key30 = 0; _key30 < _len30; _key30++) {
    args[_key30] = arguments[_key30];
  }

  return eventShortcut.bind(this).apply(undefined, ['touchmove'].concat(args));
}
function resize() {
  for (var _len31 = arguments.length, args = Array(_len31), _key31 = 0; _key31 < _len31; _key31++) {
    args[_key31] = arguments[_key31];
  }

  return eventShortcut.bind(this).apply(undefined, ['resize'].concat(args));
}
function scroll() {
  for (var _len32 = arguments.length, args = Array(_len32), _key32 = 0; _key32 < _len32; _key32++) {
    args[_key32] = arguments[_key32];
  }

  return eventShortcut.bind(this).apply(undefined, ['scroll'].concat(args));
}

exports.$ = $;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.hasClass = hasClass;
exports.toggleClass = toggleClass;
exports.attr = attr;
exports.removeAttr = removeAttr;
exports.prop = prop;
exports.data = data;
exports.removeData = removeData;
exports.dataset = dataset;
exports.val = val;
exports.transform = transform;
exports.transition = transition;
exports.on = on;
exports.off = off;
exports.once = once;
exports.trigger = trigger;
exports.transitionEnd = transitionEnd;
exports.animationEnd = animationEnd;
exports.width = width;
exports.outerWidth = outerWidth;
exports.height = height;
exports.outerHeight = outerHeight;
exports.offset = offset;
exports.hide = hide;
exports.show = show;
exports.styles = styles;
exports.css = css;
exports.toArray = toArray;
exports.each = each;
exports.forEach = forEach;
exports.filter = filter;
exports.map = map;
exports.html = html;
exports.text = text;
exports.is = is;
exports.indexOf = indexOf;
exports.index = index;
exports.eq = eq;
exports.append = append;
exports.appendTo = appendTo;
exports.prepend = prepend;
exports.prependTo = prependTo;
exports.insertBefore = insertBefore;
exports.insertAfter = insertAfter;
exports.next = next;
exports.nextAll = nextAll;
exports.prev = prev;
exports.prevAll = prevAll;
exports.siblings = siblings;
exports.parent = parent;
exports.parents = parents;
exports.closest = closest;
exports.find = find;
exports.children = children;
exports.remove = remove;
exports.detach = detach;
exports.add = add;
exports.empty = empty;
exports.scrollTo = scrollTo;
exports.scrollTop = scrollTop;
exports.scrollLeft = scrollLeft;
exports.animate = animate;
exports.stop = stop;
exports.click = click;
exports.blur = blur;
exports.focus = focus;
exports.focusin = focusin;
exports.focusout = focusout;
exports.keyup = keyup;
exports.keydown = keydown;
exports.keypress = keypress;
exports.submit = submit;
exports.change = change;
exports.mousedown = mousedown;
exports.mousemove = mousemove;
exports.mouseup = mouseup;
exports.mouseenter = mouseenter;
exports.mouseleave = mouseleave;
exports.mouseout = mouseout;
exports.mouseover = mouseover;
exports.touchstart = touchstart;
exports.touchend = touchend;
exports.touchmove = touchmove;
exports.resize = resize;
exports.scroll = scroll;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * SSR Window 2.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: May 12, 2020
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
    return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function extend(target, src) {
    if (target === void 0) {
        target = {};
    }
    if (src === void 0) {
        src = {};
    }
    Object.keys(src).forEach(function (key) {
        if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
            extend(target[key], src[key]);
        }
    });
}

var doc = typeof document !== 'undefined' ? document : {};
var ssrDocument = {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
        blur: function blur() {},
        nodeName: ''
    },
    querySelector: function querySelector() {
        return null;
    },
    querySelectorAll: function querySelectorAll() {
        return [];
    },
    getElementById: function getElementById() {
        return null;
    },
    createEvent: function createEvent() {
        return {
            initEvent: function initEvent() {}
        };
    },
    createElement: function createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function setAttribute() {},
            getElementsByTagName: function getElementsByTagName() {
                return [];
            }
        };
    },
    createElementNS: function createElementNS() {
        return {};
    },
    importNode: function importNode() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
extend(doc, ssrDocument);

var win = typeof window !== 'undefined' ? window : {};
var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState: function replaceState() {},
        pushState: function pushState() {},
        go: function go() {},
        back: function back() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
        return {
            getPropertyValue: function getPropertyValue() {
                return '';
            }
        };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {},
    matchMedia: function matchMedia() {
        return {};
    }
};
extend(win, ssrWindow);

exports.document = doc;
exports.extend = extend;
exports.window = win;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * SSR Window 1.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2018, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: July 18, 2018
 */
var doc = typeof document === 'undefined' ? {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  activeElement: {
    blur: function blur() {},
    nodeName: ''
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  location: { hash: '' }
} : document; // eslint-disable-line

var win = typeof window === 'undefined' ? {
  document: doc,
  navigator: {
    userAgent: ''
  },
  location: {},
  history: {},
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return '';
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},
  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {}
} : window; // eslint-disable-line

exports.window = win;
exports.document = doc;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(37);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(7)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!./swiper.min.css", function() {
		var newContent = require("!!../../../css-loader/index.js!./swiper.min.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)(false);
// imports


// module
exports.push([module.i, "/**\n * Swiper 4.5.1\n * Most modern mobile touch slider and framework with hardware accelerated transitions\n * http://www.idangero.us/swiper/\n *\n * Copyright 2014-2019 Vladimir Kharlampidi\n *\n * Released under the MIT License\n *\n * Released on: September 13, 2019\n */\n.swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-container-no-flexbox .swiper-slide{float:left}.swiper-container-vertical>.swiper-wrapper{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;-o-transition-property:transform;transition-property:transform;transition-property:transform,-webkit-transform;-webkit-box-sizing:content-box;box-sizing:content-box}.swiper-container-android .swiper-slide,.swiper-wrapper{-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.swiper-container-multirow>.swiper-wrapper{-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}.swiper-container-free-mode>.swiper-wrapper{-webkit-transition-timing-function:ease-out;-o-transition-timing-function:ease-out;transition-timing-function:ease-out;margin:0 auto}.swiper-slide{-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;width:100%;height:100%;position:relative;-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;-o-transition-property:transform;transition-property:transform;transition-property:transform,-webkit-transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}.swiper-container-autoheight .swiper-wrapper{-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;align-items:flex-start;-webkit-transition-property:height,-webkit-transform;transition-property:height,-webkit-transform;-o-transition-property:transform,height;transition-property:transform,height;transition-property:transform,height,-webkit-transform}.swiper-container-3d{-webkit-perspective:1200px;perspective:1200px}.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper{-webkit-transform-style:preserve-3d;transform-style:preserve-3d}.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-container-3d .swiper-slide-shadow-left{background-image:-webkit-gradient(linear,right top,left top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,0)));background-image:-webkit-linear-gradient(right,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:-o-linear-gradient(right,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-right{background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,0)));background-image:-webkit-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:-o-linear-gradient(left,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-top{background-image:-webkit-gradient(linear,left bottom,left top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,0)));background-image:-webkit-linear-gradient(bottom,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:-o-linear-gradient(bottom,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-3d .swiper-slide-shadow-bottom{background-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.5)),to(rgba(0,0,0,0)));background-image:-webkit-linear-gradient(top,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:-o-linear-gradient(top,rgba(0,0,0,.5),rgba(0,0,0,0));background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-container-wp8-horizontal,.swiper-container-wp8-horizontal>.swiper-wrapper{-ms-touch-action:pan-y;touch-action:pan-y}.swiper-container-wp8-vertical,.swiper-container-wp8-vertical>.swiper-wrapper{-ms-touch-action:pan-x;touch-action:pan-x}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:27px;height:44px;margin-top:-22px;z-index:10;cursor:pointer;background-size:27px 44px;background-position:center;background-repeat:no-repeat}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-prev,.swiper-container-rtl .swiper-button-next{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");left:10px;right:auto}.swiper-button-next,.swiper-container-rtl .swiper-button-prev{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\");right:10px;left:auto}.swiper-button-prev.swiper-button-white,.swiper-container-rtl .swiper-button-next.swiper-button-white{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\")}.swiper-button-next.swiper-button-white,.swiper-container-rtl .swiper-button-prev.swiper-button-white{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E\")}.swiper-button-prev.swiper-button-black,.swiper-container-rtl .swiper-button-next.swiper-button-black{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\")}.swiper-button-next.swiper-button-black,.swiper-container-rtl .swiper-button-prev.swiper-button-black{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23000000'%2F%3E%3C%2Fsvg%3E\")}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;-webkit-transition:.3s opacity;-o-transition:.3s opacity;transition:.3s opacity;-webkit-transform:translate3d(0,0,0);transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{-webkit-transform:scale(.33);-ms-transform:scale(.33);transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{-webkit-transform:scale(.66);-ms-transform:scale(.66);transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{-webkit-transform:scale(.33);-ms-transform:scale(.33);transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{-webkit-transform:scale(.66);-ms-transform:scale(.66);transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{-webkit-transform:scale(.33);-ms-transform:scale(.33);transform:scale(.33)}.swiper-pagination-bullet{width:8px;height:8px;display:inline-block;border-radius:100%;background:#000;opacity:.2}button.swiper-pagination-bullet{border:none;margin:0;padding:0;-webkit-box-shadow:none;box-shadow:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet-active{opacity:1;background:#007aff}.swiper-container-vertical>.swiper-pagination-bullets{right:10px;top:50%;-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:6px 0;display:block}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);width:8px}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;-webkit-transition:.2s top,.2s -webkit-transform;transition:.2s top,.2s -webkit-transform;-o-transition:.2s transform,.2s top;transition:.2s transform,.2s top;transition:.2s transform,.2s top,.2s -webkit-transform}.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 4px}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);white-space:nowrap}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{-webkit-transition:.2s left,.2s -webkit-transform;transition:.2s left,.2s -webkit-transform;-o-transition:.2s transform,.2s left;transition:.2s transform,.2s left;transition:.2s transform,.2s left,.2s -webkit-transform}.swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{-webkit-transition:.2s right,.2s -webkit-transform;transition:.2s right,.2s -webkit-transform;-o-transition:.2s transform,.2s right;transition:.2s transform,.2s right;transition:.2s transform,.2s right,.2s -webkit-transform}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:#007aff;position:absolute;left:0;top:0;width:100%;height:100%;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);-webkit-transform-origin:left top;-ms-transform-origin:left top;transform-origin:left top}.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{-webkit-transform-origin:right top;-ms-transform-origin:right top;transform-origin:right top}.swiper-container-horizontal>.swiper-pagination-progressbar,.swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-container-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-container-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-white .swiper-pagination-bullet-active{background:#fff}.swiper-pagination-progressbar.swiper-pagination-white{background:rgba(255,255,255,.25)}.swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill{background:#fff}.swiper-pagination-black .swiper-pagination-bullet-active{background:#000}.swiper-pagination-progressbar.swiper-pagination-black{background:rgba(0,0,0,.25)}.swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill{background:#000}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.swiper-container-horizontal>.swiper-scrollbar{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.swiper-container-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;-webkit-transform-origin:50%;-ms-transform-origin:50%;transform-origin:50%;-webkit-animation:swiper-preloader-spin 1s steps(12,end) infinite;animation:swiper-preloader-spin 1s steps(12,end) infinite}.swiper-lazy-preloader:after{display:block;content:'';width:100%;height:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%236c6c6c'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\");background-position:50%;background-size:100%;background-repeat:no-repeat}.swiper-lazy-preloader-white:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%20120%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20xmlns%3Axlink%3D'http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink'%3E%3Cdefs%3E%3Cline%20id%3D'l'%20x1%3D'60'%20x2%3D'60'%20y1%3D'7'%20y2%3D'27'%20stroke%3D'%23fff'%20stroke-width%3D'11'%20stroke-linecap%3D'round'%2F%3E%3C%2Fdefs%3E%3Cg%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(30%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(60%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(90%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(120%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.27'%20transform%3D'rotate(150%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.37'%20transform%3D'rotate(180%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.46'%20transform%3D'rotate(210%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.56'%20transform%3D'rotate(240%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.66'%20transform%3D'rotate(270%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.75'%20transform%3D'rotate(300%2060%2C60)'%2F%3E%3Cuse%20xlink%3Ahref%3D'%23l'%20opacity%3D'.85'%20transform%3D'rotate(330%2060%2C60)'%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E\")}@-webkit-keyframes swiper-preloader-spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes swiper-preloader-spin{100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-container-fade.swiper-container-free-mode .swiper-slide{-webkit-transition-timing-function:ease-out;-o-transition-timing-function:ease-out;transition-timing-function:ease-out}.swiper-container-fade .swiper-slide{pointer-events:none;-webkit-transition-property:opacity;-o-transition-property:opacity;transition-property:opacity}.swiper-container-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube{overflow:visible}.swiper-container-cube .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;-webkit-transform-origin:0 0;-ms-transform-origin:0 0;transform-origin:0 0;width:100%;height:100%}.swiper-container-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-cube.swiper-container-rtl .swiper-slide{-webkit-transform-origin:100% 0;-ms-transform-origin:100% 0;transform-origin:100% 0}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-container-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0;width:100%;height:100%;background:#000;opacity:.6;-webkit-filter:blur(50px);filter:blur(50px);z-index:0}.swiper-container-flip{overflow:visible}.swiper-container-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-container-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-container-coverflow .swiper-wrapper{-ms-perspective:1200px}", ""]);

// exports


/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//背景圖滾差
var ParallaxBG = function () {
  function ParallaxBG() {
    _classCallCheck(this, ParallaxBG);

    this.duration = 0.2;
    this.bg1 = $('.pbgAnimate1');
    this.bg2 = $('.pbgAnimate2');
  }

  _createClass(ParallaxBG, [{
    key: 'actionBG',
    value: function actionBG(el) {
      var _this = this;

      $(window).on('scroll', function (e) {
        var $this = $(e.currentTarget);
        var position = el.offset().top - $this.scrollTop();
        var st = Math.round(position);
        el.css('backgroundPosition', 'center calc(50% + ' + st * _this.duration + 'px)');
      });
    }
  }, {
    key: 'parallax',
    value: function parallax() {
      this.actionBG(this.bg1);
      this.actionBG(this.bg2);
    }
  }]);

  return ParallaxBG;
}();

//輸出


exports.ParallaxBG = ParallaxBG;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRcode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


__webpack_require__(15);

var _body_ctrl = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//引入外部模組
var bodyCtrl = new _body_ctrl.BodyCtrl();

//QR Code

var QRcode = function () {
  function QRcode() {
    _classCallCheck(this, QRcode);

    //主體
    this.web = $('#qrcodeWeb .qrcode>i');
    this.nav = $('#rwdNav');
    this.navLB = $('#rwdLightbox');
    this.qrCodeBtn = this.nav.find('.qrcodeWeb');

    //業務個人
    this.personalId = $('#personalIdVal').val();
    this.personal = $('#qrcodePersonal .qrcode>i');

    //物件內頁
    this.url = location.href;
    this.realty = $('#qrcodeRealty .qrcode>i');
  }
  //主體


  _createClass(QRcode, [{
    key: 'webQRcode',
    value: function webQRcode() {
      var _this = this;

      this.web.qrcode({
        render: 'table',
        width: 240,
        height: 240,
        text: 'http://www.singfujia.com'
      });

      this.qrCodeBtn.on('click', function () {
        _this.nav.removeClass('active');
        _this.navLB.removeClass('active');
        bodyCtrl.ctrl('scrollShow'); //控制瀏覽器捲軸
        bodyCtrl.ctrl('scrollShowF'); //控制瀏覽器捲軸
      });
    }
    //物件內頁

  }, {
    key: 'realtyQRcode',
    value: function realtyQRcode() {

      this.realty.qrcode({
        render: 'table',
        width: 240,
        height: 240,
        text: this.url.toString()
      });
    }
    //業務個人

  }, {
    key: 'personalQRcode',
    value: function personalQRcode() {
      this.personal.qrcode({
        render: 'table',
        width: 240,
        height: 240,
        text: 'http://www.singfujia.com/?personal_id=' + this.personalId
      });
    }
  }]);

  return QRcode;
}();

//輸出


exports.QRcode = QRcode;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VR720 = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


__webpack_require__(43);

__webpack_require__(44);

var _common = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//VR 720
var VR720 = function () {
  function VR720() {
    _classCallCheck(this, VR720);

    this.document = $(document);
    this.vr = $('#vr720');
    this.data = this.vr.data('vr-json');
    this.view = 'VRView';
    this.vrBannerTitle = this.vr.find('.vrTitleBox');
    this.vrExperienceBtn = this.vrBannerTitle.find('.vrTitle button');
    this.controlBtns = this.vr.find('.controlBtns button');
    this.mapBox = this.vr.find('.vrMapBtns');
    this.mapBtnClose = this.mapBox.find('.header');
    this.mapBtns = this.mapBox.find('li button');
  }
  //VR 視圖


  _createClass(VR720, [{
    key: 'vrView',
    value: function vrView() {
      var _this = this;

      $.getJSON(this.data, function (json) {
        //控制項目
        //https://github.com/mpetroff/pannellum/blob/master/doc/json-config-parameters.md
        var vrData = {
          "default": {
            'type': 'equirectangular', //觀看模式
            'mouseZoom': 'fullscreenonly', //滑鼠滾輪放大縮小
            'showControls': false, //工具列(全螢幕 + 放大縮小)
            'autoLoad': false, //是否一開始載入圖片，無須點擊
            'autoRotate': 0, //自動旋轉
            'autoRotateInactivityDelay': 5000, //事件後再次自動選轉
            'compass': true, //開啟關閉指南針
            'firstScene': 'vr0', //一開始預設場景圖片
            'sceneFadeDuration': 1000, //切換圖片淡出淡入效果
            'orientationOnByDefault': false //開啟關閉陀螺儀
          },
          "scenes": {}
        };
        vrData.scenes = json;
        var viewer = pannellum.viewer(_this.view, vrData);

        //控制選項
        _this.controlBtns.each(function (i, e) {
          //全螢幕
          $(e).on('click', function () {
            if ($(e).is('.fullScreen')) {
              viewer.toggleFullscreen();
            }
          });
          document.addEventListener('fullscreenchange', function () {
            if (document.fullscreenElement) {
              if ($(e).is('.fullScreen')) {
                $(e).addClass('active');
              }
              _this.vrBannerTitle.addClass('active');
            } else {
              if ($(e).is('.fullScreen')) {
                $(e).removeClass('active');
              }
              _this.vrBannerTitle.removeClass('active');
            }
          });
          document.addEventListener('webkitfullscreenchange', function () {
            if (document.webkitFullscreenElement) {
              if ($(e).is('.fullScreen')) {
                $(e).addClass('active');
              }
              _this.vrBannerTitle.addClass('active');
            } else {
              if ($(e).is('.fullScreen')) {
                $(e).removeClass('active');
              }
              _this.vrBannerTitle.removeClass('active');
            }
          });
          document.addEventListener('mozfullscreenchange', function () {
            if (document.mozFullScreenElement) {
              if ($(e).is('.fullScreen')) {
                $(e).addClass('active');
              }
              _this.vrBannerTitle.addClass('active');
            } else {
              if ($(e).is('.fullScreen')) {
                $(e).removeClass('active');
              }
              _this.vrBannerTitle.removeClass('active');
            }
          });
          document.addEventListener('MSFullscreenChange', function () {
            if (document.msFullscreenElement) {
              if ($(e).is('.fullScreen')) {
                $(e).addClass('active');
              }
              _this.vrBannerTitle.addClass('active');
            } else {
              if ($(e).is('.fullScreen')) {
                $(e).removeClass('active');
              }
              _this.vrBannerTitle.removeClass('active');
            }
          });

          /*使用HTML5與原生JS方式執行
          const view = document.getElementById(this.view);
          //開啟全螢幕
          if(view.requestFullscreen) {
            view.requestFullscreen();
          }else if(view.webkitRequestFullscreen){
            view.webkitRequestFullscreen();
          }else if(view.mozRequestFullScreen){
            view.mozRequestFullScreen();
          }else if(view.msRequestFullscreen){
            view.msRequestFullscreen();
          }
          //關閉全螢幕
          if(document.fullscreenElement){
            document.exitFullscreen();
          }else if(document.webkitFullscreenElement){
            document.webkitExitFullscreen();
          }else if(document.mozFullScreenElement){
            document.mozCancelFullScreen();
          }else if(document.msFullscreenElement){
            document.msExitFullscreen();
          }
          */

          //判斷行動裝置，是否隱藏顯示
          if (_common.checkDevice.ios || _common.checkDevice.android) {
            $(e).on('click', function () {
              if ($(e).is('.zoomIn')) {
                //Animation true開啟，陀螺儀縮放失效，需false關掉才可以做縮放。
                viewer.setHfov(viewer.getHfov() - 10, false);
              } else if ($(e).is('.zoomOut')) {
                //Animation true開啟，陀螺儀縮放失效，需false關掉才可以做縮放。
                viewer.setHfov(viewer.getHfov() + 10, false);
              } else if ($(e).is('.experience')) {
                $(e).toggleClass('active');
                if ($(e).is('.active')) {
                  //開啟陀螺儀
                  viewer.startOrientation();
                } else {
                  //關閉陀螺儀
                  viewer.stopOrientation();
                }
              }
            });
            //顯示陀螺儀按鈕
            if ($(e).is('.experience')) {
              $(e).parent().show();
            }
            //組件未支援陀螺儀模式可滑動螢幕，會直接關閉陀螺儀模式變為一般模式，以下為追加
            viewer.on('touchstart', function () {
              if ($(e).is('.experience')) {
                $(e).removeClass('active');
                viewer.stopOrientation();
              }
            });
            //立即體驗
            _this.vrExperienceBtn.on('click', function () {
              _this.vrBannerTitle.addClass('active');
            });
          } else {
            $(e).on('click', function () {
              if ($(e).is('.zoomIn')) {
                viewer.setHfov(viewer.getHfov() - 10);
              } else if ($(e).is('.zoomOut')) {
                viewer.setHfov(viewer.getHfov() + 10);
              }
            });
            //隱藏陀螺儀按鈕
            if ($(e).is('.experience')) {
              $(e).parent().hide();
            }
            //立即體驗
            _this.vrExperienceBtn.on('click', function () {
              if ($(e).is('.fullScreen')) {
                $(e).toggleClass('active');
                viewer.toggleFullscreen();
              }
            });
          }
          //iOS裝置隱藏全螢幕(iOS不支援全螢幕)
          if (_common.checkDevice.ios) {
            if ($(e).is('.fullScreen')) {
              $(e).parent().hide();
            }
          }
        });
        //Tabs 按鈕切換
        _this.mapBtns.each(function (i, e) {
          $(e).on('click', function () {
            _this.mapBtns.removeClass('active');
            $(e).addClass('active');
            viewer.loadScene('vr' + i);
            _this.mapBox.removeClass('active');
          });
        });
        //Tabs 按鈕切換 (Hot Spots)
        viewer.on('load', function () {
          _this.mapBtns.each(function (i, e) {
            if (viewer.getScene() == 'vr' + i) {
              _this.mapBtns.removeClass('active');
              $(e).addClass('active');
            }
          });
        });
      });
    }
    //VR 按鈕地圖

  }, {
    key: 'vrMap',
    value: function vrMap() {
      var _this2 = this;

      //開啟
      this.controlBtns.on('click', function (e) {
        var $this = $(e.currentTarget);
        if ($this.is('.map')) {
          _this2.mapBox.addClass('active');
        }
      });
      //關閉
      this.mapBtnClose.on('click', function () {
        _this2.mapBox.removeClass('active');
      });
    }
    //整合

  }, {
    key: 'vr720',
    value: function vr720() {
      this.vrView();
      this.vrMap();
    }
  }]);

  return VR720;
}();

//輸出


exports.VR720 = VR720;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Pannellum 2.5.6, https://github.com/mpetroff/pannellum
window.libpannellum = function (E, g, p) {
  function Ba(K) {
    function ja(a, e) {
      return 1 == a.level && 1 != e.level ? -1 : 1 == e.level && 1 != a.level ? 1 : e.timestamp - a.timestamp;
    }function Q(a, e) {
      return a.level != e.level ? a.level - e.level : a.diff - e.diff;
    }function ka(a, e, c, g, l, h) {
      this.vertices = a;this.side = e;this.level = c;this.x = g;this.y = l;this.path = h.replace("%s", e).replace("%l", c).replace("%x", g).replace("%y", l);
    }function Ja(a, e, g, p, l) {
      var h;var d = e.vertices;h = la(a, d.slice(0, 3));var u = la(a, d.slice(3, 6)),
          x = la(a, d.slice(6, 9)),
          d = la(a, d.slice(9, 12)),
          t = h[0] + u[0] + x[0] + d[0];-4 == t || 4 == t ? h = !1 : (t = h[1] + u[1] + x[1] + d[1], h = -4 == t || 4 == t ? !1 : 4 != h[2] + u[2] + x[2] + d[2]);if (h) {
        h = e.vertices;u = h[0] + h[3] + h[6] + h[9];x = h[1] + h[4] + h[7] + h[10];d = h[2] + h[5] + h[8] + h[11];t = Math.sqrt(u * u + x * x + d * d);d = Math.asin(d / t);u = Math.atan2(x, u) - p;u += u > Math.PI ? -2 * Math.PI : u < -Math.PI ? 2 * Math.PI : 0;u = Math.abs(u);e.diff = Math.acos(Math.sin(g) * Math.sin(d) + Math.cos(g) * Math.cos(d) * Math.cos(u));u = !1;for (x = 0; x < c.nodeCache.length; x++) {
          if (c.nodeCache[x].path == e.path) {
            u = !0;c.nodeCache[x].timestamp = c.nodeCacheTimestamp++;
            c.nodeCache[x].diff = e.diff;c.currentNodes.push(c.nodeCache[x]);break;
          }
        }u || (e.timestamp = c.nodeCacheTimestamp++, c.currentNodes.push(e), c.nodeCache.push(e));if (e.level < c.level) {
          var d = m.cubeResolution * Math.pow(2, e.level - m.maxLevel),
              u = Math.ceil(d * m.invTileResolution) - 1,
              x = d % m.tileResolution * 2,
              k = 2 * d % m.tileResolution;0 === k && (k = m.tileResolution);0 === x && (x = 2 * m.tileResolution);t = 0.5;if (e.x == u || e.y == u) t = 1 - m.tileResolution / (m.tileResolution + k);var y = 1 - t,
              d = [],
              s = t,
              z = t,
              D = t,
              I = y,
              A = y,
              B = y;if (k < m.tileResolution) if (e.x == u && e.y != u) {
            if (A = z = 0.5, "d" == e.side || "u" == e.side) B = D = 0.5;
          } else e.x != u && e.y == u && (I = s = 0.5, "l" == e.side || "r" == e.side) && (B = D = 0.5);x <= m.tileResolution && (e.x == u && (s = 0, I = 1, "l" == e.side || "r" == e.side) && (D = 0, B = 1), e.y == u && (z = 0, A = 1, "d" == e.side || "u" == e.side) && (D = 0, B = 1));k = [h[0], h[1], h[2], h[0] * s + h[3] * I, h[1] * t + h[4] * y, h[2] * D + h[5] * B, h[0] * s + h[6] * I, h[1] * z + h[7] * A, h[2] * D + h[8] * B, h[0] * t + h[9] * y, h[1] * z + h[10] * A, h[2] * D + h[11] * B];k = new ka(k, e.side, e.level + 1, 2 * e.x, 2 * e.y, m.fullpath);d.push(k);e.x == u && x <= m.tileResolution || (k = [h[0] * s + h[3] * I, h[1] * t + h[4] * y, h[2] * D + h[5] * B, h[3], h[4], h[5], h[3] * t + h[6] * y, h[4] * z + h[7] * A, h[5] * D + h[8] * B, h[0] * s + h[6] * I, h[1] * z + h[7] * A, h[2] * D + h[8] * B], k = new ka(k, e.side, e.level + 1, 2 * e.x + 1, 2 * e.y, m.fullpath), d.push(k));e.x == u && x <= m.tileResolution || e.y == u && x <= m.tileResolution || (k = [h[0] * s + h[6] * I, h[1] * z + h[7] * A, h[2] * D + h[8] * B, h[3] * t + h[6] * y, h[4] * z + h[7] * A, h[5] * D + h[8] * B, h[6], h[7], h[8], h[9] * s + h[6] * I, h[10] * t + h[7] * y, h[11] * D + h[8] * B], k = new ka(k, e.side, e.level + 1, 2 * e.x + 1, 2 * e.y + 1, m.fullpath), d.push(k));e.y == u && x <= m.tileResolution || (k = [h[0] * t + h[9] * y, h[1] * z + h[10] * A, h[2] * D + h[11] * B, h[0] * s + h[6] * I, h[1] * z + h[7] * A, h[2] * D + h[8] * B, h[9] * s + h[6] * I, h[10] * t + h[7] * y, h[11] * D + h[8] * B, h[9], h[10], h[11]], k = new ka(k, e.side, e.level + 1, 2 * e.x, 2 * e.y + 1, m.fullpath), d.push(k));for (e = 0; e < d.length; e++) {
            Ja(a, d[e], g, p, l);
          }
        }
      }
    }function ta() {
      return [-1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, -1, 1, 1, 1, 1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1, 1, 1, -1, 1, 1, 1, 1, -1, 1, 1, -1, -1];
    }function ua(a, e, c) {
      var g = Math.sin(e);e = Math.cos(e);
      if ("x" == c) return [a[0], e * a[1] + g * a[2], e * a[2] - g * a[1], a[3], e * a[4] + g * a[5], e * a[5] - g * a[4], a[6], e * a[7] + g * a[8], e * a[8] - g * a[7]];if ("y" == c) return [e * a[0] - g * a[2], a[1], e * a[2] + g * a[0], e * a[3] - g * a[5], a[4], e * a[5] + g * a[3], e * a[6] - g * a[8], a[7], e * a[8] + g * a[6]];if ("z" == c) return [e * a[0] + g * a[1], e * a[1] - g * a[0], a[2], e * a[3] + g * a[4], e * a[4] - g * a[3], a[5], e * a[6] + g * a[7], e * a[7] - g * a[6], a[8]];
    }function ma(a) {
      return [a[0], a[4], a[8], a[12], a[1], a[5], a[9], a[13], a[2], a[6], a[10], a[14], a[3], a[7], a[11], a[15]];
    }function Ka(a) {
      La(a, a.path + "." + m.extension, function (e, c) {
        a.texture = e;a.textureLoaded = c ? 2 : 1;
      }, va.crossOrigin);
    }function la(a, e) {
      var c = [a[0] * e[0] + a[1] * e[1] + a[2] * e[2], a[4] * e[0] + a[5] * e[1] + a[6] * e[2], a[11] + a[8] * e[0] + a[9] * e[1] + a[10] * e[2], 1 / (a[12] * e[0] + a[13] * e[1] + a[14] * e[2])],
          g = c[0] * c[3],
          l = c[1] * c[3],
          c = c[2] * c[3],
          h = [0, 0, 0];-1 > g && (h[0] = -1);1 < g && (h[0] = 1);-1 > l && (h[1] = -1);1 < l && (h[1] = 1);if (-1 > c || 1 < c) h[2] = 1;return h;
    }function Ea() {
      console.log("Reducing canvas size due to error 1286!");A.width = Math.round(A.width / 2);A.height = Math.round(A.height / 2);
    }var A = g.createElement("canvas");
    A.style.width = A.style.height = "100%";K.appendChild(A);var c, a, U, V, $, R, wa, ga, m, z, F, ca, Fa, Y, na, va;this.init = function (L, e, Ca, H, l, h, d, u) {
      function x(a) {
        if (E) {
          var e = a * a * 4,
              h = new Uint8ClampedArray(e),
              c = u.backgroundColor ? u.backgroundColor : [0, 0, 0];c[0] *= 255;c[1] *= 255;c[2] *= 255;for (var b = 0; b < e; b++) {
            h[b++] = c[0], h[b++] = c[1], h[b++] = c[2];
          }a = new ImageData(h, a, a);for (t = 0; 6 > t; t++) {
            0 == m[t].width && (m[t] = a);
          }
        }
      }e === p && (e = "equirectangular");if ("equirectangular" != e && "cubemap" != e && "multires" != e) throw console.log("Error: invalid image type specified!"), { type: "config error" };z = e;m = L;F = Ca;va = u || {};if (c) {
        U && (a.detachShader(c, U), a.deleteShader(U));V && (a.detachShader(c, V), a.deleteShader(V));a.bindBuffer(a.ARRAY_BUFFER, null);a.bindBuffer(a.ELEMENT_ARRAY_BUFFER, null);c.texture && a.deleteTexture(c.texture);if (c.nodeCache) for (L = 0; L < c.nodeCache.length; L++) {
          a.deleteTexture(c.nodeCache[L].texture);
        }a.deleteProgram(c);c = p;
      }ga = p;var t,
          E = !1,
          y;if ("cubemap" == z) for (t = 0; 6 > t; t++) {
        0 < m[t].width ? (y === p && (y = m[t].width), y != m[t].width && console.log("Cube faces have inconsistent widths: " + y + " vs. " + m[t].width)) : E = !0;
      }"cubemap" == z && 0 !== (y & y - 1) && (navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 8_/) || navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 9_/) || navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 10_/) || navigator.userAgent.match(/Trident.*rv[ :]*11\./)) || (a || (a = A.getContext("experimental-webgl", { alpha: !1, depth: !1 })), a && 1286 == a.getError() && Ea());if (!a && ("multires" == z && m.hasOwnProperty("fallbackPath") || "cubemap" == z) && ("WebkitAppearance" in g.documentElement.style || navigator.userAgent.match(/Trident.*rv[ :]*11\./) || -1 !== navigator.appVersion.indexOf("MSIE 10"))) {
        R && K.removeChild(R);R = g.createElement("div");R.className = "pnlm-world";H = m.basePath ? m.basePath + m.fallbackPath : m.fallbackPath;var Q = "frblud".split(""),
            S = 0;l = function l() {
          var a = g.createElement("canvas");a.className = "pnlm-face pnlm-" + Q[this.side] + "face";R.appendChild(a);var e = a.getContext("2d");a.style.width = this.width + 4 + "px";a.style.height = this.height + 4 + "px";a.width = this.width + 4;a.height = this.height + 4;e.drawImage(this, 2, 2);var h = e.getImageData(0, 0, a.width, a.height),
              c = h.data,
              b,
              d;for (b = 2; b < a.width - 2; b++) {
            for (d = 0; 4 > d; d++) {
              c[4 * (b + a.width) + d] = c[4 * (b + 2 * a.width) + d], c[4 * (b + a.width * (a.height - 2)) + d] = c[4 * (b + a.width * (a.height - 3)) + d];
            }
          }for (b = 2; b < a.height - 2; b++) {
            for (d = 0; 4 > d; d++) {
              c[4 * (b * a.width + 1) + d] = c[4 * (b * a.width + 2) + d], c[4 * ((b + 1) * a.width - 2) + d] = c[4 * ((b + 1) * a.width - 3) + d];
            }
          }for (d = 0; 4 > d; d++) {
            c[4 * (a.width + 1) + d] = c[4 * (2 * a.width + 2) + d], c[4 * (2 * a.width - 2) + d] = c[4 * (3 * a.width - 3) + d], c[4 * (a.width * (a.height - 2) + 1) + d] = c[4 * (a.width * (a.height - 3) + 2) + d], c[4 * (a.width * (a.height - 1) - 2) + d] = c[4 * (a.width * (a.height - 2) - 3) + d];
          }for (b = 1; b < a.width - 1; b++) {
            for (d = 0; 4 > d; d++) {
              c[4 * b + d] = c[4 * (b + a.width) + d], c[4 * (b + a.width * (a.height - 1)) + d] = c[4 * (b + a.width * (a.height - 2)) + d];
            }
          }for (b = 1; b < a.height - 1; b++) {
            for (d = 0; 4 > d; d++) {
              c[b * a.width * 4 + d] = c[4 * (b * a.width + 1) + d], c[4 * ((b + 1) * a.width - 1) + d] = c[4 * ((b + 1) * a.width - 2) + d];
            }
          }for (d = 0; 4 > d; d++) {
            c[d] = c[4 * (a.width + 1) + d], c[4 * (a.width - 1) + d] = c[4 * (2 * a.width - 2) + d], c[a.width * (a.height - 1) * 4 + d] = c[4 * (a.width * (a.height - 2) + 1) + d], c[4 * (a.width * a.height - 1) + d] = c[4 * (a.width * (a.height - 1) - 2) + d];
          }e.putImageData(h, 0, 0);D.call(this);
        };var D = function D() {
          0 < this.width ? ($ === p && ($ = this.width), $ != this.width && console.log("Fallback faces have inconsistent widths: " + $ + " vs. " + this.width)) : E = !0;S++;6 == S && ($ = this.width, K.appendChild(R), d());
        },
            E = !1;for (t = 0; 6 > t; t++) {
          h = new Image(), h.crossOrigin = va.crossOrigin ? va.crossOrigin : "anonymous", h.side = t, h.onload = l, h.onerror = D, h.src = "multires" == z ? H.replace("%s", Q[t]) + "." + m.extension : m[t].src;
        }x($);
      } else {
        if (!a) throw console.log("Error: no WebGL support detected!"), { type: "no webgl" };"cubemap" == z && x(y);m.fullpath = m.basePath ? m.basePath + m.path : m.path;m.invTileResolution = 1 / m.tileResolution;L = ta();wa = [];for (t = 0; 6 > t; t++) {
          wa[t] = L.slice(12 * t, 12 * t + 12), L = ta();
        }L = 0;if ("equirectangular" == z) {
          if (L = a.getParameter(a.MAX_TEXTURE_SIZE), Math.max(m.width / 2, m.height) > L) throw console.log("Error: The image is too big; it's " + m.width + "px wide, but this device's maximum supported size is " + 2 * L + "px."), { type: "webgl size error", width: m.width, maxWidth: 2 * L };
        } else if ("cubemap" == z && y > a.getParameter(a.MAX_CUBE_MAP_TEXTURE_SIZE)) throw console.log("Error: The image is too big; it's " + y + "px wide, but this device's maximum supported size is " + L + "px."), { type: "webgl size error", width: y, maxWidth: L };u === p || u.horizonPitch === p && u.horizonRoll === p || (ga = [u.horizonPitch == p ? 0 : u.horizonPitch, u.horizonRoll == p ? 0 : u.horizonRoll]);y = a.TEXTURE_2D;a.viewport(0, 0, a.drawingBufferWidth, a.drawingBufferHeight);a.getShaderPrecisionFormat && (e = a.getShaderPrecisionFormat(a.FRAGMENT_SHADER, a.HIGH_FLOAT)) && 1 > e.precision && (oa = oa.replace("highp", "mediump"));U = a.createShader(a.VERTEX_SHADER);e = s;"multires" == z && (e = k);a.shaderSource(U, e);a.compileShader(U);V = a.createShader(a.FRAGMENT_SHADER);e = pa;"cubemap" == z ? (y = a.TEXTURE_CUBE_MAP, e = qa) : "multires" == z && (e = bb);a.shaderSource(V, e);a.compileShader(V);c = a.createProgram();a.attachShader(c, U);a.attachShader(c, V);a.linkProgram(c);a.getShaderParameter(U, a.COMPILE_STATUS) || console.log(a.getShaderInfoLog(U));a.getShaderParameter(V, a.COMPILE_STATUS) || console.log(a.getShaderInfoLog(V));a.getProgramParameter(c, a.LINK_STATUS) || console.log(a.getProgramInfoLog(c));a.useProgram(c);
        c.drawInProgress = !1;e = u.backgroundColor ? u.backgroundColor : [0, 0, 0];a.clearColor(e[0], e[1], e[2], 1);a.clear(a.COLOR_BUFFER_BIT);c.texCoordLocation = a.getAttribLocation(c, "a_texCoord");a.enableVertexAttribArray(c.texCoordLocation);"multires" != z ? (ca || (ca = a.createBuffer()), a.bindBuffer(a.ARRAY_BUFFER, ca), a.bufferData(a.ARRAY_BUFFER, new Float32Array([-1, 1, 1, 1, 1, -1, -1, 1, 1, -1, -1, -1]), a.STATIC_DRAW), a.vertexAttribPointer(c.texCoordLocation, 2, a.FLOAT, !1, 0, 0), c.aspectRatio = a.getUniformLocation(c, "u_aspectRatio"), a.uniform1f(c.aspectRatio, a.drawingBufferWidth / a.drawingBufferHeight), c.psi = a.getUniformLocation(c, "u_psi"), c.theta = a.getUniformLocation(c, "u_theta"), c.f = a.getUniformLocation(c, "u_f"), c.h = a.getUniformLocation(c, "u_h"), c.v = a.getUniformLocation(c, "u_v"), c.vo = a.getUniformLocation(c, "u_vo"), c.rot = a.getUniformLocation(c, "u_rot"), a.uniform1f(c.h, H / (2 * Math.PI)), a.uniform1f(c.v, l / Math.PI), a.uniform1f(c.vo, h / Math.PI * 2), "equirectangular" == z && (c.backgroundColor = a.getUniformLocation(c, "u_backgroundColor"), a.uniform4fv(c.backgroundColor, e.concat([1]))), c.texture = a.createTexture(), a.bindTexture(y, c.texture), "cubemap" == z ? (a.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_X, 0, a.RGB, a.RGB, a.UNSIGNED_BYTE, m[1]), a.texImage2D(a.TEXTURE_CUBE_MAP_NEGATIVE_X, 0, a.RGB, a.RGB, a.UNSIGNED_BYTE, m[3]), a.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_Y, 0, a.RGB, a.RGB, a.UNSIGNED_BYTE, m[4]), a.texImage2D(a.TEXTURE_CUBE_MAP_NEGATIVE_Y, 0, a.RGB, a.RGB, a.UNSIGNED_BYTE, m[5]), a.texImage2D(a.TEXTURE_CUBE_MAP_POSITIVE_Z, 0, a.RGB, a.RGB, a.UNSIGNED_BYTE, m[0]), a.texImage2D(a.TEXTURE_CUBE_MAP_NEGATIVE_Z, 0, a.RGB, a.RGB, a.UNSIGNED_BYTE, m[2])) : m.width <= L ? (a.uniform1i(a.getUniformLocation(c, "u_splitImage"), 0), a.texImage2D(y, 0, a.RGB, a.RGB, a.UNSIGNED_BYTE, m)) : (a.uniform1i(a.getUniformLocation(c, "u_splitImage"), 1), H = g.createElement("canvas"), H.width = m.width / 2, H.height = m.height, H = H.getContext("2d"), H.drawImage(m, 0, 0), l = H.getImageData(0, 0, m.width / 2, m.height), a.texImage2D(y, 0, a.RGB, a.RGB, a.UNSIGNED_BYTE, l), c.texture2 = a.createTexture(), a.activeTexture(a.TEXTURE1), a.bindTexture(y, c.texture2), a.uniform1i(a.getUniformLocation(c, "u_image1"), 1), H.drawImage(m, -m.width / 2, 0), l = H.getImageData(0, 0, m.width / 2, m.height), a.texImage2D(y, 0, a.RGB, a.RGB, a.UNSIGNED_BYTE, l), a.texParameteri(y, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE), a.texParameteri(y, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE), a.texParameteri(y, a.TEXTURE_MIN_FILTER, a.LINEAR), a.texParameteri(y, a.TEXTURE_MAG_FILTER, a.LINEAR), a.activeTexture(a.TEXTURE0)), a.texParameteri(y, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE), a.texParameteri(y, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE), a.texParameteri(y, a.TEXTURE_MIN_FILTER, a.LINEAR), a.texParameteri(y, a.TEXTURE_MAG_FILTER, a.LINEAR)) : (c.vertPosLocation = a.getAttribLocation(c, "a_vertCoord"), a.enableVertexAttribArray(c.vertPosLocation), Fa || (Fa = a.createBuffer()), Y || (Y = a.createBuffer()), na || (na = a.createBuffer()), a.bindBuffer(a.ARRAY_BUFFER, Y), a.bufferData(a.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]), a.STATIC_DRAW), a.bindBuffer(a.ELEMENT_ARRAY_BUFFER, na), a.bufferData(a.ELEMENT_ARRAY_BUFFER, new Uint16Array([0, 1, 2, 0, 2, 3]), a.STATIC_DRAW), c.perspUniform = a.getUniformLocation(c, "u_perspMatrix"), c.cubeUniform = a.getUniformLocation(c, "u_cubeMatrix"), c.level = -1, c.currentNodes = [], c.nodeCache = [], c.nodeCacheTimestamp = 0);H = a.getError();if (0 !== H) throw console.log("Error: Something went wrong with WebGL!", H), { type: "webgl error" };d();
      }
    };this.destroy = function () {
      K !== p && (A !== p && K.contains(A) && K.removeChild(A), R !== p && K.contains(R) && K.removeChild(R));if (a) {
        var c = a.getExtension("WEBGL_lose_context");c && c.loseContext();
      }
    };this.resize = function () {
      var g = E.devicePixelRatio || 1;A.width = A.clientWidth * g;A.height = A.clientHeight * g;a && (1286 == a.getError() && Ea(), a.viewport(0, 0, a.drawingBufferWidth, a.drawingBufferHeight), "multires" != z && a.uniform1f(c.aspectRatio, A.clientWidth / A.clientHeight));
    };this.resize();this.setPose = function (a, c) {
      ga = [a, c];
    };this.render = function (g, e, k, s) {
      var l,
          h = 0;s === p && (s = {});s.roll && (h = s.roll);if (ga !== p) {
        l = ga[0];var d = ga[1],
            u = g,
            x = e,
            t = Math.cos(d) * Math.sin(g) * Math.sin(l) + Math.cos(g) * (Math.cos(l) * Math.cos(e) + Math.sin(d) * Math.sin(l) * Math.sin(e)),
            E = -Math.sin(g) * Math.sin(d) + Math.cos(g) * Math.cos(d) * Math.sin(e);g = Math.cos(d) * Math.cos(l) * Math.sin(g) + Math.cos(g) * (-Math.cos(e) * Math.sin(l) + Math.cos(l) * Math.sin(d) * Math.sin(e));g = Math.asin(Math.max(Math.min(g, 1), -1));e = Math.atan2(E, t);l = [Math.cos(u) * (Math.sin(d) * Math.sin(l) * Math.cos(x) - Math.cos(l) * Math.sin(x)), Math.cos(u) * Math.cos(d) * Math.cos(x), Math.cos(u) * (Math.cos(l) * Math.sin(d) * Math.cos(x) + Math.sin(x) * Math.sin(l))];d = [-Math.cos(g) * Math.sin(e), Math.cos(g) * Math.cos(e)];d = Math.acos(Math.max(Math.min((l[0] * d[0] + l[1] * d[1]) / (Math.sqrt(l[0] * l[0] + l[1] * l[1] + l[2] * l[2]) * Math.sqrt(d[0] * d[0] + d[1] * d[1])), 1), -1));0 > l[2] && (d = 2 * Math.PI - d);h += d;
      }if (a || "multires" != z && "cubemap" != z) {
        if ("multires" != z) k = 2 * Math.atan(Math.tan(0.5 * k) / (a.drawingBufferWidth / a.drawingBufferHeight)), k = 1 / Math.tan(0.5 * k), a.uniform1f(c.psi, e), a.uniform1f(c.theta, g), a.uniform1f(c.rot, h), a.uniform1f(c.f, k), !0 === F && "equirectangular" == z && (a.bindTexture(a.TEXTURE_2D, c.texture), a.texImage2D(a.TEXTURE_2D, 0, a.RGB, a.RGB, a.UNSIGNED_BYTE, m)), a.drawArrays(a.TRIANGLES, 0, 6);else {
          l = a.drawingBufferWidth / a.drawingBufferHeight;d = 2 * Math.atan(Math.tan(k / 2) * a.drawingBufferHeight / a.drawingBufferWidth);d = 1 / Math.tan(d / 2);l = [d / l, 0, 0, 0, 0, d, 0, 0, 0, 0, 100.1 / -99.9, 20 / -99.9, 0, 0, -1, 0];for (d = 1; d < m.maxLevel && a.drawingBufferWidth > m.tileResolution * Math.pow(2, d - 1) * Math.tan(k / 2) * 0.707;) {
            d++;
          }c.level = d;d = [1, 0, 0, 0, 1, 0, 0, 0, 1];d = ua(d, -h, "z");d = ua(d, -g, "x");d = ua(d, e, "y");d = [d[0], d[1], d[2], 0, d[3], d[4], d[5], 0, d[6], d[7], d[8], 0, 0, 0, 0, 1];a.uniformMatrix4fv(c.perspUniform, !1, new Float32Array(ma(l)));a.uniformMatrix4fv(c.cubeUniform, !1, new Float32Array(ma(d)));h = [l[0] * d[0], l[0] * d[1], l[0] * d[2], 0, l[5] * d[4], l[5] * d[5], l[5] * d[6], 0, l[10] * d[8], l[10] * d[9], l[10] * d[10], l[11], -d[8], -d[9], -d[10], 0];c.nodeCache.sort(ja);if (200 < c.nodeCache.length && c.nodeCache.length > c.currentNodes.length + 50) for (l = c.nodeCache.splice(200, c.nodeCache.length - 200), d = 0; d < l.length; d++) {
            a.deleteTexture(l[d].texture);
          }c.currentNodes = [];d = "fbudlr".split("");for (l = 0; 6 > l; l++) {
            u = new ka(wa[l], d[l], 1, 0, 0, m.fullpath), Ja(h, u, g, e, k);
          }c.currentNodes.sort(Q);for (g = S.length - 1; 0 <= g; g--) {
            -1 === c.currentNodes.indexOf(S[g].node) && (S[g].node.textureLoad = !1, S.splice(g, 1));
          }if (0 === S.length) for (g = 0; g < c.currentNodes.length; g++) {
            if (e = c.currentNodes[g], !e.texture && !e.textureLoad) {
              e.textureLoad = !0;setTimeout(Ka, 0, e);break;
            }
          }if (!c.drawInProgress) {
            c.drawInProgress = !0;a.clear(a.COLOR_BUFFER_BIT);for (g = 0; g < c.currentNodes.length; g++) {
              1 < c.currentNodes[g].textureLoaded && (a.bindBuffer(a.ARRAY_BUFFER, Fa), a.bufferData(a.ARRAY_BUFFER, new Float32Array(c.currentNodes[g].vertices), a.STATIC_DRAW), a.vertexAttribPointer(c.vertPosLocation, 3, a.FLOAT, !1, 0, 0), a.bindBuffer(a.ARRAY_BUFFER, Y), a.vertexAttribPointer(c.texCoordLocation, 2, a.FLOAT, !1, 0, 0), a.bindTexture(a.TEXTURE_2D, c.currentNodes[g].texture), a.drawElements(a.TRIANGLES, 6, a.UNSIGNED_SHORT, 0));
            }c.drawInProgress = !1;
          }
        }if (s.returnImage !== p) return A.toDataURL("image/png");
      } else for (l = $ / 2, s = { f: "translate3d(-" + (l + 2) + "px, -" + (l + 2) + "px, -" + l + "px)", b: "translate3d(" + (l + 2) + "px, -" + (l + 2) + "px, " + l + "px) rotateX(180deg) rotateZ(180deg)", u: "translate3d(-" + (l + 2) + "px, -" + l + "px, " + (l + 2) + "px) rotateX(270deg)",
        d: "translate3d(-" + (l + 2) + "px, " + l + "px, -" + (l + 2) + "px) rotateX(90deg)", l: "translate3d(-" + l + "px, -" + (l + 2) + "px, " + (l + 2) + "px) rotateX(180deg) rotateY(90deg) rotateZ(180deg)", r: "translate3d(" + l + "px, -" + (l + 2) + "px, -" + (l + 2) + "px) rotateY(270deg)" }, k = 1 / Math.tan(k / 2), k = k * A.clientWidth / 2 + "px", e = "perspective(" + k + ") translateZ(" + k + ") rotateX(" + g + "rad) rotateY(" + e + "rad) ", k = Object.keys(s), g = 0; 6 > g; g++) {
        if (h = R.querySelector(".pnlm-" + k[g] + "face")) h.style.webkitTransform = e + s[k[g]], h.style.transform = e + s[k[g]];
      }
    };this.isLoading = function () {
      if (a && "multires" == z) for (var g = 0; g < c.currentNodes.length; g++) {
        if (!c.currentNodes[g].textureLoaded) return !0;
      }return !1;
    };this.getCanvas = function () {
      return A;
    };var S = [],
        La = function () {
      function c() {
        var d = this;this.texture = this.callback = null;this.image = new Image();this.image.crossOrigin = l ? l : "anonymous";var e = function e() {
          if (0 < d.image.width && 0 < d.image.height) {
            var c = d.image;a.bindTexture(a.TEXTURE_2D, d.texture);a.texImage2D(a.TEXTURE_2D, 0, a.RGB, a.RGB, a.UNSIGNED_BYTE, c);a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, a.LINEAR);a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.LINEAR);a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE);a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE);a.bindTexture(a.TEXTURE_2D, null);d.callback(d.texture, !0);
          } else d.callback(d.texture, !1);S.length ? (c = S.shift(), d.loadTexture(c.src, c.texture, c.callback)) : k[g++] = d;
        };this.image.addEventListener("load", e);this.image.addEventListener("error", e);
      }function e(a, c, e, g) {
        this.node = a;this.src = c;this.texture = e;this.callback = g;
      }var g = 4,
          k = {},
          l;c.prototype.loadTexture = function (a, c, e) {
        this.texture = c;this.callback = e;this.image.src = a;
      };for (var h = 0; h < g; h++) {
        k[h] = new c();
      }return function (c, h, m, p) {
        l = p;p = a.createTexture();g ? k[--g].loadTexture(h, p, m) : S.push(new e(c, h, p, m));return p;
      };
    }();
  }var s = "attribute vec2 a_texCoord;varying vec2 v_texCoord;void main() {gl_Position = vec4(a_texCoord, 0.0, 1.0);v_texCoord = a_texCoord;}",
      k = "attribute vec3 a_vertCoord;attribute vec2 a_texCoord;uniform mat4 u_cubeMatrix;uniform mat4 u_perspMatrix;varying mediump vec2 v_texCoord;void main(void) {gl_Position = u_perspMatrix * u_cubeMatrix * vec4(a_vertCoord, 1.0);v_texCoord = a_texCoord;}",
      oa = "precision highp float;\nuniform float u_aspectRatio;\nuniform float u_psi;\nuniform float u_theta;\nuniform float u_f;\nuniform float u_h;\nuniform float u_v;\nuniform float u_vo;\nuniform float u_rot;\nconst float PI = 3.14159265358979323846264;\nuniform sampler2D u_image0;\nuniform sampler2D u_image1;\nuniform bool u_splitImage;\nuniform samplerCube u_imageCube;\nvarying vec2 v_texCoord;\nuniform vec4 u_backgroundColor;\nvoid main() {\nfloat x = v_texCoord.x * u_aspectRatio;\nfloat y = v_texCoord.y;\nfloat sinrot = sin(u_rot);\nfloat cosrot = cos(u_rot);\nfloat rot_x = x * cosrot - y * sinrot;\nfloat rot_y = x * sinrot + y * cosrot;\nfloat sintheta = sin(u_theta);\nfloat costheta = cos(u_theta);\nfloat a = u_f * costheta - rot_y * sintheta;\nfloat root = sqrt(rot_x * rot_x + a * a);\nfloat lambda = atan(rot_x / root, a / root) + u_psi;\nfloat phi = atan((rot_y * costheta + u_f * sintheta) / root);",
      qa = oa + "float cosphi = cos(phi);\ngl_FragColor = textureCube(u_imageCube, vec3(cosphi*sin(lambda), sin(phi), cosphi*cos(lambda)));\n}",
      pa = oa + "lambda = mod(lambda + PI, PI * 2.0) - PI;\nvec2 coord = vec2(lambda / PI, phi / (PI / 2.0));\nif(coord.x < -u_h || coord.x > u_h || coord.y < -u_v + u_vo || coord.y > u_v + u_vo)\ngl_FragColor = u_backgroundColor;\nelse {\nif(u_splitImage) {\nif(coord.x < 0.0)\ngl_FragColor = texture2D(u_image0, vec2((coord.x + u_h) / u_h, (-coord.y + u_v + u_vo) / (u_v * 2.0)));\nelse\ngl_FragColor = texture2D(u_image1, vec2((coord.x + u_h) / u_h - 1.0, (-coord.y + u_v + u_vo) / (u_v * 2.0)));\n} else {\ngl_FragColor = texture2D(u_image0, vec2((coord.x + u_h) / (u_h * 2.0), (-coord.y + u_v + u_vo) / (u_v * 2.0)));\n}\n}\n}",
      bb = "varying mediump vec2 v_texCoord;uniform sampler2D u_sampler;void main(void) {gl_FragColor = texture2D(u_sampler, v_texCoord);}";return { renderer: function renderer(g, k, p, s) {
      return new Ba(g, k, p, s);
    } };
}(window, document);
window.pannellum = function (E, g, p) {
  function Ba(s, k) {
    function oa() {
      var a = g.createElement("div");a.innerHTML = "\x3c!--[if lte IE 9]><i></i><![endif]--\x3e";if (1 == a.getElementsByTagName("i").length) K();else {
        ra = b.hfov;Ga = b.pitch;var f;if ("cubemap" == b.type) {
          P = [];for (a = 0; 6 > a; a++) {
            P.push(new Image()), P[a].crossOrigin = b.crossOrigin;
          }q.load.lbox.style.display = "block";q.load.lbar.style.display = "none";
        } else if ("multires" == b.type) a = JSON.parse(JSON.stringify(b.multiRes)), b.basePath && b.multiRes.basePath && !/^(?:[a-z]+:)?\/\//i.test(b.multiRes.basePath) ? a.basePath = b.basePath + b.multiRes.basePath : b.multiRes.basePath ? a.basePath = b.multiRes.basePath : b.basePath && (a.basePath = b.basePath), P = a;else if (!0 === b.dynamic) P = b.panorama;else {
          if (b.panorama === p) {
            K(b.strings.noPanoramaError);return;
          }P = new Image();
        }if ("cubemap" == b.type) for (var n = 6, c = function c() {
          n--;0 === n && pa();
        }, d = function d(a) {
          var ea = g.createElement("a");ea.href = a.target.src;ea.textContent = ea.href;K(b.strings.fileAccessError.replace("%s", ea.outerHTML));
        }, a = 0; a < P.length; a++) {
          f = b.cubeMap[a], "null" == f ? (console.log("Will use background instead of missing cubemap face " + a), c()) : (b.basePath && !qa(f) && (f = b.basePath + f), P[a].onload = c, P[a].onerror = d, P[a].src = I(f));
        } else if ("multires" == b.type) pa();else if (f = "", b.basePath && (f = b.basePath), !0 !== b.dynamic) {
          f = qa(b.panorama) ? b.panorama : f + b.panorama;P.onload = function () {
            E.URL.revokeObjectURL(this.src);pa();
          };var e = new XMLHttpRequest();e.onloadend = function () {
            if (200 != e.status) {
              var a = g.createElement("a");a.href = f;a.textContent = a.href;K(b.strings.fileAccessError.replace("%s", a.outerHTML));
            }Ba(this.response);q.load.msg.innerHTML = "";
          };e.onprogress = function (a) {
            if (a.lengthComputable) {
              q.load.lbarFill.style.width = a.loaded / a.total * 100 + "%";var b, ea;1E6 < a.total ? (b = "MB", ea = (a.loaded / 1E6).toFixed(2), a = (a.total / 1E6).toFixed(2)) : 1E3 < a.total ? (b = "kB", ea = (a.loaded / 1E3).toFixed(1), a = (a.total / 1E3).toFixed(1)) : (b = "B", ea = a.loaded, a = a.total);q.load.msg.innerHTML = ea + " / " + a + " " + b;
            } else q.load.lbox.style.display = "block", q.load.lbar.style.display = "none";
          };try {
            e.open("GET", f, !0);
          } catch (h) {
            K(b.strings.malformedURLError);
          }e.responseType = "blob";e.setRequestHeader("Accept", "image/*,*/*;q=0.9");e.withCredentials = "use-credentials" === b.crossOrigin;e.send();
        }b.draggable && J.classList.add("pnlm-grab");J.classList.remove("pnlm-grabbing");Ma = !0 === b.dynamicUpdate;b.dynamic && Ma && (P = b.panorama, pa());
      }
    }function qa(a) {
      return (/^(?:[a-z]+:)?\/\//i.test(a) || "/" == a[0] || "blob:" == a.slice(0, 5)
      );
    }function pa() {
      C || (C = new libpannellum.renderer(M));Sa || (Sa = !0, W.addEventListener("mousedown", ka, !1), g.addEventListener("mousemove", ua, !1), g.addEventListener("mouseup", ma, !1), b.mouseZoom && (J.addEventListener("mousewheel", U, !1), J.addEventListener("DOMMouseScroll", U, !1)), b.doubleClickZoom && W.addEventListener("dblclick", Ja, !1), s.addEventListener("mozfullscreenchange", d, !1), s.addEventListener("webkitfullscreenchange", d, !1), s.addEventListener("msfullscreenchange", d, !1), s.addEventListener("fullscreenchange", d, !1), E.addEventListener("resize", z, !1), E.addEventListener("orientationchange", z, !1), b.disableKeyboardCtrl || (s.addEventListener("keydown", V, !1), s.addEventListener("keyup", R, !1), s.addEventListener("blur", $, !1)), g.addEventListener("mouseleave", ma, !1), "" === g.documentElement.style.pointerAction && "" === g.documentElement.style.touchAction ? (W.addEventListener("pointerdown", A, !1), W.addEventListener("pointermove", c, !1), W.addEventListener("pointerup", a, !1), W.addEventListener("pointerleave", a, !1)) : (W.addEventListener("touchstart", Ka, !1), W.addEventListener("touchmove", la, !1), W.addEventListener("touchend", Ea, !1)), E.navigator.pointerEnabled && (s.style.touchAction = "none"));va();x(b.hfov);setTimeout(function () {}, 500);
    }function Ba(a) {
      var f = new FileReader();
      f.addEventListener("loadend", function () {
        var n = f.result;if (navigator.userAgent.toLowerCase().match(/(iphone|ipod|ipad).* os 8_/)) {
          var c = n.indexOf("\xFF\xC2");(0 > c || 65536 < c) && K(b.strings.iOS8WebGLError);
        }c = n.indexOf("<x:xmpmeta");if (-1 < c && !0 !== b.ignoreGPanoXMP) {
          var d = n.substring(c, n.indexOf("</x:xmpmeta>") + 12),
              e = function e(a) {
            var b;0 <= d.indexOf(a + '="') ? (b = d.substring(d.indexOf(a + '="') + a.length + 2), b = b.substring(0, b.indexOf('"'))) : 0 <= d.indexOf(a + ">") && (b = d.substring(d.indexOf(a + ">") + a.length + 1), b = b.substring(0, b.indexOf("<")));return b !== p ? Number(b) : null;
          },
              n = e("GPano:FullPanoWidthPixels"),
              c = e("GPano:CroppedAreaImageWidthPixels"),
              g = e("GPano:FullPanoHeightPixels"),
              h = e("GPano:CroppedAreaImageHeightPixels"),
              l = e("GPano:CroppedAreaTopPixels"),
              k = e("GPano:PoseHeadingDegrees"),
              m = e("GPano:PosePitchDegrees"),
              e = e("GPano:PoseRollDegrees");null !== n && null !== c && null !== g && null !== h && null !== l && (0 > aa.indexOf("haov") && (b.haov = c / n * 360), 0 > aa.indexOf("vaov") && (b.vaov = h / g * 180), 0 > aa.indexOf("vOffset") && (b.vOffset = -180 * ((l + h / 2) / g - 0.5)), null !== k && 0 > aa.indexOf("northOffset") && (b.northOffset = k, !1 !== b.compass && (b.compass = !0)), null !== m && null !== e && (0 > aa.indexOf("horizonPitch") && (b.horizonPitch = m), 0 > aa.indexOf("horizonRoll") && (b.horizonRoll = e)));
        }P.src = E.URL.createObjectURL(a);
      });f.readAsBinaryString !== p ? f.readAsBinaryString(a) : f.readAsText(a);
    }function K(a) {
      a === p && (a = b.strings.genericWebGLError);q.errorMsg.innerHTML = "<p>" + a + "</p>";v.load.style.display = "none";q.load.box.style.display = "none";q.errorMsg.style.display = "table";Na = !0;G = p;M.style.display = "none";B("error", a);
    }function ja(a) {
      var b = Q(a);fa.style.left = b.x + "px";fa.style.top = b.y + "px";clearTimeout(ja.t1);clearTimeout(ja.t2);fa.style.display = "block";fa.style.opacity = 1;ja.t1 = setTimeout(function () {
        fa.style.opacity = 0;
      }, 2E3);ja.t2 = setTimeout(function () {
        fa.style.display = "none";
      }, 2500);a.preventDefault();
    }function Q(a) {
      var b = s.getBoundingClientRect(),
          n = {};n.x = (a.clientX || a.pageX) - b.left;n.y = (a.clientY || a.pageY) - b.top;return n;
    }function ka(a) {
      a.preventDefault();s.focus();if (G && b.draggable) {
        var f = Q(a);if (b.hotSpotDebug) {
          var n = ta(a);console.log("Pitch: " + n[0] + ", Yaw: " + n[1] + ", Center Pitch: " + b.pitch + ", Center Yaw: " + b.yaw + ", HFOV: " + b.hfov);
        }t();Da();b.roll = 0;w.hfov = 0;ha = !0;N = Date.now();xa = f.x;ya = f.y;Oa = b.yaw;Pa = b.pitch;J.classList.add("pnlm-grabbing");J.classList.remove("pnlm-grab");B("mousedown", a);F();
      }
    }function Ja(a) {
      b.minHfov === b.hfov ? da.setHfov(ra, 1E3) : (a = ta(a), da.lookAt(a[0], a[1], b.minHfov, 1E3));
    }function ta(a) {
      var f = Q(a);a = C.getCanvas();var n = a.clientWidth,
          c = a.clientHeight;a = f.x / n * 2 - 1;var c = (1 - f.y / c * 2) * c / n,
          e = 1 / Math.tan(b.hfov * Math.PI / 360),
          d = Math.sin(b.pitch * Math.PI / 180),
          g = Math.cos(b.pitch * Math.PI / 180),
          f = e * g - c * d,
          n = Math.sqrt(a * a + f * f),
          c = 180 * Math.atan((c * g + e * d) / n) / Math.PI;a = 180 * Math.atan2(a / n, f / n) / Math.PI + b.yaw;-180 > a && (a += 360);180 < a && (a -= 360);return [c, a];
    }function ua(a) {
      if (ha && G) {
        N = Date.now();var f = C.getCanvas(),
            n = f.clientWidth,
            f = f.clientHeight;a = Q(a);var c = 180 * (Math.atan(xa / n * 2 - 1) - Math.atan(a.x / n * 2 - 1)) / Math.PI * b.hfov / 90 + Oa;w.yaw = (c - b.yaw) % 360 * 0.2;b.yaw = c;n = 360 * Math.atan(Math.tan(b.hfov / 360 * Math.PI) * f / n) / Math.PI;n = 180 * (Math.atan(a.y / f * 2 - 1) - Math.atan(ya / f * 2 - 1)) / Math.PI * n / 90 + Pa;w.pitch = 0.2 * (n - b.pitch);b.pitch = n;
      }
    }function ma(a) {
      ha && (ha = !1, 15 < Date.now() - N && (w.pitch = w.yaw = 0), J.classList.add("pnlm-grab"), J.classList.remove("pnlm-grabbing"), N = Date.now(), B("mouseup", a));
    }function Ka(a) {
      if (G && b.draggable) {
        t();Da();b.roll = 0;w.hfov = 0;var f = Q(a.targetTouches[0]);xa = f.x;ya = f.y;if (2 == a.targetTouches.length) {
          var n = Q(a.targetTouches[1]);xa += 0.5 * (n.x - f.x);ya += 0.5 * (n.y - f.y);Ha = Math.sqrt((f.x - n.x) * (f.x - n.x) + (f.y - n.y) * (f.y - n.y));
        }ha = !0;N = Date.now();Oa = b.yaw;Pa = b.pitch;B("touchstart", a);F();
      }
    }function la(a) {
      if (b.draggable && (a.preventDefault(), G && (N = Date.now()), ha && G)) {
        var f = Q(a.targetTouches[0]),
            n = f.x,
            c = f.y;2 == a.targetTouches.length && -1 != Ha && (a = Q(a.targetTouches[1]), n += 0.5 * (a.x - f.x), c += 0.5 * (a.y - f.y), f = Math.sqrt((f.x - a.x) * (f.x - a.x) + (f.y - a.y) * (f.y - a.y)), x(b.hfov + 0.1 * (Ha - f)), Ha = f);f = b.hfov / 360 * b.touchPanSpeedCoeffFactor;n = (xa - n) * f + Oa;w.yaw = (n - b.yaw) % 360 * 0.2;b.yaw = n;c = (c - ya) * f + Pa;w.pitch = 0.2 * (c - b.pitch);
        b.pitch = c;
      }
    }function Ea() {
      ha = !1;150 < Date.now() - N && (w.pitch = w.yaw = 0);Ha = -1;N = Date.now();B("touchend", event);
    }function A(a) {
      "touch" == a.pointerType && G && b.draggable && (ia.push(a.pointerId), za.push({ clientX: a.clientX, clientY: a.clientY }), a.targetTouches = za, Ka(a), a.preventDefault());
    }function c(a) {
      if ("touch" == a.pointerType && b.draggable) for (var f = 0; f < ia.length; f++) {
        if (a.pointerId == ia[f]) {
          za[f].clientX = a.clientX;za[f].clientY = a.clientY;a.targetTouches = za;la(a);a.preventDefault();break;
        }
      }
    }function a(a) {
      if ("touch" == a.pointerType) {
        for (var b = !1, n = 0; n < ia.length; n++) {
          a.pointerId == ia[n] && (ia[n] = p), ia[n] && (b = !0);
        }b || (ia = [], za = [], Ea());a.preventDefault();
      }
    }function U(a) {
      G && ("fullscreenonly" != b.mouseZoom || Aa) && (a.preventDefault(), t(), N = Date.now(), a.wheelDeltaY ? (x(b.hfov - 0.05 * a.wheelDeltaY), w.hfov = 0 > a.wheelDelta ? 1 : -1) : a.wheelDelta ? (x(b.hfov - 0.05 * a.wheelDelta), w.hfov = 0 > a.wheelDelta ? 1 : -1) : a.detail && (x(b.hfov + 1.5 * a.detail), w.hfov = 0 < a.detail ? 1 : -1), F());
    }function V(a) {
      t();N = Date.now();Da();b.roll = 0;var f = a.which || a.keycode;0 > b.capturedKeyNumbers.indexOf(f) || (a.preventDefault(), 27 == f ? Aa && h() : wa(f, !0));
    }function $() {
      for (var a = 0; 10 > a; a++) {
        r[a] = !1;
      }
    }function R(a) {
      var f = a.which || a.keycode;0 > b.capturedKeyNumbers.indexOf(f) || (a.preventDefault(), wa(f, !1));
    }function wa(a, b) {
      var n = !1;switch (a) {case 109:case 189:case 17:case 173:
          r[0] != b && (n = !0);r[0] = b;break;case 107:case 187:case 16:case 61:
          r[1] != b && (n = !0);r[1] = b;break;case 38:
          r[2] != b && (n = !0);r[2] = b;break;case 87:
          r[6] != b && (n = !0);r[6] = b;break;case 40:
          r[3] != b && (n = !0);r[3] = b;break;case 83:
          r[7] != b && (n = !0);r[7] = b;break;case 37:
          r[4] != b && (n = !0);r[4] = b;break;case 65:
          r[8] != b && (n = !0);r[8] = b;break;case 39:
          r[5] != b && (n = !0);r[5] = b;break;case 68:
          r[9] != b && (n = !0), r[9] = b;}n && b && (ba = "undefined" !== typeof performance && performance.now() ? performance.now() : Date.now(), F());
    }function ga() {
      if (G) {
        var a = !1,
            f = b.pitch,
            n = b.yaw,
            c = b.hfov,
            e;e = "undefined" !== typeof performance && performance.now() ? performance.now() : Date.now();ba === p && (ba = e);var d = (e - ba) * b.hfov / 1700,
            d = Math.min(d, 1);r[0] && !0 === b.keyboardZoom && (x(b.hfov + (0.8 * w.hfov + 0.5) * d), a = !0);r[1] && !0 === b.keyboardZoom && (x(b.hfov + (0.8 * w.hfov - 0.2) * d), a = !0);if (r[2] || r[6]) b.pitch += (0.8 * w.pitch + 0.2) * d, a = !0;if (r[3] || r[7]) b.pitch += (0.8 * w.pitch - 0.2) * d, a = !0;if (r[4] || r[8]) b.yaw += (0.8 * w.yaw - 0.2) * d, a = !0;if (r[5] || r[9]) b.yaw += (0.8 * w.yaw + 0.2) * d, a = !0;a && (N = Date.now());if (b.autoRotate) {
          if (0.001 < e - ba) {
            var a = (e - ba) / 1E3,
                g = (w.yaw / a * d - 0.2 * b.autoRotate) * a,
                g = (0 < -b.autoRotate ? 1 : -1) * Math.min(Math.abs(b.autoRotate * a), Math.abs(g));b.yaw += g;
          }b.autoRotateStopDelay && (b.autoRotateStopDelay -= e - ba, 0 >= b.autoRotateStopDelay && (b.autoRotateStopDelay = !1, Z = b.autoRotate, b.autoRotate = 0));
        }O.pitch && (m("pitch"), f = b.pitch);O.yaw && (m("yaw"), n = b.yaw);O.hfov && (m("hfov"), c = b.hfov);0 < d && !b.autoRotate && (a = 1 - b.friction, r[4] || r[5] || r[8] || r[9] || O.yaw || (b.yaw += w.yaw * d * a), r[2] || r[3] || r[6] || r[7] || O.pitch || (b.pitch += w.pitch * d * a), r[0] || r[1] || O.hfov || x(b.hfov + w.hfov * d * a));ba = e;0 < d && (w.yaw = 0.8 * w.yaw + (b.yaw - n) / d * 0.2, w.pitch = 0.8 * w.pitch + (b.pitch - f) / d * 0.2, w.hfov = 0.8 * w.hfov + (b.hfov - c) / d * 0.2, f = b.autoRotate ? Math.abs(b.autoRotate) : 5, w.yaw = Math.min(f, Math.max(w.yaw, -f)), w.pitch = Math.min(f, Math.max(w.pitch, -f)), w.hfov = Math.min(f, Math.max(w.hfov, -f)));r[0] && r[1] && (w.hfov = 0);(r[2] || r[6]) && (r[3] || r[7]) && (w.pitch = 0);(r[4] || r[8]) && (r[5] || r[9]) && (w.yaw = 0);
      }
    }function m(a) {
      var f = O[a],
          n = Math.min(1, Math.max((Date.now() - f.startTime) / 1E3 / (f.duration / 1E3), 0)),
          n = f.startPosition + b.animationTimingFunction(n) * (f.endPosition - f.startPosition);if (f.endPosition > f.startPosition && n >= f.endPosition || f.endPosition < f.startPosition && n <= f.endPosition || f.endPosition === f.startPosition) n = f.endPosition, w[a] = 0, delete O[a];b[a] = n;
    }function z() {
      d("resize");
    }function F() {
      Ta || (Ta = !0, ca());
    }function ca() {
      if (!Za) if (Fa(), Qa && clearTimeout(Qa), ha || !0 === X) requestAnimationFrame(ca);else if (r[0] || r[1] || r[2] || r[3] || r[4] || r[5] || r[6] || r[7] || r[8] || r[9] || b.autoRotate || O.pitch || O.yaw || O.hfov || 0.01 < Math.abs(w.yaw) || 0.01 < Math.abs(w.pitch) || 0.01 < Math.abs(w.hfov)) ga(), 0 <= b.autoRotateInactivityDelay && Z && Date.now() - N > b.autoRotateInactivityDelay && !b.autoRotate && (b.autoRotate = Z, da.lookAt(Ga, p, ra, 3E3)), requestAnimationFrame(ca);else if (C && (C.isLoading() || !0 === b.dynamic && Ma)) requestAnimationFrame(ca);else {
        B("animatefinished", { pitch: da.getPitch(), yaw: da.getYaw(), hfov: da.getHfov() });Ta = !1;ba = p;var a = b.autoRotateInactivityDelay - (Date.now() - N);0 < a ? Qa = setTimeout(function () {
          b.autoRotate = Z;da.lookAt(Ga, p, ra, 3E3);F();
        }, a) : 0 <= b.autoRotateInactivityDelay && Z && (b.autoRotate = Z, da.lookAt(Ga, p, ra, 3E3), F());
      }
    }function Fa() {
      var a;if (G) {
        var f = C.getCanvas();!1 !== b.autoRotate && (360 < b.yaw ? b.yaw -= 360 : -360 > b.yaw && (b.yaw += 360));a = b.yaw;var n = 0;if (b.avoidShowingBackground) {
          var c = b.hfov / 2,
              d = 180 * Math.atan2(Math.tan(c / 180 * Math.PI), f.width / f.height) / Math.PI;b.vaov > b.haov ? Math.min(Math.cos((b.pitch - c) / 180 * Math.PI), Math.cos((b.pitch + c) / 180 * Math.PI)) : n = c * (1 - Math.min(Math.cos((b.pitch - d) / 180 * Math.PI), Math.cos((b.pitch + d) / 180 * Math.PI)));
        }var c = b.maxYaw - b.minYaw,
            d = -180,
            e = 180;360 > c && (d = b.minYaw + b.hfov / 2 + n, e = b.maxYaw - b.hfov / 2 - n, c < b.hfov && (d = e = (d + e) / 2), b.yaw = Math.max(d, Math.min(e, b.yaw)));!1 === b.autoRotate && (360 < b.yaw ? b.yaw -= 360 : -360 > b.yaw && (b.yaw += 360));!1 !== b.autoRotate && a != b.yaw && ba !== p && (b.autoRotate *= -1);a = 2 * Math.atan(Math.tan(b.hfov / 180 * Math.PI * 0.5) / (f.width / f.height)) / Math.PI * 180;f = b.minPitch + a / 2;n = b.maxPitch - a / 2;b.maxPitch - b.minPitch < a && (f = n = (f + n) / 2);isNaN(f) && (f = -90);isNaN(n) && (n = 90);b.pitch = Math.max(f, Math.min(n, b.pitch));C.render(b.pitch * Math.PI / 180, b.yaw * Math.PI / 180, b.hfov * Math.PI / 180, { roll: b.roll * Math.PI / 180 });b.hotSpots.forEach(Ca);b.compass && (Ia.style.transform = "rotate(" + (-b.yaw - b.northOffset) + "deg)", Ia.style.webkitTransform = "rotate(" + (-b.yaw - b.northOffset) + "deg)");
      }
    }
    function Y(a, b, c, d) {
      this.w = a;this.x = b;this.y = c;this.z = d;
    }function na(a) {
      var f;f = a.alpha;var c = a.beta;a = a.gamma;c = [c ? c * Math.PI / 180 / 2 : 0, a ? a * Math.PI / 180 / 2 : 0, f ? f * Math.PI / 180 / 2 : 0];f = [Math.cos(c[0]), Math.cos(c[1]), Math.cos(c[2])];c = [Math.sin(c[0]), Math.sin(c[1]), Math.sin(c[2])];f = new Y(f[0] * f[1] * f[2] - c[0] * c[1] * c[2], c[0] * f[1] * f[2] - f[0] * c[1] * c[2], f[0] * c[1] * f[2] + c[0] * f[1] * c[2], f[0] * f[1] * c[2] + c[0] * c[1] * f[2]);f = f.multiply(new Y(Math.sqrt(0.5), -Math.sqrt(0.5), 0, 0));c = E.orientation ? -E.orientation * Math.PI / 180 / 2 : 0;f = f.multiply(new Y(Math.cos(c), 0, -Math.sin(c), 0)).toEulerAngles();"number" == typeof X && 10 > X ? X += 1 : 10 === X ? ($a = f[2] / Math.PI * 180 + b.yaw, X = !0, requestAnimationFrame(ca)) : (b.pitch = f[0] / Math.PI * 180, b.roll = -f[1] / Math.PI * 180, b.yaw = -f[2] / Math.PI * 180 + $a);
    }function va() {
      try {
        var a = {};b.horizonPitch !== p && (a.horizonPitch = b.horizonPitch * Math.PI / 180);b.horizonRoll !== p && (a.horizonRoll = b.horizonRoll * Math.PI / 180);b.backgroundColor !== p && (a.backgroundColor = b.backgroundColor);C.init(P, b.type, b.dynamic, b.haov * Math.PI / 180, b.vaov * Math.PI / 180, b.vOffset * Math.PI / 180, S, a);!0 !== b.dynamic && (P = p);
      } catch (f) {
        if ("webgl error" == f.type || "no webgl" == f.type) K();else if ("webgl size error" == f.type) K(b.strings.textureSizeError.replace("%s", f.width).replace("%s", f.maxWidth));else throw K(b.strings.unknownError), f;
      }
    }function S() {
      if (b.sceneFadeDuration && C.fadeImg !== p) {
        C.fadeImg.style.opacity = 0;var a = C.fadeImg;delete C.fadeImg;setTimeout(function () {
          M.removeChild(a);B("scenechangefadedone");
        }, b.sceneFadeDuration);
      }Ia.style.display = b.compass ? "inline" : "none";L();q.load.box.style.display = "none";sa !== p && (M.removeChild(sa), sa = p);G = !0;B("load");F();
    }function La(a) {
      a.pitch = Number(a.pitch) || 0;a.yaw = Number(a.yaw) || 0;var f = g.createElement("div");f.className = "pnlm-hotspot-base";f.className = a.cssClass ? f.className + (" " + a.cssClass) : f.className + (" pnlm-hotspot pnlm-sprite pnlm-" + D(a.type));var c = g.createElement("span");a.text && (c.innerHTML = D(a.text));var d;if (a.video) {
        d = g.createElement("video");var e = a.video;b.basePath && !qa(e) && (e = b.basePath + e);d.src = I(e);d.controls = !0;d.style.width = a.width + "px";M.appendChild(f);c.appendChild(d);
      } else if (a.image) {
        e = a.image;b.basePath && !qa(e) && (e = b.basePath + e);d = g.createElement("a");d.href = I(a.URL ? a.URL : e, !0);d.target = "_blank";c.appendChild(d);var h = g.createElement("img");h.src = I(e);h.style.width = a.width + "px";h.style.paddingTop = "5px";M.appendChild(f);d.appendChild(h);c.style.maxWidth = "initial";
      } else if (a.URL) {
        d = g.createElement("a");d.href = I(a.URL, !0);if (a.attributes) for (e in a.attributes) {
          d.setAttribute(e, a.attributes[e]);
        } else d.target = "_blank";M.appendChild(d);f.className += " pnlm-pointer";c.className += " pnlm-pointer";d.appendChild(f);
      } else a.sceneId && (f.onclick = f.ontouchend = function () {
        f.clicked || (f.clicked = !0, y(a.sceneId, a.targetPitch, a.targetYaw, a.targetHfov));return !1;
      }, f.className += " pnlm-pointer", c.className += " pnlm-pointer"), M.appendChild(f);if (a.createTooltipFunc) a.createTooltipFunc(f, a.createTooltipArgs);else if (a.text || a.video || a.image) f.classList.add("pnlm-tooltip"), f.appendChild(c), c.style.width = c.scrollWidth - 20 + "px", c.style.marginLeft = -(c.scrollWidth - f.offsetWidth) / 2 + "px", c.style.marginTop = -c.scrollHeight - 12 + "px";a.clickHandlerFunc && (f.addEventListener("click", function (b) {
        a.clickHandlerFunc(b, a.clickHandlerArgs);
      }, "false"), f.className += " pnlm-pointer", c.className += " pnlm-pointer");a.div = f;
    }function L() {
      Ua || (b.hotSpots ? (b.hotSpots = b.hotSpots.sort(function (a, b) {
        return a.pitch < b.pitch;
      }), b.hotSpots.forEach(La)) : b.hotSpots = [], Ua = !0, b.hotSpots.forEach(Ca));
    }function e() {
      var a = b.hotSpots;Ua = !1;delete b.hotSpots;
      if (a) for (var f = 0; f < a.length; f++) {
        var c = a[f].div;if (c) {
          for (; c.parentNode && c.parentNode != M;) {
            c = c.parentNode;
          }M.removeChild(c);
        }delete a[f].div;
      }
    }function Ca(a) {
      var f = Math.sin(a.pitch * Math.PI / 180),
          c = Math.cos(a.pitch * Math.PI / 180),
          d = Math.sin(b.pitch * Math.PI / 180),
          e = Math.cos(b.pitch * Math.PI / 180),
          g = Math.cos((-a.yaw + b.yaw) * Math.PI / 180),
          h = f * d + c * g * e;if (90 >= a.yaw && -90 < a.yaw && 0 >= h || (90 < a.yaw || -90 >= a.yaw) && 0 >= h) a.div.style.visibility = "hidden";else {
        var l = Math.sin((-a.yaw + b.yaw) * Math.PI / 180),
            k = Math.tan(b.hfov * Math.PI / 360);a.div.style.visibility = "visible";var m = C.getCanvas(),
            p = m.clientWidth,
            m = m.clientHeight,
            f = [-p / k * l * c / h / 2, -p / k * (f * e - c * g * d) / h / 2],
            c = Math.sin(b.roll * Math.PI / 180),
            d = Math.cos(b.roll * Math.PI / 180),
            f = [f[0] * d - f[1] * c, f[0] * c + f[1] * d];f[0] += (p - a.div.offsetWidth) / 2;f[1] += (m - a.div.offsetHeight) / 2;p = "translate(" + f[0] + "px, " + f[1] + "px) translateZ(9999px) rotate(" + b.roll + "deg)";a.scale && (p += " scale(" + ra / b.hfov / h + ")");a.div.style.webkitTransform = p;a.div.style.MozTransform = p;a.div.style.transform = p;
      }
    }function H(a) {
      b = {};var f,
          c,
          d = "haov vaov vOffset northOffset horizonPitch horizonRoll".split(" ");aa = [];for (f in Va) {
        Va.hasOwnProperty(f) && (b[f] = Va[f]);
      }for (f in k.default) {
        if (k.default.hasOwnProperty(f)) if ("strings" == f) for (c in k.default.strings) {
          k.default.strings.hasOwnProperty(c) && (b.strings[c] = D(k.default.strings[c]));
        } else b[f] = k.default[f], 0 <= d.indexOf(f) && aa.push(f);
      }if (null !== a && "" !== a && k.scenes && k.scenes[a]) {
        var e = k.scenes[a];for (f in e) {
          if (e.hasOwnProperty(f)) if ("strings" == f) for (c in e.strings) {
            e.strings.hasOwnProperty(c) && (b.strings[c] = D(e.strings[c]));
          } else b[f] = e[f], 0 <= d.indexOf(f) && aa.push(f);
        }b.scene = a;
      }for (f in k) {
        if (k.hasOwnProperty(f)) if ("strings" == f) for (c in k.strings) {
          k.strings.hasOwnProperty(c) && (b.strings[c] = D(k.strings[c]));
        } else b[f] = k[f], 0 <= d.indexOf(f) && aa.push(f);
      }
    }function l(a) {
      if ((a = a ? a : !1) && "preview" in b) {
        var c = b.preview;b.basePath && !qa(c) && (c = b.basePath + c);sa = g.createElement("div");sa.className = "pnlm-preview-img";sa.style.backgroundImage = "url('" + I(c).replace(/"/g, "%22").replace(/'/g, "%27") + "')";M.appendChild(sa);
      }var c = b.title,
          d = b.author;a && ("previewTitle" in b && (b.title = b.previewTitle), "previewAuthor" in b && (b.author = b.previewAuthor));b.hasOwnProperty("title") || (q.title.innerHTML = "");b.hasOwnProperty("author") || (q.author.innerHTML = "");b.hasOwnProperty("title") || b.hasOwnProperty("author") || (q.container.style.display = "none");v.load.innerHTML = "<p>" + b.strings.loadButtonLabel + "</p>";q.load.boxp.innerHTML = b.strings.loadingLabel;for (var e in b) {
        if (b.hasOwnProperty(e)) switch (e) {case "title":
            q.title.innerHTML = D(b[e]);q.container.style.display = "inline";break;case "author":
            var h = D(b[e]);b.authorURL && (h = g.createElement("a"), h.href = I(b.authorURL, !0), h.target = "_blank", h.innerHTML = D(b[e]), h = h.outerHTML);q.author.innerHTML = b.strings.bylineLabel.replace("%s", h);q.container.style.display = "inline";break;case "fallback":
            h = g.createElement("a");h.href = I(b[e], !0);h.target = "_blank";h.textContent = "Click here to view this panorama in an alternative viewer.";var k = g.createElement("p");k.textContent = "Your browser does not support WebGL.";k.appendChild(g.createElement("br"));
            k.appendChild(h);q.errorMsg.innerHTML = "";q.errorMsg.appendChild(k);break;case "hfov":
            x(Number(b[e]));break;case "autoLoad":
            !0 === b[e] && C === p && (q.load.box.style.display = "inline", v.load.style.display = "none", oa());break;case "showZoomCtrl":
            v.zoom.style.display = b[e] && !1 != b.showControls ? "block" : "none";break;case "showFullscreenCtrl":
            v.fullscreen.style.display = b[e] && !1 != b.showControls && ("fullscreen" in g || "mozFullScreen" in g || "webkitIsFullScreen" in g || "msFullscreenElement" in g) ? "block" : "none";break;case "hotSpotDebug":
            Wa.style.display = b[e] ? "block" : "none";break;case "showControls":
            b[e] || (v.orientation.style.display = "none", v.zoom.style.display = "none", v.fullscreen.style.display = "none");break;case "orientationOnByDefault":
            b[e] && Ra();}
      }a && (c ? b.title = c : delete b.title, d ? b.author = d : delete b.author);
    }function h() {
      if (G && !Na) if (Aa) g.exitFullscreen ? g.exitFullscreen() : g.mozCancelFullScreen ? g.mozCancelFullScreen() : g.webkitCancelFullScreen ? g.webkitCancelFullScreen() : g.msExitFullscreen && g.msExitFullscreen();else try {
        s.requestFullscreen ? s.requestFullscreen() : s.mozRequestFullScreen ? s.mozRequestFullScreen() : s.msRequestFullscreen ? s.msRequestFullscreen() : s.webkitRequestFullScreen();
      } catch (a) {}
    }function d(a) {
      g.fullscreenElement || g.fullscreen || g.mozFullScreen || g.webkitIsFullScreen || g.msFullscreenElement ? (v.fullscreen.classList.add("pnlm-fullscreen-toggle-button-active"), Aa = !0) : (v.fullscreen.classList.remove("pnlm-fullscreen-toggle-button-active"), Aa = !1);"resize" !== a && B("fullscreenchange", Aa);C.resize();x(b.hfov);F();
    }function u(a) {
      var c = b.minHfov;"multires" == b.type && C && !b.multiResMinHfov && (c = Math.min(c, C.getCanvas().width / (b.multiRes.cubeResolution / 90 * 0.9)));if (c > b.maxHfov) return console.log("HFOV bounds do not make sense (minHfov > maxHfov)."), b.hfov;var d = b.hfov,
          d = a < c ? c : a > b.maxHfov ? b.maxHfov : a;b.avoidShowingBackground && C && (a = C.getCanvas(), d = Math.min(d, 360 * Math.atan(Math.tan((b.maxPitch - b.minPitch) / 360 * Math.PI) / a.height * a.width) / Math.PI));return d;
    }function x(a) {
      b.hfov = u(a);B("zoomchange", b.hfov);
    }function t() {
      O = {};Z = b.autoRotate ? b.autoRotate : Z;b.autoRotate = !1;
    }function Ya() {
      Na && (q.load.box.style.display = "none", q.errorMsg.style.display = "none", Na = !1, M.style.display = "block", B("errorcleared"));G = !1;v.load.style.display = "none";q.load.box.style.display = "inline";oa();
    }function y(a, c, d, h, g) {
      G || (g = !0);G = !1;O = {};var m, q;if (b.sceneFadeDuration && !g && (m = C.render(b.pitch * Math.PI / 180, b.yaw * Math.PI / 180, b.hfov * Math.PI / 180, { returnImage: !0 }), m !== p)) {
        g = new Image();g.className = "pnlm-fade-img";g.style.transition = "opacity " + b.sceneFadeDuration / 1E3 + "s";g.style.width = "100%";g.style.height = "100%";g.onload = function () {
          y(a, c, d, h, !0);
        };g.src = m;M.appendChild(g);C.fadeImg = g;return;
      }g = "same" === c ? b.pitch : c;m = "same" === d ? b.yaw : "sameAzimuth" === d ? b.yaw + (b.northOffset || 0) - (k.scenes[a].northOffset || 0) : d;q = "same" === h ? b.hfov : h;e();H(a);w.yaw = w.pitch = w.hfov = 0;l();g !== p && (b.pitch = g);m !== p && (b.yaw = m);q !== p && (b.hfov = q);B("scenechange", a);Ya();
    }function Da() {
      E.removeEventListener("deviceorientation", na);v.orientation.classList.remove("pnlm-orientation-button-active");X = !1;
    }function Ra() {
      "function" === typeof DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then(function (a) {
        "granted" == a && (X = 1, E.addEventListener("deviceorientation", na), v.orientation.classList.add("pnlm-orientation-button-active"));
      }) : (X = 1, E.addEventListener("deviceorientation", na), v.orientation.classList.add("pnlm-orientation-button-active"));
    }function D(a) {
      return k.escapeHTML ? String(a).split(/&/g).join("&amp;").split('"').join("&quot;").split("'").join("&#39;").split("<").join("&lt;").split(">").join("&gt;").split("/").join("&#x2f;").split("\n").join("<br>") : String(a).split("\n").join("<br>");
    }function I(a, b) {
      try {
        var c = decodeURIComponent(ab(a)).replace(/[^\w:]/g, "").toLowerCase();
      } catch (d) {
        return "about:blank";
      }return 0 === c.indexOf("javascript:") || 0 === c.indexOf("vbscript:") ? (console.log("Script URL removed."), "about:blank") : b && 0 === c.indexOf("data:") ? (console.log("Data URI removed from link."), "about:blank") : a;
    }function ab(a) {
      return a.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig, function (a, b) {
        b = b.toLowerCase();return "colon" === b ? ":" : "#" === b.charAt(0) ? "x" === b.charAt(1) ? String.fromCharCode(parseInt(b.substring(2), 16)) : String.fromCharCode(+b.substring(1)) : "";
      });
    }function B(a) {
      if (a in T) for (var b = T[a].length; 0 < b; b--) {
        T[a][T[a].length - b].apply(null, [].slice.call(arguments, 1));
      }
    }var da = this,
        b,
        C,
        sa,
        ha = !1,
        N = Date.now(),
        xa = 0,
        ya = 0,
        Ha = -1,
        Oa = 0,
        Pa = 0,
        r = Array(10),
        Aa = !1,
        G,
        Na = !1,
        Sa = !1,
        P,
        ba,
        w = { yaw: 0, pitch: 0, hfov: 0 },
        Ta = !1,
        X = !1,
        $a = 0,
        Qa,
        Z = 0,
        ra,
        Ga,
        O = {},
        T = {},
        aa = [],
        Ma = !1,
        Ua = !1,
        Za = !1,
        Va = { hfov: 100, minHfov: 50, multiResMinHfov: !1, maxHfov: 120, pitch: 0, minPitch: p, maxPitch: p, yaw: 0,
      minYaw: -180, maxYaw: 180, roll: 0, haov: 360, vaov: 180, vOffset: 0, autoRotate: !1, autoRotateInactivityDelay: -1, autoRotateStopDelay: p, type: "equirectangular", northOffset: 0, showFullscreenCtrl: !0, dynamic: !1, dynamicUpdate: !1, doubleClickZoom: !0, keyboardZoom: !0, mouseZoom: !0, showZoomCtrl: !0, autoLoad: !1, showControls: !0, orientationOnByDefault: !1, hotSpotDebug: !1, backgroundColor: [0, 0, 0], avoidShowingBackground: !1, animationTimingFunction: function animationTimingFunction(a) {
        return 0.5 > a ? 2 * a * a : -1 + (4 - 2 * a) * a;
      }, draggable: !0, disableKeyboardCtrl: !1, crossOrigin: "anonymous",
      touchPanSpeedCoeffFactor: 1, capturedKeyNumbers: [16, 17, 27, 37, 38, 39, 40, 61, 65, 68, 83, 87, 107, 109, 173, 187, 189], friction: 0.15, strings: { loadButtonLabel: "Click to<br>Load<br>Panorama", loadingLabel: "Loading...", bylineLabel: "by %s", noPanoramaError: "No panorama image was specified.", fileAccessError: "The file %s could not be accessed.", malformedURLError: "There is something wrong with the panorama URL.", iOS8WebGLError: "Due to iOS 8's broken WebGL implementation, only progressive encoded JPEGs work for your device (this panorama uses standard encoding).",
        genericWebGLError: "Your browser does not have the necessary WebGL support to display this panorama.", textureSizeError: "This panorama is too big for your device! It's %spx wide, but your device only supports images up to %spx wide. Try another device. (If you're the author, try scaling down the image.)", unknownError: "Unknown error. Check developer console." } };s = "string" === typeof s ? g.getElementById(s) : s;s.classList.add("pnlm-container");s.tabIndex = 0;var J = g.createElement("div");J.className = "pnlm-ui";
    s.appendChild(J);var M = g.createElement("div");M.className = "pnlm-render-container";s.appendChild(M);var W = g.createElement("div");W.className = "pnlm-dragfix";J.appendChild(W);var fa = g.createElement("span");fa.className = "pnlm-about-msg";fa.innerHTML = '<a href="https://pannellum.org/" target="_blank">Pannellum</a> 2.5.6';J.appendChild(fa);W.addEventListener("contextmenu", ja);var q = {},
        Wa = g.createElement("div");Wa.className = "pnlm-sprite pnlm-hot-spot-debug-indicator";J.appendChild(Wa);q.container = g.createElement("div");
    q.container.className = "pnlm-panorama-info";q.title = g.createElement("div");q.title.className = "pnlm-title-box";q.container.appendChild(q.title);q.author = g.createElement("div");q.author.className = "pnlm-author-box";q.container.appendChild(q.author);J.appendChild(q.container);q.load = {};q.load.box = g.createElement("div");q.load.box.className = "pnlm-load-box";q.load.boxp = g.createElement("p");q.load.box.appendChild(q.load.boxp);q.load.lbox = g.createElement("div");q.load.lbox.className = "pnlm-lbox";q.load.lbox.innerHTML = '<div class="pnlm-loading"></div>';q.load.box.appendChild(q.load.lbox);q.load.lbar = g.createElement("div");q.load.lbar.className = "pnlm-lbar";q.load.lbarFill = g.createElement("div");q.load.lbarFill.className = "pnlm-lbar-fill";q.load.lbar.appendChild(q.load.lbarFill);q.load.box.appendChild(q.load.lbar);q.load.msg = g.createElement("p");q.load.msg.className = "pnlm-lmsg";q.load.box.appendChild(q.load.msg);J.appendChild(q.load.box);q.errorMsg = g.createElement("div");q.errorMsg.className = "pnlm-error-msg pnlm-info-box";
    J.appendChild(q.errorMsg);var v = {};v.container = g.createElement("div");v.container.className = "pnlm-controls-container";J.appendChild(v.container);v.load = g.createElement("div");v.load.className = "pnlm-load-button";v.load.addEventListener("click", function () {
      l();Ya();
    });J.appendChild(v.load);v.zoom = g.createElement("div");v.zoom.className = "pnlm-zoom-controls pnlm-controls";v.zoomIn = g.createElement("div");v.zoomIn.className = "pnlm-zoom-in pnlm-sprite pnlm-control";v.zoomIn.addEventListener("click", function () {
      G && (x(b.hfov - 5), F());
    });v.zoom.appendChild(v.zoomIn);v.zoomOut = g.createElement("div");v.zoomOut.className = "pnlm-zoom-out pnlm-sprite pnlm-control";v.zoomOut.addEventListener("click", function () {
      G && (x(b.hfov + 5), F());
    });v.zoom.appendChild(v.zoomOut);v.container.appendChild(v.zoom);v.fullscreen = g.createElement("div");v.fullscreen.addEventListener("click", h);v.fullscreen.className = "pnlm-fullscreen-toggle-button pnlm-sprite pnlm-fullscreen-toggle-button-inactive pnlm-controls pnlm-control";(g.fullscreenEnabled || g.mozFullScreenEnabled || g.webkitFullscreenEnabled || g.msFullscreenEnabled) && v.container.appendChild(v.fullscreen);v.orientation = g.createElement("div");v.orientation.addEventListener("click", function (a) {
      X ? Da() : Ra();
    });v.orientation.addEventListener("mousedown", function (a) {
      a.stopPropagation();
    });v.orientation.addEventListener("touchstart", function (a) {
      a.stopPropagation();
    });v.orientation.addEventListener("pointerdown", function (a) {
      a.stopPropagation();
    });v.orientation.className = "pnlm-orientation-button pnlm-orientation-button-inactive pnlm-sprite pnlm-controls pnlm-control";
    var Xa = !1;E.DeviceOrientationEvent && "https:" == location.protocol && 0 <= navigator.userAgent.toLowerCase().indexOf("mobi") && (v.container.appendChild(v.orientation), Xa = !0);var Ia = g.createElement("div");Ia.className = "pnlm-compass pnlm-controls pnlm-control";J.appendChild(Ia);k.firstScene ? H(k.firstScene) : k.default && k.default.firstScene ? H(k.default.firstScene) : H(null);l(!0);var ia = [],
        za = [];Y.prototype.multiply = function (a) {
      return new Y(this.w * a.w - this.x * a.x - this.y * a.y - this.z * a.z, this.x * a.w + this.w * a.x + this.y * a.z - this.z * a.y, this.y * a.w + this.w * a.y + this.z * a.x - this.x * a.z, this.z * a.w + this.w * a.z + this.x * a.y - this.y * a.x);
    };Y.prototype.toEulerAngles = function () {
      var a = Math.atan2(2 * (this.w * this.x + this.y * this.z), 1 - 2 * (this.x * this.x + this.y * this.y)),
          b = Math.asin(2 * (this.w * this.y - this.z * this.x)),
          c = Math.atan2(2 * (this.w * this.z + this.x * this.y), 1 - 2 * (this.y * this.y + this.z * this.z));return [a, b, c];
    };this.isLoaded = function () {
      return Boolean(G);
    };this.getPitch = function () {
      return b.pitch;
    };this.setPitch = function (a, c, d, e) {
      N = Date.now();if (1E-6 >= Math.abs(a - b.pitch)) return "function" == typeof d && d(e), this;(c = c == p ? 1E3 : Number(c)) ? (O.pitch = { startTime: Date.now(), startPosition: b.pitch, endPosition: a, duration: c }, "function" == typeof d && setTimeout(function () {
        d(e);
      }, c)) : b.pitch = a;F();return this;
    };this.getPitchBounds = function () {
      return [b.minPitch, b.maxPitch];
    };this.setPitchBounds = function (a) {
      b.minPitch = Math.max(-90, Math.min(a[0], 90));b.maxPitch = Math.max(-90, Math.min(a[1], 90));return this;
    };this.getYaw = function () {
      return (b.yaw + 540) % 360 - 180;
    };this.setYaw = function (a, c, d, e) {
      N = Date.now();if (1E-6 >= Math.abs(a - b.yaw)) return "function" == typeof d && d(e), this;c = c == p ? 1E3 : Number(c);a = (a + 180) % 360 - 180;c ? (180 < b.yaw - a ? a += 360 : 180 < a - b.yaw && (a -= 360), O.yaw = { startTime: Date.now(), startPosition: b.yaw, endPosition: a, duration: c }, "function" == typeof d && setTimeout(function () {
        d(e);
      }, c)) : b.yaw = a;F();return this;
    };this.getYawBounds = function () {
      return [b.minYaw, b.maxYaw];
    };this.setYawBounds = function (a) {
      b.minYaw = Math.max(-360, Math.min(a[0], 360));b.maxYaw = Math.max(-360, Math.min(a[1], 360));return this;
    };
    this.getHfov = function () {
      return b.hfov;
    };this.setHfov = function (a, c, d, e) {
      N = Date.now();if (1E-6 >= Math.abs(a - b.hfov)) return "function" == typeof d && d(e), this;(c = c == p ? 1E3 : Number(c)) ? (O.hfov = { startTime: Date.now(), startPosition: b.hfov, endPosition: u(a), duration: c }, "function" == typeof d && setTimeout(function () {
        d(e);
      }, c)) : x(a);F();return this;
    };this.getHfovBounds = function () {
      return [b.minHfov, b.maxHfov];
    };this.setHfovBounds = function (a) {
      b.minHfov = Math.max(0, a[0]);b.maxHfov = Math.max(0, a[1]);return this;
    };this.lookAt = function (a, c, d, e, g, h) {
      e = e == p ? 1E3 : Number(e);a !== p && 1E-6 < Math.abs(a - b.pitch) && (this.setPitch(a, e, g, h), g = p);c !== p && 1E-6 < Math.abs(c - b.yaw) && (this.setYaw(c, e, g, h), g = p);d !== p && 1E-6 < Math.abs(d - b.hfov) && (this.setHfov(d, e, g, h), g = p);"function" == typeof g && g(h);return this;
    };this.getNorthOffset = function () {
      return b.northOffset;
    };this.setNorthOffset = function (a) {
      b.northOffset = Math.min(360, Math.max(0, a));F();return this;
    };this.getHorizonRoll = function () {
      return b.horizonRoll;
    };this.setHorizonRoll = function (a) {
      b.horizonRoll = Math.min(90, Math.max(-90, a));C.setPose(b.horizonPitch * Math.PI / 180, b.horizonRoll * Math.PI / 180);F();return this;
    };this.getHorizonPitch = function () {
      return b.horizonPitch;
    };this.setHorizonPitch = function (a) {
      b.horizonPitch = Math.min(90, Math.max(-90, a));C.setPose(b.horizonPitch * Math.PI / 180, b.horizonRoll * Math.PI / 180);F();return this;
    };this.startAutoRotate = function (a, c) {
      a = a || Z || 1;c = c === p ? Ga : c;b.autoRotate = a;da.lookAt(c, p, ra, 3E3);F();return this;
    };this.stopAutoRotate = function () {
      Z = b.autoRotate ? b.autoRotate : Z;b.autoRotate = !1;b.autoRotateInactivityDelay = -1;return this;
    };this.stopMovement = function () {
      t();w = { yaw: 0, pitch: 0, hfov: 0 };
    };this.getRenderer = function () {
      return C;
    };this.setUpdate = function (a) {
      Ma = !0 === a;C === p ? pa() : F();return this;
    };this.mouseEventToCoords = function (a) {
      return ta(a);
    };this.loadScene = function (a, b, c, d) {
      !1 !== G && y(a, b, c, d);return this;
    };this.getScene = function () {
      return b.scene;
    };this.addScene = function (a, b) {
      k.scenes[a] = b;return this;
    };this.removeScene = function (a) {
      if (b.scene === a || !k.scenes.hasOwnProperty(a)) return !1;delete k.scenes[a];return !0;
    };this.toggleFullscreen = function () {
      h();return this;
    };this.getConfig = function () {
      return b;
    };this.getContainer = function () {
      return s;
    };this.addHotSpot = function (a, c) {
      if (c === p && b.scene === p) b.hotSpots.push(a);else {
        var d = c !== p ? c : b.scene;if (k.scenes.hasOwnProperty(d)) k.scenes[d].hasOwnProperty("hotSpots") || (k.scenes[d].hotSpots = [], d == b.scene && (b.hotSpots = k.scenes[d].hotSpots)), k.scenes[d].hotSpots.push(a);else throw "Invalid scene ID!";
      }if (c === p || b.scene == c) La(a), G && Ca(a);return this;
    };this.removeHotSpot = function (a, c) {
      if (c === p || b.scene == c) {
        if (!b.hotSpots) return !1;for (var d = 0; d < b.hotSpots.length; d++) {
          if (b.hotSpots[d].hasOwnProperty("id") && b.hotSpots[d].id === a) {
            for (var e = b.hotSpots[d].div; e.parentNode != M;) {
              e = e.parentNode;
            }M.removeChild(e);delete b.hotSpots[d].div;b.hotSpots.splice(d, 1);return !0;
          }
        }
      } else if (k.scenes.hasOwnProperty(c)) {
        if (!k.scenes[c].hasOwnProperty("hotSpots")) return !1;for (d = 0; d < k.scenes[c].hotSpots.length; d++) {
          if (k.scenes[c].hotSpots[d].hasOwnProperty("id") && k.scenes[c].hotSpots[d].id === a) return k.scenes[c].hotSpots.splice(d, 1), !0;
        }
      } else return !1;
    };this.resize = function () {
      C && z();
    };this.isLoaded = function () {
      return G;
    };this.isOrientationSupported = function () {
      return Xa || !1;
    };this.stopOrientation = function () {
      Da();
    };this.startOrientation = function () {
      Xa && Ra();
    };this.isOrientationActive = function () {
      return Boolean(X);
    };this.on = function (a, b) {
      T[a] = T[a] || [];T[a].push(b);return this;
    };this.off = function (a, b) {
      if (!a) return T = {}, this;if (b) {
        var c = T[a].indexOf(b);0 <= c && T[a].splice(c, 1);0 == T[a].length && delete T[a];
      } else delete T[a];return this;
    };this.destroy = function () {
      Za = !0;clearTimeout(Qa);C && C.destroy();Sa && (g.removeEventListener("mousemove", ua, !1), g.removeEventListener("mouseup", ma, !1), s.removeEventListener("mozfullscreenchange", d, !1), s.removeEventListener("webkitfullscreenchange", d, !1), s.removeEventListener("msfullscreenchange", d, !1), s.removeEventListener("fullscreenchange", d, !1), E.removeEventListener("resize", z, !1), E.removeEventListener("orientationchange", z, !1), s.removeEventListener("keydown", V, !1), s.removeEventListener("keyup", R, !1), s.removeEventListener("blur", $, !1), g.removeEventListener("mouseleave", ma, !1));s.innerHTML = "";s.classList.remove("pnlm-container");
    };
  }return { viewer: function viewer(g, k) {
      return new Ba(g, k);
    } };
}(window, document);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(45);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(7)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../css-loader/index.js!./pannellum.css", function() {
		var newContent = require("!!../../css-loader/index.js!./pannellum.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(6)(false);
// imports


// module
exports.push([module.i, "/* Pannellum 2.5.6, https://github.com/mpetroff/pannellum */\n.pnlm-container{margin:0;padding:0;overflow:hidden;position:relative;cursor:default;width:100%;height:100%;font-family:Helvetica,\"Nimbus Sans L\",\"Liberation Sans\",Arial,sans-serif;background:#f4f4f4 url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2267%22%20height%3D%22100%22%20viewBox%3D%220%200%2067%20100%22%3E%0A%3Cpath%20stroke%3D%22%23ccc%22%20fill%3D%22none%22%20d%3D%22M33.5%2C50%2C0%2C63%2C33.5%2C75%2C67%2C63%2C33.5%2C50m-33.5-50%2C67%2C25m-0.5%2C0%2C0%2C75m-66.5-75%2C67-25m-33.5%2C75%2C0%2C25m0-100%2C0%2C50%22%2F%3E%0A%3C%2Fsvg%3E%0A') repeat;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-o-user-select:none;-ms-user-select:none;user-select:none;outline:0;line-height:1.4;contain:content}.pnlm-container *{box-sizing:content-box}.pnlm-ui{position:absolute;width:100%;height:100%;z-index:1}.pnlm-grab{cursor:grab;cursor:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2226%22%20width%3D%2226%22%3E%0A%3Cpath%20stroke%3D%22%23000%22%20stroke-width%3D%221px%22%20fill%3D%22%23fff%22%20d%3D%22m15.3%2020.5s6.38-6.73%204.64-8.24-3.47%201.01-3.47%201.01%203.61-5.72%201.41-6.49c-2.2-0.769-3.33%204.36-3.33%204.36s0.873-5.76-1.06-5.76-1.58%205.39-1.58%205.39-0.574-4.59-2.18-4.12c-1.61%200.468-0.572%205.51-0.572%205.51s-1.58-4.89-2.93-3.79c-1.35%201.11%200.258%205.25%200.572%206.62%200.836%202.43%202.03%202.94%202.17%205.55%22%2F%3E%0A%3C%2Fsvg%3E%0A') 12 8,default}.pnlm-grabbing{cursor:grabbing;cursor:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2226%22%20width%3D%2226%22%3E%0A%3Cpath%20stroke%3D%22%23000%22%20stroke-width%3D%221px%22%20fill%3D%22%23fff%22%20d%3D%22m15.3%2020.5s5.07-5.29%203.77-6.74c-1.31-1.45-2.53%200.14-2.53%200.14s2.74-3.29%200.535-4.06c-2.2-0.769-2.52%201.3-2.52%201.3s0.81-2.13-1.12-2.13-1.52%201.77-1.52%201.77-0.261-1.59-1.87-1.12c-1.61%200.468-0.874%202.17-0.874%202.17s-0.651-1.55-2-0.445c-1.35%201.11-0.68%202.25-0.365%203.62%200.836%202.43%202.03%202.94%202.17%205.55%22%2F%3E%0A%3C%2Fsvg%3E%0A') 12 8,default}.pnlm-sprite{background-image:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2226%22%20height%3D%22208%22%3E%0A%3Ccircle%20fill-opacity%3D%22.78%22%20cy%3D%22117%22%20cx%3D%2213%22%20r%3D%2211%22%20fill%3D%22%23fff%22%2F%3E%0A%3Ccircle%20fill-opacity%3D%22.78%22%20cy%3D%22143%22%20cx%3D%2213%22%20r%3D%2211%22%20fill%3D%22%23fff%22%2F%3E%0A%3Ccircle%20cy%3D%22169%22%20cx%3D%2213%22%20r%3D%227%22%20fill%3D%22none%22%20stroke%3D%22%23000%22%20stroke-width%3D%222%22%2F%3E%0A%3Ccircle%20cy%3D%22195%22%20cx%3D%2213%22%20r%3D%227%22%20fill%3D%22none%22%20stroke%3D%22%23000%22%20stroke-width%3D%222%22%2F%3E%0A%3Ccircle%20cx%3D%2213%22%20cy%3D%22195%22%20r%3D%222.5%22%2F%3E%0A%3Cpath%20d%3D%22m5%2083v6h2v-4h4v-2zm10%200v2h4v4h2v-6zm-5%205v6h6v-6zm-5%205v6h6v-2h-4v-4zm14%200v4h-4v2h6v-6z%22%2F%3E%0A%3Cpath%20d%3D%22m13%20110a7%207%200%200%200%20-7%207%207%207%200%200%200%207%207%207%207%200%200%200%207%20-7%207%207%200%200%200%20-7%20-7zm-1%203h2v2h-2zm0%203h2v5h-2z%22%2F%3E%0A%3Cpath%20d%3D%22m5%2057v6h2v-4h4v-2zm10%200v2h4v4h2v-6zm-10%2010v6h6v-2h-4v-4zm14%200v4h-4v2h6v-6z%22%2F%3E%0A%3Cpath%20d%3D%22m17%2038v2h-8v-2z%22%2F%3E%0A%3Cpath%20d%3D%22m12%209v3h-3v2h3v3h2v-3h3v-2h-3v-3z%22%2F%3E%0A%3Cpath%20d%3D%22m13%20136-6.125%206.125h4.375v7.875h3.5v-7.875h4.375z%22%2F%3E%0A%3Cpath%20d%3D%22m10.428%20173.33v-5.77l5-2.89v5.77zm1-1.73%203-1.73-3.001-1.74z%22%2F%3E%0A%3C%2Fsvg%3E%0A')}.pnlm-container:-moz-full-screen{height:100%!important;width:100%!important;position:static!important}.pnlm-container:-webkit-full-screen{height:100%!important;width:100%!important;position:static!important}.pnlm-container:-ms-fullscreen{height:100%!important;width:100%!important;position:static!important}.pnlm-container:fullscreen{height:100%!important;width:100%!important;position:static!important}.pnlm-render-container{cursor:inherit;position:absolute;height:100%;width:100%}.pnlm-controls{margin-top:4px;background-color:#fff;border:1px solid #999;border-color:rgba(0,0,0,0.4);border-radius:3px;cursor:pointer;z-index:2;-webkit-transform:translateZ(9999px);transform:translateZ(9999px)}.pnlm-control:hover{background-color:#f8f8f8}.pnlm-controls-container{position:absolute;top:0;left:4px;z-index:1}.pnlm-zoom-controls{width:26px;height:52px}.pnlm-zoom-in{width:100%;height:50%;position:absolute;top:0;border-radius:3px 3px 0 0}.pnlm-zoom-out{width:100%;height:50%;position:absolute;bottom:0;background-position:0 -26px;border-top:1px solid #ddd;border-top-color:rgba(0,0,0,0.10);border-radius:0 0 3px 3px}.pnlm-fullscreen-toggle-button,.pnlm-orientation-button,.pnlm-hot-spot-debug-indicator{width:26px;height:26px}.pnlm-hot-spot-debug-indicator{position:absolute;top:50%;left:50%;width:26px;height:26px;margin:-13px 0 0 -13px;background-color:rgba(255,255,255,0.5);border-radius:13px;display:none}.pnlm-orientation-button-inactive{background-position:0 -156px}.pnlm-orientation-button-active{background-position:0 -182px}.pnlm-fullscreen-toggle-button-inactive{background-position:0 -52px}.pnlm-fullscreen-toggle-button-active{background-position:0 -78px}.pnlm-panorama-info{position:absolute;bottom:4px;background-color:rgba(0,0,0,0.7);border-radius:0 3px 3px 0;padding-right:10px;color:#fff;text-align:left;display:none;z-index:2;-webkit-transform:translateZ(9999px);transform:translateZ(9999px)}.pnlm-title-box{position:relative;font-size:20px;display:table;padding-left:5px;margin-bottom:3px}.pnlm-author-box{position:relative;font-size:12px;display:table;padding-left:5px}.pnlm-load-box{position:absolute;top:50%;left:50%;width:200px;height:150px;margin:-75px 0 0 -100px;background-color:rgba(0,0,0,0.7);border-radius:3px;text-align:center;font-size:20px;display:none;color:#fff}.pnlm-load-box p{margin:20px 0}.pnlm-lbox{position:absolute;top:50%;left:50%;width:20px;height:20px;margin:-10px 0 0 -10px;display:none}.pnlm-loading{animation-duration:1.5s;-webkit-animation-duration:1.5s;animation-name:pnlm-mv;-webkit-animation-name:pnlm-mv;animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite;animation-timing-function:linear;-webkit-animation-timing-function:linear;height:10px;width:10px;background-color:#fff;position:relative}@keyframes pnlm-mv{from{left:0;top:0}25%{left:10px;top:0}50%{left:10px;top:10px}75%{left:0;top:10px}to{left:0;top:0}}@-webkit-keyframes pnlm-mv{from{left:0;top:0}25%{left:10px;top:0}50%{left:10px;top:10px}75%{left:0;top:10px}to{left:0;top:0}}.pnlm-load-button{position:absolute;top:50%;left:50%;width:200px;height:100px;margin:-50px 0 0 -100px;background-color:rgba(0,0,0,.7);border-radius:3px;text-align:center;font-size:20px;display:table;color:#fff;cursor:pointer}.pnlm-load-button:hover{background-color:rgba(0,0,0,.8)}.pnlm-load-button p{display:table-cell;vertical-align:middle}.pnlm-info-box{font-size:15px;position:absolute;top:50%;left:50%;width:200px;height:150px;margin:-75px 0 0 -100px;background-color:#000;border-radius:3px;display:table;text-align:center;color:#fff;table-layout:fixed}.pnlm-info-box a,.pnlm-author-box a{color:#fff;word-wrap:break-word;overflow-wrap:break-word}.pnlm-info-box p{display:table-cell;vertical-align:middle;padding:0 5px 0 5px}.pnlm-error-msg{display:none}.pnlm-about-msg{font-size:11px;line-height:11px;color:#fff;padding:5px 8px 5px 8px;background:rgba(0,0,0,0.7);border-radius:3px;position:absolute;top:50px;left:50px;display:none;opacity:0;-moz-transition:opacity .3s ease-in-out;-webkit-transition:opacity .3s ease-in-out;-o-transition:opacity .3s ease-in-out;-ms-transition:opacity .3s ease-in-out;transition:opacity .3s ease-in-out;z-index:1}.pnlm-about-msg a:link,.pnlm-about-msg a:visited{color:#fff}.pnlm-about-msg a:hover,.pnlm-about-msg a:active{color:#eee}.pnlm-hotspot-base{position:absolute;visibility:hidden;cursor:default;vertical-align:middle;top:0;z-index:1}.pnlm-hotspot{height:26px;width:26px;border-radius:13px}.pnlm-hotspot:hover{background-color:rgba(255,255,255,0.2)}.pnlm-hotspot.pnlm-info{background-position:0 -104px}.pnlm-hotspot.pnlm-scene{background-position:0 -130px}div.pnlm-tooltip span{visibility:hidden;position:absolute;border-radius:3px;background-color:rgba(0,0,0,0.7);color:#fff;text-align:center;max-width:200px;padding:5px 10px;margin-left:-220px;cursor:default}div.pnlm-tooltip:hover span{visibility:visible}div.pnlm-tooltip:hover span:after{content:'';position:absolute;width:0;height:0;border-width:10px;border-style:solid;border-color:rgba(0,0,0,0.7) transparent transparent transparent;bottom:-20px;left:-10px;margin:0 50%}.pnlm-compass{position:absolute;width:50px;height:50px;right:4px;bottom:4px;border-radius:25px;background-image:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20height%3D%2250%22%20width%3D%2250%22%3E%0A%3Cpath%20d%3D%22m24.5078%206-3.2578%2018h7.5l-3.25781-18h-0.984376zm-3.2578%2020%203.2578%2018h0.9844l3.2578-18h-7.5zm1.19531%200.9941h5.10938l-2.5547%2014.1075-2.5547-14.1075z%22%2F%3E%0A%3C%2Fsvg%3E%0A');cursor:default;display:none}.pnlm-world{position:absolute;left:50%;top:50%}.pnlm-face{position:absolute;-webkit-transform-origin:0 0;transform-origin:0 0}.pnlm-dragfix,.pnlm-preview-img{position:absolute;height:100%;width:100%}.pnlm-preview-img{background-size:cover;background-position:center}.pnlm-lbar{width:150px;margin:0 auto;border:#fff 1px solid;height:6px}.pnlm-lbar-fill{background:#fff;height:100%;width:0}.pnlm-lmsg{font-size:12px}.pnlm-fade-img{position:absolute;top:0;left:0}.pnlm-pointer{cursor:pointer}", ""]);

// exports


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjListAJAX = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


var _common = __webpack_require__(1);

var _body_ctrl = __webpack_require__(2);

var _lazyload = __webpack_require__(3);

var _lightbox = __webpack_require__(9);

var _track = __webpack_require__(16);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//AJAX 物件列表 (頁碼載入)
var ObjListAJAX = function () {
  function ObjListAJAX() {
    _classCallCheck(this, ObjListAJAX);

    this.nav = $('#navVal').val();

    this.preloader = $('#preloader');
    this.logo = this.preloader.find('.icon');

    this.header = $('header');
    this.search = $('#rwdSearch');
    this.lightbox = $('#rwdLightbox');
    // this.searchForm     = this.search.find('#objectSearch');
    // this.searchForm     = this.search.find('#rwdSearchForm');

    this.searchForm = $('form'); //全部form底下的搜尋
    this.searchBtn = this.search.find('#searchButton');
    this.select = $('#onlySelectBar');
    this.sort = this.select.find('#orderChoose');
    this.type = this.select.find('#prefectureChoose');
    this.realtyListDOM = $('#buy_list_content');
    this.qty = this.select.find('#orderQty');
    this.paginate = $('#paginate a');
    this.paginateSelect = $('#paginate select');

    this.sortVal = this.search.find('#orderValue');
    this.typeVal = this.search.find('#prefectureValue');

    this.qtyVal = this.search.find('#maxRowValue');
    this.pageVal = this.search.find('#pageVal');

    //this.buyAjaxStatus = true;
  }
  /*
  scrollLoad() {
    //捲軸載入資料
    $(window).on('scroll', () => {
      let footerHeight = $("#footerAds").outerHeight() + $('footer').outerHeight();
      let scrollBottom = $(document).height() - $(window).height() - footerHeight;
      if($(window).scrollTop() >= scrollBottom - 200) {
        if(this.buyAjaxStatus == true) {
          this.pageVal.val(parseInt(this.pageVal.val()) + 1); //頁碼+1
          $.ajax({
            url     : 'ajaxObjectContent.php',
            data    : this.searchForm.serialize(),
            type    : 'POST',
            dataType: 'html',
            beforeSend: () => {
              this.buyAjaxStatus = false; //執行時，不再進入ajax讀取用
              $("#pageScroll").show();
            },
            success: (msg) => {
              $("#pageScroll").hide();
              if(msg != ''){
                //成功執行並有值回來的狀況
                $('.objRealty>ul').append(msg);
                this.buyAjaxStatus = true;
                  //引入外部模組
                let bodyCtrl = new BodyCtrl;
                let lazyLoad = new LazyLoad;
                let lightbox = new Lightbox;
                let track    = new Track;
                  lazyLoad.imgLoad();  //圖片延遲載入
                track.toggleTrack(); //加入追蹤
                lightbox.map();      //Lightbox-Google Map
                lightbox.form();     //Lightbox-表單
              }else{
                console.log(msg)
              }
            }
          });
        }
      }
    });
  }
  */
  //搜尋使用get


  _createClass(ObjListAJAX, [{
    key: 'getSearch',
    value: function getSearch(dataFile) {
      var _this = this;

      var getData = function getData() {
        //--------------------------
        //把該名字的所有name值加總為陣列，並轉為字串輸出
        function GetCheckedValue(checkBoxName) {
          var returnVal = $("input[name='" + checkBoxName + "']:checked").map(function () {
            // let returnVal = $("input[name='" + checkBoxName + "']").is(":checked").prop('checked',true).map(function () {
            return $(this).val();
          }).get();
          //過濾重覆值
          // console.log( checkBoxName+"::"+returnVal); 
          var result = returnVal.filter(function (element, index, arr) {
            return arr.indexOf(element) === index;
          });
          // console.log( returnVal ) ;
          return result.join(',');
        } //function GetCheckedValue(checkBoxName)  {

        //處理參數
        var keyName = ''; //暫存key值，判斷是否有重覆
        var getURL = _this.searchForm.find("input").map(function () {
          // console.log("進入:"+$(this).attr('name'));
          if ($(this).attr('type') === 'radio' || $(this).attr('type') === 'checkbox') {
            //radio、checkbox的陣列處理
            if ($(this).is(':checked') == true && $(this).val() != '不限') {
              //判斷是否有選取
              // console.log("處理陣列:"+$(this).attr('name'));
              return $(this).attr('name') + '=' + GetCheckedValue($(this).attr('name'));
            }
          } else {
            //非陣列處理
            //判斷空值
            if ($(this).val() != '' && $(this).length != 0 && $(this).attr('name') != 'nav') {
              return $(this).attr('name') + '=' + encodeURIComponent($(this).val());
            }
          }
        }).get(); //傳回時字串，用逗號分隔

        //過濾重覆值
        var result = getURL.filter(function (element, index, arr) {
          return arr.indexOf(element) === index;
        });
        // console.log(getURLString);
        var getURLString = Array.from(result).join('&'); //篩選完重覆，陣列轉字串 
        var formAction = _this.searchForm.attr('action'); //抓傳值路徑(買屋、租屋、新成屋頁面)
        location.href = './' + formAction + '&q=' + encodeURIComponent(getURLString); //轉址
        //--------------------------
      };
      getData(); //執行
    }
  }, {
    key: 'ajaxPost',
    value: function ajaxPost(dataFile) {
      var _this2 = this;

      var ajaxData = function ajaxData() {

        /*
        $.ajax({
          url : dataFile,
          type: 'POST',
          data: this.searchForm.serialize(),
          //傳送前動作
          beforeSend: () => {
            //引入外部模組
            let bodyCtrl = new BodyCtrl;
              //讀取頁面
            (checkDevice.ios || checkDevice.android) ? bodyCtrl.ctrl('scrollHideF') : bodyCtrl.ctrl('scrollHide');
            this.preloader.removeClass('active');
            this.logo.addClass('active');
              //畫面移動到搜尋區塊
            $('html, body').animate({+
              scrollTop: $('.area').offset().top - this.header.outerHeight()
            }, 1000);
          },
          //錯誤
          error: (xhr) => {
            //alert('Ajax request 發生錯誤');
          },
          //執行
          success: (response) => {
            //產生物件DOM
            this.realtyListDOM.html(response);
              //引入外部模組
            let bodyCtrl = new BodyCtrl;
            let lazyLoad = new LazyLoad;
            let lightbox = new Lightbox;
            let track    = new Track;
              //讀取頁面(移除)
            setTimeout(() => {
              this.logo.removeClass('active');
              this.preloader.addClass('active');
              bodyCtrl.ctrl('scrollShow');  //控制瀏覽器捲軸
              bodyCtrl.ctrl('scrollShowF'); //控制瀏覽器捲軸
            }, 500);
              lazyLoad.imgLoad();  //圖片延遲載入
            track.toggleTrack(); //加入追蹤
            lightbox.map();      //Lightbox-Google Map
            lightbox.form();     //Lightbox-表單
              //選擇頁碼
            $('#paginate a').on('click', (e) => {
              const $this = $(e.currentTarget);
              $('#page').val($this.attr('data-info'));
              ajaxData();
            });
            $('#paginate select').on('change', (e) => {
              const $this = $(e.currentTarget);
              $('#page').val($this.find('option:selected').attr("data-info"));
              ajaxData();
            });
          }
        });
        */
        //更改網址(此部分直接做get版本)
        //----------------------------
        /*
        //把該名字的所有name值加總為陣列，並轉為字串輸出
        function GetCheckedValue(checkBoxName)  { 
          let returnVal = $("input[name='" + checkBoxName + "']:checked").map(function () {
            return $(this).val();
          }).get();
          //過濾重覆值
          var result = returnVal.filter(function(element, index, arr){
            return arr.indexOf(element) === index;
          });
          // console.log('進入GetCheckedValue處理::'+result);
          return result.join(',');
        } //function GetCheckedValue(checkBoxName)  {
        //處理參數
        let keyName = ''; //暫存key值，判斷是否有重覆
        let getURL = this.searchForm.find("input").map(function () {
          // if( $(this).attr('name') != undefined ) {
            if($(this).attr('type') === 'radio' || $(this).attr('type') === 'checkbox' ) { //radio、checkbox的陣列處理
              if($(this).is(':checked') == true && $(this).val() != '不限') { //判斷是否有選取
                return $(this).attr('name')+'='+ GetCheckedValue( $(this).attr('name') );
              }
            } else {
              //非陣列處理
              if( $(this).val() != '' && $(this).length != 0 && $(this).attr('name') != 'nav' ) {
                return $(this).attr('name')+'='+encodeURIComponent($(this).val());
              }
            }
        }).get(); //傳回時字串，用逗號分隔
          //過濾重覆值
        var result = getURL.filter(function(element, index, arr){
          return arr.indexOf(element) === index;
        });
        console.log('ajaxPost');
        let getURLString = Array.from(result).join('&'); //篩選完重覆，陣列轉字串
        let formAction = this.searchForm.attr('action'); //抓傳值路徑(買屋、租屋、新成屋頁面)
        location.href='./' + formAction + '&q=' + encodeURIComponent(getURLString); //轉址
        alert('123');
        // history.pushState('./' + formAction + '&' + getURLString);
        // history.pushState('./?abc' );
        // var stateObj = { foo: "buy" };
        // history.pushState(stateObj, "買屋內頁", "./?nav=buy&q="+encodeURIComponent(getURLString));
        */

        //決定版get方式
        //把該名字的所有name值加總為陣列，並轉為字串輸出
        function GetCheckedValue(checkBoxName) {
          var returnVal = $("input[name='" + checkBoxName + "']:checked").map(function () {
            // let returnVal = $("input[name='" + checkBoxName + "']").is(":checked").prop('checked',true).map(function () {
            return $(this).val();
          }).get();
          //過濾重覆值
          // console.log( checkBoxName+"::"+returnVal); 
          var result = returnVal.filter(function (element, index, arr) {
            return arr.indexOf(element) === index;
          });
          // console.log( returnVal ) ;
          return result.join(',');
        } //function GetCheckedValue(checkBoxName)  {

        //處理參數
        var keyName = ''; //暫存key值，判斷是否有重覆
        var getURL = _this2.searchForm.find("input").map(function () {
          // console.log("進入:"+$(this).attr('name'));
          if ($(this).attr('type') === 'radio' || $(this).attr('type') === 'checkbox') {
            //radio、checkbox的陣列處理
            if ($(this).is(':checked') == true && $(this).val() != '不限') {
              //判斷是否有選取
              // console.log("處理陣列:"+$(this).attr('name'));
              return $(this).attr('name') + '=' + GetCheckedValue($(this).attr('name'));
            }
          } else {
            //非陣列處理
            //判斷空值
            if ($(this).val() != '' && $(this).length != 0 && $(this).attr('name') != 'nav') {
              return $(this).attr('name') + '=' + encodeURIComponent($(this).val());
            }
          }
        }).get(); //傳回時字串，用逗號分隔

        //過濾重覆值
        var result = getURL.filter(function (element, index, arr) {
          return arr.indexOf(element) === index;
        });
        // console.log(getURLString);
        var getURLString = Array.from(result).join('&'); //篩選完重覆，陣列轉字串 
        var formAction = _this2.searchForm.attr('action'); //抓傳值路徑(買屋、租屋、新成屋頁面)
        location.href = './' + formAction + '&q=' + encodeURIComponent(getURLString); //轉址
        // alert('456');

        //--------------------------
      };
      ajaxData();
    }
  }, {
    key: 'checkNavAjaxPost',
    value: function checkNavAjaxPost() {
      if (this.nav == 'buy' || this.nav == 'rent' || this.nav == 'all_object') {
        // console.log('ajax準備進入1');
        this.ajaxPost('ajax_buy_content.php');
        //this.scrollLoad();
      } else if (this.nav == 'new') {
        // console.log('ajax準備進入2');
        this.ajaxPost('ajax_newHouse_content.php');
        //this.scrollLoad();
      }
    }
  }, {
    key: 'ajaxSearch',
    value: function ajaxSearch() {
      var _this3 = this;

      //this.scrollLoad();
      //搜尋按鈕
      this.searchBtn.on('click', function () {
        _this3.lightbox.removeClass('active');
        _this3.search.removeClass('active');
        _this3.pageVal.val(1); //頁碼從1開始算
        _this3.checkNavAjaxPost();
      });
      this.searchForm.find('input[name=keyword_value]').bind('keypress', function (e) {
        if (e.keyCode == 13) {
          e.preventDefault();
          if (_this3.nav == 'buy' || _this3.nav == 'rent' || _this3.nav == 'new' || _this3.nav == 'all_object') {
            _this3.lightbox.removeClass('active');
            _this3.search.removesClass('active');
            _this3.pageVal.val(1); //頁碼從1開始算
            _this3.checkNavAjaxPost();
          }
        }
      });

      //Select-預設排序
      this.sort.on('change', function (e) {
        var $this = $(e.currentTarget);
        _this3.pageVal.val(1); //頁碼從1開始算
        _this3.sortVal.val($this.val());
        _this3.checkNavAjaxPost();
      });

      //Select-物件類型
      this.type.on('change', function (e) {
        var $this = $(e.currentTarget);
        _this3.pageVal.val(1); //頁碼從1開始算
        _this3.typeVal.val($this.val());
        _this3.checkNavAjaxPost();
      });

      //Select-顯示筆數
      this.qty.on('change', function (e) {
        var $this = $(e.currentTarget);
        _this3.pageVal.val(1); //頁碼從1開始算
        _this3.qtyVal.val($this.val());
        _this3.checkNavAjaxPost();
      });

      //選擇頁碼
      this.paginate.on('click', function (e) {
        // console.log('123');
        var $this = $(e.currentTarget);
        _this3.pageVal.val($this.attr('data-info'));
        _this3.checkNavAjaxPost();
      });

      this.paginateSelect.on('change', function (e) {
        var $this = $(e.currentTarget);
        _this3.pageVal.val($this.find('option:selected').attr("data-info"));
        _this3.checkNavAjaxPost();
      });
    }
  }]);

  return ObjListAJAX;
}();

//輸出


exports.ObjListAJAX = ObjListAJAX;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//取得高度最大值
var FilterHeight = function () {
  function FilterHeight() {
    _classCallCheck(this, FilterHeight);

    this.shObjs = $('.sameHeightObjs');
    this.sh = $('.sameHeight');
  }
  //取得最大高度


  _createClass(FilterHeight, [{
    key: 'objHeight',
    value: function objHeight(el) {
      el.attr('style', '');
      var maxHeight = el.map(function (i, e) {
        var $thisItem = $(e);
        return $thisItem.height();
      }).get();
      el.height(Math.max.apply(this, maxHeight));
    }
  }]);

  return FilterHeight;
}();

//整合


var SameHeight = function (_FilterHeight) {
  _inherits(SameHeight, _FilterHeight);

  function SameHeight() {
    _classCallCheck(this, SameHeight);

    return _possibleConstructorReturn(this, (SameHeight.__proto__ || Object.getPrototypeOf(SameHeight)).apply(this, arguments));
  }

  _createClass(SameHeight, [{
    key: 'resultHeight',
    value: function resultHeight() {
      var _this2 = this;

      _get(SameHeight.prototype.__proto__ || Object.getPrototypeOf(SameHeight.prototype), 'objHeight', this).call(this, this.shObjs);
      _get(SameHeight.prototype.__proto__ || Object.getPrototypeOf(SameHeight.prototype), 'objHeight', this).call(this, this.sh);
      //RWD 調整高度
      $(window).on('resize', function () {
        _get(SameHeight.prototype.__proto__ || Object.getPrototypeOf(SameHeight.prototype), 'objHeight', _this2).call(_this2, _this2.shObjs);
        _get(SameHeight.prototype.__proto__ || Object.getPrototypeOf(SameHeight.prototype), 'objHeight', _this2).call(_this2, _this2.sh);
      });
    }
  }]);

  return SameHeight;
}(FilterHeight);

//輸出


exports.SameHeight = SameHeight;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleSlide = exports.Tabs = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


__webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//Tabs 切換 DIV
var Tabs = function () {
  function Tabs() {
    _classCallCheck(this, Tabs);

    this.header = $('header');
    this.tabs = $('.tabBtns');
    this.btns = this.tabs.find('a, button');
    this.duration = 500;
    this.easing = 'easeOutExpo';
    this.showTab = 0;
  }
  //錨點跳躍


  _createClass(Tabs, [{
    key: 'linkScrollTo',
    value: function linkScrollTo() {
      var _this = this;

      this.btns.each(function (i, e) {
        $(e).on('click', function (event) {
          event.preventDefault();
          var position = 0;
          if (i === 5) {
            position = $('#actualData').offset().top - _this.header.outerHeight();
          } else {
            position = _this.tabs.offset().top - _this.header.outerHeight() - 20;
          }
          $('html, body').animate({
            scrollTop: position
          }, _this.duration, _this.easing);
        });
      });
    }
  }, {
    key: 'tabsToggle',
    value: function tabsToggle() {
      var _this2 = this;

      //錨點跳躍
      this.linkScrollTo();

      this.btns.each(function (i, e) {
        if (i !== 5) {
          var $default = _this2.btns.eq(_this2.showTab).addClass('active');
          $($default.attr('href')).addClass('active');
          $($default.attr('href')).siblings().removeClass('active');

          $(e).on('click', function () {
            var $clickTab = $(e).attr('href');
            _this2.btns.removeClass('active');
            $(e).addClass('active');
            $($clickTab).stop(false, true).addClass('active').siblings().removeClass('active');

            //環景看屋ajax
            /*
            if(i == 3) {
              //內容另外加入
              // $('#tab4').html('123');
              console.log('start');
              
              let obj_sn = $(e).attr('obj_sn');
              let obj_id = $(e).attr('obj_id');
              let nav = $(e).attr('nav');
              let obj_vr720 = $(e).attr('obj_vr720');
              let vr720Tabs = $(e).attr('vr720Tabs');
              // console.log(vr720Tabs);
              $.ajax('ajax_realty_720.php', { data: { obj_sn: obj_sn, obj_id:obj_id, nav: nav, obj_vr720: obj_vr720, vr720Tabs: vr720Tabs },
                  type: "post",
                  success: function(data) {
                    console.log('111');
                    $('#tab4').html(data);
                  }
                }
              ); //$.ajax(
                
              
              } //if(i == 3) {
              */

            //物件地圖ajax 

            if (i == 4) {

              var obj_id = $(e).attr('obj_id');

              //內容另外加入
              // alert('5');
              // $('#tab5').html(obj_id);

              // $.ajax('index.php?nav=ajax_realty_map&id=57862', { data: { id: obj_id },
              $.ajax('index.php?nav=ajax_realty_map', {
                data: { 'id': obj_id },
                type: "get",
                success: function success(data) {

                  $('#tab5').html(data);

                  // const iframeWindow = document.getElementsByTagName('iframe')[0].contentWindow;
                  // iframeWindow.document.body.innerHTML = data;
                } //success: function(data) {
              }); //$.ajax(
            } //if(i == 4) {


            return false;
          }).focus(function () {
            $(e).blur();
          });
        }
      });
    }
  }]);

  return Tabs;
}();

//Toggle Slide


var ToggleSlide = function () {
  function ToggleSlide() {
    _classCallCheck(this, ToggleSlide);

    this.slide = $('.slideBox');
    this.slideBtn = $('.slideBtn');
  }

  _createClass(ToggleSlide, [{
    key: 'toggleSlide',
    value: function toggleSlide() {
      var _this3 = this;

      this.slideBtn.on('click', function (e) {
        var $this = $(e.currentTarget);
        _this3.slide.addClass('active');
        $this.remove();
      });
    }
  }]);

  return ToggleSlide;
}();

//輸出

exports.Tabs = Tabs;
exports.ToggleSlide = ToggleSlide;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sticky = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); //引入外部模組


var _hcSticky = __webpack_require__(50);

var _hcSticky2 = _interopRequireDefault(_hcSticky);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sticky = function () {
  function Sticky() {
    _classCallCheck(this, Sticky);

    this.el = '#stickyBox';
  }

  _createClass(Sticky, [{
    key: 'move',
    value: function move() {
      var sticky = new _hcSticky2.default(this.el, {
        top: 60
      });
    }
  }]);

  return Sticky;
}();

//輸出


exports.Sticky = Sticky;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, __webpack_provided_window_dot_jQuery) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * HC-Sticky
 * =========
 * Version: 2.2.7
 * Author: Some Web Media
 * Author URL: https://github.com/somewebmedia
 * Plugin URL: https://github.com/somewebmedia/hc-sticky
 * Description: JavaScript library that makes any element on your page visible while you scroll
 * License: MIT
 */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t, e) {
  if ("object" == ( false ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports)) {
    if (!t.document) throw new Error("HC-Sticky requires a browser to run.");module.exports = e(t);
  } else  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e(t)),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : e(t);
}("undefined" != typeof window ? window : undefined, function (V) {
  var i,
      n,
      Q = V.document,
      U = { top: 0, bottom: 0, bottomEnd: 0, innerTop: 0, innerSticker: null, stickyClass: "sticky", stickTo: null, followScroll: !0, responsive: null, mobileFirst: !1, onStart: null, onStop: null, onBeforeResize: null, onResize: null, resizeDebounce: 100, disable: !1 },
      Y = function Y(t, e, o) {
    console.warn("%cHC Sticky:%c " + o + "%c '" + t + "'%c is now deprecated and will be removed. Use%c '" + e + "'%c instead.", "color: #fa253b", "color: default", "color: #5595c6", "color: default", "color: #5595c6", "color: default");
  },
      $ = function $(n, f) {
    var o = this;if (f = f || {}, !(n = "string" == typeof n ? Q.querySelector(n) : n)) return !1;f.queries && Y("queries", "responsive", "option"), f.queryFlow && Y("queryFlow", "mobileFirst", "option");var p = {},
        u = $.Helpers,
        s = n.parentNode;"static" === u.getStyle(s, "position") && (s.style.position = "relative");function d(t) {
      u.isEmptyObject(t = t || {}) && !u.isEmptyObject(p) || (p = Object.assign({}, U, p, t));
    }function t() {
      return p.disable;
    }function e() {
      var t,
          e = p.responsive || p.queries;if (e) {
        var o = V.innerWidth;if (t = f, (p = Object.assign({}, U, t || {})).mobileFirst) for (var i in e) {
          i <= o && !u.isEmptyObject(e[i]) && d(e[i]);
        } else {
          var n,
              s = [];for (n in e) {
            var r = {};r[n] = e[n], s.push(r);
          }for (var l = s.length - 1; 0 <= l; l--) {
            var a = s[l],
                c = Object.keys(a)[0];o <= c && !u.isEmptyObject(a[c]) && d(a[c]);
          }
        }
      }
    }function i() {
      var t, e, o, i;I.css = (t = n, e = u.getCascadedStyle(t), o = u.getStyle(t), i = { height: t.offsetHeight + "px", left: e.left, right: e.right, top: e.top, bottom: e.bottom, position: o.position, display: o.display, verticalAlign: o.verticalAlign, boxSizing: o.boxSizing, marginLeft: e.marginLeft, marginRight: e.marginRight, marginTop: e.marginTop, marginBottom: e.marginBottom, paddingLeft: e.paddingLeft, paddingRight: e.paddingRight }, e.float && (i.float = e.float || "none"), e.cssFloat && (i.cssFloat = e.cssFloat || "none"), o.MozBoxSizing && (i.MozBoxSizing = o.MozBoxSizing), i.width = "auto" !== e.width ? e.width : "border-box" === i.boxSizing || "border-box" === i.MozBoxSizing ? t.offsetWidth + "px" : o.width, i), P.init(), y = !(!p.stickTo || !("document" === p.stickTo || p.stickTo.nodeType && 9 === p.stickTo.nodeType || "object" == _typeof(p.stickTo) && p.stickTo instanceof ("undefined" != typeof HTMLDocument ? HTMLDocument : Document))), h = p.stickTo ? y ? Q : u.getElement(p.stickTo) : s, z = (R = function R() {
        var t = n.offsetHeight + (parseInt(I.css.marginTop) || 0) + (parseInt(I.css.marginBottom) || 0),
            e = (z || 0) - t;return -1 <= e && e <= 1 ? z : t;
      })(), v = (H = function H() {
        return y ? Math.max(Q.documentElement.clientHeight, Q.body.scrollHeight, Q.documentElement.scrollHeight, Q.body.offsetHeight, Q.documentElement.offsetHeight) : h.offsetHeight;
      })(), S = y ? 0 : u.offset(h).top, w = p.stickTo ? y ? 0 : u.offset(s).top : S, E = V.innerHeight, N = n.offsetTop - (parseInt(I.css.marginTop) || 0), b = u.getElement(p.innerSticker), L = isNaN(p.top) && -1 < p.top.indexOf("%") ? parseFloat(p.top) / 100 * E : p.top, k = isNaN(p.bottom) && -1 < p.bottom.indexOf("%") ? parseFloat(p.bottom) / 100 * E : p.bottom, x = b ? b.offsetTop : p.innerTop || 0, T = isNaN(p.bottomEnd) && -1 < p.bottomEnd.indexOf("%") ? parseFloat(p.bottomEnd) / 100 * E : p.bottomEnd, j = S - L + x + N;
    }function r() {
      z = R(), v = H(), O = S + v - L - T, C = E < z;var t,
          e = V.pageYOffset || Q.documentElement.scrollTop,
          o = u.offset(n).top,
          i = o - e;B = e < F ? "up" : "down", A = e - F, j < (F = e) ? O + L + (C ? k : 0) - (p.followScroll && C ? 0 : L) <= e + z - x - (E - (j - x) < z - x && p.followScroll && 0 < (t = z - E - x) ? t : 0) ? I.release({ position: "absolute", bottom: w + s.offsetHeight - O - L }) : C && p.followScroll ? "down" == B ? i + z + k <= E + .9 ? I.stick({ bottom: k }) : "fixed" === I.position && I.release({ position: "absolute", top: o - L - j - A + x }) : Math.ceil(i + x) < 0 && "fixed" === I.position ? I.release({ position: "absolute", top: o - L - j + x - A }) : e + L - x <= o && I.stick({ top: L - x }) : I.stick({ top: L - x }) : I.release({ stop: !0 });
    }function l() {
      M && (V.removeEventListener("scroll", r, u.supportsPassive), M = !1);
    }function a() {
      null !== n.offsetParent && "none" !== u.getStyle(n, "display") ? (i(), v < z ? l() : (r(), M || (V.addEventListener("scroll", r, u.supportsPassive), M = !0))) : l();
    }function c() {
      n.style.position = "", n.style.left = "", n.style.top = "", n.style.bottom = "", n.style.width = "", n.classList ? n.classList.remove(p.stickyClass) : n.className = n.className.replace(new RegExp("(^|\\b)" + p.stickyClass.split(" ").join("|") + "(\\b|$)", "gi"), " "), I.css = {}, !(I.position = null) === P.isAttached && P.detach();
    }function g() {
      c(), e(), (t() ? l : a)();
    }function m() {
      q && (V.removeEventListener("resize", W, u.supportsPassive), q = !1), l();
    }var y,
        h,
        b,
        v,
        S,
        w,
        E,
        L,
        k,
        x,
        T,
        j,
        O,
        C,
        z,
        N,
        H,
        R,
        A,
        B,
        I = { css: {}, position: null, stick: function stick(t) {
        t = t || {}, u.hasClass(n, p.stickyClass) || (!1 === P.isAttached && P.attach(), I.position = "fixed", n.style.position = "fixed", n.style.left = P.offsetLeft + "px", n.style.width = P.width, void 0 === t.bottom ? n.style.bottom = "auto" : n.style.bottom = t.bottom + "px", void 0 === t.top ? n.style.top = "auto" : n.style.top = t.top + "px", n.classList ? n.classList.add(p.stickyClass) : n.className += " " + p.stickyClass, p.onStart && p.onStart.call(n, Object.assign({}, p)));
      }, release: function release(t) {
        var e;(t = t || {}).stop = t.stop || !1, !0 !== t.stop && "fixed" !== I.position && null !== I.position && (void 0 === t.top && void 0 === t.bottom || void 0 !== t.top && (parseInt(u.getStyle(n, "top")) || 0) === t.top || void 0 !== t.bottom && (parseInt(u.getStyle(n, "bottom")) || 0) === t.bottom) || (!0 === t.stop ? !0 === P.isAttached && P.detach() : !1 === P.isAttached && P.attach(), e = t.position || I.css.position, I.position = e, n.style.position = e, n.style.left = !0 === t.stop ? I.css.left : P.positionLeft + "px", n.style.width = ("absolute" !== e ? I.css : P).width, void 0 === t.bottom ? n.style.bottom = !0 === t.stop ? "" : "auto" : n.style.bottom = t.bottom + "px", void 0 === t.top ? n.style.top = !0 === t.stop ? "" : "auto" : n.style.top = t.top + "px", n.classList ? n.classList.remove(p.stickyClass) : n.className = n.className.replace(new RegExp("(^|\\b)" + p.stickyClass.split(" ").join("|") + "(\\b|$)", "gi"), " "), p.onStop && p.onStop.call(n, Object.assign({}, p)));
      } },
        P = { el: Q.createElement("div"), offsetLeft: null, positionLeft: null, width: null, isAttached: !1, init: function init() {
        for (var t in P.el.className = "sticky-spacer", I.css) {
          P.el.style[t] = I.css[t];
        }P.el.style["z-index"] = "-1";var e = u.getStyle(n);P.offsetLeft = u.offset(n).left - (parseInt(e.marginLeft) || 0), P.positionLeft = u.position(n).left, P.width = u.getStyle(n, "width");
      }, attach: function attach() {
        s.insertBefore(P.el, n), P.isAttached = !0;
      }, detach: function detach() {
        P.el = s.removeChild(P.el), P.isAttached = !1;
      } },
        F = V.pageYOffset || Q.documentElement.scrollTop,
        M = !1,
        q = !1,
        D = function D() {
      p.onBeforeResize && p.onBeforeResize.call(n, Object.assign({}, p)), g(), p.onResize && p.onResize.call(n, Object.assign({}, p));
    },
        W = p.resizeDebounce ? u.debounce(D, p.resizeDebounce) : D,
        D = function D() {
      q || (V.addEventListener("resize", W, u.supportsPassive), q = !0), e(), (t() ? l : a)();
    };this.options = function (t) {
      return t ? p[t] : Object.assign({}, p);
    }, this.refresh = g, this.update = function (t) {
      d(t), f = Object.assign({}, f, t || {}), g();
    }, this.attach = D, this.detach = m, this.destroy = function () {
      m(), c();
    }, this.triggerMethod = function (t, e) {
      "function" == typeof o[t] && o[t](e);
    }, this.reinit = function () {
      Y("reinit", "refresh", "method"), g();
    }, d(f), D(), V.addEventListener("load", g);
  };return void 0 !== V.jQuery && (i = V.jQuery, n = "hcSticky", i.fn.extend({ hcSticky: function hcSticky(e, o) {
      return this.length ? "options" === e ? i.data(this.get(0), n).options() : this.each(function () {
        var t = i.data(this, n);t ? t.triggerMethod(e, o) : (t = new $(this, e), i.data(this, n, t));
      }) : this;
    } })), V.hcSticky = V.hcSticky || $, $;
}), function (a) {
  var t = a.hcSticky,
      c = a.document;"function" != typeof Object.assign && Object.defineProperty(Object, "assign", { value: function value(t, e) {
      if (null == t) throw new TypeError("Cannot convert undefined or null to object");for (var o = Object(t), i = 1; i < arguments.length; i++) {
        var n = arguments[i];if (null != n) for (var s in n) {
          Object.prototype.hasOwnProperty.call(n, s) && (o[s] = n[s]);
        }
      }return o;
    }, writable: !0, configurable: !0 }), Array.prototype.forEach || (Array.prototype.forEach = function (t) {
    var e, o;if (null == this) throw new TypeError("this is null or not defined");var i,
        n = Object(this),
        s = n.length >>> 0;if ("function" != typeof t) throw new TypeError(t + " is not a function");for (1 < arguments.length && (e = arguments[1]), o = 0; o < s;) {
      o in n && (i = n[o], t.call(e, i, o, n)), o++;
    }
  });var e = !1;try {
    var o = Object.defineProperty({}, "passive", { get: function get() {
        e = { passive: !1 };
      } });a.addEventListener("testPassive", null, o), a.removeEventListener("testPassive", null, o);
  } catch (t) {}function n(t, e) {
    return a.getComputedStyle ? e ? c.defaultView.getComputedStyle(t, null).getPropertyValue(e) : c.defaultView.getComputedStyle(t, null) : t.currentStyle ? e ? t.currentStyle[e.replace(/-\w/g, function (t) {
      return t.toUpperCase().replace("-", "");
    })] : t.currentStyle : void 0;
  }function s(t) {
    var e = t.getBoundingClientRect(),
        o = a.pageYOffset || c.documentElement.scrollTop,
        t = a.pageXOffset || c.documentElement.scrollLeft;return { top: e.top + o, left: e.left + t };
  }t.Helpers = { supportsPassive: e, isEmptyObject: function isEmptyObject(t) {
      for (var e in t) {
        return !1;
      }return !0;
    }, debounce: function debounce(i, n, s) {
      var r;return function () {
        var t = this,
            e = arguments,
            o = s && !r;clearTimeout(r), r = setTimeout(function () {
          r = null, s || i.apply(t, e);
        }, n), o && i.apply(t, e);
      };
    }, hasClass: function hasClass(t, e) {
      return t.classList ? t.classList.contains(e) : new RegExp("(^| )" + e + "( |$)", "gi").test(t.className);
    }, offset: s, position: function position(t) {
      var e = t.offsetParent,
          o = s(e),
          i = s(t),
          e = n(e),
          t = n(t);return o.top += parseInt(e.borderTopWidth) || 0, o.left += parseInt(e.borderLeftWidth) || 0, { top: i.top - o.top - (parseInt(t.marginTop) || 0), left: i.left - o.left - (parseInt(t.marginLeft) || 0) };
    }, getElement: function getElement(t) {
      var e = null;return "string" == typeof t ? e = c.querySelector(t) : __webpack_provided_window_dot_jQuery && t instanceof __webpack_provided_window_dot_jQuery && t.length ? e = t[0] : t instanceof Element && (e = t), e;
    }, getStyle: n, getCascadedStyle: function getCascadedStyle(t) {
      var e,
          o = t.cloneNode(!0);o.style.display = "none", Array.prototype.slice.call(o.querySelectorAll('input[type="radio"]')).forEach(function (t) {
        t.removeAttribute("name");
      }), t.parentNode.insertBefore(o, t.nextSibling), o.currentStyle ? e = o.currentStyle : a.getComputedStyle && (e = c.defaultView.getComputedStyle(o, null));var i,
          n,
          s,
          r = {};for (i in e) {
        !isNaN(i) || "string" != typeof e[i] && "number" != typeof e[i] || (r[i] = e[i]);
      }if (Object.keys(r).length < 3) for (var l in r = {}, e) {
        isNaN(l) || (r[e[l].replace(/-\w/g, function (t) {
          return t.toUpperCase().replace("-", "");
        })] = e.getPropertyValue(e[l]));
      }return r.margin || "auto" !== r.marginLeft ? r.margin || r.marginLeft !== r.marginRight || r.marginLeft !== r.marginTop || r.marginLeft !== r.marginBottom || (r.margin = r.marginLeft) : r.margin = "auto", r.margin || "0px" !== r.marginLeft || "0px" !== r.marginRight || (s = (n = t.offsetLeft - t.parentNode.offsetLeft) - (parseInt(r.left) || 0) - (parseInt(r.right) || 0), 0 != (s = t.parentNode.offsetWidth - t.offsetWidth - n - (parseInt(r.right) || 0) + (parseInt(r.left) || 0) - s) && 1 != s || (r.margin = "auto")), o.parentNode.removeChild(o), o = null, r;
    } };
}(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)(module), __webpack_require__(0)))

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//文字欄位高度自動
var TextareaAutoHeight = function () {
  function TextareaAutoHeight() {
    _classCallCheck(this, TextareaAutoHeight);

    this.textarea = $('textarea');
  }

  _createClass(TextareaAutoHeight, [{
    key: 'autoHeight',
    value: function autoHeight() {
      this.textarea.each(function (i, e) {
        var offset = e.offsetHeight - e.clientHeight;
        $(e).on('keyup input', function () {
          $(e).css('height', 'auto').css('height', e.scrollHeight + offset);
        });
      });
    }
  }]);

  return TextareaAutoHeight;
}();

//輸出


exports.TextareaAutoHeight = TextareaAutoHeight;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//演講報名表
var SpeechForm = function () {
  function SpeechForm() {
    _classCallCheck(this, SpeechForm);

    this.window = $(window);
    this.header = $('header');
    this.speechForm = $('#speechForm');
    this.footerAds = $('#footerAds');
    this.footer = $('footer');
  }

  _createClass(SpeechForm, [{
    key: 'rwdHeight',
    value: function rwdHeight() {
      var fullScreenHeight = this.window.height() - this.header.outerHeight();
      this.speechForm.css('height', fullScreenHeight);
    }
  }, {
    key: 'form',
    value: function form() {
      var _this = this;

      this.rwdHeight();
      this.window.on('resize', function () {
        _this.rwdHeight();
      });
      this.footerAds.hide();
      this.footer.hide();
    }
  }]);

  return SpeechForm;
}();

//輸出


exports.SpeechForm = SpeechForm;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//引入外部模組
// const InfiniteScroll = require('infinite-scroll/dist/infinite-scroll.pkgd'); //引入外部套件
// import imagesLoaded from "imagesloaded";

var Subscription = function () {
  function Subscription(member_authCode) {
    _classCallCheck(this, Subscription);

    //宣告共同參數
    this.member_authCode = member_authCode;
    // this.subScriptionForm = '#subScriptionForm';
    this.subScriptionForm = $('#subScriptionForm'); //新增&編輯的form名稱 object
  }
  //訂閱條件 - 新增


  _createClass(Subscription, [{
    key: 'addCondition',
    value: function addCondition() {
      $('#submitMapBtn').on('click', function () {
        var ajaxFile = 'ajax_subscription_onsale_process.php';

        var city_checked = $("input[name='city']").is(":checked");
        var area_checked = $("input[name='area']").not('#tbAreaAll').is(":checked");

        if (city_checked && area_checked) {

          $.post(ajaxFile, {
            dataType: 'json',
            'subscription_type': 1,
            'member_authCode': $('#member_authCode').val(),
            'status': $('#status').val(),
            'formData': $('#subScriptionForm').serializeArray()

          }, function (json) {
            //處理訂閱完成後回來的程式
            if (json === 'ok') {

              Swal.fire({
                title: '新增訂閱已完成',
                confirmButtonText: '確定'
              }).then(function (result) {
                if (result.isConfirmed) {
                  history.go(-1);
                }
              });

              // alert('新增訂閱已完成');
              // location.href = '?nav=subscription_onsale';
              // history.go(-1);
            }
            // }, 'json'); //$.pot(ajaxFile, {
          }); //$.post(ajaxFile, {  
        } else {
          Swal.fire({
            title: '請至少選一個縣市、區',
            icon: 'error'
          });
        } //if(city_checked && area_checked) {

        // location.href='?nav=subscription_onsale';
      });
    } //addCondition() {

    //訂閱條件 - 修改

  }, {
    key: 'editCondition',
    value: function editCondition() {
      $('#submitMapBtn').on('click', function () {
        var ajaxFile = 'ajax_subscription_onsale_process.php';

        var city_checked = $("input[name='city']").is(":checked");
        var area_checked = $("input[name='area']").not('#tbAreaAll').is(":checked");

        if (city_checked && area_checked) {

          $.post(ajaxFile, {
            dataType: 'json',
            'subscription_type': 1,
            'subscription_id': $('#subscription_id').val(),
            'member_authCode': $('#member_authCode').val(),
            'status': $('#status').val(),
            'formData': $('#subScriptionForm').serializeArray()

          }, function (json) {
            //處理訂閱完成後回來的程式
            console.log(json);
            if (json === 'ok') {

              Swal.fire({
                title: '修改完成',
                confirmButtonText: '確定'
              }).then(function (result) {
                if (result.isConfirmed) {
                  history.go(-1);
                }
              });

              // alert('修改完成');

              // location.href = '?nav=subscription_onsale';
              // history.go(-1);
            }
          }); //$.post(ajaxFile, {  
        } else {
          Swal.fire({
            title: '請至少選一個縣市、區'
          });
        } //if(city_checked && area_checked) {    

        // console.log('修改');
      });
    } //editCondition(subscription_id) {

  }, {
    key: 'delCondition',
    value: function delCondition() {
      $('.del_subsctiption').on('click', function () {
        var _this = this;

        Swal.fire({
          title: '確認是否刪除此訂閱條件?',
          showDenyButton: true,
          confirmButtonText: '是',
          denyButtonText: '\u5426'
        }).then(function (result) {
          /* Read more about isConfirmed, isDenied below */
          /*
          if (result.isConfirmed) {
            Swal.fire('Saved!', '', 'success')
          } else if (result.isDenied) {
            Swal.fire('Changes are not saved', '', 'info')
          }
          */
          if (result.isConfirmed) {
            var ajaxFile = 'ajax_subscription_del.php';
            $.post(ajaxFile, {
              dataType: 'json',
              member_authCode: $('#member_authCode').val(),
              subscription_id: $(_this).attr('data-info')

            }, function (json) {
              //處理訂閱完成後回來的程式
              if (json === 'ok') {
                // alert('已刪除');
                Swal.fire({
                  title: '已刪除',
                  confirmButtonText: '確定'
                }).then(function (result) {
                  if (result.isConfirmed) {
                    location.reload();
                  }
                });

                // Swal.fire('已刪除', '', 'success');

                // location.reload();
              }
            }); //$.post(ajaxFile, {  
          } //if (result.isConfirmed) {
        });
        /*
        if(confirm('確認是否刪除此訂閱條件?')) {
          var ajaxFile = 'ajax_subscription_del.php';
          $.post(ajaxFile, {
            dataType   : 'json',
            member_authCode: $('#member_authCode').val(),
            subscription_id: $(this).attr('data-info')
            
          }, (json) => {
            //處理訂閱完成後回來的程式
            if(json === 'ok') {
              alert('已刪除');
              location.reload();
            }
          }); //$.post(ajaxFile, {  
        } //if(confirm('確認是否刪除此訂閱條件?')) {
          */
      });
    } //delCondition($del_id) {

    //通知開啟或關閉

  }, {
    key: 'noticeChange',
    value: function noticeChange() {
      // console.log('改變通知狀態');
      $('.fa-bell').on('click', function () {

        var ajaxFile = 'ajax_subscription_onsale_notice.php';
        $.post(ajaxFile, {
          // dataType   : 'json',
          dataType: 'html',
          member_authCode: $('#member_authCode').val(),
          subscription_id: $(this).attr('data-info')

        }, function (json) {
          //處理訂閱完成後回來的程式
          console.log(json);
          if (json === 'ok') {
            // alert('已更改');
            // location.reload();
            Swal.fire({
              title: '已更改',
              confirmButtonText: '確定'
            }).then(function (result) {
              if (result.isConfirmed) {
                location.reload();
              }
            });
          }
        }); //$.post(ajaxFile, {  
      });
    } //noticeChange($subscription_id) {

    //下拉到底拉新頁面進來

  }, {
    key: 'jsonLoading',
    value: function jsonLoading() {

      // console.log(InfiniteScroll);
      // var infiniteScroll = new InfiniteScroll();

      // var $container = $('.tabBoxContent').infiniteScroll({
      //   append: false, // disable automatic appending
      // });


      //以下使用jquery的scroll，可用但較吃效能
      $(window).scroll(function () {
        var msg_list = $('.tabBoxContent');

        // if ($(document).scrollTop()<=0){
        // alert("滾動條已經到達頂部爲0");
        // }


        //原本使用
        if ($(document).scrollTop() + 1 >= $(document).height() - $(window).height()) {

          // var isLoadingVisible = $('.loading').is(':visible');
          // console.log('sLoadingVisible的狀態');
          // console.log(isLoadingVisible);
          // var scrollDistanceFromBottom = $(document).height() - ($(window).scrollTop() + $(window).height());

          // if (!isLoadingVisible && scrollDistanceFromBottom <= 10) {


          // if($(window).scrollTop() + $(window).height() == $(document).height()) {
          // alert('123');
          //底部處理
          $('.loading').show(); //打開
          var subscription_id = $('#subscription_id').val(); //訂閱id
          var page_val = parseInt($('#page').val()); //頁碼


          $.get('ajax_subscription_onsale_objs.php', { id: subscription_id, page: page_val }).done(function (data) {
            msg_list.append(data);
            $('#page').val(page_val + 1); //頁碼+1
            $('.loading').hide(); //關閉
          });
        }
      });
    } //function jsonLoading() {

  }]);

  return Subscription;
}(); //class Subscription{


//輸出


exports.Subscription = Subscription;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate, module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t, e) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.swal = e() : t.swal = e();
}(undefined, function () {
  return function (t) {
    function e(o) {
      if (n[o]) return n[o].exports;var r = n[o] = { i: o, l: !1, exports: {} };return t[o].call(r.exports, r, r.exports, e), r.l = !0, r.exports;
    }var n = {};return e.m = t, e.c = n, e.d = function (t, n, o) {
      e.o(t, n) || Object.defineProperty(t, n, { configurable: !1, enumerable: !0, get: o });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 8);
  }([function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = "swal-button";e.CLASS_NAMES = { MODAL: "swal-modal", OVERLAY: "swal-overlay", SHOW_MODAL: "swal-overlay--show-modal", MODAL_TITLE: "swal-title", MODAL_TEXT: "swal-text", ICON: "swal-icon", ICON_CUSTOM: "swal-icon--custom", CONTENT: "swal-content", FOOTER: "swal-footer", BUTTON_CONTAINER: "swal-button-container", BUTTON: o, CONFIRM_BUTTON: o + "--confirm", CANCEL_BUTTON: o + "--cancel", DANGER_BUTTON: o + "--danger", BUTTON_LOADING: o + "--loading", BUTTON_LOADER: o + "__loader" }, e.default = e.CLASS_NAMES;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 }), e.getNode = function (t) {
      var e = "." + t;return document.querySelector(e);
    }, e.stringToNode = function (t) {
      var e = document.createElement("div");return e.innerHTML = t.trim(), e.firstChild;
    }, e.insertAfter = function (t, e) {
      var n = e.nextSibling;e.parentNode.insertBefore(t, n);
    }, e.removeNode = function (t) {
      t.parentElement.removeChild(t);
    }, e.throwErr = function (t) {
      throw t = t.replace(/ +(?= )/g, ""), "SweetAlert: " + (t = t.trim());
    }, e.isPlainObject = function (t) {
      if ("[object Object]" !== Object.prototype.toString.call(t)) return !1;var e = Object.getPrototypeOf(t);return null === e || e === Object.prototype;
    }, e.ordinalSuffixOf = function (t) {
      var e = t % 10,
          n = t % 100;return 1 === e && 11 !== n ? t + "st" : 2 === e && 12 !== n ? t + "nd" : 3 === e && 13 !== n ? t + "rd" : t + "th";
    };
  }, function (t, e, n) {
    "use strict";
    function o(t) {
      for (var n in t) {
        e.hasOwnProperty(n) || (e[n] = t[n]);
      }
    }Object.defineProperty(e, "__esModule", { value: !0 }), o(n(25));var r = n(26);e.overlayMarkup = r.default, o(n(27)), o(n(28)), o(n(29));var i = n(0),
        a = i.default.MODAL_TITLE,
        s = i.default.MODAL_TEXT,
        c = i.default.ICON,
        l = i.default.FOOTER;e.iconMarkup = '\n  <div class="' + c + '"></div>', e.titleMarkup = '\n  <div class="' + a + '"></div>\n', e.textMarkup = '\n  <div class="' + s + '"></div>', e.footerMarkup = '\n  <div class="' + l + '"></div>\n';
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(1);e.CONFIRM_KEY = "confirm", e.CANCEL_KEY = "cancel";var r = { visible: !0, text: null, value: null, className: "", closeModal: !0 },
        i = Object.assign({}, r, { visible: !1, text: "Cancel", value: null }),
        a = Object.assign({}, r, { text: "OK", value: !0 });e.defaultButtonList = { cancel: i, confirm: a };var s = function s(t) {
      switch (t) {case e.CONFIRM_KEY:
          return a;case e.CANCEL_KEY:
          return i;default:
          var n = t.charAt(0).toUpperCase() + t.slice(1);return Object.assign({}, r, { text: n, value: t });}
    },
        c = function c(t, e) {
      var n = s(t);return !0 === e ? Object.assign({}, n, { visible: !0 }) : "string" == typeof e ? Object.assign({}, n, { visible: !0, text: e }) : o.isPlainObject(e) ? Object.assign({ visible: !0 }, n, e) : Object.assign({}, n, { visible: !1 });
    },
        l = function l(t) {
      for (var e = {}, n = 0, o = Object.keys(t); n < o.length; n++) {
        var r = o[n],
            a = t[r],
            s = c(r, a);e[r] = s;
      }return e.cancel || (e.cancel = i), e;
    },
        u = function u(t) {
      var n = {};switch (t.length) {case 1:
          n[e.CANCEL_KEY] = Object.assign({}, i, { visible: !1 });break;case 2:
          n[e.CANCEL_KEY] = c(e.CANCEL_KEY, t[0]), n[e.CONFIRM_KEY] = c(e.CONFIRM_KEY, t[1]);break;default:
          o.throwErr("Invalid number of 'buttons' in array (" + t.length + ").\n      If you want more than 2 buttons, you need to use an object!");}return n;
    };e.getButtonListOpts = function (t) {
      var n = e.defaultButtonList;return "string" == typeof t ? n[e.CONFIRM_KEY] = c(e.CONFIRM_KEY, t) : Array.isArray(t) ? n = u(t) : o.isPlainObject(t) ? n = l(t) : !0 === t ? n = u([!0, !0]) : !1 === t ? n = u([!1, !1]) : void 0 === t && (n = e.defaultButtonList), n;
    };
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(1),
        r = n(2),
        i = n(0),
        a = i.default.MODAL,
        s = i.default.OVERLAY,
        c = n(30),
        l = n(31),
        u = n(32),
        f = n(33);e.injectElIntoModal = function (t) {
      var e = o.getNode(a),
          n = o.stringToNode(t);return e.appendChild(n), n;
    };var d = function d(t) {
      t.className = a, t.textContent = "";
    },
        p = function p(t, e) {
      d(t);var n = e.className;n && t.classList.add(n);
    };e.initModalContent = function (t) {
      var e = o.getNode(a);p(e, t), c.default(t.icon), l.initTitle(t.title), l.initText(t.text), f.default(t.content), u.default(t.buttons, t.dangerMode);
    };var m = function m() {
      var t = o.getNode(s),
          e = o.stringToNode(r.modalMarkup);t.appendChild(e);
    };e.default = m;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(3),
        r = { isOpen: !1, promise: null, actions: {}, timer: null },
        i = Object.assign({}, r);e.resetState = function () {
      i = Object.assign({}, r);
    }, e.setActionValue = function (t) {
      if ("string" == typeof t) return a(o.CONFIRM_KEY, t);for (var e in t) {
        a(e, t[e]);
      }
    };var a = function a(t, e) {
      i.actions[t] || (i.actions[t] = {}), Object.assign(i.actions[t], { value: e });
    };e.setActionOptionsFor = function (t, e) {
      var n = (void 0 === e ? {} : e).closeModal,
          o = void 0 === n || n;Object.assign(i.actions[t], { closeModal: o });
    }, e.default = i;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(1),
        r = n(3),
        i = n(0),
        a = i.default.OVERLAY,
        s = i.default.SHOW_MODAL,
        c = i.default.BUTTON,
        l = i.default.BUTTON_LOADING,
        u = n(5);e.openModal = function () {
      o.getNode(a).classList.add(s), u.default.isOpen = !0;
    };var f = function f() {
      o.getNode(a).classList.remove(s), u.default.isOpen = !1;
    };e.onAction = function (t) {
      void 0 === t && (t = r.CANCEL_KEY);var e = u.default.actions[t],
          n = e.value;if (!1 === e.closeModal) {
        var i = c + "--" + t;o.getNode(i).classList.add(l);
      } else f();u.default.promise.resolve(n);
    }, e.getState = function () {
      var t = Object.assign({}, u.default);return delete t.promise, delete t.timer, t;
    }, e.stopLoading = function () {
      for (var t = document.querySelectorAll("." + c), e = 0; e < t.length; e++) {
        t[e].classList.remove(l);
      }
    };
  }, function (t, e) {
    var n;n = function () {
      return this;
    }();try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (n = window);
    }t.exports = n;
  }, function (t, e, n) {
    (function (e) {
      t.exports = e.sweetAlert = n(9);
    }).call(e, n(7));
  }, function (t, e, n) {
    (function (e) {
      t.exports = e.swal = n(10);
    }).call(e, n(7));
  }, function (t, e, n) {
    "undefined" != typeof window && n(11), n(16);var o = n(23).default;t.exports = o;
  }, function (t, e, n) {
    var o = n(12);"string" == typeof o && (o = [[t.i, o, ""]]);var r = { insertAt: "top" };r.transform = void 0;n(14)(o, r);o.locals && (t.exports = o.locals);
  }, function (t, e, n) {
    e = t.exports = n(13)(void 0), e.push([t.i, '.swal-icon--error{border-color:#f27474;-webkit-animation:animateErrorIcon .5s;animation:animateErrorIcon .5s}.swal-icon--error__x-mark{position:relative;display:block;-webkit-animation:animateXMark .5s;animation:animateXMark .5s}.swal-icon--error__line{position:absolute;height:5px;width:47px;background-color:#f27474;display:block;top:37px;border-radius:2px}.swal-icon--error__line--left{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:17px}.swal-icon--error__line--right{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:16px}@-webkit-keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@-webkit-keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}@keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}.swal-icon--warning{border-color:#f8bb86;-webkit-animation:pulseWarning .75s infinite alternate;animation:pulseWarning .75s infinite alternate}.swal-icon--warning__body{width:5px;height:47px;top:10px;border-radius:2px;margin-left:-2px}.swal-icon--warning__body,.swal-icon--warning__dot{position:absolute;left:50%;background-color:#f8bb86}.swal-icon--warning__dot{width:7px;height:7px;border-radius:50%;margin-left:-4px;bottom:-11px}@-webkit-keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}@keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}.swal-icon--success{border-color:#a5dc86}.swal-icon--success:after,.swal-icon--success:before{content:"";border-radius:50%;position:absolute;width:60px;height:120px;background:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal-icon--success:before{border-radius:120px 0 0 120px;top:-7px;left:-33px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:60px 60px;transform-origin:60px 60px}.swal-icon--success:after{border-radius:0 120px 120px 0;top:-11px;left:30px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 60px;transform-origin:0 60px;-webkit-animation:rotatePlaceholder 4.25s ease-in;animation:rotatePlaceholder 4.25s ease-in}.swal-icon--success__ring{width:80px;height:80px;border:4px solid hsla(98,55%,69%,.2);border-radius:50%;box-sizing:content-box;position:absolute;left:-4px;top:-4px;z-index:2}.swal-icon--success__hide-corners{width:5px;height:90px;background-color:#fff;padding:1px;position:absolute;left:28px;top:8px;z-index:1;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal-icon--success__line{height:5px;background-color:#a5dc86;display:block;border-radius:2px;position:absolute;z-index:2}.swal-icon--success__line--tip{width:25px;left:14px;top:46px;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-animation:animateSuccessTip .75s;animation:animateSuccessTip .75s}.swal-icon--success__line--long{width:47px;right:8px;top:38px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-animation:animateSuccessLong .75s;animation:animateSuccessLong .75s}@-webkit-keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@-webkit-keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}.swal-icon--info{border-color:#c9dae1}.swal-icon--info:before{width:5px;height:29px;bottom:17px;border-radius:2px;margin-left:-2px}.swal-icon--info:after,.swal-icon--info:before{content:"";position:absolute;left:50%;background-color:#c9dae1}.swal-icon--info:after{width:7px;height:7px;border-radius:50%;margin-left:-3px;top:19px}.swal-icon{width:80px;height:80px;border-width:4px;border-style:solid;border-radius:50%;padding:0;position:relative;box-sizing:content-box;margin:20px auto}.swal-icon:first-child{margin-top:32px}.swal-icon--custom{width:auto;height:auto;max-width:100%;border:none;border-radius:0}.swal-icon img{max-width:100%;max-height:100%}.swal-title{color:rgba(0,0,0,.65);font-weight:600;text-transform:none;position:relative;display:block;padding:13px 16px;font-size:27px;line-height:normal;text-align:center;margin-bottom:0}.swal-title:first-child{margin-top:26px}.swal-title:not(:first-child){padding-bottom:0}.swal-title:not(:last-child){margin-bottom:13px}.swal-text{font-size:16px;position:relative;float:none;line-height:normal;vertical-align:top;text-align:left;display:inline-block;margin:0;padding:0 10px;font-weight:400;color:rgba(0,0,0,.64);max-width:calc(100% - 20px);overflow-wrap:break-word;box-sizing:border-box}.swal-text:first-child{margin-top:45px}.swal-text:last-child{margin-bottom:45px}.swal-footer{text-align:right;padding-top:13px;margin-top:13px;padding:13px 16px;border-radius:inherit;border-top-left-radius:0;border-top-right-radius:0}.swal-button-container{margin:5px;display:inline-block;position:relative}.swal-button{background-color:#7cd1f9;color:#fff;border:none;box-shadow:none;border-radius:5px;font-weight:600;font-size:14px;padding:10px 24px;margin:0;cursor:pointer}.swal-button:not([disabled]):hover{background-color:#78cbf2}.swal-button:active{background-color:#70bce0}.swal-button:focus{outline:none;box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(43,114,165,.29)}.swal-button[disabled]{opacity:.5;cursor:default}.swal-button::-moz-focus-inner{border:0}.swal-button--cancel{color:#555;background-color:#efefef}.swal-button--cancel:not([disabled]):hover{background-color:#e8e8e8}.swal-button--cancel:active{background-color:#d7d7d7}.swal-button--cancel:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(116,136,150,.29)}.swal-button--danger{background-color:#e64942}.swal-button--danger:not([disabled]):hover{background-color:#df4740}.swal-button--danger:active{background-color:#cf423b}.swal-button--danger:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(165,43,43,.29)}.swal-content{padding:0 20px;margin-top:20px;font-size:medium}.swal-content:last-child{margin-bottom:20px}.swal-content__input,.swal-content__textarea{-webkit-appearance:none;background-color:#fff;border:none;font-size:14px;display:block;box-sizing:border-box;width:100%;border:1px solid rgba(0,0,0,.14);padding:10px 13px;border-radius:2px;transition:border-color .2s}.swal-content__input:focus,.swal-content__textarea:focus{outline:none;border-color:#6db8ff}.swal-content__textarea{resize:vertical}.swal-button--loading{color:transparent}.swal-button--loading~.swal-button__loader{opacity:1}.swal-button__loader{position:absolute;height:auto;width:43px;z-index:2;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);text-align:center;pointer-events:none;opacity:0}.swal-button__loader div{display:inline-block;float:none;vertical-align:baseline;width:9px;height:9px;padding:0;border:none;margin:2px;opacity:.4;border-radius:7px;background-color:hsla(0,0%,100%,.9);transition:background .2s;-webkit-animation:swal-loading-anim 1s infinite;animation:swal-loading-anim 1s infinite}.swal-button__loader div:nth-child(3n+2){-webkit-animation-delay:.15s;animation-delay:.15s}.swal-button__loader div:nth-child(3n+3){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}@keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}.swal-overlay{position:fixed;top:0;bottom:0;left:0;right:0;text-align:center;font-size:0;overflow-y:auto;background-color:rgba(0,0,0,.4);z-index:10000;pointer-events:none;opacity:0;transition:opacity .3s}.swal-overlay:before{content:" ";display:inline-block;vertical-align:middle;height:100%}.swal-overlay--show-modal{opacity:1;pointer-events:auto}.swal-overlay--show-modal .swal-modal{opacity:1;pointer-events:auto;box-sizing:border-box;-webkit-animation:showSweetAlert .3s;animation:showSweetAlert .3s;will-change:transform}.swal-modal{width:478px;opacity:0;pointer-events:none;background-color:#fff;text-align:center;border-radius:5px;position:static;margin:20px auto;display:inline-block;vertical-align:middle;-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 50%;transform-origin:50% 50%;z-index:10001;transition:opacity .2s,-webkit-transform .3s;transition:transform .3s,opacity .2s;transition:transform .3s,opacity .2s,-webkit-transform .3s}@media (max-width:500px){.swal-modal{width:calc(100% - 20px)}}@-webkit-keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}', ""]);
  }, function (t, e) {
    function n(t, e) {
      var n = t[1] || "",
          r = t[3];if (!r) return n;if (e && "function" == typeof btoa) {
        var i = o(r);return [n].concat(r.sources.map(function (t) {
          return "/*# sourceURL=" + r.sourceRoot + t + " */";
        })).concat([i]).join("\n");
      }return [n].join("\n");
    }function o(t) {
      return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(t)))) + " */";
    }t.exports = function (t) {
      var e = [];return e.toString = function () {
        return this.map(function (e) {
          var o = n(e, t);return e[2] ? "@media " + e[2] + "{" + o + "}" : o;
        }).join("");
      }, e.i = function (t, n) {
        "string" == typeof t && (t = [[null, t, ""]]);for (var o = {}, r = 0; r < this.length; r++) {
          var i = this[r][0];"number" == typeof i && (o[i] = !0);
        }for (r = 0; r < t.length; r++) {
          var a = t[r];"number" == typeof a[0] && o[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), e.push(a));
        }
      }, e;
    };
  }, function (t, e, n) {
    function o(t, e) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n],
            r = m[o.id];if (r) {
          r.refs++;for (var i = 0; i < r.parts.length; i++) {
            r.parts[i](o.parts[i]);
          }for (; i < o.parts.length; i++) {
            r.parts.push(u(o.parts[i], e));
          }
        } else {
          for (var a = [], i = 0; i < o.parts.length; i++) {
            a.push(u(o.parts[i], e));
          }m[o.id] = { id: o.id, refs: 1, parts: a };
        }
      }
    }function r(t, e) {
      for (var n = [], o = {}, r = 0; r < t.length; r++) {
        var i = t[r],
            a = e.base ? i[0] + e.base : i[0],
            s = i[1],
            c = i[2],
            l = i[3],
            u = { css: s, media: c, sourceMap: l };o[a] ? o[a].parts.push(u) : n.push(o[a] = { id: a, parts: [u] });
      }return n;
    }function i(t, e) {
      var n = v(t.insertInto);if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var o = w[w.length - 1];if ("top" === t.insertAt) o ? o.nextSibling ? n.insertBefore(e, o.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), w.push(e);else {
        if ("bottom" !== t.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e);
      }
    }function a(t) {
      if (null === t.parentNode) return !1;t.parentNode.removeChild(t);var e = w.indexOf(t);e >= 0 && w.splice(e, 1);
    }function s(t) {
      var e = document.createElement("style");return t.attrs.type = "text/css", l(e, t.attrs), i(t, e), e;
    }function c(t) {
      var e = document.createElement("link");return t.attrs.type = "text/css", t.attrs.rel = "stylesheet", l(e, t.attrs), i(t, e), e;
    }function l(t, e) {
      Object.keys(e).forEach(function (n) {
        t.setAttribute(n, e[n]);
      });
    }function u(t, e) {
      var n, o, r, i;if (e.transform && t.css) {
        if (!(i = e.transform(t.css))) return function () {};t.css = i;
      }if (e.singleton) {
        var l = h++;n = g || (g = s(e)), o = f.bind(null, n, l, !1), r = f.bind(null, n, l, !0);
      } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = c(e), o = p.bind(null, n, e), r = function r() {
        a(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = s(e), o = d.bind(null, n), r = function r() {
        a(n);
      });return o(t), function (e) {
        if (e) {
          if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;o(t = e);
        } else r();
      };
    }function f(t, e, n, o) {
      var r = n ? "" : o.css;if (t.styleSheet) t.styleSheet.cssText = x(e, r);else {
        var i = document.createTextNode(r),
            a = t.childNodes;a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(i, a[e]) : t.appendChild(i);
      }
    }function d(t, e) {
      var n = e.css,
          o = e.media;if (o && t.setAttribute("media", o), t.styleSheet) t.styleSheet.cssText = n;else {
        for (; t.firstChild;) {
          t.removeChild(t.firstChild);
        }t.appendChild(document.createTextNode(n));
      }
    }function p(t, e, n) {
      var o = n.css,
          r = n.sourceMap,
          i = void 0 === e.convertToAbsoluteUrls && r;(e.convertToAbsoluteUrls || i) && (o = y(o)), r && (o += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");var a = new Blob([o], { type: "text/css" }),
          s = t.href;t.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s);
    }var m = {},
        b = function (t) {
      var e;return function () {
        return void 0 === e && (e = t.apply(this, arguments)), e;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        v = function (t) {
      var e = {};return function (n) {
        return void 0 === e[n] && (e[n] = t.call(this, n)), e[n];
      };
    }(function (t) {
      return document.querySelector(t);
    }),
        g = null,
        h = 0,
        w = [],
        y = n(15);t.exports = function (t, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != (typeof document === "undefined" ? "undefined" : _typeof(document))) throw new Error("The style-loader cannot be used in a non-browser environment");e = e || {}, e.attrs = "object" == _typeof(e.attrs) ? e.attrs : {}, e.singleton || (e.singleton = b()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");var n = r(t, e);return o(n, e), function (t) {
        for (var i = [], a = 0; a < n.length; a++) {
          var s = n[a],
              c = m[s.id];c.refs--, i.push(c);
        }if (t) {
          o(r(t, e), e);
        }for (var a = 0; a < i.length; a++) {
          var c = i[a];if (0 === c.refs) {
            for (var l = 0; l < c.parts.length; l++) {
              c.parts[l]();
            }delete m[c.id];
          }
        }
      };
    };var x = function () {
      var t = [];return function (e, n) {
        return t[e] = n, t.filter(Boolean).join("\n");
      };
    }();
  }, function (t, e) {
    t.exports = function (t) {
      var e = "undefined" != typeof window && window.location;if (!e) throw new Error("fixUrls requires window.location");if (!t || "string" != typeof t) return t;var n = e.protocol + "//" + e.host,
          o = n + e.pathname.replace(/\/[^\/]*$/, "/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
        var r = e.trim().replace(/^"(.*)"$/, function (t, e) {
          return e;
        }).replace(/^'(.*)'$/, function (t, e) {
          return e;
        });if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(r)) return t;var i;return i = 0 === r.indexOf("//") ? r : 0 === r.indexOf("/") ? n + r : o + r.replace(/^\.\//, ""), "url(" + JSON.stringify(i) + ")";
      });
    };
  }, function (t, e, n) {
    var o = n(17);"undefined" == typeof window || window.Promise || (window.Promise = o), n(21), String.prototype.includes || (String.prototype.includes = function (t, e) {
      "use strict";
      return "number" != typeof e && (e = 0), !(e + t.length > this.length) && -1 !== this.indexOf(t, e);
    }), Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", { value: function value(t, e) {
        if (null == this) throw new TypeError('"this" is null or not defined');var n = Object(this),
            o = n.length >>> 0;if (0 === o) return !1;for (var r = 0 | e, i = Math.max(r >= 0 ? r : o - Math.abs(r), 0); i < o;) {
          if (function (t, e) {
            return t === e || "number" == typeof t && "number" == typeof e && isNaN(t) && isNaN(e);
          }(n[i], t)) return !0;i++;
        }return !1;
      } }), "undefined" != typeof window && function (t) {
      t.forEach(function (t) {
        t.hasOwnProperty("remove") || Object.defineProperty(t, "remove", { configurable: !0, enumerable: !0, writable: !0, value: function value() {
            this.parentNode.removeChild(this);
          } });
      });
    }([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
  }, function (t, e, n) {
    (function (e) {
      !function (n) {
        function o() {}function r(t, e) {
          return function () {
            t.apply(e, arguments);
          };
        }function i(t) {
          if ("object" != _typeof(this)) throw new TypeError("Promises must be constructed via new");if ("function" != typeof t) throw new TypeError("not a function");this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], f(t, this);
        }function a(t, e) {
          for (; 3 === t._state;) {
            t = t._value;
          }if (0 === t._state) return void t._deferreds.push(e);t._handled = !0, i._immediateFn(function () {
            var n = 1 === t._state ? e.onFulfilled : e.onRejected;if (null === n) return void (1 === t._state ? s : c)(e.promise, t._value);var o;try {
              o = n(t._value);
            } catch (t) {
              return void c(e.promise, t);
            }s(e.promise, o);
          });
        }function s(t, e) {
          try {
            if (e === t) throw new TypeError("A promise cannot be resolved with itself.");if (e && ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) || "function" == typeof e)) {
              var n = e.then;if (e instanceof i) return t._state = 3, t._value = e, void l(t);if ("function" == typeof n) return void f(r(n, e), t);
            }t._state = 1, t._value = e, l(t);
          } catch (e) {
            c(t, e);
          }
        }function c(t, e) {
          t._state = 2, t._value = e, l(t);
        }function l(t) {
          2 === t._state && 0 === t._deferreds.length && i._immediateFn(function () {
            t._handled || i._unhandledRejectionFn(t._value);
          });for (var e = 0, n = t._deferreds.length; e < n; e++) {
            a(t, t._deferreds[e]);
          }t._deferreds = null;
        }function u(t, e, n) {
          this.onFulfilled = "function" == typeof t ? t : null, this.onRejected = "function" == typeof e ? e : null, this.promise = n;
        }function f(t, e) {
          var n = !1;try {
            t(function (t) {
              n || (n = !0, s(e, t));
            }, function (t) {
              n || (n = !0, c(e, t));
            });
          } catch (t) {
            if (n) return;n = !0, c(e, t);
          }
        }var d = setTimeout;i.prototype.catch = function (t) {
          return this.then(null, t);
        }, i.prototype.then = function (t, e) {
          var n = new this.constructor(o);return a(this, new u(t, e, n)), n;
        }, i.all = function (t) {
          var e = Array.prototype.slice.call(t);return new i(function (t, n) {
            function o(i, a) {
              try {
                if (a && ("object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) || "function" == typeof a)) {
                  var s = a.then;if ("function" == typeof s) return void s.call(a, function (t) {
                    o(i, t);
                  }, n);
                }e[i] = a, 0 == --r && t(e);
              } catch (t) {
                n(t);
              }
            }if (0 === e.length) return t([]);for (var r = e.length, i = 0; i < e.length; i++) {
              o(i, e[i]);
            }
          });
        }, i.resolve = function (t) {
          return t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t.constructor === i ? t : new i(function (e) {
            e(t);
          });
        }, i.reject = function (t) {
          return new i(function (e, n) {
            n(t);
          });
        }, i.race = function (t) {
          return new i(function (e, n) {
            for (var o = 0, r = t.length; o < r; o++) {
              t[o].then(e, n);
            }
          });
        }, i._immediateFn = "function" == typeof e && function (t) {
          e(t);
        } || function (t) {
          d(t, 0);
        }, i._unhandledRejectionFn = function (t) {
          "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", t);
        }, i._setImmediateFn = function (t) {
          i._immediateFn = t;
        }, i._setUnhandledRejectionFn = function (t) {
          i._unhandledRejectionFn = t;
        }, void 0 !== t && t.exports ? t.exports = i : n.Promise || (n.Promise = i);
      }(this);
    }).call(e, n(18).setImmediate);
  }, function (t, e, n) {
    function o(t, e) {
      this._id = t, this._clearFn = e;
    }var r = Function.prototype.apply;e.setTimeout = function () {
      return new o(r.call(setTimeout, window, arguments), clearTimeout);
    }, e.setInterval = function () {
      return new o(r.call(setInterval, window, arguments), clearInterval);
    }, e.clearTimeout = e.clearInterval = function (t) {
      t && t.close();
    }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
      this._clearFn.call(window, this._id);
    }, e.enroll = function (t, e) {
      clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
    }, e.unenroll = function (t) {
      clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
    }, e._unrefActive = e.active = function (t) {
      clearTimeout(t._idleTimeoutId);var e = t._idleTimeout;e >= 0 && (t._idleTimeoutId = setTimeout(function () {
        t._onTimeout && t._onTimeout();
      }, e));
    }, n(19), e.setImmediate = setImmediate, e.clearImmediate = clearImmediate;
  }, function (t, e, n) {
    (function (t, e) {
      !function (t, n) {
        "use strict";
        function o(t) {
          "function" != typeof t && (t = new Function("" + t));for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) {
            e[n] = arguments[n + 1];
          }var o = { callback: t, args: e };return l[c] = o, s(c), c++;
        }function r(t) {
          delete l[t];
        }function i(t) {
          var e = t.callback,
              o = t.args;switch (o.length) {case 0:
              e();break;case 1:
              e(o[0]);break;case 2:
              e(o[0], o[1]);break;case 3:
              e(o[0], o[1], o[2]);break;default:
              e.apply(n, o);}
        }function a(t) {
          if (u) setTimeout(a, 0, t);else {
            var e = l[t];if (e) {
              u = !0;try {
                i(e);
              } finally {
                r(t), u = !1;
              }
            }
          }
        }if (!t.setImmediate) {
          var s,
              c = 1,
              l = {},
              u = !1,
              f = t.document,
              d = Object.getPrototypeOf && Object.getPrototypeOf(t);d = d && d.setTimeout ? d : t, "[object process]" === {}.toString.call(t.process) ? function () {
            s = function s(t) {
              e.nextTick(function () {
                a(t);
              });
            };
          }() : function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                  n = t.onmessage;return t.onmessage = function () {
                e = !1;
              }, t.postMessage("", "*"), t.onmessage = n, e;
            }
          }() ? function () {
            var e = "setImmediate$" + Math.random() + "$",
                n = function n(_n) {
              _n.source === t && "string" == typeof _n.data && 0 === _n.data.indexOf(e) && a(+_n.data.slice(e.length));
            };t.addEventListener ? t.addEventListener("message", n, !1) : t.attachEvent("onmessage", n), s = function s(n) {
              t.postMessage(e + n, "*");
            };
          }() : t.MessageChannel ? function () {
            var t = new MessageChannel();t.port1.onmessage = function (t) {
              a(t.data);
            }, s = function s(e) {
              t.port2.postMessage(e);
            };
          }() : f && "onreadystatechange" in f.createElement("script") ? function () {
            var t = f.documentElement;s = function s(e) {
              var n = f.createElement("script");n.onreadystatechange = function () {
                a(e), n.onreadystatechange = null, t.removeChild(n), n = null;
              }, t.appendChild(n);
            };
          }() : function () {
            s = function s(t) {
              setTimeout(a, 0, t);
            };
          }(), d.setImmediate = o, d.clearImmediate = r;
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self);
    }).call(e, n(7), n(20));
  }, function (t, e) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }function o() {
      throw new Error("clearTimeout has not been defined");
    }function r(t) {
      if (u === setTimeout) return setTimeout(t, 0);if ((u === n || !u) && setTimeout) return u = setTimeout, setTimeout(t, 0);try {
        return u(t, 0);
      } catch (e) {
        try {
          return u.call(null, t, 0);
        } catch (e) {
          return u.call(this, t, 0);
        }
      }
    }function i(t) {
      if (f === clearTimeout) return clearTimeout(t);if ((f === o || !f) && clearTimeout) return f = clearTimeout, clearTimeout(t);try {
        return f(t);
      } catch (e) {
        try {
          return f.call(null, t);
        } catch (e) {
          return f.call(this, t);
        }
      }
    }function a() {
      b && p && (b = !1, p.length ? m = p.concat(m) : v = -1, m.length && s());
    }function s() {
      if (!b) {
        var t = r(a);b = !0;for (var e = m.length; e;) {
          for (p = m, m = []; ++v < e;) {
            p && p[v].run();
          }v = -1, e = m.length;
        }p = null, b = !1, i(t);
      }
    }function c(t, e) {
      this.fun = t, this.array = e;
    }function l() {}var u,
        f,
        d = t.exports = {};!function () {
      try {
        u = "function" == typeof setTimeout ? setTimeout : n;
      } catch (t) {
        u = n;
      }try {
        f = "function" == typeof clearTimeout ? clearTimeout : o;
      } catch (t) {
        f = o;
      }
    }();var p,
        m = [],
        b = !1,
        v = -1;d.nextTick = function (t) {
      var e = new Array(arguments.length - 1);if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }m.push(new c(t, e)), 1 !== m.length || b || r(s);
    }, c.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, d.title = "browser", d.browser = !0, d.env = {}, d.argv = [], d.version = "", d.versions = {}, d.on = l, d.addListener = l, d.once = l, d.off = l, d.removeListener = l, d.removeAllListeners = l, d.emit = l, d.prependListener = l, d.prependOnceListener = l, d.listeners = function (t) {
      return [];
    }, d.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, d.cwd = function () {
      return "/";
    }, d.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, d.umask = function () {
      return 0;
    };
  }, function (t, e, n) {
    "use strict";
    n(22).polyfill();
  }, function (t, e, n) {
    "use strict";
    function o(t, e) {
      if (void 0 === t || null === t) throw new TypeError("Cannot convert first argument to object");for (var n = Object(t), o = 1; o < arguments.length; o++) {
        var r = arguments[o];if (void 0 !== r && null !== r) for (var i = Object.keys(Object(r)), a = 0, s = i.length; a < s; a++) {
          var c = i[a],
              l = Object.getOwnPropertyDescriptor(r, c);void 0 !== l && l.enumerable && (n[c] = r[c]);
        }
      }return n;
    }function r() {
      Object.assign || Object.defineProperty(Object, "assign", { enumerable: !1, configurable: !0, writable: !0, value: o });
    }t.exports = { assign: o, polyfill: r };
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(24),
        r = n(6),
        i = n(5),
        a = n(36),
        s = function s() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }if ("undefined" != typeof window) {
        var n = a.getOpts.apply(void 0, t);return new Promise(function (t, e) {
          i.default.promise = { resolve: t, reject: e }, o.default(n), setTimeout(function () {
            r.openModal();
          });
        });
      }
    };s.close = r.onAction, s.getState = r.getState, s.setActionValue = i.setActionValue, s.stopLoading = r.stopLoading, s.setDefaults = a.setDefaults, e.default = s;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(1),
        r = n(0),
        i = r.default.MODAL,
        a = n(4),
        s = n(34),
        c = n(35),
        l = n(1);e.init = function (t) {
      o.getNode(i) || (document.body || l.throwErr("You can only use SweetAlert AFTER the DOM has loaded!"), s.default(), a.default()), a.initModalContent(t), c.default(t);
    }, e.default = e.init;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(0),
        r = o.default.MODAL;e.modalMarkup = '\n  <div class="' + r + '" role="dialog" aria-modal="true"></div>', e.default = e.modalMarkup;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(0),
        r = o.default.OVERLAY,
        i = '<div \n    class="' + r + '"\n    tabIndex="-1">\n  </div>';e.default = i;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(0),
        r = o.default.ICON;e.errorIconMarkup = function () {
      var t = r + "--error",
          e = t + "__line";return '\n    <div class="' + t + '__x-mark">\n      <span class="' + e + " " + e + '--left"></span>\n      <span class="' + e + " " + e + '--right"></span>\n    </div>\n  ';
    }, e.warningIconMarkup = function () {
      var t = r + "--warning";return '\n    <span class="' + t + '__body">\n      <span class="' + t + '__dot"></span>\n    </span>\n  ';
    }, e.successIconMarkup = function () {
      var t = r + "--success";return '\n    <span class="' + t + "__line " + t + '__line--long"></span>\n    <span class="' + t + "__line " + t + '__line--tip"></span>\n\n    <div class="' + t + '__ring"></div>\n    <div class="' + t + '__hide-corners"></div>\n  ';
    };
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(0),
        r = o.default.CONTENT;e.contentMarkup = '\n  <div class="' + r + '">\n\n  </div>\n';
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(0),
        r = o.default.BUTTON_CONTAINER,
        i = o.default.BUTTON,
        a = o.default.BUTTON_LOADER;e.buttonMarkup = '\n  <div class="' + r + '">\n\n    <button\n      class="' + i + '"\n    ></button>\n\n    <div class="' + a + '">\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n\n  </div>\n';
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(4),
        r = n(2),
        i = n(0),
        a = i.default.ICON,
        s = i.default.ICON_CUSTOM,
        c = ["error", "warning", "success", "info"],
        l = { error: r.errorIconMarkup(), warning: r.warningIconMarkup(), success: r.successIconMarkup() },
        u = function u(t, e) {
      var n = a + "--" + t;e.classList.add(n);var o = l[t];o && (e.innerHTML = o);
    },
        f = function f(t, e) {
      e.classList.add(s);var n = document.createElement("img");n.src = t, e.appendChild(n);
    },
        d = function d(t) {
      if (t) {
        var e = o.injectElIntoModal(r.iconMarkup);c.includes(t) ? u(t, e) : f(t, e);
      }
    };e.default = d;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(2),
        r = n(4),
        i = function i(t) {
      navigator.userAgent.includes("AppleWebKit") && (t.style.display = "none", t.offsetHeight, t.style.display = "");
    };e.initTitle = function (t) {
      if (t) {
        var e = r.injectElIntoModal(o.titleMarkup);e.textContent = t, i(e);
      }
    }, e.initText = function (t) {
      if (t) {
        var e = document.createDocumentFragment();t.split("\n").forEach(function (t, n, o) {
          e.appendChild(document.createTextNode(t)), n < o.length - 1 && e.appendChild(document.createElement("br"));
        });var n = r.injectElIntoModal(o.textMarkup);n.appendChild(e), i(n);
      }
    };
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(1),
        r = n(4),
        i = n(0),
        a = i.default.BUTTON,
        s = i.default.DANGER_BUTTON,
        c = n(3),
        l = n(2),
        u = n(6),
        f = n(5),
        d = function d(t, e, n) {
      var r = e.text,
          i = e.value,
          d = e.className,
          p = e.closeModal,
          m = o.stringToNode(l.buttonMarkup),
          b = m.querySelector("." + a),
          v = a + "--" + t;if (b.classList.add(v), d) {
        (Array.isArray(d) ? d : d.split(" ")).filter(function (t) {
          return t.length > 0;
        }).forEach(function (t) {
          b.classList.add(t);
        });
      }n && t === c.CONFIRM_KEY && b.classList.add(s), b.textContent = r;var g = {};return g[t] = i, f.setActionValue(g), f.setActionOptionsFor(t, { closeModal: p }), b.addEventListener("click", function () {
        return u.onAction(t);
      }), m;
    },
        p = function p(t, e) {
      var n = r.injectElIntoModal(l.footerMarkup);for (var o in t) {
        var i = t[o],
            a = d(o, i, e);i.visible && n.appendChild(a);
      }0 === n.children.length && n.remove();
    };e.default = p;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(3),
        r = n(4),
        i = n(2),
        a = n(5),
        s = n(6),
        c = n(0),
        l = c.default.CONTENT,
        u = function u(t) {
      t.addEventListener("input", function (t) {
        var e = t.target,
            n = e.value;a.setActionValue(n);
      }), t.addEventListener("keyup", function (t) {
        if ("Enter" === t.key) return s.onAction(o.CONFIRM_KEY);
      }), setTimeout(function () {
        t.focus(), a.setActionValue("");
      }, 0);
    },
        f = function f(t, e, n) {
      var o = document.createElement(e),
          r = l + "__" + e;o.classList.add(r);for (var i in n) {
        var a = n[i];o[i] = a;
      }"input" === e && u(o), t.appendChild(o);
    },
        d = function d(t) {
      if (t) {
        var e = r.injectElIntoModal(i.contentMarkup),
            n = t.element,
            o = t.attributes;"string" == typeof n ? f(e, n, o) : e.appendChild(n);
      }
    };e.default = d;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(1),
        r = n(2),
        i = function i() {
      var t = o.stringToNode(r.overlayMarkup);document.body.appendChild(t);
    };e.default = i;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(5),
        r = n(6),
        i = n(1),
        a = n(3),
        s = n(0),
        c = s.default.MODAL,
        l = s.default.BUTTON,
        u = s.default.OVERLAY,
        f = function f(t) {
      t.preventDefault(), v();
    },
        d = function d(t) {
      t.preventDefault(), g();
    },
        p = function p(t) {
      if (o.default.isOpen) switch (t.key) {case "Escape":
          return r.onAction(a.CANCEL_KEY);}
    },
        m = function m(t) {
      if (o.default.isOpen) switch (t.key) {case "Tab":
          return f(t);}
    },
        b = function b(t) {
      if (o.default.isOpen) return "Tab" === t.key && t.shiftKey ? d(t) : void 0;
    },
        v = function v() {
      var t = i.getNode(l);t && (t.tabIndex = 0, t.focus());
    },
        g = function g() {
      var t = i.getNode(c),
          e = t.querySelectorAll("." + l),
          n = e.length - 1,
          o = e[n];o && o.focus();
    },
        h = function h(t) {
      t[t.length - 1].addEventListener("keydown", m);
    },
        w = function w(t) {
      t[0].addEventListener("keydown", b);
    },
        y = function y() {
      var t = i.getNode(c),
          e = t.querySelectorAll("." + l);e.length && (h(e), w(e));
    },
        x = function x(t) {
      if (i.getNode(u) === t.target) return r.onAction(a.CANCEL_KEY);
    },
        _ = function _(t) {
      var e = i.getNode(u);e.removeEventListener("click", x), t && e.addEventListener("click", x);
    },
        k = function k(t) {
      o.default.timer && clearTimeout(o.default.timer), t && (o.default.timer = window.setTimeout(function () {
        return r.onAction(a.CANCEL_KEY);
      }, t));
    },
        O = function O(t) {
      t.closeOnEsc ? document.addEventListener("keyup", p) : document.removeEventListener("keyup", p), t.dangerMode ? v() : g(), y(), _(t.closeOnClickOutside), k(t.timer);
    };e.default = O;
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(1),
        r = n(3),
        i = n(37),
        a = n(38),
        s = { title: null, text: null, icon: null, buttons: r.defaultButtonList, content: null, className: null, closeOnClickOutside: !0, closeOnEsc: !0, dangerMode: !1, timer: null },
        c = Object.assign({}, s);e.setDefaults = function (t) {
      c = Object.assign({}, s, t);
    };var l = function l(t) {
      var e = t && t.button,
          n = t && t.buttons;return void 0 !== e && void 0 !== n && o.throwErr("Cannot set both 'button' and 'buttons' options!"), void 0 !== e ? { confirm: e } : n;
    },
        u = function u(t) {
      return o.ordinalSuffixOf(t + 1);
    },
        f = function f(t, e) {
      o.throwErr(u(e) + " argument ('" + t + "') is invalid");
    },
        d = function d(t, e) {
      var n = t + 1,
          r = e[n];o.isPlainObject(r) || void 0 === r || o.throwErr("Expected " + u(n) + " argument ('" + r + "') to be a plain object");
    },
        p = function p(t, e) {
      var n = t + 1,
          r = e[n];void 0 !== r && o.throwErr("Unexpected " + u(n) + " argument (" + r + ")");
    },
        m = function m(t, e, n, r) {
      var i = typeof e === "undefined" ? "undefined" : _typeof(e),
          a = "string" === i,
          s = e instanceof Element;if (a) {
        if (0 === n) return { text: e };if (1 === n) return { text: e, title: r[0] };if (2 === n) return d(n, r), { icon: e };f(e, n);
      } else {
        if (s && 0 === n) return d(n, r), { content: e };if (o.isPlainObject(e)) return p(n, r), e;f(e, n);
      }
    };e.getOpts = function () {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t[e] = arguments[e];
      }var n = {};t.forEach(function (e, o) {
        var r = m(0, e, o, t);Object.assign(n, r);
      });var o = l(n);n.buttons = r.getButtonListOpts(o), delete n.button, n.content = i.getContentOpts(n.content);var u = Object.assign({}, s, c, n);return Object.keys(u).forEach(function (t) {
        a.DEPRECATED_OPTS[t] && a.logDeprecation(t);
      }), u;
    };
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 });var o = n(1),
        r = { element: "input", attributes: { placeholder: "" } };e.getContentOpts = function (t) {
      var e = {};return o.isPlainObject(t) ? Object.assign(e, t) : t instanceof Element ? { element: t } : "input" === t ? r : null;
    };
  }, function (t, e, n) {
    "use strict";
    Object.defineProperty(e, "__esModule", { value: !0 }), e.logDeprecation = function (t) {
      var n = e.DEPRECATED_OPTS[t],
          o = n.onlyRename,
          r = n.replacement,
          i = n.subOption,
          a = n.link,
          s = o ? "renamed" : "deprecated",
          c = 'SweetAlert warning: "' + t + '" option has been ' + s + ".";if (r) {
        c += " Please use" + (i ? ' "' + i + '" in ' : " ") + '"' + r + '" instead.';
      }var l = "https://sweetalert.js.org";c += a ? " More details: " + l + a : " More details: " + l + "/guides/#upgrading-from-1x", console.warn(c);
    }, e.DEPRECATED_OPTS = { type: { replacement: "icon", link: "/docs/#icon" }, imageUrl: { replacement: "icon", link: "/docs/#icon" }, customClass: { replacement: "className", onlyRename: !0, link: "/docs/#classname" }, imageSize: {}, showCancelButton: { replacement: "buttons", link: "/docs/#buttons" }, showConfirmButton: { replacement: "button", link: "/docs/#button" }, confirmButtonText: { replacement: "button", link: "/docs/#button" }, confirmButtonColor: {}, cancelButtonText: { replacement: "buttons", link: "/docs/#buttons" }, closeOnConfirm: { replacement: "button", subOption: "closeModal", link: "/docs/#button" }, closeOnCancel: { replacement: "buttons", subOption: "closeModal", link: "/docs/#buttons" }, showLoaderOnConfirm: { replacement: "buttons" }, animation: {}, inputType: { replacement: "content", link: "/docs/#content" }, inputValue: { replacement: "content", link: "/docs/#content" }, inputPlaceholder: { replacement: "content", link: "/docs/#content" }, html: { replacement: "content", link: "/docs/#content" }, allowEscapeKey: { replacement: "closeOnEsc", onlyRename: !0, link: "/docs/#closeonesc" }, allowClickOutside: { replacement: "closeOnClickOutside", onlyRename: !0, link: "/docs/#closeonclickoutside" } };
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17).setImmediate, __webpack_require__(17).clearImmediate, __webpack_require__(4)(module)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") {
            callback = new Function("" + callback);
        }
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i + 1];
        }
        // Store and register the task
        var task = { callback: callback, args: args };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function registerImmediate(handle) {
            process.nextTick(function () {
                runIfPresent(handle);
            });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function () {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function onGlobalMessage(event) {
            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function registerImmediate(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function registerImmediate(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function registerImmediate(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function registerImmediate(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();
    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();
    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();
    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();
    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18), __webpack_require__(56)))

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ })
],[20]);


// WEBPACK FOOTER //
// bundle_website.ed99ee5f6c77f279555d.js